window.hsonslidecart = window.hsonslidecart || {};
window.hsonslidecart = window.hsonslidecart || {};
hsonslidecart.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase
 
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    var hs_money = formatString.replace(placeholderRegex, value);
    if(hs_money.indexOf('money') == -1){
		hs_money = '<span class=money>'+formatString.replace(placeholderRegex, value)+'</span>';
    }
    return hs_money;
  }

  return {
    formatMoney: formatMoney
  }
})();

if(typeof HsCurrency==="undefined") {
    var HsCurrency= {}
}

HsCurrency.moneyFormats = {
    USD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} USD"
    }
    ,
    EUR: {
        money_format: "&euro;{{amount_with_comma_separator}}", money_with_currency_format: "&euro;{{amount_with_comma_separator}} EUR"
    }
    ,
    GBP: {
        money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP"
    }
    ,
    CAD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} CAD"
    }
    ,
    ALL: {
        money_format:"Lek {{amount}}",
        money_with_currency_format:"Lek {{amount}} ALL"
    }
    ,
    DZD: {
        money_format:"DA {{amount}}",
        money_with_currency_format:"DA {{amount}} DZD"
    }
    ,
    AOA: {
        money_format:"Kz{{amount}}",
        money_with_currency_format:"Kz{{amount}} AOA"
    }
    ,
    ARS: {
        money_format:"${{amount_with_comma_separator}}",
        money_with_currency_format:"${{amount_with_comma_separator}} ARS"
    }
    ,
    AMD: {
        money_format:"{{amount}} AMD",
        money_with_currency_format:"{{amount}} AMD"
    }
    ,
    AWG: {
        money_format:"Afl{{amount}}",
        money_with_currency_format:"Afl{{amount}} AWG"
    }
    ,
    AUD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} AUD"
    }
    ,
    BBD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} Bds"
    }
    ,
    AZN: {
        money_format:"m.{{amount}}",
        money_with_currency_format:"m.{{amount}} AZN"
    }
    ,
    BDT: {
        money_format:"Tk {{amount}}",
        money_with_currency_format:"Tk {{amount}} BDT"
    }
    ,
    BSD: {
        money_format:"BS${{amount}}",
        money_with_currency_format:"BS${{amount}} BSD"
    }
    ,
    BHD: {
        money_format:"{{amount}}0 BD",
        money_with_currency_format:"{{amount}}0 BHD"
    }
    ,
    BYR: {
        money_format:"Br {{amount}}",
        money_with_currency_format:"Br {{amount}} BYR"
    }
    ,
    BZD: {
        money_format:"BZ${{amount}}",
        money_with_currency_format:"BZ${{amount}} BZD"
    }
    ,
    BTN: {
        money_format:"Nu {{amount}}",
        money_with_currency_format:"Nu {{amount}} BTN"
    }
    ,
    BAM: {
        money_format:"KM {{amount_with_comma_separator}}",
        money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"
    }
    ,
    BRL: {
        money_format:"R$ {{amount_with_comma_separator}}",
        money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"
    }
    ,
    BOB: {
        money_format:"Bs{{amount_with_comma_separator}}",
        money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"
    }
    ,
    BWP: {
        money_format:"P{{amount}}",
        money_with_currency_format:"P{{amount}} BWP"
    }
    ,
    BND: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} BND"
    }
    ,
    BGN: {
        money_format:"{{amount}} лв",
        money_with_currency_format:"{{amount}} лв BGN"
    }
    ,
    MMK: {
        money_format:"K{{amount}}",
        money_with_currency_format:"K{{amount}} MMK"
    }
    ,
    KHR: {
        money_format:"KHR{{amount}}",
        money_with_currency_format:"KHR{{amount}}"
    }
    ,
    KYD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} KYD"
    }
    ,
    XAF: {
        money_format:"FCFA{{amount}}",
        money_with_currency_format:"FCFA{{amount}} XAF"
    }
    ,
    CLP: {
        money_format:"${{amount_no_decimals}}",
        money_with_currency_format:"${{amount_no_decimals}} CLP"
    }
    ,
    CNY: {
        money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY"
    }
    ,
    COP: {
        money_format:"${{amount_with_comma_separator}}",
        money_with_currency_format:"${{amount_with_comma_separator}} COP"
    }
    ,
    CRC: {
        money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    }
    ,
    HRK: {
        money_format:"{{amount_with_comma_separator}} kn",
        money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"
    }
    ,
    CZK: {
        money_format:"{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"
    }
    ,
    DKK: {
        money_format:"{{amount_with_comma_separator}}",
        money_with_currency_format:"kr.{{amount_with_comma_separator}}"
    }
    ,
    DOP: {
        money_format:"RD$ {{amount}}",
        money_with_currency_format:"RD$ {{amount}}"
    }
    ,
    XCD: {
        money_format:"${{amount}}",
        money_with_currency_format:"EC${{amount}}"
    }
    ,
    EGP: {
        money_format:"LE {{amount}}",
        money_with_currency_format:"LE {{amount}} EGP"
    }
    ,
    ETB: {
        money_format:"Br{{amount}}",
        money_with_currency_format:"Br{{amount}} ETB"
    }
    ,
    XPF: {
        money_format:"{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"
    }
    ,
    FJD: {
        money_format:"${{amount}}",
        money_with_currency_format:"FJ${{amount}}"
    }
    ,
    GMD: {
        money_format:"D {{amount}}",
        money_with_currency_format:"D {{amount}} GMD"
    }
    ,
    GHS: {
        money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}"
    }
    ,
    GTQ: {
        money_format:"Q{{amount}}",
        money_with_currency_format:"{{amount}} GTQ"
    }
    ,
    GYD: {
        money_format:"G${{amount}}",
        money_with_currency_format:"${{amount}} GYD"
    }
    ,
    GEL: {
        money_format:"{{amount}} GEL",
        money_with_currency_format:"{{amount}} GEL"
    }
    ,
    HNL: {
        money_format:"L {{amount}}",
        money_with_currency_format:"L {{amount}} HNL"
    }
    ,
    HKD: {
        money_format:"${{amount}}",
        money_with_currency_format:"HK${{amount}}"
    }
    ,
    HUF: {
        money_format:"{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"
    }
    ,
    ISK: {
        money_format:"{{amount_no_decimals}} kr",
        money_with_currency_format:"{{amount_no_decimals}} kr ISK"
    }
    ,
    INR: {
        money_format:"Rs. {{amount}}",
        money_with_currency_format:"Rs. {{amount}}"
    }
    ,
    IDR: {
        money_format:"{{amount_with_comma_separator}}",
        money_with_currency_format:"Rp {{amount_with_comma_separator}}"
    }
    ,
    ILS: {
        money_format:"{{amount}} NIS",
        money_with_currency_format:"{{amount}} NIS"
    }
    ,
    JMD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} JMD"
    }
    ,
    JPY: {
        money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    }
    ,
    JEP: {
        money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP"
    }
    ,
    JOD: {
        money_format:"{{amount}}0 JD",
        money_with_currency_format:"{{amount}}0 JOD"
    }
    ,
    KZT: {
        money_format:"{{amount}} KZT",
        money_with_currency_format:"{{amount}} KZT"
    }
    ,
    KES: {
        money_format:"KSh{{amount}}",
        money_with_currency_format:"KSh{{amount}}"
    }
    ,
    KWD: {
        money_format:"{{amount}}0 KD",
        money_with_currency_format:"{{amount}}0 KWD"
    }
    ,
    KGS: {
        money_format:"лв{{amount}}",
        money_with_currency_format:"лв{{amount}}"
    }
    ,
    LVL: {
        money_format:"Ls {{amount}}",
        money_with_currency_format:"Ls {{amount}} LVL"
    }
    ,
    LBP: {
        money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP"
    }
    ,
    LTL: {
        money_format:"{{amount}} Lt",
        money_with_currency_format:"{{amount}} Lt"
    }
    ,
    MGA: {
        money_format:"Ar {{amount}}",
        money_with_currency_format:"Ar {{amount}} MGA"
    }
    ,
    MKD: {
        money_format:"ден {{amount}}",
        money_with_currency_format:"ден {{amount}} MKD"
    }
    ,
    MOP: {
        money_format:"MOP${{amount}}",
        money_with_currency_format:"MOP${{amount}}"
    }
    ,
    MVR: {
        money_format:"Rf{{amount}}",
        money_with_currency_format:"Rf{{amount}} MRf"
    }
    ,
    MXN: {
        money_format:"$ {{amount}}",
        money_with_currency_format:"$ {{amount}} MXN"
    }
    ,
    MYR: {
        money_format:"RM{{amount}} MYR",
        money_with_currency_format:"RM{{amount}} MYR"
    }
    ,
    MUR: {
        money_format:"Rs {{amount}}",
        money_with_currency_format:"Rs {{amount}} MUR"
    }
    ,
    MDL: {
        money_format:"{{amount}} MDL",
        money_with_currency_format:"{{amount}} MDL"
    }
    ,
    MAD: {
        money_format:"{{amount}} dh",
        money_with_currency_format:"Dh {{amount}} MAD"
    }
    ,
    MNT: {
        money_format:"{{amount_no_decimals}} &#8366",
        money_with_currency_format:"{{amount_no_decimals}} MNT"
    }
    ,
    MZN: {
        money_format:"{{amount}} Mt",
        money_with_currency_format:"Mt {{amount}} MZN"
    }
    ,
    NAD: {
        money_format:"N${{amount}}",
        money_with_currency_format:"N${{amount}} NAD"
    }
    ,
    NPR: {
        money_format:"Rs{{amount}}",
        money_with_currency_format:"Rs{{amount}} NPR"
    }
    ,
    ANG: {
        money_format: "&fnof;{{amount}}", money_with_currency_format:"{{amount}} NA&fnof;"
    }
    ,
    NZD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} NZD"
    }
    ,
    NIO: {
        money_format:"C${{amount}}",
        money_with_currency_format:"C${{amount}} NIO"
    }
    ,
    NGN: {
        money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN"
    }
    ,
    NOK: {
        money_format:"kr {{amount_with_comma_separator}}",
        money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"
    }
    ,
    OMR: {
        money_format:"{{amount_with_comma_separator}} OMR",
        money_with_currency_format:"{{amount_with_comma_separator}} OMR"
    }
    ,
    PKR: {
        money_format:"Rs.{{amount}}",
        money_with_currency_format:"Rs.{{amount}} PKR"
    }
    ,
    PGK: {
        money_format:"K {{amount}}",
        money_with_currency_format:"K {{amount}} PGK"
    }
    ,
    PYG: {
        money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    }
    ,
    PEN: {
        money_format:"S/. {{amount}}",
        money_with_currency_format:"S/. {{amount}} PEN"
    }
    ,
    PHP: {
        money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP"
    }
    ,
    PLN: {
        money_format:"{{amount_with_comma_separator}} zl",
        money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"
    }
    ,
    QAR: {
        money_format:"QAR {{amount_with_comma_separator}}",
        money_with_currency_format:"QAR {{amount_with_comma_separator}}"
    }
    ,
    RON: {
        money_format:"{{amount_with_comma_separator}} lei",
        money_with_currency_format:"{{amount_with_comma_separator}} lei RON"
    }
    ,
    RUB: {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    }
    ,
    RWF: {
        money_format:"{{amount_no_decimals}} RF",
        money_with_currency_format:"{{amount_no_decimals}} RWF"
    }
    ,
    WST: {
        money_format:"WS$ {{amount}}",
        money_with_currency_format:"WS$ {{amount}} WST"
    }
    ,
    SAR: {
        money_format:"{{amount}} SR",
        money_with_currency_format:"{{amount}} SAR"
    }
    ,
    STD: {
        money_format:"Db {{amount}}",
        money_with_currency_format:"Db {{amount}} STD"
    }
    ,
    RSD: {
        money_format:"{{amount}} RSD",
        money_with_currency_format:"{{amount}} RSD"
    }
    ,
    SCR: {
        money_format:"Rs {{amount}}",
        money_with_currency_format:"Rs {{amount}} SCR"
    }
    ,
    SGD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} SGD"
    }
    ,
    SYP: {
        money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP"
    }
    ,
    ZAR: {
        money_format:"R {{amount}}",
        money_with_currency_format:"R {{amount}} ZAR"
    }
    ,
    KRW: {
        money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    }
    ,
    LKR: {
        money_format:"Rs {{amount}}",
        money_with_currency_format:"Rs {{amount}} LKR"
    }
    ,
    SEK: {
        money_format:"{{amount_no_decimals}} kr",
        money_with_currency_format:"{{amount_no_decimals}} kr SEK"
    }
    ,
    CHF: {
        money_format:"SFr. {{amount}}",
        money_with_currency_format:"SFr. {{amount}} CHF"
    }
    ,
    TWD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} TWD"
    }
    ,
    THB: {
        money_format:"{{amount}} &#xe3f;",
        money_with_currency_format:"{{amount}} &#xe3f; THB"
    }
    ,
    TZS: {
        money_format:"{{amount}} TZS",
        money_with_currency_format:"{{amount}} TZS"
    }
    ,
    TTD: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}} TTD"
    }
    ,
    TND: {
        money_format:"{{amount}}",
        money_with_currency_format:"{{amount}} DT"
    }
    ,
    TRY: {
        money_format:"{{amount}}TL",
        money_with_currency_format:"{{amount}}TL"
    }
    ,
    UGX: {
        money_format:"Ush {{amount_no_decimals}}",
        money_with_currency_format:"Ush {{amount_no_decimals}} UGX"
    }
    ,
    UAH: {
        money_format:"₴{{amount}}",
        money_with_currency_format:"₴{{amount}} UAH"
    }
    ,
    AED: {
        money_format:"Dhs. {{amount}}",
        money_with_currency_format:"Dhs. {{amount}} AED"
    }
    ,
    UYU: {
        money_format:"${{amount_with_comma_separator}}",
        money_with_currency_format:"${{amount_with_comma_separator}} UYU"
    }
    ,
    VUV: {
        money_format:"${{amount}}",
        money_with_currency_format:"${{amount}}VT"
    }
    ,
    VEF: {
        money_format:"Bs. {{amount_with_comma_separator}}",
        money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"
    }
    ,
    VND: {
        money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"
    }
    ,
    XBT: {
        money_format:"{{amount_no_decimals}} BTC",
        money_with_currency_format:"{{amount_no_decimals}} BTC"
    }
    ,
    XOF: {
        money_format:"CFA{{amount}}",
        money_with_currency_format:"CFA{{amount}} XOF"
    }
    ,
    ZMW: {
        money_format:"K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"
    }
};

var delay = (function(){
var timer = 0;
  return function(callback, ms){
     clearTimeout (timer);
     timer = setTimeout(callback, ms);
  };
})();
/* ================ ON!!! ================ */

Object.defineProperty(Array.prototype, 'chunk_inefficient2', {
  enumerable: false,
  writable: true,
  value: function(chunkSize) {
    var array = this;
    return [].concat.apply([],
      array.map(function(elem, i) {
        return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
      })
    );
  }
});

var HsCartDrawer = {
  	shopifyUrl:'salt-strong.myshopify.com',
	pathname:window.location.href,
	obj:[],
	params:[],
  	arr_variants:[],
    arr_rewards:'',
	where:'',
	feed:'',
	textcart:'',
	scroll:'',
	total:'',
    footer:'',
	color:'',
	colorThumb:'',
	count:0,
	next:0,
	back:0,
	css:'',
	status_text_checkout:'',
	status_text_cart:'',
	display_variant:'none',
	display_variant_position:'absolute',
	display_swatch:'none',
	display_popup:'none',
	display_addtocart:'none',
	content_popup:'490px',
    position_slide_cart: 'sticky',
	style:'',
    query: false,
    json:false,
    text_style: '',
    openSlideCart:'header a[href="/cart"],header a[href="#cart"],a[href="#cart"],.hs-sticky-cart-cart-drawer,.navigation a[href="/cart"],a[href="/cart"],.cart-wrap,.tt-desctop-parent-cart,.cart-summary,.header-icon-with-text,.tt-cart,.header-inner #cart',
    empty_cart: '<svg width="60px" id="Capa_1" data-name="Capa 1" viewBox="0 0 1042 1186.53"><defs><style>.cls-1{fill:#f2f2f2;}.cls-2{fill:#bababa;}.cls-3{fill:#fefefe;}.cls-4{fill:#ebebeb;}.cls-5{fill:#6d6d6d;}</style></defs><title>heysenior_cart</title><path class="cls-1" d="M79.11,1148.9V182.64c1.81-3.35-1.14-9,4.94-10.31C93,164.7,103.48,163,115,163q485,.23,970,.12c1.09,0,2.18.06,3.26,0,10.8-.69,20.19,2.16,27.29,10.76,4.74,1.78,4.22,6.35,5.32,10.07v3.91c-1.3,2.69-.62,5.56-.62,8.33q-.06,473.87,0,947.71c0,26.92-16.76,45.54-43.81,48.69a2.22,2.22,0,0,0-1.11.6H124.68c-15.62-1.63-28.3-8.38-37.4-21.41C82.47,1164.89,80.47,1157,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-2" d="M1117.1,177.52c-9.15-11-21.36-12-34.67-11.94q-486.5.3-973,0c-9.49,0-17.52,2.66-24.14,9.17-3.36,3.3-2-.23-2.36-1.3-1.84-5.35,2.45-8.17,5.32-10.76,21.09-19,41.85-38.27,62.89-57.28,16.38-14.8,32.66-29.73,49-44.6C218.71,44,237.2,27,255.92,10.23c1.66-1.49,3.77-2.09,5.5-3.39H937.28c14.92,11.22,27.83,24.7,41.71,37.1,22.29,19.9,44.32,40.1,66.39,60.25,17.43,15.91,35,31.64,52.15,47.91,5.18,4.92,11.38,8.8,15.64,14.62C1115.45,169.85,1119.28,172.66,1117.1,177.52Z" transform="translate(-79 -6.74)"></path><path class="cls-4" d="M1119.58,1146.28q0-474.85.07-949.72c0-2.9-1.17-6.1,1.24-8.71V1146.3C1120.45,1146.89,1120,1146.92,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M1119.58,1146.28l1.31,0c0,14.54-.09,29.08.09,43.62,0,2.8-.54,3.38-3.34,3.34-14.11-.18-28.22-.08-42.32-.08,7.89-3.33,16.47-5,23.48-10.44C1110.84,1173.47,1118.33,1161.67,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M79.11,1148.9c3.73,7.26,5.29,15.52,10.1,22.28,7.76,10.92,18.87,16.73,31.37,20.39,1.42.41,3.06.23,4.1,1.61-14.1,0-28.21-.1-42.32.08-2.8,0-3.38-.54-3.34-3.34C79.21,1176.25,79.11,1162.57,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-5" d="M830.88,471.23c0,26.65,1.23,53.37-5.41,79.59C806.13,627.26,760.56,682,688,712.47c-90.54,38-193.23,14.58-259.69-58.12-31.83-34.83-50.93-76.08-57.65-123C367,506.25,369,481.09,368.44,456c-.22-10.19-.08-20.39,0-30.59.09-16.3,10.67-27.79,25.52-27.83,14.61,0,25.92,11.59,26.08,27.54.29,28-.47,56,.43,84,1.27,39.75,15.78,74.8,41.19,105.19s57.59,50.44,96.17,59.67q58.14,13.92,113.27-9.75a176.89,176.89,0,0,0,77.79-64.1c20.93-30.74,30.94-65.16,30.85-102.44-.06-24.31-.12-48.61,0-72.91.1-16,11.22-27.35,26.17-27.17,13.37.17,24.62,10.77,24.89,24.21C831.13,438.24,830.88,454.74,830.88,471.23Z" transform="translate(-79 -6.74)"></path></svg>',
    text_style_active:'',
    ipinfo:function(data,$){
      if(!parseInt(data.enable_shipping_country))
      {
        return false;
      }
      $.ajax({
        type: "GET",
        url: "/browsing_context_suggestions.json",
        async:false,
        contentType: "application/json",
        success: function(r) {
        if(typeof window.HSSLIDECART !== 'undefined'
           && typeof window.HSSLIDECART.rewards !== 'undefined'
           && typeof window.HSSLIDECART.rewards.json !== 'undefined') {
              $.each(window.HSSLIDECART.rewards.json, function( index, value ) {
                if(r.detected_values.country.handle == value.country_small)
                {
                  HsCartDrawer.arr_rewards = value;
                }
              });
          }
        },
        error: function(xhr) {
          //console.log('Try catch');
        },
        complete: function() {
        }
      });
      
    },
    moduleUpsell:function(data,$){
      if(parseInt(data.enable_recommend_products))
      {
        var status_text_slide_cart = '';
        if(typeof window.HSSLIDECART !== 'undefined'
           && typeof window.HSSLIDECART.upsell !== 'undefined'
           && typeof window.HSSLIDECART.upsell.json !== 'undefined') {
           status_text_slide_cart = HsCartDrawer.upsellProductsJson(parseInt(data.upsell_show_quantity_box),parseInt(data.upsell_mode),'swiper-container-static',window.HSSLIDECART.upsell.json,data,$);
        }
        if(status_text_slide_cart)
        {
          if(parseInt(data.upsell_mode))
          {
            $('.hs-products-stacked').html(status_text_slide_cart);
          }else{
            $('.hs-mode-static').html(status_text_slide_cart);
          }
        }
      }
    },
    ajaxUpsellHandle:function(text,data,$){
      if(parseInt(data.enable_upsell_cross_sell))
      {
        if(!text)
        {
          $('.hs-cross-sell').hide();
          return false;
        }
        $.ajax({
          type: 'GET',
          async:true,
          data:{q:text,view:'hs-products'},
          url: '/search',
          contentType: "application/json",
          beforeSend: function() {
            //loader
          },
          success: function(r) {
            if(HsCartDrawer.isJson(r) == true)
            {
              var obj = JSON.parse(r), status_text_slide_cart = '';
              if(obj)
              {
                status_text_slide_cart = HsCartDrawer.upsellProductsJson(parseInt(data.upsell_cross_sell_show_quantity_box),parseInt(data.upsell_cross_sell_mode),'swiper-container-dynamic',obj,data,$);
                $('.hs-cross-sell').hide();
                if(status_text_slide_cart)
                {
                  $('.hs-cross-sell').show();
                  if(parseInt(data.upsell_cross_sell_mode))
                  {
                    $('.hs-products-dynamic-stacked').html(status_text_slide_cart);
                  }else{
                    $('.hs-mode-dynamic').html(status_text_slide_cart);
                  }
                  HsCartDrawer.swiperDynamicHSCart(data,$);
                }
              }
            }
          },
          error: function(xhr) {
            //console.log('Try catch');
          },
          complete: function() {
            HsCartDrawer.upsellVariants(data,$);
            HsCartDrawer.addToCartFreeShipping(data,$);
          }
        });
      }
    },
    unique:function(names,data,$){
      var uniq = names.slice() // slice makes copy of array before sorting it
      .sort(function(a,b){
        return a > b;
      })
      .reduce(function(a,b){
        if (a.slice(-1)[0] !== b) a.push(b); // slice(-1)[0] means last item in array without removing it (like .pop())
        return a;
      },[]); // this empty array becomes the starting value for a

      // one liner
      return names.slice().sort(function(a,b){return a > b}).reduce(function(a,b){if (a.slice(-1)[0] !== b) a.push(b);return a;},[]);
    },
    dynamicUpsell:function(result,handle,data,$){
      if(result.length > 0)
      {
        result = HsCartDrawer.unique(result,data,$);
      }
      if(typeof window.HSSLIDECART !== 'undefined'
         && typeof window.HSSLIDECART.dynamicUpsell !== 'undefined'
         && typeof window.HSSLIDECART.dynamicUpsell.json !== 'undefined') {
         var arr = [],arr2= [],a = [],b = [],text = '',dynamic_upsell = '',is_equal = false;
		 $.each(window.HSSLIDECART.dynamicUpsell.json, function( index, item ) {
           //is_equal = _.isEqual(_.sortBy(result), _.sortBy(item.result));
           dynamic_upsell = item.dynamic_upsell.filter(val => !handle.includes(val));
           const a = result;
           const b = item.result;
           if(b)
           {
             is_equal = a.some(v => b.includes(v));
             if(is_equal){
               arr.push(dynamic_upsell);
               //text = item.dynamic_upsell.join('|');
             }
           }
           //console.log(product_id);
		 });
        if(arr){
          arr.sort(function(a,b){
            return Object.keys(a).length - Object.keys(b).length;
          });
          //console.log(result);
          $.each(arr, function( index, item ) {
            text = item.join('|');
          });
          /*if(text)
          {
            arr2 = text.split('|');
          }
          arr2 = arr2.filter(val => !handle.includes(val));
          if(arr2){
            text = arr2.join('|');
          }*/
        }
        HsCartDrawer.ajaxUpsellHandle(text,data,$);
        //console.log(window.HSSLIDECART.dynamicUpsell.json);
        //console.log(result);
        
        
        /*$.get('//services.heysenior.com/sticky/result/onget?shop='+HsCartDrawer.shopifyUrl,{ products: result }, function(data) {
          if(data)
          {
            
          }
        });*/
      }
    },
    upsellProductsJson:function(show_quantity_box,mode,upsell_class,obj,data,$){
      var selectCombobox = '',selectParent = '',quantity_box = '',parent_class = '',status_text_slide_cart = '',featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif',featured_image_variant = '';
        $.each(obj, function( index, item ) {
          if (typeof item.error === "undefined") {
            featured_image = '//cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
            if(item.featured_image !== null)
            {
              featured_image = HsCartDrawer.resizeSrc(item.featured_image,'x200')
              //featured_image_variant = featured_image;
            } 
            selectParent = '';
            featured_image_variant = '';
            $.each(item.variants, function( x, n ) {
              featured_image_variant = '';
              if(n.featured_image !== null)
              {
                featured_image_variant = HsCartDrawer.resizeSrc(n.featured_image.src,'x200');
              }
              selectParent = selectParent.concat('<option value="'+n.id+'" title="'+n.title+'" data-id="'+item.id+'" data-price="'+n.price+'" data-sku="'+n.sku+'" data-available="'+n.available+'" data-handle="/products/'+item.handle+'" data-barcode="'+n.barcode+'" data-featuredimage="'+featured_image_variant+'" data-inventorymanagement="'+n.inventory_management+'" data-compareatprice="'+n.compare_at_price+'" data-variantid="'+n.id+'">'+n.title+'</option>');
            });
            parent_class = '';
            if(item.variants.length == 1)
            {
              parent_class = ' hs-hidden-element';
            }
            selectCombobox = '<select class="hs-swipper-option-parent-'+item.id+' hs-swipper-select-option-add-to-cart'+parent_class+'" data-id="'+item.id+'">'+selectParent+'</select>';
            var price_sw = item.variants[0].price,compare_at_price_sw = item.variants[0].compare_at_price;
            if(compare_at_price_sw > price_sw)
            {
              compare_at_price_sw = HsCartDrawer.vat(compare_at_price_sw,data,$);
              compare_at_price_sw = '<div class="hs-compare-price-sw">'+hsonslidecart.Currency.formatMoney(compare_at_price_sw, data['money_format'])+'</div>';
            }else{
              compare_at_price_sw = '';
            }
            if(show_quantity_box)
            {
            	quantity_box = '<div class="hs-qty-upsell"><div class="hs-item-cart-content-quantity-upsell"><div class="hs-item-cart-qty-upsell"><div class="hs-cart-plus-minus-upsell"><div class="hs-dec-upsell hs-qtybutton-upsell "><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="1"><div class="hs-inc-upsell hs-qtybutton-upsell"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div></div></div></div>';
            }
           	price_sw = HsCartDrawer.vat(price_sw,data,$);
            price_sw = '<div class="hs-price-sw">'+hsonslidecart.Currency.formatMoney(price_sw, data['money_format'])+'</div>';
            status_text_slide_cart = status_text_slide_cart.concat('<div class="swiper-slide"><div class="hs-content-product-slide-cart"><div class="hs-product-content-image-swipper"><a href="/products/'+item.handle+'" class="hs-product-link-image"><img src="'+featured_image+'" /></a></div><div class="hs-content-title-price-swiper"><div class="hs-title-swiper"><a href="/products/'+item.handle+'" class="hs-product-link-image">'+item.title+'</a></div><div class="hs-content-price-swiper">'+compare_at_price_sw+price_sw+'</div><div class="hs-variants-swipper'+parent_class+'">'+selectCombobox+'</div><div class="hs-upsell-add"><button type="button" class="hs-upsell-add-to-cart"><span class="hs-add--to--cart">'+data.text_add+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw margin-bottom"></i></span></button></div>'+quantity_box+'</div></div></div>')
          }
        });
      if(status_text_slide_cart){
        if(!mode)
        {
         status_text_slide_cart = '<div class="swiper-container '+upsell_class+'">\
          <div class="swiper-wrapper">'+status_text_slide_cart+'</div>\
          <div class="swiper-pagination"></div>\
          <div class="swiper-button-next"></div>\
          <div class="swiper-button-prev"></div>\
          </div>';
        }
      }
      return status_text_slide_cart;
    },
    addstyle:function(data,$){
    var handle = data.stickycart_position,x = '',y = '',distance = data.toppositionwidget+'%';
    var isFirefox = typeof InstallTrigger !== 'undefined';
    $('.hs-sticky-cart-cart-drawer').css('right', '');
    $('.hs-sticky-cart-cart-drawer').css('top', '');
    $('.hs-sticky-cart-cart-drawer').css('right', '');
    $('.hs-sticky-cart-cart-drawer').css('bottom', '');
    $('.hs-sticky-cart-cart-drawer').css('left', '');
    $('.hs-sticky-cart-cart-drawer').css('top', '');
    $('.hs-sticky-cart-cart-drawer').css('left', '');
    $('.hs-sticky-cart-cart-drawer').css('bottom', '');
    if(handle === 'hs-top-right')
    {
      x = 'right';
      y = 'top';
    }
    if(handle === 'hs-bottom-right')
    {
      x = 'right';
      y = 'bottom';
    }
    if(handle === 'hs-top-left')
    {
      x = 'left';
      y = 'top';
    }
    if(handle === 'hs-bottom-left')
    {
      x = 'left';
      y = 'bottom';
    }  
	if(data.status_swatch == 1)
	{
		HsCartDrawer.display_swatch = 'block';
	}
	if(data.variants_options_status == 1)
	{
		HsCartDrawer.display_variant = 'block';
		HsCartDrawer.display_variant_position = 'relative';
	}
	if(data.status == 1)
	{
		HsCartDrawer.display_popup = 'block';
	}
	if(data.add_to_cart_status == 1)
	{
		HsCartDrawer.display_addtocart = 'block';
	}
    if(data.style == 0)
    {
        HsCartDrawer.text_style_active = '.hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {  height: 100%; }.hs-popup-cart-sp-load .hs-site-cart-popup{display:block !important;}.hs-popup-cart-sp-load.active {right: 0px !important;-webkit-transform: none; transform: none;}.hs-site-cart-popup,.hs-popup-cart-sp-load .hs-site-cart-popup form{background:#fff;}.hs-drawer-checkout {width: 100%; z-index: 10; }';
        HsCartDrawer.text_style = 'max-width:440px;top: 0px !important;height: 100%;-ms-overflow-style: none; transition: transform 0.25s ease-in-out;';
    }
    if(data.style == 2)
    {
        HsCartDrawer.text_style_active = '.hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {  height: 100%; }.hs-popup-cart-sp-load .hs-site-cart-popup{display:block !important;}.hs-popup-cart-sp-load.active {right: 0px !important;-webkit-transform: none; transform: none;}.hs-site-cart-popup,.hs-popup-cart-sp-load .hs-site-cart-popup form{background:#fff;}.hs-drawer-checkout {width: 100%; z-index: 10; }';
        HsCartDrawer.text_style = 'max-width:440px;top: 0px !important;height: 100%;-ms-overflow-style: none; transition: transform 0.25s ease-in-out;';
    }
    if(HsCartDrawer.IEdetection(data,$) !== 'Not IE')
    {
 		HsCartDrawer.position_slide_cart = 'relative';
    }
    if(isFirefox){
        HsCartDrawer.position_slide_cart = 'relative';
    }
	HsCartDrawer.style = HsCartDrawer.text_style_active+'.hs-popup-cart-sp-load {\
		display: inline-block;\
		vertical-align: middle;\
		position: '+data.position+';\
		z-index:2147483646 !important;\
		border:0px !important;\
        '+HsCartDrawer.text_style+'\
	}\
	.hs-sticky-cart-cart-drawer {\
		z-index: 2147483645;\
	}\
	@media (max-width: 1600px) {\
		.hs-popup-cart-sp-load {\
			max-width: 440px;\
		}\
	}\
	@media (max-width: 769px) {\
		.hs-popup-cart-sp-load {\
			width:100%;\
		}\
	}';
	if(data.style == 1)
	{
		HsCartDrawer.content_popup = '200px';
		HsCartDrawer.style = '.hs-popup-cart-sp-load {\
		display: inline-block;\
		vertical-align: middle;\
		position: '+data.position+';\
		z-index:2147483646 !important;\
	}\
	.hs-product-content-image-swipper { width: 20%; }\
	.hs-sticky-cart-cart-drawer {\
		z-index: 2147483647;\
	}\
	';	
	}
	HsCartDrawer.css = data.custom_css+HsCartDrawer.style+'s.product-single__price--compare {margin-left: 5px;color: #cc1515;}.grid-popup-cart.col-items {position: relative;width: 100%;}.hs-item-cart-image a:last-child { text-align: center;}.hs-close-popup-cart a img {width: 15px !important; height: 15px !important;min-width: 15px;border: 0px !important;}.jspContainer{overflow:hidden;position:relative;outline: 0;}.jspHorizontalBar,.jspPane,.jspVerticalBar{position:absolute}.jspVerticalBar{top:0;right:0;width:5px;height:100%;background:#3c3c3c}.jspHorizontalBar{bottom:0;left:0;width:100%;height:16px;background:red}.jspCap{display:none}.jspHorizontalBar .jspCap{float:left}.jspTrack{background:#f1f1f1;position:relative}.jspDrag{background:#c1c1c1;position:relative;top:0;left:0;cursor:pointer}.jspHorizontalBar .jspDrag,.jspHorizontalBar .jspTrack{float:left;height:100%}.jspArrow{background:#50506d;text-indent:-20000px;display:block;cursor:pointer;padding:0;margin:0}.jspArrow.jspDisabled{cursor:default;background:#80808d}.jspVerticalBar .jspArrow{height:16px}.jspHorizontalBar .jspArrow{width:16px;float:left;height:100%}.jspVerticalBar .jspArrow:focus{outline:0}.jspCorner{background:#eeeef4;float:left;height:100%}* html .jspCorner{margin:0 -3px 0 0}\
	.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:headShake;animation-name:headShake}@-webkit-keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}@keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{-webkit-animation-name:jello;animation-name:jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipOutY;animation-name:flipOutY}@-webkit-keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}@keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}@keyframes rotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}\
	@font-face{font-family:hs-swiper-icons;src:url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");font-weight:400;font-style:normal}:root{--hs-swiper-theme-color:#007aff}.hs-container-swp .swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.hs-container-swp .swiper-container-vertical>.swiper-wrapper{flex-direction:column}.hs-container-swp .swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.hs-container-swp .swiper-container-android .swiper-slide,.hs-container-swp .swiper-wrapper{transform:translate3d(0,0,0)}.hs-container-swp .swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.hs-container-swp .swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.hs-container-swp .swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.hs-container-swp .swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.hs-container-swp .swiper-slide-invisible-blank{visibility:hidden}.hs-container-swp .swiper-container-autoheight,.hs-container-swp .swiper-container-autoheight .swiper-slide{height:auto}.hs-container-swp .swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.hs-container-swp .swiper-container-3d{perspective:1200px}.hs-container-swp .swiper-container-3d .swiper-cube-shadow,.hs-container-swp .swiper-container-3d .swiper-slide,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top,.hs-container-swp .swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.hs-container-swp .swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.hs-container-swp .swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--hs-swiper-navigation-size:44px}.hs-container-swp .swiper-button-next,.hs-container-swp .swiper-button-prev{position:absolute;top:50%;width:calc(var(--hs-swiper-navigation-size)/ 44 * 27);height:var(--hs-swiper-navigation-size);margin-top:calc(-1 * var(--hs-swiper-navigation-size)/ 2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--hs-swiper-navigation-color,var(--hs-swiper-theme-color))}.hs-container-swp .swiper-button-next.swiper-button-disabled,.hs-container-swp .swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.hs-container-swp .swiper-button-next:after,.hs-container-swp .swiper-button-prev:after{font-family:hs-swiper-icons;font-size:16px;text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:initial}.hs-container-swp .swiper-button-prev,.hs-container-swp .swiper-container-rtl .swiper-button-next{left:-20px;right:auto}.hs-container-swp .swiper-button-next,.hs-container-swp .swiper-container-rtl .swiper-button-prev{right:-20px;left:auto}.hs-container-swp .swiper-button-prev:after,.hs-container-swp .swiper-container-rtl .swiper-button-next:after{content:\'prev\'}.hs-container-swp .swiper-button-next:after,.hs-container-swp .swiper-container-rtl .swiper-button-prev:after{content:\'next\'}.hs-container-swp .swiper-button-next.swiper-button-white,.hs-container-swp .swiper-button-prev.swiper-button-white{--hs-swiper-navigation-color:#ffffff}.hs-container-swp .swiper-button-next.swiper-button-black,.hs-container-swp .swiper-button-prev.swiper-button-black{--hs-swiper-navigation-color:#000000}.hs-container-swp.swiper-button-lock{display:none}.hs-container-swp .swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.hs-container-swp .swiper-pagination.swiper-pagination-hidden{opacity:0}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets,.hs-container-swp .swiper-pagination-custom,.hs-container-swp .swiper-pagination-fraction{bottom:10px;left:0;width:100%}.hs-container-swp .swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.hs-container-swp .swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}.hs-container-swp button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.hs-container-swp .swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.hs-container-swp .swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--hs-swiper-theme-color))}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.hs-container-swp .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.hs-container-swp .swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.hs-container-swp .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--hs-swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.hs-container-swp .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.hs-container-swp .swiper-pagination-white{--swiper-pagination-color:#ffffff}.hs-container-swp .swiper-pagination-black{--swiper-pagination-color:#000000}.hs-container-swp .swiper-pagination-lock{display:none}.hs-container-swp .swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.hs-container-swp .swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.hs-container-swp .swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.hs-container-swp .swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.hs-container-swp .swiper-scrollbar-cursor-drag{cursor:move}.hs-container-swp .swiper-scrollbar-lock{display:none}.hs-container-swp .swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.hs-container-swp .swiper-zoom-container>canvas,.hs-container-swp .swiper-zoom-container>img,.hs-container-swp .swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.hs-container-swp .swiper-slide-zoomed{cursor:move}.hs-container-swp .swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:hs-swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--hs-swiper-preloader-color,var(--hs-swiper-theme-color));border-radius:50%;border-top-color:transparent}.hs-container-swp .swiper-lazy-preloader-white{--hs-swiper-preloader-color:#fff}.hs-container-swp .swiper-lazy-preloader-black{--hs-swiper-preloader-color:#000}@keyframes hs-swiper-preloader-spin{100%{transform:rotate(360deg)}}.hs-container-swp .swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.hs-container-swp .swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.hs-container-swp .swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.hs-container-swp .swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp .swiper-container-fade .swiper-slide-active,.hs-container-swp .swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-cube{overflow:visible}.hs-container-swp .swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.hs-container-swp .swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp .swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.hs-container-swp .swiper-container-cube .swiper-slide-active,.hs-container-swp .swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-cube .swiper-slide-active,.hs-container-swp .swiper-container-cube .swiper-slide-next,.hs-container-swp .swiper-container-cube .swiper-slide-next+.swiper-slide,.hs-container-swp .swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.hs-container-swp .swiper-container-cube .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-left,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-right,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.hs-container-swp .swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.hs-container-swp.swiper-container-flip{overflow:visible}.hs-container-swp .swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.hs-container-swp .swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp.swiper-container-flip .swiper-slide-active,.hs-container-swp.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-flip .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-left,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-right,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}\
	.hs-popup-cart-sp-load{\
    	box-sizing: border-box !important;\
        -webkit-transform: translateX(100%);\
        transform: translateX(100%);\
		right: 0px;\
		width:100%;\
    }\
    body.hs-open-cart .hs-bg-slide-cart {\
    	background: #000;\
        content: "";\
		display:block !important;\
        top: 0;\
        left: 0;\
        right: 0;\
        bottom: 0;\
        position: fixed;\
		visibility: inherit !important;\
		opacity: .6;\
        z-index: 2147483645;\
    }\
    body.hs-open-cart {\
        overflow: hidden !important;\
        position: relative;\
    }\
    .hs-sl-container-cart .hs-close-popup-cart {\
        border: 0px !important;\
    }\
	html.hs-open-drawer{\
        overflow: hidden !important;\
    }\
    .hs-hidden-element {\
        display: none;\
    }\
    .hs-site-cart-popup input {\
      max-width: 100% !important;\
    }\
    .hs--loading i {\
        margin-bottom: 0px !important;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup {\
		background:'+data.background_color+';\
        box-shadow: 0 0 0 1px rgba(39, 44, 48, .05), 0 1px 5px 1px rgba(39, 44, 48, .16);\
        display: -webkit-box;\
        display: flex;\
        display: -webkit-box;\
        display: flex;\
        flex-direction: column;\
        height: 100%;\
        top: 0;\
		bottom: 0;\
        width: 100%;\
        -webkit-box-orient: vertical;\
        -webkit-box-direction: normal;\
        -webkit-transition: 0.4s -webkit-transform;\
	   -webkit-overflow-scrolling: touch;\
        transition: 0.4s -webkit-transform;\
        transition: 0.4s transform;\
        transition: 0.4s transform, 0.4s -webkit-transform;\
		z-index: 2147483646;\
    }\
    .hs-add-discount,.hs-sticky-cart,.hs-content-discounts-calculate-checkout,.hs-content-count-products-clear-all,.hs-cart-note,.hs-drawer-content-checkout {\
        padding: 0px 25px 0 25px;\
    }\
    .hs-rewards-content {\
        padding: 20px 0px;\
    }\
    .hs-content-discounts-calculate-checkout {\
        padding: 0px 25px;\
		border-bottom: 1px solid '+data.cart_border_color+';\
    }\
	.hs-site-cart-popup .hs-dobly-content,.hs-swipper-containter-cart{\
		margin: 0px 25px 0 25px;\
    }\
    .hs-swipper-containter-cart {\
        position: relative;\
    }\
	.hs-site-cart-popup .hs-dobly-content .doubly-message{\
		margin-bottom:20px !important;\
	}\
    .gm-target .hs-content-cart-drawer-loop {\
        display: none !important;\
    }\
    .hs-products-stacked,.hs-products-dynamic-stacked {\
        padding: 0px 25px;\
    }\
    .hs-products-stacked .hs-content-product-slide-cart,.hs-products-dynamic-stacked .hs-content-product-slide-cart {\
		padding: 15px 0;\
        background: transparent !important;\
        box-shadow: none !important;\
		width: 100% !important;\
		margin: 0px !important;\
    }\
    .hs-container-stacked.hs-recommend-products {\
        background: '+data.upsell_content_background+';\
    }\
    .hs-container-dynamic-stacked.hs-cross-sell {\
        background: '+data.upsell_cross_sell_content_background+';\
    }\
    .hs-container-dynamic-stacked.hs-cross-sell .hs-content-product-slide-cart {\
        padding: 15px 0;\
        border-bottom: 1px solid #ffffff;\
        margin: 0;\
        border-radius: 0;\
    }\
    .hs-products-stacked,.hs-products-dynamic-stacked {\
        padding-bottom: 15px;\
    }\
    .hs-products-stacked .swiper-slide:last-child .hs-content-product-slide-cart,.hs-products-dynamic-stacked .swiper-slide:last-child .hs-content-product-slide-cart {\
        border-bottom: 0 !important;\
    }\
    .hs-recommend-products .hs-frequently-bought {\
        background: '+data.upsell_title_background+';\
        color: '+data.upsell_title_color+';\
        padding: 10px;\
        margin-bottom: 20px;\
    }\
    .hs-cross-sell .hs-frequently-bought {\
        background: '+data.upsell_cross_sell_title_background+';\
        color: '+data.upsell_cross_sell_title_color+';\
        padding: 10px;\
        margin-bottom: 20px;\
    }\
    .hs-recommend-products .hs-frequently-bought h2 {\
		color: '+data.upsell_title_color+';\
  		font-size: 14px !important;\
  		margin: 0;\
        text-align: center;\
        text-transform: initial;\
        font-weight: 500 !important;\
        letter-spacing: normal !important;\
        line-height: 14px !important;\
        padding: 0px !important;\
    }\
    .hs-popup-cart-sp-load .fa,.hs-sticky-checkout-bar .fa,.hs-sticky-cart-cart-drawer .fa {\
        display: inline-block !important;\
        font: normal normal normal 14px/1 FontAwesome !important;\
        font-size: inherit !important;\
        text-rendering: auto !important;\
        -webkit-font-smoothing: antialiased !important;\
        -moz-osx-font-smoothing: grayscale !important;\
    }\
    .hs-cross-sell .hs-frequently-bought h2 {\
		color: '+data.upsell_cross_sell_title_color+';\
  		font-size: 14px !important;\
  		margin: 0;\
        text-align: center;\
        text-transform: initial;\
        font-weight: 500 !important;\
        letter-spacing: normal !important;\
        line-height: 14px !important;\
        padding: 0px !important;\
    }\
    .hs-site-cart-popup .hs-sticky-cart svg {\
		vertical-align: inherit;\
		margin: 0 auto;\
    }\
    .hs-recommend-products .hs-products-stacked .swiper-slide .hs-content-product-slide-cart {\
        padding: 15px 0;\
        border-bottom: 1px solid '+data.upsell_content_border+';\
        margin: 0;\
        border-radius: 0;\
    }\
    .hs-cross-sell .hs-products-stacked .swiper-slide .hs-content-product-slide-cart {\
        padding: 15px 0;\
        border-bottom: 1px solid '+data.upsell_cross_sell_content_border+';\
        margin: 0;\
        border-radius: 0;\
    }\
	.shopping-cart-content.show { display: none !important; }\
    .hs-product-link-image, .hs-content-title-price-swiper {\
        display: inline-block;\
        vertical-align: top;\
    }\
    .hs-sticky-checkout-bar {\
        position: fixed;\
        top: 0;\
        left: 0;\
        z-index: 2147483644;\
        width: 100%;\
    }\
    .hs-original-price-total.hs-desktop {\
        display: block !important;\
    }\
	.hs-content-checkout-bar.hs-hidden-select .hs-select-box-load,.hs-content-checkout-bar .hs-hidden-quantity-mobile {\
		display: none !important;\
	}\
	.hs-content-checkout-bar.hs-hidden-select .hs-hidden-quantity-mobile{\
		display: flex !important;\
    }\
	.hs-content-cart-drawer-loop.hs-hidden-quick-buy-button {\
		display: none !important;\
	}\
	.hs-sticky-checkout-bar.hs-show-element{\
        visibility: visible !important;\
        opacity: 1 !important;\
    }\
	.grid-product__meta .hs-content-cart-drawer-loop { display: none; }\
	.hs-sticky-checkout-bar.hs-hide-element{\
      	visibility: hidden !important;\
        opacity: 0 !important;\
		height: 0;\
		overflow: hidden;\
    }\
    .hs-title-swiper {\
        display: block;\
        text-align: center;\
		line-height: 1;\
		font-weight: 600;\
        text-align: left;\
    }\
	.hs-sticky-checkout-bar.hs-desktop-top {\
		box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
    }\
	.hs-sticky-checkout-bar.hs-desktop-top{\
		top:'+data.position_offset_desktop+'px;\
		bottom: inherit;\
    }\
	.hs-sticky-checkout-bar.hs-desktop-bottom{\
		bottom:'+data.position_offset_desktop+'px;\
		top: auto;\
    }\
    .hs-sticky-checkout-bar.hs-desktop-bottom {\
        box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
    }\
    .hs-sticky-checkout-bar.hs-mobile-bottom {\
        box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;\
    }\
    .hs-combobox-option-variant li::before {\
        content: none !important;\
    }\
    .hs-product-price {\
        margin-left: 10px;\
    }\
    .hs-checkout-bar-price span {\
        word-break: normal !important;\
    }\
    .hs-content-checkout-bar .hs-content-image-and-title {\
        vertical-align: middle;\
        height: 57px;\
        -webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: justify;\
        justify-content: space-between;\
        display: flex;\
        flex-direction: row;\
        flex-wrap: nowrap;\
        width: auto;\
        flex: 1 1 auto;\
        overflow: hidden;\
        position: relative;\
    }\
    .hs-content-checkout-bar .hs-bar-content-price {\
    	display: none;\
        -webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: justify;\
        justify-content: space-between;\
    }\
    .hs-content-checkout-bar .hs-select-box-load {\
        position: relative;\
        display: flex;\
        -webkit-box-align: center;\
        align-items: center;\
        max-width: 140px;\
        min-width: 110px;\
		padding-right: 5px;\
        flex: 1 1 auto;\
	}\
    .hs-content-checkout-bar .hs-select-box-load .hs-select-text {\
        display: none;\
    }\
    .hs-content-checkout-bar .hs-content-variant-select-option {\
        margin-bottom: 0rem;\
        display: flex;\
        flex-direction: row;\
        margin-left: 0px;\
        width: auto;\
    	-webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: justify;\
    }\
	.hs-content-checkout-bar .hs-select-option-checkout-bar {\
        -webkit-appearance: none !important;\
        -moz-appearance: none !important;\
        appearance: none !important;\
        background-position: right center !important;\
        background-image: url("//cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/ico-select.svg") !important;\
        background-repeat: no-repeat !important;\
        background-position: right 10px center !important;\
        padding-right: 28px !important;\
        text-indent: 0.01px !important;\
        text-overflow: "" !important;\
        cursor: pointer !important;\
        padding-top: 0px !important;\
        padding-left: 18px !important;\
        padding-bottom: 0px !important;\
		height: 41px !important;\
		margin: 0;\
        appearance: none;\
        width: 100%;\
        text-overflow: ellipsis;\
    }\
    .hs-content-checkout-bar .hs-change-select-option {\
        position: relative;\
        margin-bottom: 0rem;\
        display: flex;\
        flex-direction: row;\
        margin-left: 0px;\
        width: auto;\
    }\
    .hs-content-checkout-bar .hs-image-thumb {\
        display: flex;\
        -webkit-box-align: center;\
        align-items: center;\
        width: 100%;\
        max-width: 100%;\
        flex: 1 1 auto;\
        overflow: hidden;\
    }\
    .hs-content-checkout-bar .hs-content-image-and-title .hs-image-thumb img {\
        margin-right: 10px;\
        max-height: 48px;\
        max-width: 48px;\
    }\
    .hs-content-checkout-bar .hs-sticky-bar-add-to-cart-product-title {\
		cursor: default;\
        text-decoration: none;\
        vertical-align: middle;\
        flex-direction: column;\
        -webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: justify;\
    }\
    .hs-terms-content a {\
        font-weight: 500;\
    }\
    .hs-terms-content a:hover {\
        text-decoration: underline;\
    }\
    .hs-terms-content {\
        font-size: 12px;\
		margin-bottom: 10px;\
    }\
    .hs-terms-content input {\
        vertical-align: middle;\
        margin-right: 5px;\
        -webkit-appearance: checkbox;\
        height: 15px;\
        width: 15px;\
    }\
	.hs-terms-content span {\
    	vertical-align: middle;\
	}\
    .hs-add-to-cart i:before {\
        speak: none;\
        text-decoration: inherit;\
        width: auto;\
        margin-right: auto;\
        text-align: center;\
        font-variant: normal;\
        text-transform: none;\
        line-height: initial;\
    }\
	.hs-item-cart-qty i:before {\
        speak: none;\
        text-decoration: inherit;\
        width: auto;\
        margin-right: auto;\
        text-align: center;\
        font-variant: normal;\
        text-transform: none;\
        line-height: initial;\
    }\
	.hs--loading i:before {\
        speak: none;\
        text-decoration: inherit;\
        width: auto;\
        margin-right: auto;\
        text-align: center;\
        font-variant: normal;\
        text-transform: none;\
        line-height: initial;\
    }\
    .hs-variants-swipper {\
        width: 70%;\
        display: inline-block;\
        vertical-align: middle;\
    }\
    .hs-upsell-add {\
        width: 30%;\
        display: inline-block;\
        vertical-align: middle;\
        text-align: right;\
    }\
    .hs-sticky-checkout-bar .hs-quick-button-quantity {\
		color: #3d4246 !important;\
        position: relative !important;\
        display: inline-block !important;\
        border-radius: 0 !important;\
        padding: 5px !important;\
        width: 60px !important;\
        height: 41px !important;\
        min-height: 41px !important;\
		top: inherit !important;\
    	right: inherit !important;\
		max-width: initial;\
		margin: 0 !important;\
		outline: none;\
    }\
    .hs_discount_response.hs_coupon_popup .icon.icon-saletag {\
        height: 16px;\
    }\
    .hs-progess-content.hs-hidden-percentages .hs-progress-indicator {\
        display: none;\
    }\
    .hs-progess-content.hs-hidden-percentages {\
        margin: 0;\
    }\
    .hs_discount_response.hs_coupon_popup {\
        position: relative;\
        margin: 5px 0px;\
        padding: 10px;\
        background-color: #cdf7cd;\
		color: '+data.cart_color+';\
        text-align: center;\
        font-size: 14px;\
		margin-bottom: 15px;\
    }\
    .hs-content-image-properties img {\
        max-width: 100px !important;\
		margin: 5px 0px;\
    }\
    .hs-close-discount-slide-cart {\
    	display:inline-block;\
        margin-left: 10px;\
    }\
    .hs-close-discount-slide-cart svg {\
        stroke: #7d7d7d;\
        width: 14px;\
        display: inline-block;\
    }\
	.hs-close-discount-slide-cart:hover svg {\
        stroke: #000;\
        width: 14px;\
        display: inline-block;\
    }\
    .hs_coupon_popup:before {\
        content: \'\';\
        display: block;\
        position: absolute;\
        left: 0px;\
        right: 0px;\
        bottom: -10px;\
        transform: rotate(180deg);\
        width: 100%;\
        height: 10px;\
        background: linear-gradient(45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%),linear-gradient(-45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%);\
        background-size: 12px 40px;\
	}\
    .hs-item-cart-qty .hs-loading {\
        min-width: 105px;\
    }\
	.hs_coupon_popup:after {\
      content: \'\';\
      display: block;\
      position: absolute;\
      left: 0px;\
      right: 0px;\
      top: -10px;\
      width: 100%;\
      height: 10px;\
      background: linear-gradient(45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%),linear-gradient(-45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%);\
      background-size: 12px 40px;\
     }\
    .hs-checkout-bar-price,.hs-checkout-bar-compare-at-price{\
        vertical-align: middle;\
        display: flex;\
        flex-direction: row;\
    }\
    .hs-upsell-add-to-cart i {\
        font-size: 14px !important;\
		width: 60px;\
		line-height: 0px;\
		margin: 0 !important;\
    }\
    .hs-checkout-bar-price .hs-money-price ,.hs-checkout-bar-compare-at-price .hs-money-compare-price {\
		color:'+data.sticky_cart_bar_price_color+';\
        margin-left: 10px;\
    }\
    .hs-checkout-bar-compare-at-price {\
        text-decoration: line-through !important;\
        color:'+data.sticky_cart_bar_compare_price_color+';\
    }\
	.hs-checkout-bar-compare-at-price .hs-money-compare-price{\
		color:'+data.sticky_cart_bar_compare_price_color+';\
    }\
    .hs-continue-shopping {\
        position: inherit !important;\
    }\
    .hs-trust-payment {\
		display:none;\
        width: 100%;\
		margin-top:15px;\
		text-align: center;\
    }\
    .hs-trust-payment img {\
        max-width: 250px;\
		max-height: 40px;\
    }\
	.hs-cart-drawer-0 .hs-site-cart-popup form.sn-cart .hs-sticky-cart .hs-item-cart-content .hs-item-content-variants .hs-item-cart-description .hs-product-title {\
		max-width: none;\
	}\
    .hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {\
		background: '+data.sticky_cart_bar_background_color+';\
		display:none;\
        position: absolute;\
        right: 0;\
    }\
	.hs-countdown-cart{\
        background: '+data.countdown_bgcolor+';\
        color: '+data.countdown_fontcolor+';\
        border: 1px solid '+data.countdown_bordercolor+';\
        border-right: 0px;\
        border-left: 0px;\
        font-size: '+data.countdown_fontsize+';\
        text-align: '+data.countdown_align+';\
        font-weight: 500;\
        padding: 10px 25px;\
		line-height: 20px;\
    }\
	.hs-countdown-offer{\
        background: '+data.all_page_countdown_bgcolor+';\
        color: '+data.all_page_countdown_fontcolor+';\
        font-size: '+data.all_page_countdown_fontsize+';\
        text-align: '+data.all_page_countdown_align+';\
        font-weight: bold;\
    }\
    .hs-countdown-slide-cart{\
        color: #504f4f;\
        font-weight: 400;\
        background: var(--countdown-timer-background-color, #fff);\
        padding: 5px 10px;\
        display: inline-block;\
        margin: 5px 6px;\
    }\
    .hs-countdown-offer-mobile {\
        margin-left: 10px;\
    }\
    .hs-content-checkout-bar {\
		box-sizing: border-box;\
        margin: 0 auto;\
        width: 100%;\
        font-size: 18px;\
        line-height: 18px;\
        background: '+data.sticky_cart_bar_background_color+';\
		padding-right: 10px;\
    	padding-left: 10px;\
        display: flex;\
        -webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: justify;\
    }\
    .hs-content-checkout-bar .hs-full-bar-button {\
        margin-left: 10px;\
    }\
	.hs-content-checkout-bar .hs-full-bar-button .hs-checkout-bar-add-to-cart {\
		box-sizing: border-box !important;\
		margin: 0;\
		width: 100%;\
	}\
    .hs-content-checkout-bar .hs-product-review {\
		color:'+data.sticky_cart_bar_product_title_color+';\
        font-size: 14px;\
  		white-space: nowrap;\
  		text-overflow: ellipsis;\
        overflow: hidden;\
    }\
    .hs-content-checkout-bar .hs-thumb-and-title {\
        -webkit-box-pack: justify;\
        display: flex;\
        -webkit-box-align: center;\
        align-items: center;\
        margin-right: 1rem;\
        margin-bottom: 0px;\
        width: auto;\
        flex: 1 1 auto;\
        overflow: hidden;\
    }\
    .hs-content-checkout-bar .hs-bar-content-title {\
        display: flex;\
		width: calc(100% - 60px);\
        flex-direction: column;\
		line-height: 1.4;\
    }\
	.hs--loading {\
        display: none;\
    }\
    .hs-checkout-bar-add-to-cart {\
		position:relative;\
        -moz-user-select: none;\
        -ms-user-select: none;\
        -webkit-user-select: none;\
        user-select: none;\
        -webkit-appearance: none;\
        -moz-appearance: none;\
        appearance: none;\
        display: inline-block;\
        width: auto;\
        text-decoration: none;\
        text-align: center;\
        vertical-align: middle;\
        cursor: pointer;\
        border: 1px solid transparent;\
        border-radius: 2px;\
        padding: 8px 5px;\
        background-color: '+data.sticky_cart_bar_button_color+';\
        color: '+data.sticky_cart_bar_button_text_color+';\
        font-style: normal;\
        font-weight: 500;\
		font-family: \'Josefin Sans\', sans-serif;\
        white-space: normal;\
        font-size: 14px;\
        margin-left: 10px;\
        -webkit-box-pack: center;\
        justify-content: center;\
        white-space: nowrap;\
        user-select: none;\
        overflow: hidden;\
		min-width:120px;\
    }\
	.hs-checkout-bar-add-to-cart[disabled] {\
		opacity:0.5;\
	}\
    .hs-site-cart-popup form .hs-close-popup-cart svg,.hs-site-cart-popup form .hs-content-count-products-clear-all svg,.hs-site-cart-popup form .hs-announcement-module svg,.hs-site-cart-popup form .hs-content-discounts-calculate-checkout svg,.hs-site-cart-popup form .hs-sticky-cart svg,.hs-site-cart-popup form .hs-container-mg-top-up svg,.hs-site-cart-popup form .hs-container-swp svg {\
        width: auto !important;\
        height: auto !important;\
    }\
	.hs-sticky-bar-add-to-cart-product-title .hs-sticky-bar-product-title{\
		color: '+data.sticky_cart_bar_product_title_color+';\
		cursor: pointer;\
		white-space: nowrap;\
    	text-overflow: ellipsis;\
    	overflow: hidden;\
    }\
    .hs-loading-btn .hs-add--to--cart {\
        visibility: hidden;\
        opacity: 0;\
    }\
    .hs-loading-btn .hs--loading {\
        display: block;\
        position: absolute;\
        top: 50%;\
        left: 50%;\
        transform: translate(-50%, -50%);\
    }\
    .hs-popup-cart-sp-load .hs-checkout-purchase .fa {\
        font-size: 21px !important;\
    }\
    .hs-checkout-purchase.hs-loading-btn .hs-add--to--cart {\
        display: none !important;\
    }\
    .hs-checkout-purchase.hs-loading-btn .hs--loading {\
        display: contents !important;\
    }\
    .hs-btn-checkout-bar {\
    	vertical-align: middle;\
        display: flex;\
        flex-direction: row;\
    }\
    .hs-error-code-discount {\
        font-size: 11px;\
        color: red;\
    }\
    .fa-spin {\
      -webkit-animation: fa-spin 0.5s infinite linear !important;\
      animation: fa-spin 0.5s infinite linear !important;\
    }\
    .hs-min-money-cart {\
        width: 100%;\
        display: block;\
        text-align: center;\
        font-weight: 500;\
        font-size: 16px;\
    }\
    .hs-item-cart-image .hs-content-cart-drawer-loop {\
        display: none;\
    }\
    .hs-cart-content-price {\
        display: inline-block;\
        vertical-align: top;\
        position: relative;\
		text-align: right;\
		word-break: break-word;\
		width: 100%;\
    }\
    .hs-price-total {\
        font-size: 14px;\
    }\
    #hs_shipping_progress {\
        width: 100%;\
		border-radius: '+data.rewards_bar_border_radius+';\
        background: '+data.rewards_progress_background_color+';\
    }\
    #hs_shipping_bar {\
		background: '+data.rewards_bar_background_color+';\
		height: 10px;\
    	border-radius: '+data.rewards_bar_border_radius+';\
    }\
	.hs-content-cart-drawer-loop .hs-quick-button-quantity{\
		border: 1px solid '+data.quick_buy_button_background+';\
	}\
    .hs-site-cart-popup .hs-discount-app-cart svg {\
        display: inline-block;\
        width: 14px !important;\
        height: 14px !important;\
        vertical-align: middle;\
        fill: currentColor;\
    }\
    .hs-discount-app-cart {\
        font-size: 14px;\
    }\
    .cart-popup-wrapper.is-transitioning {\
        display: none !important;\
    }\
    .hs-error-code-discount span {\
		display:block;\
        margin-top: 5px;\
		margin-bottom: 10px;\
    }\
    .hs---quantity.hs---buttons_added svg {\
        width: auto !important;\
        height: auto !important;\
    }\
    .hs-content-propertie {\
        font-size: 12px;\
    }\
    .hs-product-content-image-swipper .hs-content-cart-drawer-loop {\
        display: none !important;\
    }\
    .hs-top-left .hs-quick-button-quantity {\
        position: absolute;\
        background: #fff;\
        display: block;\
        z-index: 3;\
        margin: 0;\
        text-align: right;\
    }\
	.hs-content-cart-drawer-loop .hs-top-left .hs-quick-button-quantity{\
		border: 1px solid '+data.quick_buy_button_background+';\
	}\
    .hs-hidden-count-cart{\
    	display:none !important;\
    }\
    .hs-sticky-cart-cart-drawer {\
		cursor:pointer;\
        position: fixed;\
        '+y+': '+distance+';\
        '+x+': 15px;\
    }\
    .hs-item-cart-image .satcb_quick_buy {\
        display: none !important;\
    }\
    .hs-sticky-cart-cart-drawer-content {\
		color:'+data.color_cart_widget+';\
		background: '+data.button_background_color+';\
		font-size:20px;\
        display: block;\
        -webkit-border-radius: 30px !important;\
        -moz-border-radius: 30px !important;\
        border-radius: 30px !important;\
        -webkit-box-shadow: 1px 1px 5px grey !important;\
        -moz-box-shadow: 1px 1px 5px grey !important;\
        box-shadow: 1px 1px 5px grey !important;\
        padding: 10px;\
        width: 30px;\
        height: 30px;\
        margin: 0 auto;\
        line-height: 30px!important;\
        text-align: center;\
        position: relative;\
        box-sizing: content-box !important;\
        z-index: 1;\
    }\
    .hs-sticky-cart-cart-drawer-content i{\
		color:'+data.color_cart_widget+';\
	}\
    .hs-sticky-cart-cart-drawer-content mark {\
		background-color: #FFFFFF;\
		color: #000000;\
        -webkit-border-radius: 20px;\
        -moz-border-radius: 20px;\
        border-radius: 20px;\
        border: 2px solid transparent;\
        width: 20px;\
        height: 20px;\
        position: absolute;\
        top: -5px;\
        left: -10px;\
        font-size: 10px !important;\
        line-height: 20px;\
        font-weight: 700;\
        box-sizing: content-box !important;\
		box-shadow: -1px 0px 3px #707080;\
        padding: 0 !important;\
    }\
   .hs-popup-cart-sp-load .hs-site-cart-popup .hs-close-popup-cart h2 {\
		font-size: 18px !important;\
        margin: 0;\
        font-weight: 600;\
        color: '+data.cart_color+';\
        text-align:center;\
		padding: 0px;\
		border: 0px !important;\
		line-height: 18px !important;\
		text-transform: inherit;\
    	letter-spacing: inherit;\
    }\
	.hs-item-content-variants { letter-spacing: 0 !important; }\
    .hs-discount-heading,.hs-note-heading {\
		color: '+data.cart_color+';\
        font-size: 14px;\
        text-align: left;\
        font-weight: 400;\
        margin: 0;\
        text-transform: inherit;\
        letter-spacing: inherit;\
    }\
    .hs-site-cart-popup .hs-cart-note {\
        border-top: 1px solid '+data.cart_border_color+';\
        font-size: 14px;\
        padding: 20px 25px;\
    }\
    .hs-continue-shopping {\
        line-height: normal;\
        right: auto;\
        top: auto;\
    }\
	.hs-content-discount-add {\
        position: relative;\
    }\
    .hs-item-content-variants .hs-content-cart-drawer-loop {\
      	display: none !important;\
    }\
	.grid-product__meta .hs-content-cart-drawer-loop{\
		display: none !important;\
    }\
    button.hs-apply-discount {\
		cursor:pointer;\
        position: absolute;\
        right: 0;\
        top: 0;\
        margin: 0;\
        font-size: 14px;\
        padding: 10px;\
        text-transform: capitalize;\
        font-weight: 500;\
        width: 30%;\
        height: 40px;\
        line-height: 0px;\
        outline: none;\
        border: '+data.apply_border_size_button+'px;\
		border-style: '+data.apply_border_style_button+';\
        background-color: '+data.apply_background_button+';\
        border-color: '+data.apply_border_color_button+' !important;\
        border-radius: 0px '+data.apply_border_radius_button+'px '+data.apply_border_radius_button+'px 0px !important;\
        color: '+data.apply_color_button+';\
        border-left: 0px;\
    }\
    .hs-cart-ins {\
		line-height: 14px;\
        box-sizing: border-box !important;\
        font-size: 14px;\
        height: 40px;\
        padding: 10px;\
		outline:none;\
        min-height: 60px;\
		resize:none;\
		width: 100%;\
		margin: 0 !important;\
    }\
    button.hs-apply-discount:hover {\
        background-color: '+data.apply_hover_background_color+';\
        border-radius: 0px '+data.apply_border_radius_button+'px '+data.apply_border_radius_button+'px 0px !important;\
        color: '+data.apply_hover_color+';\
    }\
    input.hs-discount-code {\
		border: '+data.apply_border_size_button+'px;\
		border-style: solid;\
        border-radius: '+data.apply_border_radius_button+'px 0px 0px '+data.apply_border_radius_button+'px;\
        border-color: '+data.apply_border_color_button+' !important;\
        box-sizing: border-box !important;\
		color:#000 !important;\
		outline: none;\
        width: 70% !important;\
        padding: 10px 10px 10px 10px;\
        font-size: 14px !important;\
		line-height: 14px;\
        margin: 0;\
		height: 40px !important;\
    }\
    button.hs-apply-discount .hs--loading i {\
        width: 50px;\
        font-size: 14px !important;\
    }\
    button.hs-apply-discount.hs-loading .hs-text--apply--discount {\
        display: none;\
    }\
    button.hs-apply-discount.hs-loading .hs--loading {\
        display: block;\
    }\
    .hs-title-swiper,.hs-price-sw {\
        margin-bottom: 2px;\
    }\
    .hs-empty-page-content.hs-text-center p {\
		color: '+data.cart_color+';\
        margin: 0;\
    }\
    .hs-empty-page-content.hs-text-center .hs-close {\
		float: right;\
    }\
    .hs-container-swp {\
        position: relative;\
    }\
    .hs-content-empty-cart {\
		text-align:center;\
		line-height:50px;\
    }\
    .hs-close {\
        line-height: 0;\
        background: #0000000d;\
        display: flex;\
        -webkit-box-align: center;\
        align-items: center;\
        -webkit-box-pack: center;\
        justify-content: center;\
        background-color: rgba(0,0,0,0.05);\
        -webkit-transition: 0.2s background-color;\
        transition: 0.2s background-color;\
        width: 30px;\
        height: 30px;\
        border-radius: 50%;\
        cursor: pointer;\
    }\
	.hs-content-count,.hs-header-close-empty{\
      display: flex;\
      -webkit-box-align: center;\
      align-items: center;\
      -webkit-box-pack: justify;\
      justify-content: space-between;\
      width: auto;\
    }\
    .hs-header-close-empty {\
        margin: 0px 25px 0 25px;\
    }\
    .hs-close-popup-cart {\
        line-height: 50px;\
    }\
    .hs-site-cart-popup form .XeCartFooterMessage {\
        margin: 0px !important;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup .hs-close-popup-cart .hs-close {\
        line-height: 0px;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup .hs-close-popup-cart{\
		border-bottom: 1px solid '+data.cart_border_color+';\
    }\
	.hs-popup-cart-sp-load.active .hs-site-cart-popup {\
        color: '+data.cart_color+';\
        display: block;\
	}\
    .hs-item-cart-qty img {\
        max-width: 30px !important;\
    }\
    .hs-discount-price-total {\
        font-size: 14px;\
		margin-left: 5px;\
    }\
    .hs-discount-price-line-through {\
        text-decoration: line-through;\
    }\
	.hs-site-cart-popup .swiper-button-prev{\
		background-image: none !important;\
        position: absolute;\
        top: 50%;\
        width: 15px;\
        text-align: center;\
        height: 30px;\
        line-height: 30px;\
        font-size: 16px;\
        z-index: 2;\
        color:'+data.cart_color+';\
        margin-top: -20px;\
        user-select: none;\
        -webkit-user-drag: none;\
    }\
    .hs-site-cart-popup .swiper-button-next {\
		background-image: none !important;\
        position: absolute;\
        top: 50%;\
        width: 15px;\
        text-align: center;\
        height: 30px;\
        line-height: 30px;\
        font-size: 16px;\
        z-index: 2;\
        color:'+data.cart_color+';\
        margin-top: -20px;\
        user-select: none;\
        -webkit-user-drag: none;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart span {\
        font-size: 16px;\
        font-weight: 600;\
        line-height: 16px;\
        text-transform: none;\
    }\
    .hs-popup-cart-sp-load .hs_shipping_amount {\
        float: right;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart .hs_subtotal_amount,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart .hs_subtotal_amount_discount {\
		color: '+data.footer_text_color+';\
        margin: 0;\
        font-weight: 700;\
		font-size: 16px;\
        line-height: 16px;\
		text-align:right;\
		float: right;\
		line-height: 16px;\
    }\
    .hs-payment-discount .hs_subtotal_amount {\
        margin-right: 7px !important;\
        text-decoration: line-through;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form{\
        background: '+data.background_color+';\
        width:100%;\
        position:relative;\
        margin:0px;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {\
        padding: 15px 0px;\
        font-size: 16px;\
        margin: 0px 25px;\
        text-align: center;\
        position: relative;\
	}\
    .hs-content-cart-drawer-loop i {\
        margin: 0;\
    }\
    .hs-sticky-cart-cart-drawer i {\
        margin: 0;\
    }\
    .hs-shipping-taxes {\
		font-size: 14px;\
    	padding: 0px 0px 10px 0px;\
		text-align:center;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart{\
        outline: 0;\
        width:100%;\
        box-sizing: border-box !important;\
        -webkit-overflow-scrolling: auto;\
	}\
    .hs-original-price-total .hs-item-original-line-price {\
        text-decoration: line-through !important;\
        margin-right: 5px;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart img {\
        position:relative;\
        opacity:1;\
        border:0px !important;\
        max-width:100%;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image {\
		display: inline-block;\
    	vertical-align: top;\
		text-align:center;\
		max-width: 75px;\
	}\
    .hs-item-content-variants {\
        display: grid;\
        grid-template-columns: 60px calc(100% - 80px);\
        grid-gap: 20px;\
        align-items: center;\
    }\
    .hs-item-close {\
		display: inline-block;\
		vertical-align: middle;\
      	text-align: left;\
    }\
    .hs-item-cart-description .hs-item-close {\
        position: absolute;\
        right: 0;\
        top: 0;\
    }\
    .hs-remove-item {\
        font-size: 12px;\
    }\
	.hs-remove-item:hover,hs-clear-all-button:hover {\
        text-decoration: underline;\
    }\
    .hs-content-product-slide-cart .hs-content-cart-drawer-loop {\
        display: none;\
    }\
    .hs-compare-price-sw {\
        display: inline-block;\
        vertical-align: middle;\
		margin-right:4px;\
		text-decoration: line-through;\
    }\
    .hs-price-sw {\
        display: inline-block;\
        vertical-align: middle;\
    }\
    .hs-content-price-swiper {\
        display: inline-block;\
        vertical-align: middle;\
        width: 70%;\
    }\
	.hs-variants-swipper.hs-hidden-element{\
		display:none;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image a {\
        display: block;\
        vertical-align:middle;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-image a.hs-remove-item{\
		display:inline-block;\
		vertical-align:middle;\
		cursor:pointer;\
    	color: #3d4245;\
		margin-right:5px;\
    	font-size: 14px;\
    	max-width: 10px;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-image a.hs-remove-item img {\
		width: 12px !important;\
		min-width: 12px;\
		border: 0px !important;\
	}\
    .hs-site-cart-popup form{\
        text-align: left;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty {\
		vertical-align: middle;\
		width: 100%;\
      	position: relative;\
      	display: inline-flex;\
        display: -webkit-flex;\
        display: -moz-flex;\
        display: -ms-flexbox;\
        display: -o-flex;\
        display: flex;\
        -webkit-flex-direction: row;\
        -moz-flex-direction: row;\
        -ms-flex-direction: row;\
        -o-flex-direction: row;\
        flex-direction: row;\
      	-webkit-box-align: center;\
      	align-items: center;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .hs-inc.hs-qtybutton,.hs-inc-upsell.hs-qtybutton-upsell {\
		border-top-right-radius: 2px;\
    	border-bottom-right-radius: 2px;\
		border: 1px solid #ccc !important;\
		color: #000;\
		cursor: pointer;\
      	display: inline-flex;\
        display: -webkit-flex;\
        display: -moz-flex;\
        display: -ms-flexbox;\
        display: -o-flex;\
        display: flex;\
        -webkit-flex-direction: row;\
        -moz-flex-direction: row;\
        -ms-flex-direction: row;\
        -o-flex-direction: row;\
        flex-direction: row;\
        outline: none;\
        margin: 0px;\
        line-height: 30px;\
        font-family: Muli,sans-serif !important;\
  		-webkit-box-align: center;\
  		align-items: center;\
        -webkit-box-pack: center;\
        width: 30px;\
        height: 30px;\
        font-weight: 700;\
        text-align:center;\
        background: transparent;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .hs-dec.hs-qtybutton,.hs-dec-upsell.hs-qtybutton-upsell {\
		border-top-left-radius: 2px;\
        border-bottom-left-radius: 2px;\
		border: 1px solid #ccc !important;\
     	color: #000;\
        cursor: pointer;\
      	display: inline-flex;\
        display: -webkit-flex;\
        display: -moz-flex;\
        display: -ms-flexbox;\
        display: -o-flex;\
        display: flex;\
        -webkit-flex-direction: row;\
        -moz-flex-direction: row;\
        -ms-flex-direction: row;\
        -o-flex-direction: row;\
        flex-direction: row;\
        outline: none;\
        margin: 0px;\
        line-height: 30px;\
        font-family: Muli,sans-serif !important;\
  		-webkit-box-align: center;\
  		align-items: center;\
        -webkit-box-pack: center;\
        width: 30px;\
        height: 30px;\
        font-weight: 700;\
        text-align:center;\
        background: transparent;\
        z-index: 9999;\
	}\
	.hs-dec.hs-qtybutton svg,.hs-inc.hs-qtybutton svg,.hs-inc-upsell.hs-qtybutton-upsell svg,.hs-dec-upsell.hs-qtybutton-upsell svg {\
		margin: 0 auto;\
		vertical-align: inherit;\
    }\
    .hs-qty-upsell {\
        margin-top: 5px;\
    }\
    .hs-cart-plus-minus,.hs-cart-plus-minus-upsell {\
		background: #fff;\
		border-radius: 2px;\
        display: -webkit-inline-box;\
      	display: inline-flex;\
        display: -webkit-flex;\
        display: -moz-flex;\
        display: -ms-flexbox;\
        display: -o-flex;\
        display: flex;\
        -webkit-flex-direction: row;\
        -moz-flex-direction: row;\
        -ms-flex-direction: row;\
        -o-flex-direction: row;\
        flex-direction: row;\
        -webkit-box-align: center;\
        align-items: center;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input,.hs-cart-plus-minus-upsell input {\
		box-shadow: none;\
        text-indent: inherit !important;\
        box-sizing: border-box !important;\
        display: -webkit-inline-box;\
        display: inline-flex;\
        line-height: 30px !important;\
        height: 30px !important;\
        max-height: none;\
        min-height: 0;\
        border: none;\
		font-size:16px;\
        background: transparent;\
        border-top: 1px solid #ccc !important;\
        border-bottom: 1px solid #ccc !important;\
        border-left: 0px !important;\
        border-right: 0px !important;\
        width: 45px !important;\
		min-width: auto !important;\
        text-align: center;\
        color: #000;\
        padding: 0;\
        border-radius: 0;\
        min-height: 0 !important;\
        margin: 0 !important;\
	}\
	.hs-qtybutton svg,.hs-qtybutton-upsell svg{\
		fill:#7d7d7d;\
    }\
	.hs-qtybutton:hover svg,.hs-qtybutton-upsell:hover svg{\
		fill:#000;\
    }\
    .hs-site-cart-popup span:after {\
        content: \'\' !important;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart {\
        -ms-flex-order: 2;\
		order: 2;\
        padding: 10px 0px 10px 0px;\
        background: none;\
        text-transform: uppercase;\
		line-height:0px;\
    }\
    .hs-sub-total-cart.hs-shipping-next span {\
        font-weight: inherit !important;\
    }\
    .hs-content-count.hs-clear-all-hidden.hs-products-count-hidden {\
        display: none;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description {\
        display: inline-block;\
        vertical-align: top;\
        line-height: 16px;\
        font-size: 16px;\
        word-break: break-word;\
        width: 100%;\
		position:relative;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup a:hover{\
		opacity: 1 !important;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description a{\
		color:'+data.cart_color+';\
		text-decoration:none;\
	}\
    .hs-item-cart-description p {\
        color: '+data.text_color+';\
    }\
    .hs-item-cart-description span.hs-price-total, {\
		color: '+data.product_price_color+';\
        display: inline-block;\
		font-size:16px;\
    }\
	.hs-original-price-total{\
		color: '+data.product_price_color+';\
    }\
    .hs-price-total.hs-desktop {\
		color: '+data.product_price_color+';\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description .hs-variant-title {\
		color:'+data.text_color+';\
		display: block;\
        font-size: 14px;\
		margin-top: 5px;\
    }\
	.hs-container-swp,.hs-container-dynamic-stacked{\
    	color:'+data.text_color+';\
    }\
    .hs-content-product-and-variant-title {\
		display: block;\
        font-size: 16px;\
        margin-right: 20px;\
		margin-bottom: 7px;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description .hs-product-title,.hs-title-swiper a {\
		color:'+data.text_color+';\
        font-weight: 600;\
		text-decoration: none;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description .hs-product-title:hover,.hs-title-swiper a:hover {\
		color:'+data.hover_text_color+';\
    }\
	.hs-item-cart-description .hs-content-quantity-price{\
    	margin-top: auto;\
        display: -webkit-box;\
      	display: inline-flex;\
        display: -webkit-flex;\
        display: -moz-flex;\
        display: -ms-flexbox;\
        display: -o-flex;\
        display: flex;\
        -webkit-flex-direction: row;\
        -moz-flex-direction: row;\
        -ms-flex-direction: row;\
        -o-flex-direction: row;\
        flex-direction: row;\
        -webkit-box-pack: justify;\
        justify-content: space-between;\
        -webkit-box-align: center;\
        align-items: center;\
    }\
	.hs-content-product-and-variant-title .hs-product-title:hover{\
		color:'+data.hover_text_color+' !important;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content {\
		border-top: 1px solid '+data.cart_border_color+';\
		font-size:0px;\
        padding: 20px 25px;\
		position:relative;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content:first-child{\
		border-top:0px;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase {\
		width:100%;\
		padding-bottom:15px;\
		box-sizing: border-box !important;\
	}\
	.hs-upsell-add-to-cart,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-checkout-purchase,.hs-apply-discount {\
		cursor:pointer;\
		color: '+data.button_color+';\
		background: '+data.button_background_color+';\
		border-radius: '+data.checkout_border_radius_button+'px;\
		border: '+data.checkout_border_size_button+'px;\
		border-color: '+data.checkout_border_color_button+';\
		border-style: '+data.checkout_border_style_button+';\
		box-sizing: border-box !important;\
		box-shadow: none;\
		display:inline-block;\
		font-weight: 500;\
		padding: 10px;\
		text-align: center;\
		text-decoration: none;\
        font-size: 16px;\
        padding-top: 10px;\
        padding-bottom: 10px;\
		width: 59%;\
    	margin-right: 2%;\
		min-width: auto !important;\
        vertical-align: middle;\
        line-height: 0px;\
        height: 42px;\
		outline: none;\
        overflow: hidden;\
        white-space: nowrap;\
        text-overflow: ellipsis;\
	}\
	body #hs-additional-buttons .shopify-cleanslate ._1n3zwJXRK30xbubjNiZsKV{\
		border-radius: '+data.checkout_border_radius_button+'px !important;\
    }\
	.hs-upsell-add-to-cart:hover,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-checkout-purchase:hover,.hs-apply-discount:hover {\
		background: '+data.button_hover_background_color+';\
		color: '+data.checkout_color_hover_button+';\
		border-color: '+data.checkout_border_color_hover_button+';\
	}\
    .hs-content-checkout-button {\
        display: inline-block;\
        width: 59%;\
        margin-right: 2%;\
    }\
	.hs-content-checkout-button .hs-checkout-purchase{\
        width: 100% !important;\
        margin-right: 0px !important;\
		height: 52px !important;\
    }\
	.hs-finalize-purchase .hs-cart-purchase{\
		height: 52px !important;\
    }\
    .cart-popup-wrapper.cart-popup-wrapper--hidden {\
        display: none !important;\
    }\
    .hs-upsell-add-to-cart {\
		cursor:pointer;\
        width: auto !important;\
        font-size: 12px;\
        margin: 0;\
        padding: 7px 15px;\
		text-transform:capitalize;\
		outline: none;\
		position:relative;\
		line-height: 16px;\
		height: auto !important;\
    }\
    .hs-site-cart-popup div {\
        box-sizing: border-box !important;\
    }\
    .hs-site-cart-popup form {\
        box-sizing: border-box !important;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-cart-purchase {\
		color: '+data.cart_button_color+';\
		background: '+data.cart_button_background_color+';\
		border-radius: '+data.cart_border_radius_button+'px;\
		border: '+data.cart_border_size_button+'px;\
		border-color: '+data.cart_border_color_button+';\
		border-style: '+data.cart_border_style_button+';\
		box-sizing: border-box !important;\
		display:inline-block !important;\
		padding: 10px;\
		text-align: center;\
		text-decoration: none;\
        font-size: 16px;\
		font-weight: 500;\
        padding-top: 10px;\
        padding-bottom: 10px;\
		line-height: 20px;\
		width: 39%;\
		vertical-align: middle;\
		height: 42px;\
		outline: none;\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-cart-purchase:hover {\
		background: '+data.cart_button_hover_background_color+';\
		border-color: '+data.cart_border_color_hover_button+';\
		color: '+data.cart_color_hover_button+';\
	}\
    .hs-finalize-purchase .hs-continue-shopping {\
		background: transparent !important;\
		color: '+data.continue_shopping_color_button+';\
        box-sizing: border-box !important;\
        padding: 10px;\
        text-align: center;\
        text-decoration: none;\
        font-size: 16px;\
        width: 100%;\
        padding: 20px;\
        margin: 0 auto;\
        text-align: center;\
        display: block;\
        text-align: center;\
        display: block;\
        margin-top: 15px;\
		padding: 0px !important;\
		line-height: 20px;\
    }\
	.hs-container-swp .swiper-button-next:focus,.hs-container-swp .swiper-button-prev:focus {\
        outline: none;\
    }\
	.hs-container-swp .swiper-button-next:hover,.hs-container-swp .swiper-button-prev:hover {\
        color: #ccc;\
    }\
	.hs-finalize-purchase .hs-continue-shopping:hover {\
		color: '+data.continue_shopping_color_hover_button+';\
	}\
    .hs-discount-app-cart svg {\
        max-width: 12px !important;\
        max-height: 12px !important;\
    }\
    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a:last-child{\
		margin-bottom:0px;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a:hover{\
		opacity:1;\
	}\
    .hs-add-to-cart span {\
        display: block;\
        background: '+data.quick_buy_button_background+';\
		color: '+data.quick_buy_button_color+';\
        font-size: 20px;\
        line-height: 35px;\
        width: 35px;\
        border-radius: 50%;\
        height: 35px;\
		opacity:.9;\
    }\
    .hs-product-link-image img {\
        max-width: 100%;\
    }\
    .hs-product-content-image-swipper {\
		display: inline-block;\
        max-width: 75px;\
		vertical-align: middle;\
    }\
    .hs-content-count-products-clear-all .hs-content-count {\
        padding: 10px 0px 0px 0px;\
    }\
    .hs-swipper-select-option-add-to-cart {\
        font-size: 14px;\
        padding: 4px 20px 4px 10px;\
        height: 30px !important;\
        -webkit-appearance: none !important;\
        -moz-appearance: none !important;\
        appearance: none !important;\
        background-position: right center !important;\
        background-repeat: no-repeat !important;\
        background-position: right 8px center !important;\
        padding-right: 28px !important;\
        text-indent: 0.01px !important;\
        cursor: pointer !important;\
        padding-top: 0px !important;\
        padding-left: 10px !important;\
        padding-bottom: 0px !important;\
        margin: 0;\
        appearance: none;\
        width: 100%;\
        text-overflow: ellipsis;\
    }\
	.hs-add-to-cart:hover span {\
    	background: '+data.quick_buy_button_background+';\
		opacity:1;\
    }\
    body #hs-additional-buttons .shopify-cleanslate ._3TUeZPsTWjDxakSmeDcA4D,body #hs-additional-buttons .shopify-cleanslate .kEwctmM5pguv6XkPR8mx6, body #hs-additional-buttons .shopify-cleanslate ._2PfRg7DFvcstLFRNRf5W1e {\
        flex-basis: auto !important;\
    	text-align: center !important;\
        height: 45px !important;\
        -webkit-flex-basis: auto !important;\
        -ms-flex-preferred-size:auto !important;\
        margin: 0 5px 5px !important;\
        -webkit-box-flex: 0 !important;\
        -webkit-flex-grow: 0 !important;\
        -ms-flex-positive: 0 !important;\
        flex-grow: 0 !important;\
		width: 100% !important;\
    }\
	body #hs-additional-buttons .shopify-cleanslate ._1axiYDNHVzBHv3h8UhmWtr, body #hs-additional-buttons .shopify-cleanslate .iZJMuEDN4NxKS3mrxcBP9{\
        display: -webkit-box !important;\
        display: -webkit-flex !important;\
        display: -ms-flexbox !important;\
        display: flex !important;\
        -webkit-box-orient: horizontal !important;\
        -webkit-box-direction: normal !important;\
        -webkit-flex-direction: row !important;\
        -ms-flex-direction: row !important;\
        flex-direction: row !important;\
        -webkit-flex-wrap: wrap !important;\
        -ms-flex-wrap: wrap !important;\
        flex-wrap: wrap !important;\
        margin: 0 -5px !important;\
		margin-bottom: -5px !important;\
    }\
    body #hs-additional-buttons .shopify-cleanslate ._2zarRkvJ2j83NID3Q3t0Ix, .shopify-cleanslate ._1M9S34W-UyhhDRRQQiV3RH {\
        border-radius: '+data.checkout_border_radius_button+'px !important;\
        width: 100% !important;\
        height: 45px !important;\
    }\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input:focus,.hs-cart-plus-minus-upsell input {\
		outline: none !important;\
	}\
	.hs-load-ajax-popup-cart,.hs-load-popup-cart-show-products,.hs-load-notify-show {\
		background: rgba(255, 255, 255, 0.50);\
		height: 100%;\
		position: fixed;\
		top: 0px;\
		width: 100%;\
		z-index: 1000000;\
	}\
	.hs-load-notify-show{\
		z-index: 1000001;\
	}\
    #hs-additional-buttons #dynamic-checkout-cart {\
        margin-top: 5px;\
        width: 100%;\
    }\
	.hs-site-cart-popup .currency-converter-cart-note{\
		padding:10px 25px 0 25px !important;\
    }\
	.hs-message-notify-popup-cart {\
		background: '+data.background_color+';\
		color: '+data.cart_color+';\
		box-shadow: 0 0 0 1px rgba(39, 44, 48, .05), 0 1px 5px 1px rgba(39, 44, 48, .16);\
		min-width: 740px;\
		margin: 0 auto;\
		padding: 40px 20px;\
		position: fixed;\
		top: 50%;\
		left: 50%;\
		transform: translate(-50%, -50%);\
		z-index: 2147483647;\
	}\
    .hs-mg-price {\
        margin-top: 5px;\
    }\
	.hs-message-notify-popup-cart .hs-remove-notify {\
		width: 12px;\
		display: block;\
		position: absolute;\
		top: 20px;\
		right: 20px;\
	}\
	.hs-message-notify-popup-cart p{\
		margin:0px;\
		text-align:center;\
		font-weight: 500;\
	}\
	.hs-load-popup-cart-show-products {\
		z-index: 100;\
	}\
    .hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets, .hs-container-swp .swiper-pagination-custom, .hs-container-swp .swiper-pagination-fraction {\
        bottom: 0px;\
    }\
    .hs-container-swp .swiper-pagination-bullet-active, .swiper-pagination-clickable .swiper-pagination-bullet {\
        background: #fff;\
        border: 2px solid rgba(0,0,0,0.5);\
    }\
	.hs-btn-checkout-bar .hs-checkout-bar-price, .hs-btn-checkout-bar .hs-checkout-bar-compare-at-price{\
		line-height: 39px;\
	}\
	.hs-load-ajax-popup-cart svg {\
		position: absolute;\
		top: 50%;\
		left: 50%;\
		transform: translate(-50%, -50%);\
		max-width: 50px;\
	}\
	.hs-load-ajax-popup-cart svg circle {\
		stroke: '+data.load_color+';\
	}\
	.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .transparent-qty {\
		position: absolute;\
		width: 100%;\
		height: 100%;\
		background: rgba(255, 255, 255, 0);\
	}\
    .hs-button-100-w {\
        width: 100% !important;\
        margin: 0px !important;\
    }\
	button.btn.product-form__cart-submit_popup_cart {\
	  width: 100%;\
	  margin: 10px 0px;\
	}\
    .hs-content-cart-drawer-loop {\
        position: relative;\
        z-index: 4;\
        width: 100%;\
		display: block;\
    }\
    .hs-select-text {\
        font-size: 12px;\
    }\
    .hs-announcement.hs-top-4 {\
        margin-top: 4px;\
    }\
    .hs-site-cart-popup form.sn-cart {\
        width: 100%;\
        z-index: 2147483646;\
        -webkit-transition: 0.4s -webkit-transform;\
        transition: 0.4s -webkit-transform;\
        transition: 0.4s transform;\
        transition: 0.4s transform, 0.4s -webkit-transform;\
        display: -webkit-box;\
        display: flex;\
        -webkit-box-orient: vertical;\
        -webkit-box-direction: normal;\
        flex-direction: column;\
		height: 100%;\
		overflow-y: scroll;\
		overflow-x: hidden;\
		-webkit-overflow-scrolling: touch;\
    }\
    .hs-container-mg-top-up {\
        width: 100%;\
        margin-top: auto;\
        position: relative;\
        padding: 0px;\
    }\
    .hs-add-discount {\
		border-top: 1px solid '+data.cart_border_color+';\
        padding: 20px 25px;\
    }\
    .hs-content-cart-drawer-loop .hs-select-box-load select {\
        width: 100%;\
        padding-top: 10px;\
        padding-left: 18px;\
        padding-bottom: 10px;\
        -webkit-appearance: none;\
        -moz-appearance: none;\
        appearance: none;\
        background-position: right center;\
        background-image: url(//cdn.shopify.com/s/files/1/3067/1988/t/10/assets/ico-select.svg?44545);\
        background-repeat: no-repeat;\
        background-position: right 10px center;\
        line-height: 1.2;\
        padding-right: 28px;\
        text-indent: 0.01px;\
        text-overflow: "";\
        cursor: pointer;\
        padding-top: 8px;\
        padding-left: 15px;\
        padding-bottom: 8px;\
    }\
	.hs-content-cart-drawer-loop select:last-child {\
		margin-bottom: 0px\
		margin-top: 0px\
	}\
    .hs-count-products-cart {\
        font-size: 14px;\
    }\
    .hs-clear-all-button {\
		color: '+data.cart_color+';\
        font-size: 14px;\
		text-decoration: none;\
    }\
    .hs-clear-all-button:hover {\
		color: '+data.cart_color+' !important;\
    }\
    .hs-close svg,.hs-remove-item svg,.hs-remove-item svg g {\
		fill:'+data.slide_cart_close_color+' !important;\
    }\
	.hs-close:hover svg,.hs-remove-item:hover svg,.hs-remove-item:hover svg g {\
		fill:'+data.slide_cart_close_hover_color+' !important;\
    }\
	.hs-inc.hs-qtybutton svg g{\
    	fill: #7d7d7d !important;\
    }\
	.hs-inc.hs-qtybutton:hover svg g{\
    	fill: #000 !important;\
    }\
    .hs-product-label {\
        position: absolute;\
        z-index: 1;\
        background: #d2354f;\
        padding: 0 4px 0 8px;\
        color: #fff;\
        font-weight: 500;\
        font-size: 11px;\
        line-height: 20px;\
        white-space: nowrap;\
    }\
    .hs-right-arrow {\
        position: absolute;\
        top: 0;\
        right: -9px;\
        border-left: 9px solid #d2354f;\
        border-top: 10px solid transparent;\
        border-bottom: 10px solid transparent;\
    }\
    .hs---quantity.hs---buttons_added {\
        text-align: left;\
        position: relative;\
        white-space: nowrap;\
        vertical-align: top;\
    }\
    .hs---quantity.hs---buttons_added .hs---minus,.hs---quantity.hs---buttons_added .hs---plus {\
		display: inline-block;\
        padding: 0px 8px !important;\
        background-color: #ffffff;\
        border-radius: 0px !important;\
        border: 1px solid #949494;\
        height: 41px !important;\
		line-height: 41px !important;\
        min-height: auto;\
        cursor: pointer;\
		font-size: inherit !important;\
		box-sizing: border-box !important;\
        line-height: 1;\
        box-shadow: none !important;\
        outline: none !important;\
        letter-spacing: 0;\
    }\
    .hs---quantity .hs-quick-button-quantity2 {\
        color: #000;\
        width: 40px !important;\
        height: 41px !important;\
        padding: 0px !important;\
        text-align: center !important;\
        background-color: transparent !important;\
        border: 0px !important;\
        border-top: 1px solid #949494 !important;\
        border-bottom: 1px solid #949494 !important;\
        border-radius: 0 !important;\
		outline: none;\
		min-height: auto !important;\
    }\
    .hs---quantity.hs---buttons_added input {\
        display: inline-block;\
        margin: 0;\
        vertical-align: top;\
        box-shadow: none;\
    }\
    .hs---quantity.hs---buttons_added .hs---minus {\
        border-right: 0;\
    }\
    .hs---quantity.hs---buttons_added .hs---plus {\
        border-left: 0;\
    }\
    .hs---minus svg,.hs---plus svg {\
        fill: #7d7d7d;\
    }\
    .hs-flag-content {\
        position: absolute;\
        top: 0;\
        left: 0;\
    }\
    .hs-text-free-shipping {\
        font-size: '+data.rewards_font_size+';\
		line-height: '+data.rewards_font_size+';\
        width: 100%;\
        display: block;\
        text-align: center;\
		margin-bottom: 10px;\
    }\
	button.product-form__cart-submit_popup_cart {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_background+';\
		display: '+HsCartDrawer.display_addtocart+' !important;\
		width: 100%;\
		line-height: 1.4;\
		padding-left: 5px;\
		padding-right: 5px;\
		white-space: normal;\
		padding: 10px 18px;\
		border: 0px;\
		margin-top:10px;\
		text-transform:uppercase;\
	}\
	button.product-form__cart-submit_popup_cart:active {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_hover_background+';\
	}\
	button.product-form__cart-submit_popup_cart:focus {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_hover_background+';\
	}\
	button.product-form__cart-submit_popup_cart:focus-within {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_hover_background+';\
	}\
	button.product-form__cart-submit_popup_cart:hover {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_hover_background+';\
	}\
	button.product-form__cart-submit_popup_cart:visited {\
		color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_hover_background+';\
	}\
	button.product-form__cart-submit_popup_cart[disabled] {\
	    color: '+data.add_to_cart_button_color+';\
		background: '+data.add_to_cart_button_background+';\
		cursor: default;\
		opacity: 0.5;\
	}\
	button.product-form__cart-submit_popup_cart:focus {\
	 	outline: none;\
	}\
    .hs-announcement {\
        background: '+data.announcement_background_color+';\
        border: 1px solid '+data.announcement_border_color+';\
        color: '+data.announcement_color+';\
		font-weight:500;\
		font-size: '+data.announcement_fontsize+';\
		line-height: 20px;\
        text-align: '+data.announcement_align+';\
        position: relative;\
        padding: 10px 25px;\
    }\
    .hs-quantity-content-arrows.hs-top-right {\
        position: absolute;\
		top: 4px;\
		right: 4px;\
    }\
    .hs-quantity-content-arrows.hs-top-left {\
        left: 4px !important;\
        position: absolute;\
		top: 4px;\
    }\
    .hs-top-right .hs-add-to-cart {\
        border: 0px;\
        position: absolute;\
        top: 0px;\
        right: 0px;\
        z-index: 4;\
        line-height: 0px;\
        padding: 0px;\
        margin: 0px;\
        outline: none;\
        background: transparent;\
        border-radius: 50%;\
		display: inline-block;\
		width: auto;\
		min-height: auto !important;\
    }\
    .hs-top-left .hs-add-to-cart {\
        border: 0px;\
        position: absolute;\
        top: 0px;\
        left: 0px;\
        z-index: 4;\
        line-height: 0px;\
        padding: 0px;\
        margin: 0px;\
        outline: none;\
        background: transparent;\
        border-radius: 50%;\
		display: inline-block;\
		width: auto;\
		min-height: auto !important;\
    }\
    .hs-quantity-content-arrows {\
        position: relative;\
        display: inline-block;\
		width: 85px;\
    }\
	.hs-success-code-discount{\
		position: relative;\
    }\
    .hs-success-code-discount .hs--content--warning {\
		border: 1px solid #d3e7f5;\
        border-color: #f0e4bc;\
        background-color: #fff8de;\
        position: relative;\
        display: table;\
        opacity: 1;\
        padding: 10px;\
        padding-right: 25px;\
        border-radius: 4px;\
	    margin-bottom: 15px;\
        color: #545454;\
        -webkit-transition: opacity 0.5s ease-in-out;\
        transition: opacity 0.5s ease-in-out;\
    }\
    .hs-success-code-discount .hs--content--success {\
        border: 1px solid '+data.coupon_border_color+';\
        border-color: '+data.coupon_border_color+';\
        background-color: '+data.coupon_background_color+';\
        position: relative;\
        display: table;\
        opacity: 1;\
        padding: 10px;\
        padding-right: 25px;\
        border-radius: 4px;\
	    margin-bottom: 15px;\
        color: #545454;\
        -webkit-transition: opacity 0.5s ease-in-out;\
        transition: opacity 0.5s ease-in-out;\
    }\
    .hs-success-code-discount .hs-close-discount-slide-cart.hs---warging {\
        position: absolute;\
        top: 15px;\
        right: 15px;\
    }\
    .hs-success-code-discount .hs-close-discount-slide-cart.hs---success {\
        position: absolute;\
        top: 15px;\
        right: 15px;\
		line-height: 0;\
    }\
    .notice__text {\
        display: inline-block;\
    }\
    .hs-container-swp .swiper-container {\
        overflow: visible !important;\
    }\
    .hs--content--warning .notice__text {\
		color: #000;\
        display: table-cell;\
        width: 100%;\
		vertical-align: top;\
    }\
    .hs---warning---icon {\
        margin-top: -0.14286em;\
        margin-right: 0.71429em;\
        color: #b88600;\
    }\
    .hs---warning---icon svg {\
        fill: #b88600 !important;\
    }\
    .hs_notice__text {\
        display: inline-block;\
    }\
    .hs--content--success .hs-notice__text {\
		color: #000;\
        display: table-cell;\
        width: 100%;\
		vertical-align: top;\
        margin: 0 !important;\
        padding: 0px !important;\
    }\
    .hs---success---icon {\
        margin-right: 0.71429em;\
        color: #b88600;\
		line-height: 0;\
    }\
    .hs---success---icon svg {\
        fill: '+data.coupon_icon_color+' !important;\
    }\
    .hs--content--success p {\
        margin: 0;\
    }\
    .hs-add-to-cart.hs-top-left {\
        border: 0px;\
        position: absolute;\
        top: 4px;\
        left: 4px;\
        z-index: 4;\
        line-height: 0px;\
        padding: 0px;\
        margin: 0px;\
        outline: none;\
        background: transparent;\
        border-radius: 50%;\
		display: inline-block;\
		width: auto;\
    }\
	.hs-sticky-cart{\
		-webkit-overflow-scrolling: auto;\
    }\
    .hs-sticky-cart::-webkit-scrollbar-track\
    {\
        -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,0.1);\
        background-color: #f5f6f7;\
    }\
    .hs-sticky-cart::-webkit-scrollbar\
    {\
        width: 8px;\
        background-color: #c1c1c1;\
    }\
    .hs-sticky-cart::-webkit-scrollbar-thumb\
    {\
        background-color: #c1c1c1;\
    }\
	.hs-combobox-option-variant{\
		-webkit-overflow-scrolling: auto;\
    }\
    .hs-combobox-option-variant::-webkit-scrollbar-track\
    {\
        -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,0.1);\
        background-color: #f5f6f7;\
    }\
    .hs-combobox-option-variant::-webkit-scrollbar\
    {\
        width: 8px;\
        background-color: #c1c1c1;\
    }\
    .hs-combobox-option-variant::-webkit-scrollbar-thumb\
    {\
        background-color: #c1c1c1;\
    }\
    .hs-loading {\
        width: 100%;\
        height: 30px;\
        line-height: 30px;\
        text-align: center;\
    }\
    .hs-mobile{\
    	display:none !important;\
    }\
	.fa-2x {\
		font-size: 1.5em !important;\
	}\
    .hs-desktop{\
    	display:inline-block !important;\
    }\
    ul.hs-combobox-option-variant.hs-top-left {\
        left: 0;\
    }\
    ul.hs-combobox-option-variant.hs-top-right {\
        right: 0;\
    }\
    .farm-quantity-button {\
        line-height: 0;\
    }\
    input.hs-quick-button-quantity[type=number]::-webkit-inner-spin-button,input.hs-quick-button-quantity[type=number]::-webkit-outer-spin-button {\
       opacity: 1;\
    }\
    .hs-combobox-option-variant {\
		display:none;\
        position: absolute;\
        top: 45px;\
        z-index: 100;\
        width: 90%;\
        font-size: 13px;\
        overflow: hidden;\
		overflow-y: auto;\
        list-style: none;\
        text-align: center;\
		opacity:.9;\
		margin:0px;\
    }\
	.hs-combobox-option-variant:hover {\
		opacity:1;\
	}\
	.hs-combobox-option-variant.active {\
		display:block !important;\
	}\
    .hs-combobox-option-variant li {\
		display: block;\
        background: #eee;\
        color: #000;\
        padding: 5px;\
        margin: 0;\
        border-bottom: 1px solid #ddd;\
        line-height: 1;\
		cursor: pointer;\
    }\
	.hs-combobox-option-variant li:hover {\
		opacity:.9;\
	}\
	.hs-item-cart-content-quantity,.hs-item-cart-content-quantity-upsell {\
		display: inline-block;\
		width: auto;\
		vertical-align: middle;\
	}\
	.hs-sticky-bar-add-to-cart-product-title {\
		 text-decoration: none;\
	}\
	.hs-sticky-checkout-bar.hs-sticky---bar---1 {\
		z-index: 2147483646;\
	}\
    .hs-recommend-products .hs-content-product-slide-cart {\
		font-size:14px;\
        background: '+data.upsell_content_background+';\
        padding: 15px;\
        border-radius: 10px;\
        box-shadow: 2px 2px 6px #ebe4e4;\
		width: 99%;\
		margin-bottom: 20px;\
		text-align: left;\
		position:relative;\
        display: grid;\
        grid-template-columns: 60px calc(100% - 70px);\
        grid-gap: 10px;\
        align-items: center;\
        align-content: center;\
    }\
    .hs-cross-sell .hs-content-product-slide-cart {\
		font-size:14px;\
        background: '+data.upsell_cross_sell_content_background+';\
        padding: 15px;\
        border-radius: 10px;\
        box-shadow: 2px 2px 6px #ebe4e4;\
		width: 99%;\
		margin-bottom: 20px;\
		text-align: left;\
		position:relative;\
        display: grid;\
        grid-template-columns: 60px calc(100% - 70px);\
        grid-gap: 10px;\
        align-items: center;\
        align-content: center;\
    }\
    .hs-site-cart-popup .hs-sticky-cart {\
        padding: 0;\
    }\
	.hs-upsell-add-to-cart svg {\
        margin-right: 5px;\
    }\
    .hs-content-title-price-swiper {\
        width: 100%;\
        display:inline-block;\
        vertical-align: middle;\
    }\
	.hs-drawer-checkout{\
		box-sizing: border-box !important;\
		display: block;\
        position: '+HsCartDrawer.position_slide_cart+';\
        bottom: 0;\
        z-index: 9999;\
	}\
	body .hs-drawer-content-checkout{\
		color:'+data.footer_text_color+';\
		padding-top: 5px;\
		background:'+data.slide_cart_checkout_background+';\
		border-top: 1px solid rgba(0,0,0,0.05);\
		display: block;\
    	width: 100%;\
    }\
	body .hs-drawer-content-checkout a{\
    	color:'+data.footer_text_color+';\
    }\
	body .hs-drawer-content-checkout a:hover{\
    	color:'+data.footer_text_color+';\
    }\
	body .hs-recommend-products .hs-content-title-price-swiper{\
		color:'+data.upsell_content_color+';\
    }\
	body .hs-cross-sell .hs-content-title-price-swiper{\
		color:'+data.upsell_cross_sell_content_color+';\
    }\
	.hs-progess-content{\
        margin: 0 auto 25px;\
        position: relative;\
        width: 100%;\
    }\
    .hs-progess-content .hs-progress-indicator {\
		color:'+data.rewards_bar_color+';\
		font-size: 12px;\
		font-weight: 700;\
        position: absolute;\
        top: 100%;\
        text-transform: uppercase;\
        text-align: center;\
    }\
    .hs-progess-content .hs-progress-indicator:before {\
        display: block;\
        height: 5px;\
        width: 1px;\
        background: #ccc;\
        margin: 0 auto;\
        content: "";\
    }\
    .hs-container-swp .swiper-slide.swiper-slide-active {\
        width: 100% !important;\
    }\
    .hs-progess-content .hs-progress-indicator:first-of-type {\
        left: 1px;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator:nth-of-type(2) {\
        left: 25%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator:nth-of-type(3) {\
        left: 50%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator:nth-of-type(4) {\
        left: 75%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator:nth-of-type(5) {\
		right: 1px;\
    	transform: translateX(50%);\
    }\
    .hs-progess-content .hs-progress-indicator.hs-progress-price:first-of-type {\
        left: 1px;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(2) {\
        left: 25%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(3) {\
        left: 50%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(4) {\
        left: 75%;\
        transform: translateX(-50%);\
    }\
    .hs-progess-content .hs-progress-indicator.hs-progress-price:nth-of-type(5) {\
		right: 1px;\
    	transform: translateX(50%);\
    }\
	.hs-popup-cart-sp-load.hs-cart-drawer-0{\
    	display:none;\
    }\
    .hs-open-cart .hs-popup-cart-sp-load.hs-cart-drawer-0 {\
        display: block;\
        position: fixed;\
        top: 6% !important;\
        bottom: 6%;\
        height: 88%;\
        left: 50%;\
        max-width: 800px;\
        width: auto;\
        -webkit-transform: translateX(-50%);\
        -moz-transform: translateX(-50%);\
        -ms-transform: translateX(-50%);\
        -o-transform: translateX(-50%);\
        transform: translateX(-50%);\
    }\
    .hs-content-cart-drawer-loop .hs-top-right .hs-quick-button-quantity {\
        background: #fff;\
        width: 85px;\
        height: 35px;\
        min-height: 35px;\
        display: block;\
        z-index: 3;\
        border-radius: 17px;\
        padding: 7px 35px 7px 5px;\
        margin: 0;\
        text-align: right;\
        color: #a0a0a0;\
		outline: none;\
    }\
    .farm-quantity-nav {\
  		display: none;\
        position: absolute;\
        top: 0;\
    }\
    .hs-content-cart-drawer-loop .hs-top-left .hs-quick-button-quantity {\
        background: #fff;\
        width: 85px;\
        height: 35px;\
        min-height: 35px;\
        display: block;\
        z-index: 3;\
        border-radius: 17px;\
        padding: 7px 5px 7px 35px;\
        margin: 0;\
        text-align: right;\
        color: #a0a0a0;\
    }\
	.hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart{\
		display:none;\
    }\
	.hs-sticky-cart-cart-drawer.hs-hidden-devices-count-cart{\
		display:block;\
    }\
	.hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart.hs-hidden-devices-count-cart{\
		display:none;\
    }\
    .hs-site-cart-popup form .hs-item-cart-content-quantity .hs-cart-plus-minus svg,.hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content svg {\
        width: 10px !important;\
        height: 10px !important;\
    }\
    .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-discount-app-cart svg {\
        width: 15px !important;\
        height: 15px !important;\
    }\
	.hs-site-cart-popup form .hs-close svg{\
        width: 12px !important;\
        height: 12px !important;\
    }\
	.hs-content-checkout-bar .hs-bar-content-image {\
        line-height: 0;\
    }\
	@media (max-width: 1600px) {\
      .hs-content-product-slide-cart {\
          width: 99%;\
      }\
    }\
	@media (max-width: 1024px) {\
      .hs-countdown-offer {\
          font-size: 16px;\
      }\
	}\
	@media (max-width: 769px) {\
        .hs-sticky-cart, .hs-content-discounts-calculate-checkout, .hs-drawer-content-checkout {\
            padding: 0px 20px 0 20px;\
        }\
        .hs-header-close-empty, .hs-site-cart-popup .hs-dobly-content, .hs-swipper-containter-cart {\
            margin: 0px 20px 0 20px;\
        }\
        .hs-countdown-cart {\
            padding: 10px 20px;\
        }\
        .hs-content-discounts-calculate-checkout {\
            padding: 0px 20px;\
        }\
        .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content {\
            padding: 20px 20px;\
        }\
        .hs-products-stacked, .hs-products-dynamic-stacked {\
            padding: 0px 20px;\
        }\
        .hs-cart-note {\
            padding: 20px 20px;\
        }\
        .hs-add-discount {\
            padding: 20px 20px;\
        }\
        .hs-content-checkout-bar{\
            font-size: 16px;\
            line-height: 16px;\
        	-webkit-box-align: center;\
            align-items: center;\
            -webkit-box-pack: justify;\
            justify-content: space-between;\
            display: flex;\
            flex-direction: row;\
			padding: 0px;\
            flex-wrap: wrap;\
            width: 100%;\
            flex: 1 1 auto;\
            overflow: hidden;\
        }\
		.hs-content-checkout-bar.hs-hidden-select .hs-change-select-option .hs-content-quantity {\
        	display: none !important;\
    	}\
    	.hs-content-checkout-bar .hs-checkout-bar-add-to-cart{\
			font-size: 16px;\
			height:52px !important;\
        }\
		.hs-content-checkout-bar .hs-bar-content-price {\
    		display: flex;\
		}\
        .hs-content-checkout-bar .hs-thumb-and-title {\
            margin-right: 0px;\
        }\
        .hs-content-checkout-bar .hs-change-select-option{\
        	width: calc(100% + 1.1rem);\
        }\
        .hs-content-checkout-bar .hs-content-image-and-title {\
			line-height: 0;\
            height: auto;\
            margin-bottom: 5px;\
			padding: 5px 5px 0px 5px;\
			vertical-align: middle;\
        }\
        .hs-content-checkout-bar .hs-content-image-and-title.hs-bar-hidden-button {\
            margin-bottom: 5px;\
            line-height: 0;\
        }\
        .hs-content-checkout-bar .hs-select-box-load {\
            position: relative;\
            display: flex;\
            -webkit-box-align: center;\
            align-items: center;\
			max-width: initial;\
			min-width: 70px;\
            padding-right: 0px;\
            flex: 1 1 auto;\
        }\
        .hs-content-checkout-bar .hs-select-option-checkout-bar {\
            padding-right: 25px !important;\
            padding-left: 10px !important;\
        }\
        .hs-success-code-discount .hs--content--warning {\
            padding-right: 20px;\
        }\
        .hs-success-code-discount .hs--content--success {\
            padding-right: 20px;\
        }\
        .hs-content-checkout-bar .hs-content-variant-select-option {\
            -webkit-box-align: center;\
            align-items: center;\
            -webkit-box-pack: justify;\
            justify-content: space-between;\
            display: flex;\
            flex-direction: row;\
            flex-wrap: wrap;\
            width: 100%;\
            flex: 1 1 auto;\
            overflow: hidden;\
        }\
		.hs-content-checkout-bar .hs-select-box-load {\
        	margin-bottom: 5px;\
    	}\
        .hs-content-checkout-bar .hs-change-select-option .hs-content-quantity {\
            margin-bottom: 5px;\
        }\
        .hs-content-checkout-bar .hs-full-bar-button {\
            margin-left: 0px;\
        }\
    	.hs-content-checkout-bar .hs-content-image-and-title {\
          	width: 100%;\
    	}\
        .hs-content-checkout-bar.hs-hidden-header .hs-content-image-and-title {\
            display: none;\
        }\
        .hs-content-variant-select-option {\
            width: 100%;\
        }\
        .hs-countdown-offer {\
            font-size: 14px;\
        }\
        .hs-sticky-cart-cart-drawer.hs-hidden-desktop-count-cart{\
            display:block;\
        }\
        .hs-sticky-cart-cart-drawer.hs-hidden-devices-count-cart{\
            display:none;\
        }\
        .hs-btn-checkout-bar .hs-checkout-bar-price .hs-money-price {\
            margin: 0;\
            margin-right: 10px;\
        }\
        .hs-change-select-option {\
            padding-right: 0px;\
        }\
        .hs-full-bar-button button {\
            margin: 8px 0;\
        }\
        .hs-full-bar-button {\
            align-items: center;\
            flex-direction: row;\
            width: 100%;\
			margin-left:0px;\
        }\
		.hs-sticky-checkout-bar.hs-sticky---bar---1 {\
			z-index: 2147483644;\
		}\
		.hs-popup-cart-sp-load .hs-site-cart-popup {\
			height: 100%;\
		}\
		.hs-popup-cart-sp-load.hs-cart-drawer-1 {\
			display:none;\
			width: 100%;\
			height: 100%;\
			left: 0px !important;\
			right: auto !important;\
			top: 0px !important;\
		}\
		.hs-popup-cart-sp-load.hs-cart-drawer-1 .hs-drawer-checkout {\
			width: 100%;\
			z-index: 10;\
		}\
		.hs-popup-cart-sp-load.hs-cart-drawer-1.active {\
			display:block;\
		}\
		.hs-full-bar-button.hs-bar-button-mobile {\
			display: flex !important;\
		}\
		.hs-content-variant-select-option .hs-checkout-bar-compare-at-price, .hs-content-variant-select-option .hs-checkout-bar-price{\
			display:none !important;\
		}\
        .hs-sticky-checkout-bar.hs-mobile-top{\
            top:'+data.position_offset_mobile+'px;\
			bottom: auto;\
        }\
        .hs-sticky-checkout-bar.hs-mobile-bottom{\
            bottom:'+data.position_offset_mobile+'px;\
          	top: auto;\
        }\
		button.product-form__cart-submit_popup_cart {\
			color: '+data.add_to_cart_button_color+';\
			background: '+data.add_to_cart_button_background+';\
			width: 100%;\
			line-height: 1.4;\
			padding-left: 0px;\
			padding-right: 0px;\
			white-space: normal;\
			padding: 10px 10px;\
			border: 0px;\
			margin-top: 10px;\
			text-transform: uppercase;\
		}\
		.hs-popup-cart-sp-load {\
			z-index: 2147483647 !important;\
		}\
	}\
    @media (max-width: 750px) {\
        .hs-upsell-add-to-cart,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-checkout-purchase,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-cart-purchase {\
            height: 54px;\
        }\
        body #hs-additional-buttons .shopify-cleanslate ._3TUeZPsTWjDxakSmeDcA4D, body #hs-additional-buttons .shopify-cleanslate .kEwctmM5pguv6XkPR8mx6, body #hs-additional-buttons .shopify-cleanslate ._2PfRg7DFvcstLFRNRf5W1e {\
            height: 54px !important;\
        }\
    }\
	@media (max-width: 600px) {\
		.hs-countdown-offer-mobile {\
            display: block;\
            margin: 0 auto;\
        }\
        .hs-popup-cart-sp-load.hs-cart-drawer-1 {\
            left: auto !important;\
        }\
		.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image a {\
    		display: block;\
    		vertical-align: middle;\
		}\
		.hs-popup-cart-sp-load.hs-cart-drawer-1.hs-mobile-content-cart{\
			width: 100% !important;\
    	}\
	}\
	@media (max-width: 480px) {\
      .hs-content-price-swiper {\
          width: 60%;\
      }\
      .hs-upsell-add {\
          width: 40%;\
      }\
    .hs-variants-swipper {\
        width: 60%;\
    }\
      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description {\
          line-height: 14px;\
          font-size: 14px;\
      }\
      .hs-announcement,.hs-countdown-cart {\
          font-size: 14px;\
      }\
      input.hs-discount-code {\
          width: 60% !important;\
      }\
      button.hs-apply-discount {\
          width: 40%;\
  	  }\
      .hs-swipper-select-option-add-to-cart {\
          max-width: 95%;\
      }\
      .hs-popup-cart-sp-load .hs-site-cart-popup h2 {\
      	font-size: 14px !important;\
      }\
      .hs-popup-cart-sp-load{\
        width: 100% !important;\
        min-width: auto;\
        max-width: initial;\
        height: 100%;\
        right: -90% !important;\
      }\
	}\
	@media (max-width: 400px) {\
	  .hs-original-price-total .hs-item-original-line-price{\
		  display:block;\
          text-decoration: line-through !important;\
          margin-right: 0px;\
      }\
      .hs-content-product-and-variant-title {\
          display: block;\
          margin-right: 0px;\
      }\
      .hs-content-product-and-variant-title {\
          font-size: 14px;\
      }\
      .hs-item-cart-description .hs-variant-title {\
          font-size: 12px;\
      }\
	  .hs-content-product-and-variant-title {\
		  margin-right: 10px;\
      }\
	}\
    @media (max-width: 380px) {\
      .hs-item-cart-qty .hs-loading {\
          min-width: 95px;\
      }\
	  .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input{\
		  width: 35px !important;\
      }\
      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty,.hs-item-cart-qty-upsell {\
          width: 100%;\
      }\
    }',
    $('head').append('<style type="text/css">'+HsCartDrawer.css+'</style>');
	},
    IEdetection:function(data,$) { 
      var ua = window.navigator.userAgent; 
      var msie = ua.indexOf('MSIE '); 
      if (msie > 0) { 
        // IE 10 or older, return version number 
        return ('IE ' + parseInt(ua.substring( 
        msie + 5, ua.indexOf('.', msie)), 10)); 
      } 
      var trident = ua.indexOf('Trident/'); 
      if (trident > 0) { 
        // IE 11, return version number 
        var rv = ua.indexOf('rv:'); 
        return ('IE ' + parseInt(ua.substring( 
          rv + 3, ua.indexOf('.', rv)), 10)); 
      } 
      var edge = ua.indexOf('Edge/'); 
      if (edge > 0) { 
        //Edge (IE 12+), return version number 
        return ('IE ' + parseInt(ua.substring( 
          edge + 5, ua.indexOf('.', edge)), 10)); 
      } 
      // User uses other browser 
      return ('Not IE'); 
    },
	plusMin:function(data,$){
	/*----- cart-plus-minus-button -----*/	
        $(".hs-cart-plus-minus").each(function(e){
          $(this).html('<div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="'+$(this).data('quantity')+'" data-id="'+$(this).data('id')+'" data-key="'+$(this).data('key')+'" data-line="'+$(this).data('line')+'"><div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div>');
        });
		$(".hs-qtybutton").unbind('click');
      	$(".hs-qtybutton").click(function(e){
			var arr_variants = [],
                $button = $(this),
                newVal = 0,
                load = '',
                parent = $button.closest('.hs-item-cart-qty'),
                oldValue = $button.closest('.hs-item-cart-qty').find('input').val(),
                id = $button.closest('.hs-item-cart-qty').find('input').data('id'),
                line = $button.closest('.hs-item-cart-qty').find('input').data('line'),
                key = $button.closest('.hs-item-cart-qty').find('input').data('key');
			if ($button.hasClass('hs-inc')) {
				newVal = parseFloat(oldValue) + 1;
			} else {
              // Don't allow decrementing below zero
              if (oldValue > 0) {
                  newVal = parseFloat(oldValue) - 1;
              } else {
                  newVal = 0;
              }
			}
            load = '<div class="hs-cart-plus-minus" data-quantity="'+newVal+'" data-id="'+id+'" data-key="'+key+'" data-line="'+line+'"><div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="'+newVal+'" data-id="'+id+'" data-key="'+key+'" data-line="'+line+'"><div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>';
			$button.parent().find("input").val(newVal);
            arr_variants = { line: line, quantity: newVal };
          	HsCartDrawer.onloadAjaxCart(parent,load,arr_variants,data,$);
		});
	},  
	removeItemCart:function(data,$){
		var arr = [];
		$('.hs-remove-item').unbind('click');
		$('.hs-remove-item').click(function(e){
          	var arr_variants = [],$button = $(this),id = $button.data('id'),key = $button.data('key'),line = $button.data('line'),qty = 0,load='<div class="hs-loading"><span><i class="fa fa-refresh fa-spin fa-2x fa-fw"></i></span></div>',parent = $button;
            $button.closest('.hs-item-cart-content').remove();
            arr_variants = { line: line, quantity: qty };
          	HsCartDrawer.onloadAjaxCart(parent,load,arr_variants,data,$);
		});
	},
    changeQuantityCart:function(data,$){
      $('.hs-item-cart-qty .hs-cart-plus-minus input').unbind('keyup');
      $('.hs-item-cart-qty .hs-cart-plus-minus input').keyup(function(e){
        e.preventDefault();
        this.value = this.value.replace(/[^0-9\.]/g,'');
        if(!this.value)
        {
          this.value = 1;
        }
        if(this.value == 0)
        {
          this.value = 1;
        }
        var where = $(this),value = this.value;
        delay(function(){
          if(value === '')
          {
            value = 1;
          }
          where.closest('.hs-item-cart-qty').html('<div class="hs-loading"><span><i class="fa fa-refresh fa-spin fa-2x fa-fw"></i></span></div>');
          var arr_variants = [],id = where.data('id'),key = where.data('key'),line = where.data('line'),qty = value,load='<div class="hs-cart-plus-minus" data-quantity="'+value+'" data-id="'+id+'" data-key="'+key+'" data-line="'+line+'"><div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="'+value+'" data-id="'+id+'" data-key="'+key+'" data-line="'+line+'"><div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>',parent = $('.hs-item-'+id);
          arr_variants = { line: line, quantity: qty };
          HsCartDrawer.onloadAjaxCart(parent,load,arr_variants,data,$);
        }, 400 );
      });
      $('textarea.hs-cart-ins').unbind('keyup');
      $('textarea.hs-cart-ins').keyup(function(e){
        e.preventDefault();
        var where = $(this),value = this.value;
        delay(function(){
          HsCartDrawer.UpdateNote(value,data,$);
        }, 400 );
      });
      
    },
    onloadAjaxCart:function($button,load,arr_variants,data,$){
      HsCartDrawer.notifyHide(data,$);
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        async:false,
        data: arr_variants,
        success: function(response) {
          if(typeof window.BOLD !== 'undefined'
             && typeof window.BOLD.common !== 'undefined'
             && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            // NOTE: "cart" should be the variable containing the cart json data
            response = window.BOLD.common.cartDoctor.fix(response);
          }
          HsCartDrawer.cart2(response,data,$);
          HsCartDrawer.countCart(response,data,$);
          HsCartDrawer.priceCart(response,data,$);
          HsCartDrawer.currencyConverter(data,$);
          HsCartDrawer.hideCartPopup(data,$);
        },
		error: function(e,b,c){
			//error
		},
        complete:function(e){
          HsCartDrawer.plusMin(data,$);
          HsCartDrawer.removeItemCart(data,$);
          HsCartDrawer.positionPopup(data,$);
          HsCartDrawer.hideCartPopup(data,$);
          HsCartDrawer.changeQuantityCart(data,$);
          HsCartDrawer.clearALL(data,$);
          HsCartDrawer.resizeDesktopAndMobile(data,$);
          HsCartDrawer.startDiscount(data,$);
        }
      });
    },
    UpdateNote:function(note,data,$){
      $.ajax({
        type: 'POST',
        url : '/cart/update.js',
        dataType: 'json',
        async:true,
        data : { note:note },
        success: function(response){
        },
        error: function(e,b,c){
        },
        complete:function(e){
        }
      });
    },
    onloadHtml:function($button,load,data,$){
      $button.html(load);
    },
  	updateRewardsCart:function(data,$){
      	var d = new Date(), n = d.getTime();
        if(!parseInt(data.enable_app))
        {
          return false;
        }
		$.ajax({
			type: 'GET',
			url : '/cart.js?_=57892_'+n,
			dataType: 'json',
			async:true,
			success: function(response){
                if(typeof window.BOLD !== 'undefined'
                   && typeof window.BOLD.common !== 'undefined'
                   && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                  // NOTE: "cart" should be the variable containing the cart json data
                  response = window.BOLD.common.cartDoctor.fix(response);
                }
                HsCartDrawer.priceCart(response,data,$);
			},
			error: function(e){
				//console.log(e);
			},
			complete:function(){
			}
		});
	},
	getCart:function(w,e,data,$){
      	var d = new Date(), n = d.getTime();
        if(!parseInt(data.enable_app))
        {
          return false;
        }
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'GET',
			url : '/cart.js?_=57892_'+n,
			dataType: 'json',
			async:true,
			success: function(response){
                if(typeof window.BOLD !== 'undefined'
                   && typeof window.BOLD.common !== 'undefined'
                   && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                  // NOTE: "cart" should be the variable containing the cart json data
                  response = window.BOLD.common.cartDoctor.fix(response);
                }
              	HsCartDrawer.cart(response,data,$);
                HsCartDrawer.countCart(response,data,$);
                HsCartDrawer.priceCart(response,data,$);
              	HsCartDrawer.currencyConverter(data,$);
                if(w > 0)
                {
                  HsCartDrawer.showCartPopup(data,$);
                }
                HsCartDrawer.hideCartPopup(data,$);
			},
			error: function(e){
				//console.log(e);
			},
			complete:function(){
				HsCartDrawer.plusMin(data,$);
				HsCartDrawer.removeItemCart(data,$);
				HsCartDrawer.positionPopup(data,$);
                HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
                HsCartDrawer.clearALL(data,$);
              	HsCartDrawer.resizeDesktopAndMobile(data,$);
              	HsCartDrawer.startDiscount(data,$);
                HsCartDrawer.swiperHSCart(data,$);
                HsCartDrawer.upsellVariants(data,$);
                HsCartDrawer.addToCartFreeShipping(data,$);
			}
		});
	},
  	getCart2:function(w,e,data,$){
      	var d = new Date(), n = d.getTime();
        if(!parseInt(data.enable_app))
        {
          return false;
        }
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'GET',
			url : '/cart.js?_=57892_'+n,
			dataType: 'json',
			async:true,
			success: function(response){
                if(typeof window.BOLD !== 'undefined'
                   && typeof window.BOLD.common !== 'undefined'
                   && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                  // NOTE: "cart" should be the variable containing the cart json data
                  response = window.BOLD.common.cartDoctor.fix(response);
                }
              	HsCartDrawer.cart2(response,data,$);
                HsCartDrawer.countCart(response,data,$);
                HsCartDrawer.priceCart(response,data,$);
                HsCartDrawer.currencyConverter(data,$);
                if(w > 0)
                {
                  HsCartDrawer.showCartPopup(data,$);
                }
                HsCartDrawer.hideCartPopup(data,$);
			},
			error: function(e){
				//console.log(e);
			},
			complete:function(){
				HsCartDrawer.plusMin(data,$);
				HsCartDrawer.removeItemCart(data,$);
				HsCartDrawer.positionPopup(data,$);
                HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
                HsCartDrawer.clearALL(data,$);
              	HsCartDrawer.resizeDesktopAndMobile(data,$);
              	HsCartDrawer.startDiscount(data,$);
			}
		});
	},
    swiperDynamicHSCart:function(data,$){
      if(!parseInt(data.enable_slide_cart))
      {
        return false;
      }
      if(parseInt(data.upsell_cross_sell_mode))
      {
        return false;
      }
      new Swiper('.swiper-container-dynamic', {
        spaceBetween: 30,
        loop: true,
        autoHeight: true,
        shortSwipes:false,
        longSwipesRatio:0.3,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            shortSwipes:true
          }
        }
      });
      //HsCartDrawer.paginationHover(data,$);
    },
    swiperHSCart:function(data,$){
      if(!parseInt(data.enable_slide_cart))
      {
        return false;
      }
      if(parseInt(data.upsell_mode))
      {
        return false;
      }
      new Swiper('.swiper-container-static', {
        spaceBetween: 30,
        loop: true,
        autoHeight: true,
        shortSwipes:false,
        longSwipesRatio:0.3,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        768: {
          shortSwipes:true
        }
      }
      });
      //HsCartDrawer.paginationHover(data,$);
    },
    paginationHover:function(data,$){
      $('.hs-container-swp .swiper-pagination-bullet').hover(
        function() {
          $(this).click();
        }
      );
    },
  	ajaxCart:function(status,params,where,data,$){
      var slide_cart_length = $('.hs-sticky-cart .hs-item-cart-content').length;
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'POST',
			url : '/cart/add.js',
			dataType: 'json',
			async:true,
			data : params,
			success: function(response){
              if(!parseInt(data.status)){
                HsCartDrawer.redirectCart(data,$);
                return false;
              }
              if(data.quick_buy_button_clicked !== 'no-redirect')
              {
                window.location.href = '/'+data.quick_buy_button_clicked;
                return false;
              }
              if(response)
              {
                if(slide_cart_length > 0)
                {
                   HsCartDrawer.getCart2(1,0,data,$);
                }else{
                   HsCartDrawer.getCart(1,0,data,$);
                }
                if(status == 0)
                {
                	HsCartDrawer.removeDisabledButton(1,where,data,$);
                }else{
                  	HsCartDrawer.changeButton(where,data,$);
                  	HsCartDrawer.removeDisabledButton(1,where,data,$);
                }
              }
			},
			error: function(e,b,c){
              	var obj = $.parseJSON( e.responseText );
              	HsCartDrawer.changeButton(where,data,$);
              	if(obj)
                {
                  setTimeout(function(){
					if(obj.status == 422){
						HsCartDrawer.openCart(data,$);
						alert(obj.description,data,$);
                      	HsCartDrawer.closeCart(data,$);
						HsCartDrawer.hideCartPopup(data,$);
					}
                  }, 500);
                  HsCartDrawer.removeDisabledButton(0,where,data,$);
                }
			},
			complete:function(e){
              	HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
                HsCartDrawer.clearALL(data,$);
			}
		});
	},
    closeCart:function(data,$){
      	//$('html').removeClass('hs-open-drawer');
      	$('body').removeClass('hs-open-cart');
    },
	openCart:function(data,$){
      	//$('html').addClass('hs-open-drawer');
		$('body').addClass('hs-open-cart');
	},
    ajaxBarCart:function(status,params,where,data,$){
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'POST',
			url : '/cart/add.js',
			dataType: 'json',
			async:true,
			data : params,
			success: function(response){
              if(!parseInt(data.status)){
                HsCartDrawer.redirectCart(data,$);
                return false;
              }
              if(data.sticky_cart_bar_skip_button !== 'no-redirect')
              {
                window.location.href = '/'+data.sticky_cart_bar_skip_button;
                return false;
              }
              if(response)
              {
                HsCartDrawer.getCart(1,0,data,$);
                if(status == 0)
                {
                	HsCartDrawer.removeDisabledButton(1,where,data,$);
                }else{
                  	HsCartDrawer.changeButton(where,data,$);
                }
              }
			},
			error: function(e,b,c){
              	var obj = $.parseJSON( e.responseText );
              	if(obj)
                {
                  setTimeout(function(){
					if(obj.status == 422){
						HsCartDrawer.openCart(data,$);
						alert(obj.description,data,$);
                      	HsCartDrawer.closeCart(data,$);
						HsCartDrawer.hideCartPopup(data,$);
					}
                  }, 500);
                  HsCartDrawer.changeButton(where,data,$);
                }
			},
			complete:function(e){
              	HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
                HsCartDrawer.clearALL(data,$);
              
			}
		});
	},
    ajaxProductCart:function(params,where,data,$){
      	var slide_cart_length = $('.hs-sticky-cart .hs-item-cart-content').length;
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'POST',
			url : '/cart/add.js',
			dataType: 'json',
			async:true,
			data : params,
			success: function(response){
              if(!parseInt(data.status)){
                HsCartDrawer.redirectCart(data,$);
                return false;
              }
              if(response)
              {
                if(slide_cart_length > 0)
                {
                   HsCartDrawer.getCart2(1,0,data,$);
                }else{
                   HsCartDrawer.getCart(1,0,data,$);
                }
              }
              HsCartDrawer.changeAddButton(where,data,$);
			},
			error: function(e,b,c){
              	var obj = $.parseJSON( e.responseText );
              	if(obj)
                {
                  setTimeout(function(){
					if(obj.status == 422){
						HsCartDrawer.openCart(data,$);
						alert(obj.description,data,$);
                      	HsCartDrawer.closeCart(data,$);
						HsCartDrawer.hideCartPopup(data,$);
					}
                  }, 500);
                }
			},
			complete:function(e){
              	HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
                HsCartDrawer.clearALL(data,$);
			}
		});
	},
    changeAddButton:function(where,data,$){
      var button = $('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] button.tt-btn-addtocart,form[action="/cart/add"] button[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"],form[action="/cart/add"] button.btn-addtocart,form[action="/cart/add"] .button-cart,form[action="/cart/add"] .pt-btn-addtocart,form[action="/cart/add"] #add-to-cart,form[action="/cart/add"] button[type="submit"]');
      button.removeAttr('disabled');
      button.removeClass('disabled');
      button.removeClass('active');
      button.removeClass('btn--loading');
	},
    ajaxProductCartUpsell:function(params,where,data,$){
      	HsCartDrawer.notifyHide(data,$);
		$.ajax({
			type: 'POST',
			url : '/cart/add.js',
			dataType: 'json',
			async:true,
			data : params,
			success: function(response){
              if(!parseInt(data.status)){
                HsCartDrawer.redirectCart(data,$);
                return false;
              }
              if(response)
              {
                HsCartDrawer.getCart2(1,0,data,$);
              }
			},
			error: function(e,b,c){
              	var obj = $.parseJSON( e.responseText );
              	if(obj)
                {
                  setTimeout(function(){
					if(obj.status == 422){
						HsCartDrawer.openCart(data,$);
						alert(obj.description,data,$);
						HsCartDrawer.hideCartPopup(data,$);
					}
                  }, 500);
                }
			},
			complete:function(e){
              	HsCartDrawer.hideCartPopup(data,$);
                HsCartDrawer.changeQuantityCart(data,$);
              	HsCartDrawer.changeButton(where,data,$);
                HsCartDrawer.clearALL(data,$);
			}
		});
	},
    countCart:function(result,data,$){
      $('#CartCount').find('span').eq(0).html(result.item_count);
      if($('.num-items-in-cart').find('.number').length > 0)
      {
        $('.num-items-in-cart').find('.number').html(result.item_count);
      }else{
      	$('.num-items-in-cart .block-cart').html('Cart ('+result.item_count+')');
      }
      $('#cartCount').html('( '+result.item_count+' )');
      $('.count-style.bigcounter').html(result.item_count);
      $('span#CartCount').html(result.item_count);
      $('.CartCount').html(result.item_count);
      $('.tt-badge-cart').html(result.item_count);
      $('a[href*=cart] span.cart-count').html(result.item_count);
      $('a[href*=cart] .cart_count').html(result.item_count);
      $('a[href*=cart] em').html(result.item_count);
      $('.header-cart__icon .header-cart__count').html(result.item_count);
      $('a[href*=cart] .cartCountSelector').html(result.item_count);
      $('#cart-count a:first, #gocart p a, #cart .checkout em, .item-count, #CartCount span').html(result.item_count);
      $('.site-header__cart-count').find('span').eq(0).html('('+result.item_count+')');
      $('.site-header__cart').find('.site-header__cart-count').find('span').eq(0).html(result.item_count);
      $('.cart-summary .cart-count').html('<span class="cart-count__text">Cart ('+result.item_count+')</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag"><title>Cart</title><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>');
      $('.cart-count.cart-summary').html('<span class="cart-count__text">('+result.item_count+')</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag"><title>Cart</title><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>');
      $('.hs-count-cart,.cart-item-count-header,.js-cart-count').html(result.item_count);
      $('.cart-target .n-item,.header__action-item-content .header__cart-count').html(result.item_count);
      
      if($('.header__btn-cart').length > 0)
      {
      	$('.header__btn-cart').find('.d-lg-inline').html('('+result.item_count+')');
        $('.header__btn-cart').find('.d-lg-inline').attr('data-js-cart-count-desktop',result.item_count);
      	$('.header__btn-cart').find('.header__counter').html(result.item_count);
        $('.header__btn-cart').find('.header__counter').attr('data-js-cart-count-mobile',result.item_count);
      }
      
      $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
      $('a[href*=cart] .Header__CartDot').removeClass('is-visible');
      $('a[href*=cart] .header-cart-count').removeClass('active');
      if(result.item_count > 0){
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        $('a[href*=cart] .Header__CartDot').addClass('is-visible');
        $('a[href*=cart] .header-cart-count').addClass('active');
      }
      if(parseInt(data.status_widget))
      {
        if(result.item_count > 0)
        {
          $('.hs-sticky-cart-cart-drawer').removeClass('hs-hidden-count-cart');
        }else{
          if(parseInt(data.stickycart_hide_if_empty))
          {
            $('.hs-sticky-cart-cart-drawer').addClass('hs-hidden-count-cart');
          }else{
            $('.hs-sticky-cart-cart-drawer').removeClass('hs-hidden-count-cart');
          }
        }
      }
    },
    vat:function(price,data,$){
      if(parseInt(data.enable_price_vat))
      {
        var price_vat = data.price_vat;
        if(price_vat == 0)
        {
          price_vat = 1;
        }
        price = price * parseFloat(price_vat);
      }
      return price;
    },
    rewardsContent:function(total_price,data,$){
      var arr = [],from_free_shipping = 0,total_discount_price = parseFloat($('#hs-discount-price-global').val()),total_from_free_shipping = 0,text_free_shipping = '',text_free_shipping_price_away = '',free_shipping_price_away = '';
      if(total_discount_price > 0)
      {
        total_price = total_discount_price;
      }
      if(parseInt(data.enable_default_country))
      {
      	from_free_shipping = parseFloat(data.from_free_shipping);
      	text_free_shipping_price_away = data.text_away_from_free_shipping;
      }
      if(parseInt(data.enable_shipping_country))
      {
        if(HsCartDrawer.arr_rewards)
        {
          from_free_shipping = parseFloat(HsCartDrawer.arr_rewards.amount);
          text_free_shipping_price_away = HsCartDrawer.arr_rewards.title;
          data.text_congrats_free_shipping = HsCartDrawer.arr_rewards.congrats;
        }
      }
      if(text_free_shipping_price_away !== '')
      {
        from_free_shipping = from_free_shipping * 100;
        total_from_free_shipping = total_price / from_free_shipping;
        total_from_free_shipping = total_from_free_shipping * 100;
        free_shipping_price_away = total_price;

        free_shipping_price_away = from_free_shipping - free_shipping_price_away;
        free_shipping_price_away = HsCartDrawer.vat(free_shipping_price_away,data,$)
        free_shipping_price_away = hsonslidecart.Currency.formatMoney(free_shipping_price_away, data['money_format']);

        text_free_shipping_price_away = text_free_shipping_price_away.replace("{{ price }}", free_shipping_price_away);

        text_free_shipping = '<div class="hs-text-free-shipping">'+text_free_shipping_price_away+'</div>';
        if(total_from_free_shipping >= 100)
        {
          total_from_free_shipping = 100;
          text_free_shipping = '<div class="hs-text-free-shipping">'+data.text_congrats_free_shipping+'</div>';
        }
      }
      arr = {'total_from_free_shipping':total_from_free_shipping,'free_shipping_price_away':free_shipping_price_away,'text_free_shipping':text_free_shipping};
      return arr;
    },
    rewardsBar:function(total_price,data,$){
      var result_rewards = '',rewards_content_style = '',text_multiple_from_free_shipping = '',count_multiple_from_free_shipping = 0,multiple_from_free_shipping = 0,top_enable_countdown_cart = '',rewards_show_percentages = '',free_shipping = '', announcement = '',text_free_shipping = '',text_free_shipping_price_away = '',free_shipping_price_away = '',from_free_shipping = parseFloat(data.from_free_shipping) * 100,total_from_free_shipping = 0;
      result_rewards = HsCartDrawer.rewardsContent(total_price,data,$);
      if(parseInt(data.enable_countdown_cart))
      {
        top_enable_countdown_cart = ' hs-top-4';
      }
      announcement = '<div class="hs-announcement'+top_enable_countdown_cart+'">'+data.announcement_module+'</div>';
      if(announcement.indexOf('{{ price }}') > -1){
        if(parseInt(data.enable_announcement))
        {
          if(announcement.indexOf('{{ price }}') > -1){
          	result_rewards.text_free_shipping = '';
          }
          announcement =  announcement.replace("{{ price }}", result_rewards.free_shipping_price_away);
          if(result_rewards.total_from_free_shipping >= 100)
          {
            announcement = '<div class="hs-announcement'+top_enable_countdown_cart+'">'+data.text_congrats_free_shipping+'</div>';
          }
        }
      }
      if(parseInt(data.enable_shipping_country))
      {
        if(HsCartDrawer.arr_rewards)
        {
          from_free_shipping = parseFloat(HsCartDrawer.arr_rewards.amount) * 100;
        }
      }
      if(!parseInt(data.rewards_show_percentages))
      {
        rewards_show_percentages = ' hs-hidden-percentages';
      }
      if(from_free_shipping > 0)
      {
        if(!parseInt(data.rewards_style))
        {
          multiple_from_free_shipping = from_free_shipping / 4;
          for (i = 0; i < 5; i++) {
            count_multiple_from_free_shipping =  multiple_from_free_shipping * i;
            count_multiple_from_free_shipping = hsonslidecart.Currency.formatMoney(count_multiple_from_free_shipping, data['money_format']);
            text_multiple_from_free_shipping = text_multiple_from_free_shipping.concat('<span class="hs-progress-indicator hs-progress-price">'+count_multiple_from_free_shipping+'</span>');
          }
        }
      }
      rewards_content_style = '<span class="hs-progress-indicator">0%</span><span class="hs-progress-indicator">25%</span><span class="hs-progress-indicator">50%</span><span class="hs-progress-indicator">75%</span><span class="hs-progress-indicator">100%</span>';
      if(!parseInt(data.rewards_style))
      {
        rewards_content_style = text_multiple_from_free_shipping;
      }
      free_shipping = '<div class="hs-rewards-content"><div class="hs-progess-content'+rewards_show_percentages+'">'+result_rewards.text_free_shipping+'<div id="hs_shipping_progress"><div id="hs_shipping_bar" style="width:'+result_rewards.total_from_free_shipping+'%;"></div></div>'+rewards_content_style+'</div></div>';
      if(!parseInt(data.enable_rewards))
      {
        free_shipping = '';
      }
      if(!parseInt(data.enable_default_country))
      {
        if(!HsCartDrawer.arr_rewards){
          free_shipping = '';
        }
      }
      if(!parseInt(data.enable_announcement))
      {
        announcement = '';
      }
      $('.hs-announcement-module').html(announcement);
      $('.hs-content-discounts-calculate-checkout').html(free_shipping);
    },
    priceCart:function(result,data,$){
      var count_cart = '',cl_products_count = '',class_banner = '',cl_clear_all = '',text_products_count = '',text_clear_all = '<a href="javascript:void(0);" class="hs-clear-all-button">'+data.text_clear_all+'</a>',total_price = result.total_price,status_text_cart = '', status_text_checkout = '', total = '';
      HsCartDrawer.rewardsBar(result.total_price,data,$);
      total_price = HsCartDrawer.vat(total_price,data,$);
      if(result.item_count == 1)
      {
        count_cart = result.item_count+' '+data.text_products_singular;
      }else{
        count_cart = result.item_count+' '+data.text_products_plural;
      }
      text_products_count = '<span class="hs-count-products-cart">'+count_cart+'</span>';
      if(!parseInt(data.show_clear_all))
      {
        text_clear_all = '';
        cl_clear_all = ' hs-clear-all-hidden';
      }
      if(!parseInt(data.show_products_count))
      {
        text_products_count = '';
        cl_products_count = ' hs-products-count-hidden';
      }
      if(!parseInt(data.enable_announcement))
      {
        class_banner = ' hs-border-announcement';
      }
      if(parseInt(data.enable_countdown_cart))
      {
        class_banner = '';
      }
      count_cart = '<div class="hs-content-count'+class_banner+cl_clear_all+cl_products_count+'">'+text_products_count+text_clear_all+'</div>';
	  $('#hs-total-price-global').val(total_price);
      $('.hs_subtotal_amount').html(hsonslidecart.Currency.formatMoney(total_price, data['money_format']));
      $('a[href*=cart] .cartTotalSelector,a[href*=cart] #CartCost').html(hsonslidecart.Currency.formatMoney(total_price, data['money_format']));
      $('.hs-sticky-cart-cart-drawer-content mark').html(result.item_count);
      $('.hs-content-count-products-clear-all').html(count_cart);
      if($('.CartCost').length > 0)
      {
      	$('.CartCost').html(hsonslidecart.Currency.formatMoney(total_price, data['money_format']));
      }
      if($('.shopping-cart__total').length > 0)
      {
        $('.shopping-cart__total').html(hsonslidecart.Currency.formatMoney(total_price, data['money_format']));
      }
    },
	cart:function(result,data,$){
      	var arr_product_id = [],arr_product_handle = [],bold_original_line_price = '',bold_line_price = '',one_page_checkout = 'checkout',header = '',status_text_slide_cart_dynamic = '',item_handle = '',additional_buttons = '',item_id = '',item_product_id = '',item_url = '',item_key = '',item_total_price_no_money='',item_quantity = '',item_image = '',item_product_title='',item_variant_title='',item_original_line_price = '',orinal_price_discount = '',total_price = parseFloat(result.total_price),text_shipping_taxes = '',mg_price = '',per_quantity = '',min_money = parseFloat(data.minimum_order),min_money = min_money * 100,discount_code = '',note = result.note,text_countdown_cart = '',countdown_cart = '',selectCombobox = '',parent_class = '',text_variant_propertie = '',item_price = '',item_discounted_price = '',item_line_price = '',item_total_price = '',terms = '',selectParent = '',text_discounts = '',status_text_slide_cart = '',all_discount_price = '',line = 0,text_total_variant = '',line_price_discount = '',text_total_variant_discount_price = '',btn_continue_shopping = '',textcart = '',status_text_cart = '',text_quantity_products = '',button_shopify = '', status_text_checkout = '',status_text_discount = '',status_text_note = '', footer = '';
		$('li.btn__cart a[href*=cart]').html('<span class="icon" aria-hidden="true">'+result.item_count+'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="22px" height="27px" viewBox="0 0 22 27" enable-background="new 0 0 22 27" xml:space="preserve"><path fill="#010101" d="M17.1 6.6V6.3C17.1 2.8 14.2 0 10.7 0S4.4 2.8 4.4 6.3v0.4H0V27h21.2V6.6H17.1zM6.3 6.3c0-2.4 2-4.3 4.4-4.3s4.4 2 4.4 4.3v0.4H6.3V6.3zM19 8.8v16H2.2V8.8"></path></svg></span><span class="text">'+data.shopping_cart_text+'</span>');
      	$.each(result.items, function( index, item ) {
            text_discounts = '',all_discount_price = '',orinal_price_discount = '';
            line = line + 1;
            item_id = item.id;
          	item_product_id = item.product_id;
          	item_url = item.url;
          	item_handle = item.handle;
            item_key = item.key;
          	item_quantity = item.quantity;
          	item_price = hsonslidecart.Currency.formatMoney(item.price, data['money_format']);
          	item_discounted_price = hsonslidecart.Currency.formatMoney(item.discounted_price, data['money_format']);
          	item_product_title = item.product_title;
          	item_variant_title = item.variant_title;
          	item_image = item.image;
            item_price = HsCartDrawer.vat(item_price,data,$);
            item_line_price = HsCartDrawer.vat(item.line_price,data,$);
            item_total_price = HsCartDrawer.vat(item.total_price,data,$);
          	item_original_line_price = HsCartDrawer.vat(item.original_line_price,data,$);
            item_total_price_no_money = item_total_price; 
          	item_total_price = hsonslidecart.Currency.formatMoney(item_total_price, data['money_format']);
          	item_line_price = hsonslidecart.Currency.formatMoney(item_line_price, data['money_format']);
          	item_original_line_price = hsonslidecart.Currency.formatMoney(item_original_line_price, data['money_format']);
            line_price_discount = '';
            text_total_variant_discount_price = '';
          
            if(typeof window.BOLD !== 'undefined'
               && typeof window.BOLD.common !== 'undefined'
               && typeof window.BOLD.common.cartDoctor !== 'undefined') {
               bold_line_price = HsCartDrawer.vat(item.line_price,data,$);
               bold_original_line_price = HsCartDrawer.vat(item.original_line_price,data,$);
               orinal_price_discount = '<span class="hs-item-original-line-price">'+item_original_line_price+'</span>';
               if(bold_line_price == bold_original_line_price)
               {
                 orinal_price_discount = '';
               }
            }
			if(item_variant_title == null)
			{
				item_variant_title = '';
			}
          	if(item_image == null)
            {
              item_image = 'https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
            }else{
              item_image = HsCartDrawer.resizeSrc(item_image,'x200');
            }
          	if(item.discounts)
            {
              $.each(item.discounts, function( c, f ) {
                all_discount_price = f.amount;
                all_discount_price = hsonslidecart.Currency.formatMoney(all_discount_price, data['money_format']);
                text_discounts = text_discounts.concat('<span class="hs-discount-app-cart hs-desktop"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg> '+f.title+'</span>');
              });
              if(text_discounts){
                orinal_price_discount = '<span class="hs-item-original-line-price">'+item_original_line_price+'</span>';
              }
            }
            if(item.properties)
            {
              text_variant_propertie = '';
              $.each(item.properties, function( c, o ) {
                 if(c.charAt(0) !== '_'){
                   	if(c.indexOf('uploader') > -1){
                      o = '<div class="hs-content-image-properties"><img src="'+o+'" class="hs-uploader-image-properties" /></div>'
                    }
                   	if(o !== '')
                    {
                 		text_variant_propertie = text_variant_propertie.concat('<div class="hs-content-propertie"><span class="hs-propertie">'+c+': </span>'+o+'</div>');
                    }
                 }
              });
              text_variant_propertie = '<div class="hs-propertie-content">'+text_variant_propertie+'</div>';
            }
            if(data.show_property == 0)
            {
              text_variant_propertie = '';
            }
            if(data.show_total_per_variant == 1)
            {
                if(item.total_discount > 0)
                {
                    line_price_discount = ' hs-discount-price-line-through';
                	text_total_variant_discount_price = '<span class="hs-discount-price-total hs-variant-'+item_id+'-discount-price-total hs-desktop">'+item_discounted_price+'</span>';
                }
                text_total_variant = '<span class="hs-price-total hs-variant-'+item_id+'-price-total'+line_price_discount+' hs-desktop">'+item_price+'</span>';
            }
          	if(data.show_total_quantity_products == 1)
            {
              	if(text_total_variant !== '')
                {
                  per_quantity = '<span class="hs-quantity-original-price">x'+item_quantity+' </span>';
                  mg_price = ' hs-mg-price';
                }
          		text_quantity_products = '<span class="hs-original-price-total hs-variant-'+item_id+'-original-price-total hs-desktop'+mg_price+'">'+per_quantity+orinal_price_discount+item_line_price+'</span>';
            }
          	arr_product_id.push(item_product_id);
          	arr_product_handle.push(item_handle);
            textcart = textcart.concat('<div class="hs-item-cart-content hs-product-'+item_id+'">\
				<div class="hs-item-content-variants">\
				<div class="hs-item-cart-image">\
					<a href="'+item_url+'"><img class="hs-cart-image" src="'+item_image+'" alt="'+item_product_title+'"></a>\
				</div>\
				<div class="hs-item-cart-description">\
					<div class="hs-item-close"><a href="javascript:void(0);" class="hs-remove-item" data-id="'+item_id+'" data-key="'+item_key+'" data-line="'+line+'"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></a></div>\
					<div class="hs-content-product-and-variant-title">\
                      <a href="'+item_url+'" class="hs-product-title">\
                          '+item_product_title+'\
                      </a>\
                      <span class="hs-variant-title">'+item_variant_title+'</span>\
                      '+text_variant_propertie+'\
				    </div>\
                    <div class="hs-content-quantity-price">\
                      <div class="hs-item-cart-content-quantity">\
                          <div class="hs-item-cart-qty hs-item-'+item_id+'">\
                              <div class="hs-cart-plus-minus" data-quantity="'+item_quantity+'" data-id="'+item_id+'" data-key="'+item_key+'" data-line="'+line+'"></div>\
                          </div>\
                      </div>\
                      <div class="hs-cart-content-price">\
						'+text_total_variant+'\
                        '+text_total_variant_discount_price+'\
                        '+text_quantity_products+'\
                        '+text_discounts+'\
                      </div>\
					</div>\
                  </div>\
				</div>\
			</div>');
		});
        if(note == null)
        {
          note = '';
        }
        if(data.status_text_cart == 0 || data.status_text_checkout == 0)
        {
          button_shopify = ' hs-button-100-w';
        }

        if(data.status_text_checkout == 1)
        {
          if (typeof opcSettings != 'undefined' && opcSettings.enabled){
            one_page_checkout = 'checkout_one_page';
          }
          status_text_checkout = '<div class="hs-content-checkout-button'+button_shopify+'"><button name="'+one_page_checkout+'" type="submit" class="hs-checkout-purchase'+button_shopify+'"><span class="hs-add--to--cart">'+data.text_checkout+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button></div>';
        }
        if(data.status_text_cart == 1)
        {
          status_text_cart = '<button type="button" class="hs-cart-purchase'+button_shopify+'">'+data.text_cart+'</button>';
          if(parseInt(data.redirect_minimum_order))
          {
            status_text_cart = '';
            status_text_checkout = '<div class="hs-content-checkout-button'+button_shopify+'"><button type="button" class="hs-cart-purchase'+button_shopify+'"><span class="hs-add--to--cart">'+data.text_cart+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button></div>';
          }
        }
        if(min_money > 0)
        {
          if(total_price < min_money)
          {
            min_money = hsonslidecart.Currency.formatMoney(min_money, data['money_format']);
            status_text_checkout = data.tex_minimum_order.replace("{{ money }}",min_money );
            if($('.hs-content-checkout-button').length > 0)
            {
            	status_text_checkout = '<div class="hs-min-money-cart">'+status_text_checkout+'</div>';
            }else{
              	status_text_checkout = '<div class="hs-content-checkout-button'+button_shopify+'"><div class="hs-min-money-cart">'+status_text_checkout+'</div></div>';
            }
          }
        }
        if(data.show_discount == 1)
        {
          discount_code =  HsCartDrawer.readCookie('hscodediscount');
          discount_code = decodeURIComponent(discount_code);
          status_text_discount = '<div class="hs-add-discount"><div class="hs-success-code-discount"></div><label class="hs-discount-heading">'+data.text_discount+'</label><div class="hs-content-discount-add"><input type="text" class="hs-discount-code" placeholder="'+data.text_discount_code+'" value="'+discount_code+'" name="hsdiscount" autocomplete="off"><button type="button" class="hs-apply-discount"><span class="hs-text--apply--discount">'+data.text_apply+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button></div><div class="hs-error-code-discount"></div></div>';
        }
        if(data.show_note == 1)
        {
          if(data.text_note)
          {
          	data.text_note = '<label class="hs-note-heading">'+data.text_note+'</label>';
          }
          status_text_note = '<div class="hs-cart-note">'+data.text_note+'<textarea class="hs-cart-ins" placeholder="'+data.text_instructions+'" name="note" autocomplete="off">'+note+'</textarea></div>';
        }
      	if(data.status_text_continue_shopping == 1)
        {
          btn_continue_shopping = '<a class="hs-continue-shopping" href="'+data.continue_shopping_link+'">'+data.text_continue_shopping+'</a>';
        }
        if(parseInt(data.enable_slide_cart))
        {
            if(parseInt(data.enable_recommend_products))
            {
              if(typeof window.HSSLIDECART !== 'undefined'
                 && typeof window.HSSLIDECART.upsell !== 'undefined'
                 && typeof window.HSSLIDECART.upsell.json !== 'undefined') {
                status_text_slide_cart = HsCartDrawer.upsellProductsJson(parseInt(data.upsell_show_quantity_box),parseInt(data.upsell_mode),'swiper-container-static',window.HSSLIDECART.upsell.json,data,$);
              }
              if(status_text_slide_cart)
              {
                if(parseInt(data.upsell_mode))
                {
                  status_text_slide_cart = '<div class="hs-container-stacked hs-recommend-products"><div class="hs-frequently-bought"><h2>'+data.upsell_title+'</h2></div><div class="hs-products-stacked">'+status_text_slide_cart+'</div></div>';
                }else{
                  status_text_slide_cart = '<div class="hs-container-swp hs-recommend-products">\
                  <div class="hs-frequently-bought">\
                    <h2>'+data.upsell_title+'</h2>\
                  </div>\
                  <div class="hs-swipper-containter-cart hs-mode-static">'+status_text_slide_cart+'</div>\
                 </div>';
                }
              }
            }
            if(parseInt(data.enable_upsell_cross_sell))
            {
              if(parseInt(data.upsell_cross_sell_mode))
              {
                status_text_slide_cart_dynamic = '<div class="hs-container-dynamic-stacked hs-cross-sell" style="display:none;"><div class="hs-frequently-bought"><h2>'+data.upsell_cross_sell_title+'</h2></div><div class="hs-products-dynamic-stacked"></div></div>';
              }else{
                status_text_slide_cart_dynamic = '<div class="hs-container-swp hs-cross-sell" style="display:none;">\
                <div class="hs-frequently-bought">\
                  <h2>'+data.upsell_cross_sell_title+'</h2>\
                </div>\
                <div class="hs-swipper-containter-cart hs-mode-dynamic"></div>\
               </div>';
              }
            }
          
        }
      	text_shipping_taxes = '<div class="hs-shipping-taxes">'+data.text_shipping+'</div>';
      	if(!parseInt(data.show_text_shipping_taxes))
        {
          text_shipping_taxes = '';
        }
        text_countdown_cart = data.time_remaining;
        text_countdown_cart = text_countdown_cart.replace("{{time_remaining}}", "<span id='hs_countdown_cart_plus'>"+data.how_many_minutes_cart_reservation+":00</span>");
        if(parseInt(data.enable_countdown_cart))
        {
          countdown_cart = '<div class="hs-countdown-cart">'+text_countdown_cart+'</div>';
        }
      	terms = '<div class="hs-terms-content"><input type="checkbox" id="hs_front_check_agreed"><span>'+data.text_agreed+' <a href="'+data.link_terms_and_conditions+'" target="_blank">'+data.text_terms_and_conditions+'</a></span></div>';
      	if(!parseInt(data.show_terms_and_conditions))
        {
          terms = '';
        }
      	if(parseInt(data.enable_additional_buttons))
        {
          if(Shopify.PaymentButton){
            additional_buttons = '<div id="hs-additional-buttons"><div class="dynamic-checkout__content" id="dynamic-checkout-cart" data-shopify="dynamic-checkout-cart"></div></div>';
          }
        }
        footer = '<div class="hs-content-discounts-calculate-checkout"></div><div class="hs-content-count-products-clear-all"></div><div class="hs-sticky-cart">'+textcart+'</div><div class="hs-container-mg-top-up"></div>'+status_text_discount+status_text_slide_cart_dynamic+status_text_slide_cart+status_text_note+'<div class="hs-dobly-content"><div class="doubly-message"></div></div><div class="hs-drawer-checkout"><div class="hs-drawer-content-checkout">\
		<div class="hs-content-total-cart">\
		<div class="hs-sub-total-cart hs-shipping-next" style="display:none;">\
              <span>Versand</span>\
              <span class="hs_shipping_amount">Berechnet im nächsten Schritt</span>\
          </div>\
          <div class="hs-sub-total-cart">\
              <span>'+data.text_subtotal+'</span>\
              <span class="hs_subtotal_amount_discount"></span>\
              <span class="hs_subtotal_amount">'+item_total_price+'</span>\
              <input type="hidden" value="'+item_total_price_no_money+'" id="hs-total-price-global" />\
			  <input type="hidden" value="0" id="hs-discount-price-global" />\
          </div>\
		  <div class="hs-terms-and-conditions">'+terms+'</div>\
        </div>\
        <div class="hs-finalize-purchase">\
            '+text_shipping_taxes+'\
          	'+status_text_checkout+status_text_cart+'\
			'+additional_buttons+'\
			'+btn_continue_shopping+'\
          <div class="hs-trust-payment"><img src="https://cdn.shopify.com/s/files/1/1009/6916/t/2/assets/trust-payment.png"></div>\
        </div>\
        </div></div>';
      	header = '<div class="hs-close-popup-cart"><div class="hs-header-close-empty"><span class="hs-shopping-cart-icon"><i class="fa '+data.stickycart_icon+'" aria-hidden="true"></i></span><h2>'+data.shopping_cart_text+'</h2><a href="javascript:void(0)" class="hs-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="12px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg></a></div></div>';
        if(result.item_count > 0)
        {
          $('.hs-popup-cart-sp-load .hs-site-cart-popup').html('<form action="/cart" method="post" novalidate class="sn-cart hs-sl-container-cart">'+header+countdown_cart+'<div class="hs-announcement-module"></div>'+footer+'</form>');
        }else{
          $('.hs-popup-cart-sp-load .hs-site-cart-popup').html('<form action="/cart" method="post" novalidate class="sn-cart">'+header+'<div class="hs-content-empty-cart">'+data.no_result_text+'</div></div>');
        }
      	HsCartDrawer.dynamicUpsell(arr_product_id,arr_product_handle,data,$);
        if(parseInt(data.enable_additional_buttons))
        {
          if(Shopify.PaymentButton){
            Shopify.PaymentButton.init();
          }
        }
	},
    startTimer:function(duration,display,data,$) {
      var timer = duration, minutes, seconds,obj = 1;
      setInterval(function () {
        display = $('#hs_countdown_cart_plus');
        obj = display.length;
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.html(minutes + ":" + seconds);
        if(obj == 0)
        {
          timer = -1;
        }
        if (--timer < 0) {
          if(timer == -1)
          {
            if(parseInt(data.countdown_expires_clear_cart))
            {
              HsCartDrawer.ajaxClearAll(data,$);
            }
          }
          timer = duration;
          $('.hs-countdown-cart').html(data.countdown_expires);
        }
      }, 1000);
    },
    iniTimer:function(data,$){
      var minutes = parseInt(data.how_many_minutes_cart_reservation),fiveMinutes = 60 * minutes,
          fiveMinutes = fiveMinutes - 1,display = $('#hs_countdown_cart_plus');
      HsCartDrawer.startTimer(fiveMinutes,display,data,$);
    },
  	cart2:function(result,data,$){
		var arr_product_id = [],arr_product_handle = [],one_page_checkout = 'checkout',bold_line_price = '',bold_original_line_price = '',header = '',additional_buttons = '',item_id = '',item_product_id = '',item_handle = '',item_url = '',item_key = '',item_total_price_no_money='',item_quantity = '',item_image = '',item_product_title='',item_variant_title='',item_original_line_price = '',orinal_price_discount = '',total_price = parseFloat(result.total_price),mg_price = '',per_quantity = '',min_money = parseFloat(data.minimum_order),min_money = min_money * 100,text_discounts = '',note = result.note,text_variant_propertie = '',item_price = '',item_discounted_price = '',item_line_price = '',item_total_price = '',status_text_slide_cart = '',all_discount_price = '',line = 0,text_total_variant = '',line_price_discount = '',text_total_variant_discount_price = '',btn_continue_shopping = '',textcart = '',status_text_cart = '',text_quantity_products = '',button_shopify = '', status_text_checkout = '',status_text_discount = '',status_text_note = '', footer = '';
		$('li.btn__cart a[href*=cart]').html('<span class="icon" aria-hidden="true">'+result.item_count+'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="22" height="27" viewBox="0 0 22 27" enable-background="new 0 0 22 27" xml:space="preserve"><path fill="#010101" d="M17.1 6.6V6.3C17.1 2.8 14.2 0 10.7 0S4.4 2.8 4.4 6.3v0.4H0V27h21.2V6.6H17.1zM6.3 6.3c0-2.4 2-4.3 4.4-4.3s4.4 2 4.4 4.3v0.4H6.3V6.3zM19 8.8v16H2.2V8.8"></path></svg></span><span class="text">'+data.shopping_cart_text+'</span>');
      	$.each(result.items, function( index, item ) {
            text_discounts = '',all_discount_price = '',orinal_price_discount = '';
          	line = line + 1;
            item_id = item.id;
          	item_product_id = item.product_id;
          	item_handle = item.handle;
            item_key = item.key;
            item_quantity = item.quantity;
          	item_url = item.url;
            item_price = hsonslidecart.Currency.formatMoney(item.price, data['money_format']);
            item_discounted_price = hsonslidecart.Currency.formatMoney(item.discounted_price, data['money_format']);
            item_product_title = item.product_title;
            item_variant_title = item.variant_title;
            item_image = item.image;
            item_price = HsCartDrawer.vat(item_price,data,$);
            item_line_price = HsCartDrawer.vat(item.line_price,data,$);
            item_total_price = HsCartDrawer.vat(item.total_price,data,$);
            item_original_line_price = HsCartDrawer.vat(item.original_line_price,data,$);
            item_total_price_no_money = item_total_price; 
            item_total_price = hsonslidecart.Currency.formatMoney(item_total_price, data['money_format']);
            item_line_price = hsonslidecart.Currency.formatMoney(item_line_price, data['money_format']);
            item_original_line_price = hsonslidecart.Currency.formatMoney(item_original_line_price, data['money_format']);
            line_price_discount = '';
            text_total_variant_discount_price = '';
          
            if(typeof window.BOLD !== 'undefined'
               && typeof window.BOLD.common !== 'undefined'
               && typeof window.BOLD.common.cartDoctor !== 'undefined') {
               bold_line_price = HsCartDrawer.vat(item.line_price,data,$);
               bold_original_line_price = HsCartDrawer.vat(item.original_line_price,data,$);
               orinal_price_discount = '<span class="hs-item-original-line-price">'+item_original_line_price+'</span>';
               if(bold_line_price == bold_original_line_price)
               {
                 orinal_price_discount = '';
               }
            }
          
			if(item_variant_title == null)
			{
				item_variant_title = '';
			}
          	if(item_image == null)
            {
              item_image = 'https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
            }else{
              item_image = HsCartDrawer.resizeSrc(item_image,'x200');
            }
          
          	if(item.discounts)
            {
              $.each(item.discounts, function( c, f ) {
                all_discount_price = f.amount;
                all_discount_price = hsonslidecart.Currency.formatMoney(all_discount_price, data['money_format']);
                text_discounts = text_discounts.concat('<span class="hs-discount-app-cart hs-desktop"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg> '+f.title+'</span>');
              });
              if(text_discounts){
                orinal_price_discount = '<span class="hs-item-original-line-price">'+item_original_line_price+'</span>';
              }
            }
            line_price_discount = '';
            text_total_variant_discount_price = '';
            if(data.show_total_per_variant == 1)
            {
                if(item.total_discount > 0)
                {
                    line_price_discount = ' hs-discount-price-line-through';
                	text_total_variant_discount_price = '<span class="hs-discount-price-total hs-variant-'+item_id+'-discount-price-total hs-desktop">'+item_discounted_price+'</span>';
                }
                text_total_variant = '<span class="hs-price-total hs-variant-'+item_id+'-price-total'+line_price_discount+' hs-desktop"> '+item_price+'</span>';
            }
            if(item.properties)
            {
              text_variant_propertie = '';
              $.each(item.properties, function( c, o ) {
                 if(c.charAt(0) !== '_'){
                   	if(c.indexOf('uploader') > -1){
                      o = '<div class="hs-content-image-properties"><img src="'+o+'" class="hs-uploader-image-properties" /></div>'
                    }
                   	if(o !== '')
                    {
                 		text_variant_propertie = text_variant_propertie.concat('<div class="hs-content-propertie"><span class="hs-propertie">'+c+': </span>'+o+'</div>');
                    }
                 }
              });
              text_variant_propertie = '<div class="hs-propertie-content">'+text_variant_propertie+'</div>';
            }
            if(data.show_property == 0)
            {
              text_variant_propertie = '';
            }
          	if(data.show_total_quantity_products == 1)
            {
              	if(text_total_variant !== '')
                {
                  per_quantity = '<span class="hs-quantity-original-price">x'+item_quantity+' </span>';
                  mg_price = ' hs-mg-price';
                }
          		text_quantity_products = '<span class="hs-original-price-total hs-variant-'+item_id+'-original-price-total hs-desktop'+mg_price+'">'+per_quantity+orinal_price_discount+item_line_price+'</span>';
            }
            if(note == null)
            {
              note = '';
            }
            arr_product_id.push(item_product_id);
          	arr_product_handle.push(item_handle);
            textcart = textcart.concat('<div class="hs-item-cart-content hs-product-'+item_id+'">\
				<div class="hs-item-content-variants">\
				<div class="hs-item-cart-image">\
					<a href="'+item_url+'"><img class="hs-cart-image" src="'+item_image+'" alt="'+item_product_title+'"></a>\
				</div>\
				<div class="hs-item-cart-description">\
					<div class="hs-item-close"><a href="javascript:void(0);" class="hs-remove-item" data-id="'+item_id+'" data-key="'+item_key+'" data-line="'+line+'"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></a></div>\
					<div class="hs-content-product-and-variant-title">\
                      <a href="'+item_url+'" class="hs-product-title">\
                          '+item_product_title+'\
                      </a>\
                      <span class="hs-variant-title">'+item_variant_title+'</span>\
                      '+text_variant_propertie+'\
				    </div>\
                    <div class="hs-content-quantity-price">\
                      <div class="hs-item-cart-content-quantity">\
                          <div class="hs-item-cart-qty hs-item-'+item_id+'">\
                              <div class="hs-cart-plus-minus" data-quantity="'+item_quantity+'" data-id="'+item_id+'" data-key="'+item_key+'" data-line="'+line+'"></div>\
                          </div>\
                      </div>\
                      <div class="hs-cart-content-price">\
						'+text_total_variant+'\
                        '+text_total_variant_discount_price+'\
                        '+text_quantity_products+'\
                        '+text_discounts+'\
                      </div>\
					</div>\
                  </div>\
				</div>\
			</div>');
		});
        if(data.status_text_cart == 0 || data.status_text_checkout == 0)
        {
          button_shopify = ' hs-button-100-w';
        }
        if(data.status_text_checkout == 1)
        {
          if (typeof opcSettings != 'undefined' && opcSettings.enabled){
            one_page_checkout = 'checkout_one_page';
          }
          status_text_checkout = '<button name="'+one_page_checkout+'" type="submit" class="hs-checkout-purchase'+button_shopify+'"><span class="hs-add--to--cart">'+data.text_checkout+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button>';
        }
        if(data.status_text_cart == 1)
        {
          status_text_cart = '<button type="button" class="hs-cart-purchase'+button_shopify+'"><span class="hs-add--to--cart">'+data.text_cart+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button>';
          if(parseInt(data.redirect_minimum_order))
          {
            status_text_cart = '';
            status_text_checkout = '<button type="button" class="hs-cart-purchase'+button_shopify+'">'+data.text_cart+'</button>';
          }
        }
      	if(min_money > 0)
        {
          if(total_price < min_money)
          {
            min_money = hsonslidecart.Currency.formatMoney(min_money, data['money_format']);
            status_text_checkout = data.tex_minimum_order.replace("{{ money }}",min_money );
            if($('.hs-content-checkout-button').length > 0)
            {
            	status_text_checkout = '<div class="hs-min-money-cart">'+status_text_checkout+'</div>';
            }else{
              	status_text_checkout = '<div class="hs-content-checkout-button'+button_shopify+'"><div class="hs-min-money-cart">'+status_text_checkout+'</div></div>';
            }
          }
        }
        if(data.show_discount == 1)
        {
          if(data.text_discount)
          {
          	data.text_discount = '<label class="hs-discount-heading">'+data.text_discount+'</label>';
          }
          status_text_discount = '<div class="hs-add-discount">'+data.text_discount+'<input type="text" class="hs-discount-code" name="discount" autocomplete="off"></div>';
        }
        if(data.show_note == 1)
        {
          status_text_note = '<div class="hs-cart-note"><textarea class="hs-cart-ins" placeholder="'+data.text_instructions+'" name="note" autocomplete="off">'+note+'</textarea></div>';
        }
      	if(data.status_text_continue_shopping == 1)
        {
          btn_continue_shopping = '<a class="hs-continue-shopping" href="'+data.continue_shopping_link+'">'+data.text_continue_shopping+'</a>';
        }
      	$('.hs-content-checkout-button').html(status_text_checkout);
      	header = '<div class="hs-close-popup-cart"><div class="hs-header-close-empty"><span class="hs-shopping-cart-icon"><i class="fa '+data.stickycart_icon+'" aria-hidden="true"></i></span><h2>'+data.shopping_cart_text+'</h2><a href="javascript:void(0)" class="hs-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="12px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg></a></div></div>';
		if(result.item_count > 0)
		{
          	$('.hs-sticky-cart').html(textcart);
		}else{
		    $('.hs-popup-cart-sp-load .hs-site-cart-popup').html('<form action="/cart" method="post" novalidate class="sn-cart">'+header+'<div class="hs-content-empty-cart">'+data.no_result_text+'</div></div>');
		}
      	HsCartDrawer.dynamicUpsell(arr_product_id,arr_product_handle,data,$);
        if(parseInt(data.enable_additional_buttons))
        {
          if(Shopify.PaymentButton){
            additional_buttons = '<div class="dynamic-checkout__content" id="dynamic-checkout-cart" data-shopify="dynamic-checkout-cart"></div>';
            $('#hs-additional-buttons').html(additional_buttons);
            Shopify.PaymentButton.init();
          }
        }
  },
  resizeSrc:function(t, r) {
    try {
      if ("original" == r) return t;
      var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return e[1] + "_" + r + "." + e[2]
    } catch (r) {
      return t
    }
  },
	showCartPopup:function(data,$){
      	if(data.style != 1)
        {
      		HsCartDrawer.openCart(data,$);
        }
        $('.hs-load-popup-cart-show-products').show();
        $('.hs-popup-cart-sp-load').addClass('active');
	},
	hideCartPopup:function(data,$){
      	$('.hs-open-cart').unbind('click');
      	$('.hs-open-cart').click(function(e){
          HsCartDrawer.closeCart(data,$);
          $('.hs-popup-cart-sp-load').removeClass('active');
          $('.hs-load-popup-cart-show-products').hide();
		  if(!$('.hs-popup-cart-sp-load.hs-desktop-content-cart').hasClass('active'))
		  {
			$('.hs-message-notify-popup-cart').hide();
		  }
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
        });
        $('.hs-open-cart .hs-bg-slide-cart').unbind('click');
        $('.hs-open-cart .hs-bg-slide-cart').click(function(e){
          HsCartDrawer.closeCart(data,$);
          $('.hs-popup-cart-sp-load').removeClass('active');
          $('.hs-load-popup-cart-show-products').hide();
          if(!$('.hs-popup-cart-sp-load.hs-desktop-content-cart').hasClass('active'))
          {
            $('.hs-message-notify-popup-cart').hide();
          }
          $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
          $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
        });
		$('.hs-close').unbind('click');
		$('.hs-close').click(function(e){
			e.preventDefault();
          	HsCartDrawer.closeCart(data,$);
			$('.hs-popup-cart-sp-load').removeClass('active');
			$('.hs-load-popup-cart-show-products').hide();
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
		});
        $('.hs-continue-shopping').unbind('click');
        $('.hs-continue-shopping').click(function(e){
          e.preventDefault();
          var value = $(this).attr('href'); 
          if(value)
          {
            window.location.href = value;
            return false;
          }
          HsCartDrawer.closeCart(data,$);
          $('.hs-popup-cart-sp-load').removeClass('active');
          $('.hs-load-popup-cart-show-products').hide();
          $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
          $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
        });
		$('.hs-load-popup-cart-show-products').unbind('click');
		$('.hs-load-popup-cart-show-products').click(function(e){
			e.preventDefault();
          	HsCartDrawer.closeCart(data,$);
			$('.hs-popup-cart-sp-load').removeClass('active');
			$(this).hide();
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
		});
        $('.hs-message-notify-popup-cart .hs-remove-notify').unbind('click');
		$('.hs-message-notify-popup-cart .hs-remove-notify').click(function(e){
          	e.preventDefault();
			$('.hs-message-notify-popup-cart').hide();
			if(!$('.hs-popup-cart-sp-load.hs-desktop-content-cart').hasClass('active'))
			{
				HsCartDrawer.closeCart(data,$);
			}
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
			$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
		});
        $('.hs-popup-cart-sp-load,.hs-message-notify-popup-cart,#hs-checkout-bold').unbind('click');
        $('.hs-popup-cart-sp-load,.hs-message-notify-popup-cart,#hs-checkout-bold').click(function(e){
          e.stopPropagation();
        });
      	$('.hs-checkout-purchase').unbind('click');
      	$('.hs-checkout-purchase').click(function(e){
          e.stopImmediatePropagation();
          e.preventDefault();
          var where = $(this),elementTerms = $('#hs_front_check_agreed'),elementDiscount = $('input.hs-discount-code'),elementNote = $('input.hs-cart-ins'),discount = elementDiscount.val(),note = elementNote.val();
          if(elementDiscount.length == 0)
          {
            discount = '';
          }
          where.addClass('hs-loading-btn');
          if(elementTerms.length > 0)
          {
            where.addClass('hs-loading-btn');
            if(elementTerms.is(':checked')) {
            } else {  
              alert(data.text_message_terms_and_conditions);
              return false;
            }  
          }
          HsCartDrawer.UpdateAjaxCart(1,discount,note,data,$,where);
        });
        $('.hs-cart-purchase').unbind('click');
        $('.hs-cart-purchase').click(function(e){
          e.stopImmediatePropagation();
          e.preventDefault();
          var where = $(this),elementDiscount = $('input.hs-discount-code'),elementNote = $('input.hs-cart-ins'),discount = null,note = elementNote.val();
          if(elementNote.length == 0)
          {
            HsCartDrawer.redirectCart(data,$);
            return false;
          }
          if(note === '')
          {
            HsCartDrawer.redirectCart(data,$);
            return false;
          }
          HsCartDrawer.UpdateAjaxCart(0,discount,note,data,$,where);
        });
	},
  	UpdateAjaxCart:function(level,discount,note,data,$,where){
      $.ajax({
        type: 'POST',
        url : '/cart/update.js',
        dataType: 'json',
        async:true,
        data : {note:note},
        success: function(response){
          var d = new Date(), n = d.getTime();
          var myJSON = JSON.stringify(response);
          if(typeof window.BOLD !== 'undefined'
             && typeof window.BOLD.common !== 'undefined'
             && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            // NOTE: "cart" should be the variable containing the cart json data
            response = window.BOLD.common.cartDoctor.fix(response);
            $('#hs-checkout-bold').trigger('click');
            return false;
          }
          discount = encodeURIComponent(discount);
          if(response){
            if (typeof opcSettings != 'undefined' && opcSettings.enabled){
              window.opcLoadCart();
              return false;
            }
            
            if(level == 0)
            {
            	HsCartDrawer.redirectCart(data,$);
            }else{
              if(myJSON.indexOf('shipping_interval_frequency') > -1) {
                function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
                do {
                  var token=get_cookie('cart');
                }
                while(token == undefined);
                var myshopify_domain = HsCartDrawer.shopifyUrl;
                var customer_id = '';
                var customer_email = '';
                var customer_param = '';
                if($('#hs_subscriptions_customer_id').length > 0)
                {
                  customer_id = $('#hs_subscriptions_customer_id').val();
                  customer_email = $('#hs_subscriptions_customer_email').val();
                  customer_param  = '&customer_id='+customer_id+'&customer_email='+customer_email;
                }
                try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
                var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+customer_param+"&discount="+discount;
                window.location.href = checkout_url;
              }else {
                if(discount !== '')
                {
                  discount = '?discount='+discount;
                }
                window.location.href = '/checkout'+discount;
              }
            }
          }
        },
        error: function(e,b,c){
        },
        complete:function(e){
        }
      });
    },
	contentPopup:function(data,$){
		if(data.enable_app == 1)
		{
          var elementSlideCart = $('.hs-popup-cart-sp-load'),stickycart_show_desktop = '',stickycart_devices_desktop = '',animatedHover = '',hs_hidden_count_cart = '',url = window.location.href,style_text = '',style = parseInt(data.style),class_style='',id_style='',iniCart = 1;
          if(elementSlideCart.length > 0)
          {
            return false;
          }
          if(style == 0)
          {
            class_style = ' hs-cart-drawer-0';
            id_style = ' id="hs-cart-drawer-by-shopify-0"'
          }
          if(style == 1)
          {
            class_style = ' hs-cart-drawer-1';
            id_style = ' id="hs-cart-drawer-by-shopify-1"'
          }
          if(style == 2)
          {
            class_style = ' hs-cart-drawer-2';
            id_style = ' id="hs-cart-drawer-by-shopify-2"'
          }
          if(url.indexOf('/cart') > -1){
            if(data.stickycart_hide_cart_page == 1){
            	iniCart = 0;
            }
          }
          if(data.stickycart_hide_if_empty == 1)
          {
            hs_hidden_count_cart = ' hs-hidden-count-cart';
          }
          if(data.stickycart_show_desktop == 0)
          {
            stickycart_show_desktop = ' hs-hidden-desktop-count-cart';
          }
          if(data.stickycart_devices_status == 0)
          {
            stickycart_devices_desktop = ' hs-hidden-devices-count-cart';
          }
          if(data.animatedHover == 1)
          {
          	animatedHover = ' animated bounceIn';
          }
          if(iniCart > 0)
          {
            if(data.status_widget == 1){
              $('body').append('<div class="hs-sticky-cart-cart-drawer'+animatedHover+hs_hidden_count_cart+stickycart_show_desktop+stickycart_devices_desktop+'"><span class="hs-sticky-cart-cart-drawer-content" style="background-color:'+data.background_cart_widget+';color:'+data.color_cart_widget+';"><mark style="background-color:'+data.background_count_widget+';color:'+data.color_count_widget+';">0</mark><i class="fa '+data.stickycart_icon+'" aria-hidden="true"></i></span></div>');
            }
            if(parseInt(data.status)){
            	$('body').append('<div class="hs-popup-cart-sp-load'+class_style+'"'+id_style+'><div class="hs-site-cart-popup"></div></div><div class="hs-bg-slide-cart" style="display: none;"></div>');
            }
            if(data.enable_event == 0)
            {
              $(HsCartDrawer.openSlideCart).unbind('click');
              $(HsCartDrawer.openSlideCart).click(function(e){
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                HsCartDrawer.openCartDrawerClick($(this),data,$);
              });
              HsCartDrawer.getCart(0,[],data,$);
            }
          }
        }
	},
    redirectCart:function(data,$){
      var d = new Date(), n = d.getTime();
      window.location.href = '/cart?'+n;
    },
    openCartDrawerClick:function(where,data,$){
      var stickycart_takes_user_to = parseInt(data.stickycart_takes_user_to),validate = where.hasClass('hs-open-cart-url');
      if(stickycart_takes_user_to == 2)
      {
        window.location.href = "/cart";
        return false;
      }
      if(stickycart_takes_user_to == 3)
      {
        window.location.href = "/checkout";
        return false;
      }
      if(!parseInt(data.status)){
        window.location.href = "/cart";
        return false;
      }
      if(!validate){
		  validate = where.hasClass('hs-open-cart-url-2');
	  }
		
      $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
	  $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');

      if(validate){
        HsCartDrawer.closeCart(data,$);
        $('.hs-popup-cart-sp-load').removeClass('active');
        $('.hs-popup-cart-sp-load').removeClass('active');
        $('.hs-load-popup-cart-show-products').hide();
        HsCartDrawer.hideCartPopup(data,$);
      }else{
        where.addClass('hs-open-cart-url');
        HsCartDrawer.positionPopup(data,$);
        HsCartDrawer.showCartPopup(data,$);
      }
      HsCartDrawer.notifyShow(data,$);
      HsCartDrawer.hideCartPopup(data,$);
    },
    openCartDrawer:function(data,$){
      HsCartDrawer.showCartPopup(data,$);
      HsCartDrawer.getCart(0,[],data,$)
    },
	positionPopup:function(data,$){
      if(parseInt(data.style) == 0)
      {
        return false;
      }
      if(parseInt(data.style) == 2)
      {
        return false;
      }
      var element = $('.hs-sticky-cart-cart-drawer a[href="/cart"].hs-open-cart-url')
      if(element.length == 0)
      {
        element = $('header a[href="/cart"],.cart-wrap');
        if(element.length > 1){
          element = element.eq(1);
        }
      }
      if(element.length == 0){
        element = $('header .Header__Icon');
      }

      var scroll = $(window).scrollTop();
      var zoom = 1;   
      var result_box_max_width = 440;
      //var result_box_width = 422;
      var result_box_width = 440;

      var bodyWidth = $('body').width();

      var offset = element.offset();
      var height = element.outerHeight();
      var width  = element.outerWidth();

      if (width > result_box_width)
        result_box_width = width;
      var top = offset.top + height;
      var right = offset.left + width;
      var left = offset.left;

      var diff = offset.left+result_box_max_width-bodyWidth;
      if (diff > 0) {
        diff = offset.left+result_box_width-right;
      } else {
        diff = 0;
      }
      left = left - diff;
      left = zoom*left;
      top = zoom*top;
      result_box_width = zoom*result_box_width;
      if (bodyWidth < result_box_width) {
        left = zoom*10;
        result_box_width = zoom*(bodyWidth - 20);
      }

      top = top - scroll;

      //top = top + 7.5;
      $( '.hs-popup-cart-sp-load' ).css( "left", left+"px" );
      $( '.hs-popup-cart-sp-load' ).css( "top", top+"px" );


      $(window).scroll(function(){
        var element = $('.hs-sticky-cart-cart-drawer a[href="/cart"].hs-open-cart-url');

        if(element.length == 0)
        {
          element = $('header a[href="/cart"],.cart-wrap');
          if(element.length > 1){
            element = element.eq(1);
          }
        }
        if(element.length == 0){
          element = $('header .Header__Icon');
        }
        var scroll = $(window).scrollTop();
        var zoom = 1;   
        var result_box_max_width = 440;
        //var result_box_width = 422;
        var result_box_width = 440;

        var bodyWidth = $('body').width();

        var offset = element.offset();
        var height = element.outerHeight();
        var width  = element.outerWidth();

        if (width > result_box_width)
          result_box_width = width;

        var top = offset.top + height;
        var right = offset.left + width;
        var left = offset.left;

        var diff = offset.left+result_box_max_width-bodyWidth;
        if (diff > 0) {
          diff = offset.left+result_box_width-right;
        } else {
          diff = 0;
        }
        left = left - diff;
        left = zoom*left;
        top = zoom*top;
        result_box_width = zoom*result_box_width;
        if (bodyWidth < result_box_width) {
          left = zoom*10;
          result_box_width = zoom*(bodyWidth - 20);
        }

        top = top - scroll;
        //top = top + 7.5;
        //console.log(top);
        $( '.hs-popup-cart-sp-load' ).css( "left", left+"px" );
        $( '.hs-popup-cart-sp-load' ).css( "top", top+"px" );
      });

	},
	notify:function(message,data,$){
		HsCartDrawer.notifyShow(data,$);
		$('.hs-message-notify-popup-cart').html('<p>'+message+'</p><a href="javascript:void(0);" class="hs-remove-notify"><svg width="12px" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 500 500" enable-background="new 0 0 500 500" xml:space="preserve"> <g> <rect x="230.626" y="-48.852" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -103.7603 250.4999)" stroke-width="1.2421" stroke-miterlimit="10" width="39.749" height="598.703"></rect> <rect x="230.626" y="-48.852" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 250.5026 604.7603)" stroke-width="1.2421" stroke-miterlimit="10" width="39.748" height="598.703"></rect></g></svg></a>');
	},
    notifyShow:function(data,$){
      $('.hs-load-notify-show').show();
      //$('.hs-message-notify-popup-cart').show();
    },
    notifyHide:function(data,$){
      $('.hs-load-notify-show').hide();
      //$('.hs-message-notify-popup-cart').hide();
    },
	addToCart:function(data,$){
      if(data.enable_event == true)
      {
        return false;
      }
	  HsCartDrawer.params = [];
	  $('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] button[type="button"][name="add"],form[action*="/cart/add"] button.tt-btn-addtocart,form[action="/cart/add"] button[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"],form[action="/cart/add"] button.btn-addtocart,form[action="/cart/add"] .button-cart,form[action="/cart/add"] .pt-btn-addtocart,form[action="/cart/add"] #add-to-cart').unbind('click');
      $('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] button[type="button"][name="add"],form[action*="/cart/add"] button.tt-btn-addtocart,form[action="/cart/add"] button[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"],form[action="/cart/add"] button.btn-addtocart,form[action="/cart/add"] .button-cart,form[action="/cart/add"] .pt-btn-addtocart,form[action="/cart/add"] #add-to-cart').click(function(e){
        e.preventDefault();
        var where = $(this),arrProperties = [],concatProperties = '',elementForm = where.closest('form'),element = where.closest('form').find('select[name="id"]'),variantid = element.val(),qty = where.closest('form').find('input[name="quantity"]'),quantity = 1;
        if(!where.closest('form')[0].checkValidity())
        {
          return false;
        }
        if(elementForm.serializeArray())
        {
          $.each( elementForm.serializeArray(), function( i, l ){
             if(l.name.indexOf('properties[') > -1){
               l.name = l.name.replace("properties[", "");
               l.name = l.name.replace("]", "");
               concatProperties = concatProperties.concat("'"+l.name+"':'"+l.value+"',");
             }
             if(l.name == 'id'){
               variantid = l.value;
             }
             if(!variantid)
             {
               variantid = where.attr('data-add-id');
             }
             if(l.name == 'quantity'){
               quantity = l.value;
             }
          });
          if(concatProperties)
          {
            concatProperties = concatProperties.slice(0, -1);
            concatProperties = concatProperties.replace("\r\n", "\\n")
            concatProperties = JSON.stringify(eval("({" + concatProperties + "})"));
            concatProperties = JSON.parse(concatProperties);
          }
        }
        if($('.spb-fileupload').find('input[name="file"]').length > 0)
        {
          if($('.spb-fileupload').find('input[name="file"]').val() === '')
          {
            return false;
          }
        }
		$('header a[href*=cart]').addClass('hs-open-cart-url-2');
        HsCartDrawer.params = {'id':variantid,'quantity':quantity};
        if(concatProperties)
        {
          HsCartDrawer.params = {'id':variantid,'quantity':quantity,properties: concatProperties};
        }
        HsCartDrawer.ajaxProductCart(HsCartDrawer.params,where,data,$);
      });
      $('.Popover__Value').unbind('click');
      $('.Popover__Value').click(function(e){	
        setTimeout(function(){ HsCartDrawer.addToCart(data,$); }, 100);
      });
	},
	replaceSymbol:function(v){
		v = v.toLowerCase();
		v = v.replace(/\s/g, "-");
		v = v.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-");
		return v;
	},
	removeDisabledButton:function(a,where,data,$){
        setTimeout(function(){
          if(a == 1)
          {
          	where.html('<span><i class="fa fa-check"></i></span>');
          }
          setTimeout(function(){ 
            where.removeAttr('disabled');
            where.html('<span><i class="fa '+data.quickbuybutton_icon+'"></i></span>');
            where.removeClass('hs-loading-cart');
          }, 500);
        }, 200);
	},
  	changeButton:function(where,data,$){
        setTimeout(function(){
          where.removeClass('hs-loading-btn');
        }, 200);
	},
	showApp:function(data,$){
      $('.content-popup-cart-product-form').show();
      $('.product-form__cart-submit_popup_cart').show();
      $('.wrapper.wrapper--margins .pagination.text-center').css('margin-top','50px');
	},
    resizeDesktopAndMobile:function(data,$){
      var sticky_cart_bar_mobile_show_scroll = parseInt(data.sticky_cart_bar_mobile_show_scroll),
          sticky_cart_bar_desktop_hide_add_to_cart = parseInt(data.sticky_cart_bar_desktop_hide_add_to_cart),
          sticky_cart_bar_mobile_hide_add_to_cart = parseInt(data.sticky_cart_bar_mobile_hide_add_to_cart),
          sticky_cart_bar_mobile_show_full_width = parseInt(data.sticky_cart_bar_mobile_show_full_width),
          sticky_cart_bar_desktop_show_product_image = parseInt(data.sticky_cart_bar_desktop_show_product_image),
          sticky_cart_bar_mobile_show_product_image = parseInt(data.sticky_cart_bar_mobile_show_product_image),
          sticky_cart_bar_desktop_show_product_title = parseInt(data.sticky_cart_bar_desktop_show_product_title),
          sticky_cart_bar_mobile_show_product_title = parseInt(data.sticky_cart_bar_mobile_show_product_title),
          sticky_cart_bar_desktop_show_review_stars = parseInt(data.sticky_cart_bar_desktop_show_review_stars),
          sticky_cart_bar_mobile_show_review_stars = parseInt(data.sticky_cart_bar_mobile_show_review_stars),
          sticky_cart_bar_desktop_show_variant_select = parseInt(data.sticky_cart_bar_desktop_show_variant_select),
          sticky_cart_bar_mobile_show_variant_select = parseInt(data.sticky_cart_bar_mobile_show_variant_select),
          sticky_cart_bar_desktop_show_quantity_select = parseInt(data.sticky_cart_bar_desktop_show_quantity_select),
          sticky_cart_bar_mobile_show_quantity_select = parseInt(data.sticky_cart_bar_mobile_show_quantity_select),
          sticky_cart_bar_desktop_show_price = parseInt(data.sticky_cart_bar_desktop_show_price),
          sticky_cart_bar_mobile_show_price = parseInt(data.sticky_cart_bar_mobile_show_price),
          sticky_cart_bar_desktop_show_compare_price = parseInt(data.sticky_cart_bar_desktop_show_compare_price),
          sticky_cart_bar_mobile_show_compare_price = parseInt(data.sticky_cart_bar_mobile_show_compare_price),
          sticky_cart_bar_desktop_show_devices = parseInt(data.sticky_cart_bar_desktop_show_devices),
          sticky_cart_bar_mobile_show_devices = parseInt(data.sticky_cart_bar_mobile_show_devices),
          stickycart_devices_status = parseInt(data.stickycart_devices_status),
          stickycart_show_desktop = parseInt(data.stickycart_show_desktop),
          show_on_tablets_and_mobile_devices_quick_buy_button = parseInt(data.show_on_tablets_and_mobile_devices_quick_buy_button),
          show_on_desktop_computers_quick_buy_button = parseInt(data.show_on_desktop_computers_quick_buy_button);
          if($( window ).width() < 769)
          {
            $('.hs-content-checkout-bar').removeClass('hs-hidden-header');
            if(!sticky_cart_bar_mobile_show_product_image){
              if(!sticky_cart_bar_mobile_show_product_title){
                if(!sticky_cart_bar_mobile_show_variant_select){
                  if(!sticky_cart_bar_mobile_show_quantity_select){
                    if(!sticky_cart_bar_mobile_show_price)
                    {
                      if(!sticky_cart_bar_mobile_show_compare_price){
                        $('.hs-content-checkout-bar').addClass('hs-hidden-header');
                      }
                    }
                  }
                }
              }
            }
            if(!stickycart_devices_status)
            {
              $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
            }else{
              $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
            }
            if(!show_on_tablets_and_mobile_devices_quick_buy_button)
            {
              $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
            }else{
              $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
            }

            if(!sticky_cart_bar_mobile_show_devices)
            {
              $('.hs-content-checkout-bar').hide();
            }else{
              $('.hs-content-checkout-bar').show();
            }

            if(!sticky_cart_bar_mobile_show_compare_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').show();
            }

            if(!sticky_cart_bar_mobile_show_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-price').show();
            }

            if(!sticky_cart_bar_mobile_show_quantity_select){
                $('.hs-content-checkout-bar .hs-content-quantity').hide();
            }else{
                $('.hs-content-checkout-bar .hs-content-quantity').show();
            }

            if(!sticky_cart_bar_mobile_show_variant_select){
              	$('.hs-content-checkout-bar').addClass('hs-hidden-select');
              	$('.hs-content-checkout-bar .hs-select-box-load').hide();
            }else{
              	$('.hs-content-checkout-bar').removeClass('hs-hidden-select');
				$('.hs-content-checkout-bar .hs-select-box-load').show();
            }
            
            $('.hs-content-checkout-bar').removeClass('hs-hidden-select');
            if($('.hs-load-select-box-bar-1').find('.hs-select-option-checkout-bar').find('[value="Default Title"]').length > 0)
            {
              $('.hs-content-checkout-bar').addClass('hs-hidden-select');
            }
            
            if(!sticky_cart_bar_mobile_show_review_stars){
                $('.hs-content-checkout-bar .hs-product-review').hide();
            }else{
                $('.hs-content-checkout-bar .hs-product-review').show();
            }

            if(!sticky_cart_bar_mobile_show_product_title){
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').hide();
                $('.hs-content-checkout-bar .hs-content-variant-select-option .hs-btn-checkout-bar').show();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').show();
                $('.hs-content-checkout-bar .hs-content-variant-select-option .hs-btn-checkout-bar').hide();
            }

            if(!sticky_cart_bar_mobile_show_product_image){
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').hide();
            }else{
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').show();
            }

            if(!sticky_cart_bar_mobile_hide_add_to_cart){
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').show();
            }else{
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').hide();
            }

          }else{
            $('.hs-content-checkout-bar').removeClass('hs-hidden-header');
            if(!stickycart_show_desktop)
            {
                $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
            }
            if(!show_on_desktop_computers_quick_buy_button)
            {
                $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
            }else{
                $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
            }

            if(!sticky_cart_bar_desktop_show_devices)
            {
                $('.hs-content-checkout-bar').hide();
            }else{
                $('.hs-content-checkout-bar').show();
            } 
            if(!sticky_cart_bar_desktop_show_compare_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').show();
            }
            if(!sticky_cart_bar_desktop_show_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-price').show();
            }
            if(!sticky_cart_bar_desktop_show_quantity_select){
              $('.hs-content-checkout-bar .hs-content-quantity').hide();
            }else{
              $('.hs-content-checkout-bar .hs-content-quantity').show();
            }
            $('.hs-content-checkout-bar').removeClass('hs-hidden-select');
            if($('.hs-load-select-box-bar-1').find('.hs-select-option-checkout-bar').find('[value="Default Title"]').length > 0)
            {
              $('.hs-content-checkout-bar').addClass('hs-hidden-select');
            }
            if(!sticky_cart_bar_desktop_show_variant_select){
              $('.hs-content-checkout-bar .hs-select-box-load').hide();
            }else{
              $('.hs-content-checkout-bar .hs-select-box-load').show();
            } 
            if(!sticky_cart_bar_desktop_show_review_stars){
              $('.hs-content-checkout-bar .hs-product-review').hide();
            }else{
              $('.hs-content-checkout-bar .hs-product-review').show();
            }
            if(!sticky_cart_bar_desktop_show_product_title){
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').hide();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').show();
            }  
            if(!sticky_cart_bar_desktop_show_product_image){
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').hide();
            }else{
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').show();
            }
            if(!sticky_cart_bar_desktop_hide_add_to_cart){
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').show();
            }else{
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').hide();
            }
          }
      $( window ).resize(function() {
		$(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
          if($( window ).width() < 769)
          {
            $('.hs-content-checkout-bar').removeClass('hs-hidden-header');
            if(!sticky_cart_bar_mobile_show_product_image){
              if(!sticky_cart_bar_mobile_show_product_title){
                if(!sticky_cart_bar_mobile_show_variant_select){
                  if(!sticky_cart_bar_mobile_show_quantity_select){
                    if(!sticky_cart_bar_mobile_show_price)
                    {
                      if(!sticky_cart_bar_mobile_show_compare_price){
                        $('.hs-content-checkout-bar').addClass('hs-hidden-header');
                      }
                    }
                  }
                }
              }
            }
            if(!stickycart_devices_status)
            {
              $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
            }else{
              $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
            }
            if(!show_on_tablets_and_mobile_devices_quick_buy_button)
            {
              $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
            }else{
              $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
            }

            if(!sticky_cart_bar_mobile_show_devices)
            {
              $('.hs-content-checkout-bar').hide();
            }else{
              $('.hs-content-checkout-bar').show();
            }

            if(!sticky_cart_bar_mobile_show_compare_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').show();
            }

            if(!sticky_cart_bar_mobile_show_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-price').show();
            }

            if(!sticky_cart_bar_mobile_show_quantity_select){
                $('.hs-content-checkout-bar .hs-content-quantity').hide();
            }else{
                $('.hs-content-checkout-bar .hs-content-quantity').show();
            }

            if(!sticky_cart_bar_mobile_show_variant_select){
              	$('.hs-content-checkout-bar').addClass('hs-hidden-select');
              	$('.hs-content-checkout-bar .hs-select-box-load').hide();
            }else{
              	$('.hs-content-checkout-bar').removeClass('hs-hidden-select');
				$('.hs-content-checkout-bar .hs-select-box-load').show();
            }
            
            $('.hs-content-checkout-bar').removeClass('hs-hidden-select');
            if($('.hs-load-select-box-bar-1').find('.hs-select-option-checkout-bar').find('[value="Default Title"]').length > 0)
            {
              $('.hs-content-checkout-bar').addClass('hs-hidden-select');
            }
            
            if(!sticky_cart_bar_mobile_show_review_stars){
                $('.hs-content-checkout-bar .hs-product-review').hide();
            }else{
                $('.hs-content-checkout-bar .hs-product-review').show();
            }

            if(!sticky_cart_bar_mobile_show_product_title){
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').hide();
                $('.hs-content-checkout-bar .hs-content-variant-select-option .hs-btn-checkout-bar').show();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').show();
                $('.hs-content-checkout-bar .hs-content-variant-select-option .hs-btn-checkout-bar').hide();
            }

            if(!sticky_cart_bar_mobile_show_product_image){
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').hide();
            }else{
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').show();
            }

            if(!sticky_cart_bar_mobile_hide_add_to_cart){
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').show();
            }else{
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').hide();
            }

          }else{
            $('.hs-content-checkout-bar').removeClass('hs-hidden-header');
            if(!stickycart_show_desktop)
            {
                $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
            }
            if(!show_on_desktop_computers_quick_buy_button)
            {
                $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
            }else{
                $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
            }

            if(!sticky_cart_bar_desktop_show_devices)
            {
                $('.hs-content-checkout-bar').hide();
            }else{
                $('.hs-content-checkout-bar').show();
            } 
            if(!sticky_cart_bar_desktop_show_compare_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').show();
            }
            if(!sticky_cart_bar_desktop_show_price){
              $('.hs-content-checkout-bar .hs-checkout-bar-price').hide();
            }else{
              $('.hs-content-checkout-bar .hs-checkout-bar-price').show();
            }
            if(!sticky_cart_bar_desktop_show_quantity_select){
              $('.hs-content-checkout-bar .hs-content-quantity').hide();
            }else{
              $('.hs-content-checkout-bar .hs-content-quantity').show();
            }
            $('.hs-content-checkout-bar').removeClass('hs-hidden-select');
            if($('.hs-load-select-box-bar-1').find('.hs-select-option-checkout-bar').find('[value="Default Title"]').length > 0)
            {
              $('.hs-content-checkout-bar').addClass('hs-hidden-select');
            }
            if(!sticky_cart_bar_desktop_show_variant_select){
              $('.hs-content-checkout-bar .hs-select-box-load').hide();
            }else{
              $('.hs-content-checkout-bar .hs-select-box-load').show();
            } 
            if(!sticky_cart_bar_desktop_show_review_stars){
              $('.hs-content-checkout-bar .hs-product-review').hide();
            }else{
              $('.hs-content-checkout-bar .hs-product-review').show();
            }
            if(!sticky_cart_bar_desktop_show_product_title){
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').hide();
            }else{
                $('.hs-content-checkout-bar .hs-sticky-bar-product-title').show();
            }  
            if(!sticky_cart_bar_desktop_show_product_image){
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').hide();
            }else{
                $('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image').show();
            }
            if(!sticky_cart_bar_desktop_hide_add_to_cart){
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').show();
            }else{
                $('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart').hide();
            }
          }
      });
    },
	resize:function(data,$){
      if($( window ).width() < 600)
      {
          $('.hs-popup-cart-sp-load').removeClass('hs-desktop-content-cart');
          $('.hs-popup-cart-sp-load').addClass('hs-mobile-content-cart');
      }else{
          $('.hs-popup-cart-sp-load').removeClass('hs-mobile-content-cart');
          $('.hs-popup-cart-sp-load').addClass('hs-desktop-content-cart');
      }
      $( window ).resize(function() {
        delay(function(){
          HsCartDrawer.positionPopup(data,$);
          HsCartDrawer.mobileCart($(this),data,$);
          HsCartDrawer.HideCart(data,$);
          HsCartDrawer.mgTop(data,$);
          HsCartDrawer.swiperHSCart(data,$);
        }, 200 );
      });
	},
    HideCart:function(data,$){
      	$('.hs-popup-cart-sp-load.hs-cart-drawer-1.hs-desktop-content-cart').removeClass('active');
    },
    mobileCart:function(where,data,$){
        if (where.width() < 600) {
          $('.hs-popup-cart-sp-load').removeClass('hs-desktop-content-cart');
          $('.hs-popup-cart-sp-load').addClass('hs-mobile-content-cart');
        }else{
          $('.hs-popup-cart-sp-load').removeClass('hs-mobile-content-cart');
          $('.hs-popup-cart-sp-load').addClass('hs-desktop-content-cart');
        }
    },
	getParameterByName:function (name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, "+"));
    },
    clearALL:function(data,$){
      $('.hs-clear-all-button').unbind('click');
      $('.hs-clear-all-button').click(function(e){
        e.preventDefault();
		HsCartDrawer.ajaxClearAll(data,$)
      });
    },
    ajaxClearAll:function(data,$){
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        async:true,
        success: function(response) {
          if(typeof window.BOLD !== 'undefined'
             && typeof window.BOLD.common !== 'undefined'
             && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            // NOTE: "cart" should be the variable containing the cart json data
            response = window.BOLD.common.cartDoctor.fix(response);
          }
          if(response)
          {
            var header = '<div class="hs-close-popup-cart"><div class="hs-header-close-empty"><span class="hs-shopping-cart-icon"><i class="fa '+data.stickycart_icon+'" aria-hidden="true"></i></span><h2>'+data.shopping_cart_text+'</h2><a href="javascript:void(0)" class="hs-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="12px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg></a></div></div>';
            $('.hs-popup-cart-sp-load .hs-site-cart-popup').html('<form action="/cart" method="post" novalidate class="sn-cart">'+header+'<div class="hs-content-empty-cart">'+data.no_result_text+'</div></div>');
            if(data.style == 2)
            {
              //$('.hs-popup-cart-sp-load').removeClass('active');
            }
            HsCartDrawer.removeCart(data,$);
            HsCartDrawer.countCart(response,data,$);
            HsCartDrawer.priceCart(response,data,$);
            $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url');
            $(HsCartDrawer.openSlideCart).removeClass('hs-open-cart-url-2');
          }
        },
        error: function(e) {
          //console.log(e);
        },
        complete:function(e){
          HsCartDrawer.plusMin(data,$);
          HsCartDrawer.removeItemCart(data,$);
          HsCartDrawer.positionPopup(data,$);
          HsCartDrawer.hideCartPopup(data,$);
          HsCartDrawer.changeQuantityCart(data,$);
          HsCartDrawer.clearALL(data,$);
        }
      });
    },
	removeCart:function(data,$){
		$('.hs-popup-cart-sp-load').removeClass('active');
		HsCartDrawer.closeCart(data,$);
	},
    addComboboxCollections:function(data,$){
      if (typeof HsCartDrawerCollection !== 'undefined') {
     	 var json = HsCartDrawerCollection.HsJson(),content = '',quantity = '',button='',flag = '',filterText1 = '',filterText2 = '',filterText3 = '',options = [],variants = [],filteredArr1 = [],filteredArr2 = [],filteredArr3 = [],opt1= [],opt2= [],opt3= [],option1 = '',option2 = '',option3 = '',selectParent = '',selectVariant = '';
      	 if(json)
         {
           $.each(json, function( index, value ) {
             options = value.options;
             variants = value.variants;
             selectParent = '';
             selectVariant = '';
             opt1 = [];
             opt2 = [];
             opt3 = [];
             $.each(variants, function( x, n ) {
               option1 = '';
               option2 = '';
               option3 = '';
               $.each(n.options, function( u, w ) {
                 if(u == 0)
                 {
                   option1 = w;
                 }
                 if(u == 1)
                 {
                   option2 = w;
                 }
                 if(u == 2)
                 {
                   option3 = w;
                 }
               });
               if(option1.length > 0)
               {
                 opt1.push(option1);
               }
               if(option2.length > 0)
               {
                 opt2.push(option2);
               }
               if(option3.length > 0)
               {
                 opt3.push(option3);
               }
               selectParent = selectParent.concat('<option value="'+n.title+'" title="'+n.title+'" data-id="'+value.id+'" data-price="'+n.price+'" data-sku="'+n.sku+'" data-available="'+n.available+'" data-barcode="'+n.barcode+'" data-featuredimage="'+value.featured_image+'" data-inventorymanagement="'+n.inventory_management+'" data-compareatprice="'+n.compare_at_price+'" data-variantid="'+n.id+'">'+n.title+'</option>');
               selectVariant = selectVariant.concat('<li data-id="'+value.id+'" data-vid="'+n.id+'"><span>'+n.title+'</li></span>');
             });
             filterText1 = '';
             filterText2 = '';
             filterText3 = '';
             selectVariant = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-'+value.id+'">'+selectVariant+'</ul>';
             quantity = '<input type="number" class="satcb_qb_quantity satcb_qb_quantity_top_right" name="satcb_qb_quantity" value="1" min="1" style="position: absolute; background: #fff; width: 85px; height: 35px; min-height: 35px; top: 4px; left: 4px; display: block; z-index: 3; border-radius: 17px; padding: 7px 5px 7px 40px; margin: 0; text-align: center; border: 1px solid #eee; color: #a0a0a0;">';
             button = '<button type="button" class="hs-add-to-cart hs-button-cart-'+value.id+' animated bounceIn" data-id="'+value.id+'"><span><i class="fa '+data.quickbuybutton_icon+'"></i></span></button>';
             flag = '<div class="hs-flag-content hs-flag-'+value.id+'" style="display:none;"></div>';
             selectParent = '<select class="hs-option-parent-'+value.id+' hs-select-option-add-to-cart" data-id="'+value.id+'" name="none" style="display:none;">'+selectParent+'</select>';
             filteredArr1 = opt1.filter(function(item, index) {
               if (opt1.indexOf(item) == index)
                 return item;
             });
             filteredArr2 = opt2.filter(function(item, index) {
               if (opt2.indexOf(item) == index)
                 return item;
             });
             filteredArr3 = opt3.filter(function(item, index) {
               if (opt3.indexOf(item) == index)
                 return item;
             });
             if(filteredArr1.length > 0)
             {
               $.each(filteredArr1, function( i, v ) {
                 filterText1 = filterText1.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
               });
               filterText1 = '<div class="hs-select-box-load"><span class="hs-select-text">'+value.options[0]+'</span><select class="hs-option-'+value.id+'-0 hs-select-option" name="none">'+filterText1+'</select></div>';
             }
             if(filteredArr2.length > 0)
             {
               $.each(filteredArr2, function( i, v ) {
                 filterText2 = filterText2.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
               });
               filterText2 = '<div class="hs-select-box-load"><span class="hs-select-text">'+value.options[1]+'</span><select class="hs-option-'+value.id+'-1 hs-select-option" name="none">'+filterText2+'</select></div>';
             }
             if(filteredArr3.length > 0)
             {
               $.each(filteredArr3, function( i, v ) {
                 filterText3 = filterText3.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
               });
               filterText3 = '<div class="hs-select-box-load"><span class="hs-select-text">'+value.options[2]+'</span><select class="hs-option-'+value.id+'-2 hs-select-option" name="none">'+filterText3+'</select></div>';
             }
             if(data.show_quantity_selector_buy_button == 0)
             {
               quantity = '';
             }
             content = '<div class="hs-change-select-option" style="display:none;">'+filterText1+filterText2+filterText3+'</div>'+selectParent;
             $('.hs-product-cart-drawer-'+value.id).html(content);
			 $('.hs-product-cart-drawer-'+value.id).parent('div').css('position','relative');
             $('.hs-product-cart-drawer-'+value.id).parent('div').append(button+quantity+flag+selectVariant);
           });
           HsCartDrawer.changeVariants(data,$);
           HsCartDrawer.onLoadVariants(data,$);
         }
      }
    },
    captureVariants:function(text,data,$){
      var arr = [];
      if(HsCartDrawer.arr_variants)
      {
        $.each(HsCartDrawer.arr_variants, function( index, value ) {
			if(text === value.title)
            {
              arr.push(value);
            }
        });
        arr = arr[0];
      }
      return arr;
    },
	callBackVariant:function(variant,data,$){
		if(!variant)
        {
          $('.hs-checkout-bar-add-to-cart').html(data.text_unavailable);
          $('.hs-checkout-bar-add-to-cart').attr('disabled','disabled');
          return false;
        }
        var url = window.location.href,featured_image = '',variantid = variant.id,available = variant.available,price = variant.price,compareatprice = variant.compare_at_price,compare_price_active = '';
        $('select.hs-select-variants-bar').val(variantid).change();
		$('.hs-checkout-bar-compare-at-price').html('');
		$('.hs-checkout-bar-price').html('');
      	if(variant.featured_image != null)
        {
          featured_image = HsCartDrawer.imageResize(variant.featured_image.src,'thumb');
          $('.hs-bar-featured-image').attr('src',featured_image);
        }
		if(compareatprice)
		{
			if(compareatprice > price)
			{
              	compare_price_active = ' hs-compare-price-active';
              	compareatprice = HsCartDrawer.vat(compareatprice,data,$);
				$('.hs-checkout-bar-compare-at-price').html('<s class="hs-money-compare-price">'+hsonslidecart.Currency.formatMoney(compareatprice, data['money_format'])+'</s>');	
			}
		}
		if(price)
		{
          	price = HsCartDrawer.vat(price,data,$);
			$('.hs-checkout-bar-price').html('<span class="hs-product-price"><span class="money" data-product-id="'+ variant.id +'">'+ hsonslidecart.Currency.formatMoney(variant.price, data['money_format']) + '</span></span>');
		}
        if(available)
        {
            url = HsCartDrawer.removeParam('variant',url);
            url = HsCartDrawer.URL_add_parameter(url,'variant',variantid);
            window.history.pushState({}, "keywords", url);
          	$('.hs-checkout-bar-add-to-cart').removeAttr('disabled');
          	$('.hs-checkout-bar-add-to-cart').html('<span class="hs-add--to--cart">'+data.text_add_to_cart+'</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span>');
        }else{
          	$('.hs-checkout-bar-add-to-cart').attr('disabled','disabled');
          	$('.hs-checkout-bar-add-to-cart').html(data.text_stock);
            url = HsCartDrawer.removeParam('variant',url);
            url = HsCartDrawer.URL_add_parameter(url,'variant',variantid);
            window.history.pushState({}, "keywords", url);  
        }
      
        //BOLD PRE
        if(typeof BOLD === "object" &&
           typeof BOLD.pre === "object" &&
           typeof BOLD.pre.events === "object" &&
           typeof BOLD.pre.events.emit === "function"){
          BOLD.pre.events.emit("variant_changed", {variant: variant});
        }
        //End BOLD PRE
	},
    upsellVariants:function(data,$){
      $('.hs-swipper-select-option-add-to-cart').unbind('change');
      $('.hs-swipper-select-option-add-to-cart').change(function(e){
        e.preventDefault();
        var variant = [];
        var variantid = $(this).find('option:selected').data('variantid');
        var price = hsonslidecart.Currency.formatMoney($(this).find('option:selected').data('price'), data['money_format']);
        var compareatprice = hsonslidecart.Currency.formatMoney($(this).find('option:selected').data('compareatprice'), data['money_format']);
        var image = $(this).find('option:selected').data('featuredimage');
        var available = $(this).find('option:selected').data('available');
        var image = $(this).find('option:selected').data('featuredimage');
        var handle = $(this).find('option:selected').data('handle');
        variant.push({id:variantid,available:available,compare_at_price:compareatprice,price:price});
        $(this).closest('.hs-content-product-slide-cart').find('.hs-upsell-add').find('.hs-upsell-add-to-cart').removeAttr('disabled');
        if(image)
        {
          $(this).closest('.hs-content-product-slide-cart').find('.hs-product-content-image-swipper').find('img').attr('src',image);
        }
        if(available)
        {
          $(this).closest('.hs-content-product-slide-cart').find('.hs-product-content-image-swipper').find('a').attr('href',handle+'?variant='+variantid);
          $(this).closest('.hs-content-product-slide-cart').find('.hs-upsell-add').find('.hs-upsell-add-to-cart').find('.hs-add--to--cart').html(data.text_add);
          $(this).closest('.hs-content-title-price-swiper').find('.hs-price-sw').html(price);
          $(this).closest('.hs-content-title-price-swiper').find('.hs-compare-price-sw').html(compareatprice);
        }else{
          $(this).closest('.hs-content-product-slide-cart').find('.hs-upsell-add').find('.hs-upsell-add-to-cart').prop('disabled', true);
          $(this).closest('.hs-content-product-slide-cart').find('.hs-upsell-add').find('.hs-upsell-add-to-cart').find('.hs-add--to--cart').html(data.text_stock);
          $(this).closest('.hs-content-title-price-swiper').find('.hs-price-sw').html(price);
          $(this).closest('.hs-content-title-price-swiper').find('.hs-compare-price-sw').html(compareatprice);
        }
        
      });
      $('.hs-cart-plus-minus-upsell input').unbind('keyup');
      $('.hs-cart-plus-minus-upsell input').keyup(function(e){
        e.preventDefault();
        this.value = this.value.replace(/[^0-9\.]/g,'');
        if(!this.value)
        {
          this.value = 1;
        }
        if(this.value == 0)
        {
          this.value = 1;
        }
      });
      $('.hs-qtybutton-upsell').unbind('click');
      $('.hs-qtybutton-upsell').click(function(e){
        var arr_variants = [],
            $button = $(this),
            newVal = 0,
            oldValue = $button.closest('.hs-item-cart-qty-upsell').find('input').val();
        if ($button.hasClass('hs-inc-upsell')) {
          newVal = parseFloat(oldValue) + 1;
        } else {
          // Don't allow decrementing below zero
          if (oldValue > 1) {
            newVal = parseFloat(oldValue) - 1;
          } else {
            newVal = 1;
          }
        }
        $button.closest('.hs-item-cart-qty-upsell').find('input').val(newVal);
      });
    },
    changeVariantsCheckoutBar:function(data,$){
      var variant = '';
      if($('form[action="/cart/add"]').find('select').length > 0)
      {
        $('form[action="/cart/add"]').find('select').each(function( index ) {
          var select_index = $(this).attr('name');
            if(select_index !== "id"){
              $(this).change(function(e){
                var value = $(this).val(),text = '',value_variant = [];
				$('form[action="/cart/add"]').find('select').each(function( xxx ) {
					var where = $(this),value_select = where.val(),select_index_child = where.attr('name');
                      if(select_index_child !== "id"){
                        if(select_index_child !== "quantity")
                        {
                          if(select_index_child !== "none")
                          {
                            if(value_select != null)
                            {
                              value_variant.push(value_select);
                              text = text.concat(value_select+' / ');
                            }
                          }
                        }
                    }
				});
				if(text)
				{
					text = text.slice(0, -3);
				}
				if(value_variant.length > 0){
					$.each(value_variant, function( index, value ) {
						$('.hs-content-variant-select-option').find('.hs-change-select-option').find('.hs-select-box-load').eq(index).find('select.hs-select-option-checkout-bar').val(value);
					});
					variant = HsCartDrawer.captureVariants(text,data,$);
					HsCartDrawer.callBackVariant(variant,data,$);
				}
              });
            }
        });
      }
      $('.hs-sticky-bar-product-title').unbind('click');
      $('.hs-sticky-bar-product-title').click(function(e){
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "slow");
      });
      $('.hs---buttons_added input').unbind('keyup');
      $('.hs---buttons_added input').keyup(function(e){
        e.preventDefault();
        this.value = this.value.replace(/[^0-9\.]/g,'');
        if(!this.value)
        {
          this.value = 1;
        }
        if(this.value == 0)
        {
          this.value = 1;
        }
        $('input.hs-quick-button-quantity2').val(this.value);
      });
      $('.hs---qty').unbind('click');
      $('.hs---qty').click(function(e){
        var arr_variants = [],
            $button = $(this),
            newVal = 0,
            oldValue = $button.closest('.hs---buttons_added').find('input').val();
        if ($button.hasClass('hs---plus')) {
          newVal = parseFloat(oldValue) + 1;
        } else {
          // Don't allow decrementing below zero
          if (oldValue > 1) {
            newVal = parseFloat(oldValue) - 1;
          } else {
            newVal = 1;
          }
        }
        $('input.hs-quick-button-quantity2').val(newVal);
        //$button.closest('.hs---buttons_added').find('input').val(newVal);
      });
      $('.hs-select-option-checkout-bar').unbind('change');
      $('.hs-select-option-checkout-bar').change(function(e){
        e.preventDefault();
        var id = $(this).find('option:selected').data('id'),value = $(this).val(),variant_option = '',text='',arr = [],variant = [];
        $('.hs-content-variant-select-option').find('.hs-change-select-option').find('.hs-select-box-load').each(function( index ) {
          text = text.concat($( this ).find('select').val()+' / ');
          arr.push($( this ).find('select').val());
        });
        if(text)
        {
          text = text.slice(0, -3);
        }
        if($('form[action="/cart/add"]').find('select').length > 0)
        {
          $('form[action="/cart/add"]').find('select').each(function( index ) {
            var select_index = $(this).attr('name');
              if(select_index !== "id"){
				if(value == arr[index])
				{
					var id = $(this).attr('id');
					$(this).val(arr[index]); 
					var element = document.getElementById(id);
					var evt = document.createEvent('HTMLEvents');
					evt.initEvent('change', false, true);
					element.dispatchEvent(evt);
				}
              }
          });
        }
		variant = HsCartDrawer.captureVariants(text,data,$);
		HsCartDrawer.callBackVariant(variant,data,$);
      });
      $('form[action="/cart/add"]').find('select[name="id"]').trigger('change');
      $('.hs-checkout-bar-add-to-cart').click(function(e){
        e.preventDefault();
        var where = $(this),element_variant_id = $('form[action="/cart/add"] input[name="id"]'),variantid = $('form[action="/cart/add"] select[name="id"]').val(),element = $('.hs-change-select-option .hs-content-quantity input.hs-quick-button-quantity2'),quantity=1;
        if(element.length > 0)
        {
          quantity = element.val();
        }
        if(element_variant_id.length > 0)
        {
          variantid = element_variant_id.val();
        }
        if(!variantid) { 
          variantid = $(this).closest('.hs-content-checkout-bar').find('.hs-content-variant-select-option').find('select.hs-select-variants-bar').val(); 
        }
        where.addClass('hs-loading-btn');
        quantity = parseInt(quantity);
		$('header a[href*=cart]').addClass('hs-open-cart-url-2');
        HsCartDrawer.params = {id:variantid,quantity:quantity};
        HsCartDrawer.ajaxBarCart(1,HsCartDrawer.params,where,data,$);
      });
      
	  var sticky_cart_bar_mobile_show_scroll = data.sticky_cart_bar_mobile_show_scroll;
      var aTop = 80;
	  if($( window ).width() < 770)
	  {
		if(sticky_cart_bar_mobile_show_scroll == 0){
			aTop = 0;
		}
	  }
      $('.hs-sticky-checkout-bar').addClass('hs-hide-element');
      $('.hs-sticky-checkout-bar').removeClass('hs-show-element');

      if($(window).scrollTop()>=aTop){
        $('.hs-sticky-checkout-bar').removeClass('hs-hide-element');
        $('.hs-sticky-checkout-bar').addClass('hs-show-element');

      }
      $(window).scroll(function(){
		aTop = 80;
		if($( window ).width() < 770)
		{
			if(sticky_cart_bar_mobile_show_scroll == 0){
				aTop = 0;
			}
		}
		  
        $('.hs-sticky-checkout-bar').addClass('hs-hide-element');
        $('.hs-sticky-checkout-bar').removeClass('hs-show-element');

        if($(this).scrollTop()>=aTop){
          $('.hs-sticky-checkout-bar').removeClass('hs-hide-element');
          $('.hs-sticky-checkout-bar').addClass('hs-show-element');

        }
      });
		
	  $( window ).resize(function() {
		  aTop = 80;
		  if($(this).width() < 770)
		  {
			if(sticky_cart_bar_mobile_show_scroll == 0){
				aTop = 0;

			}
		  }
		  $('.hs-sticky-checkout-bar').addClass('hs-hide-element');
		  $('.hs-sticky-checkout-bar').removeClass('hs-show-element');

		  if($(this).scrollTop()>=aTop){
			$('.hs-sticky-checkout-bar').removeClass('hs-hide-element');
			$('.hs-sticky-checkout-bar').addClass('hs-show-element');
		  }
	  });
      
      if($('form[action="/cart/add"]').find('select').length > 0)
      {
        $('form[action="/cart/add"]').find('select').each(function( xxx ) {
          var select_index_child = $(this).attr('name');
          if(select_index_child !== "id"){
            if(select_index_child !== "quantity")
            {
              $(this).change();
            }
          }
        });
      }
    },
    URL_add_parameter: function(url, param, value){
      var hash       = {};
      var parser     = document.createElement('a');

      parser.href    = url;

      var parameters = parser.search.split(/\?|&/);

      for(var i=0; i < parameters.length; i++) {
        if(!parameters[i])
          continue;

        var ary      = parameters[i].split('=');
        hash[ary[0]] = ary[1];
      }

      hash[param] = value;

      var list = [];  


      Object.keys(hash).forEach(function (key) {
        list.push(key + '=' + hash[key]);
      });

      parser.search = '?' + list.join('&');
      return parser.href;
    },
    removeParam:function(key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
          param,
          params_arr = [],
          queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },
    changeVariants:function(data,$){
	  $('.hs-select-option').unbind('change');
      $('.hs-select-option').change(function(e){
        e.preventDefault();
        var id = $(this).find('option:selected').data('id'),variant_option = '',text='';
        $('.hs-product-cart-drawer-'+id).find('.hs-change-select-option').find('.hs-select-box-load').each(function( index ) {
          text = text.concat($( this ).find('select').val()+' / ');
        });
        if(text)
        {
        	text = text.slice(0, -3);
        }
        $('.hs-option-parent-'+id).val(text).trigger('change');
      });
      
      $('.hs-select-option-add-to-cart').unbind('change');
      $('.hs-select-option-add-to-cart').change(function(e){
        e.preventDefault();
        var element = $(this).find('option:selected'),id = $(this).data('id'),variantid = element.data('variantid'),available = element.data('available');
        $('.hs-button-cart-'+id).removeAttr('disabled');
        $('.hs-flag-'+id).html('');
        if(available == false){
          $('.hs-flag-'+id).html('<div class="hs-product-label hs-top-left" style="background: #9E9E9E;"><span class="hs-right-arrow" style="border-left-color: #9E9E9E;"></span>'+data.text_stock+'</div>');
        }
        if(typeof available === "undefined"){
          	$('.hs-button-cart-'+id).attr('disabled','disabled');
			$('.hs-flag-'+id).html('<div class="hs-product-label hs-top-left" style="background: #9E9E9E;"><span class="hs-right-arrow" style="border-left-color: #9E9E9E;"></span>'+data.text_unavailable+'</div>');
        }
      }); 
      
      $('.hs-quick-button-quantity').unbind('click');
      $('.hs-quick-button-quantity').click(function(e){
        e.preventDefault();
      });
      $('.hs-add-to-cart').unbind('click');
      $('.hs-add-to-cart').click(function(e){
        e.preventDefault();
        var id = $(this).data('id'),h=160,where = $(this),text = '',elementP = $(this).closest('.hs-product-cart-drawer-'+id),elementProduct = elementP.parent('div'),element = $('.hs-option-parent-'+id),elementVid = $('.hs-combobox-option-variant'),elementVariant = $('.hs-combobox-option-variant-'+id),variantid = '',left = 0,e = $('.hs-combobox-option-variant-'+id+'.active'),quantity = 1;
        if(e.length > 0)
        {
          elementVariant.removeClass('active');
          return false;
        }
        if(elementProduct.length > 0)
        {
          h = elementProduct.height() - 45;
        }
        if(elementP.find('.hs-quick-button-quantity').length > 0)
        {
          quantity = elementP.find('.hs-quick-button-quantity').val();
        }
		  
		$('header a[href*=cart]').addClass('hs-open-cart-url-2');
		  
        quantity = parseInt(quantity);
        elementVariant.height(h);
        elementVid.removeClass('active')
        $(this).addClass('hs-loading-cart');
        $(this).html('<span><i class="fa fa-refresh fa-spin fa-1x fa-fw"></i></span>');
        left = $(this).closest('.hs-content-cart-drawer-loop').find('.hs-select-option-add-to-cart').find('option').length;
        if(left == 1)
        {
          variantid = element.find('option:selected').data('variantid');
          HsCartDrawer.params = {id:variantid,quantity:quantity};
          HsCartDrawer.ajaxCart(1,HsCartDrawer.params,where,data,$);
        }else{
          setTimeout(function(){
            where.html('<span><i class="fa '+data.quickbuybutton_icon+'"></i></span>');
          	elementVariant.addClass('active');
          }, 200);
        }
      });
      $('.hs-combobox-option-variant').find('li').unbind('click');
      $('.hs-combobox-option-variant').find('li').click(function(e){
        e.preventDefault();
        var id = $(this).data('id'),variantid = $(this).data('vid'),elementP = $('.hs-product-cart-drawer-'+id),element = $('.hs-button-cart-'+id),elementVariant = $('.hs-combobox-option-variant-'+id),quantity=1;
        elementVariant.removeClass('active');
        element.addClass('hs-loading-cart');
        element.html('<span><i class="fa fa-refresh fa-spin fa-1x fa-fw"></i></span>');
        if(elementP.find('.hs-quick-button-quantity').length > 0)
        {
          quantity = elementP.find('.hs-quick-button-quantity').val();
        }
        quantity = parseInt(quantity);
        HsCartDrawer.params = {id:variantid,quantity:quantity};
        HsCartDrawer.ajaxCart(0,HsCartDrawer.params,element,data,$);
      });
    },
    onLoadVariants:function(data,$){
      $('.hs-select-option-add-to-cart').change();
    },
	quickBuyButtonByCollections:function(data,$){
	  var url = window.location.href;
      if(!parseInt(data.enable_app))
      {
        return false;
      }
	  if(url.indexOf('/cart') > -1){
		return false;
	  }
      if(!parseInt(data.enable_quick_buy_button))
      {
        return false;
      }
      if(parseInt(data.quick_buy_button_type))
      {
        HsCartDrawer.changeVariants(data,$);
        HsCartDrawer.onLoadVariants(data,$);
        $('.hs-content-cart-drawer-loop').removeClass('hs-hidden-quick-buy-button');
        $('.hs-content-cart-drawer-loop').show();
        return false;
      }
      var arr = [],handle = '',url = '',where = '',x = 0;
      $('a[href*="products"]').each(function( index ) {
        where = $(this),url = $(this).attr('href');
        if(where.find('.hs-content-cart-drawer-loop').length > 0)
        {
          return false;
        }
        if (typeof url !== "undefined") {
          if(url.indexOf('/products/') > -1){
            x = x + 1;
            handle = url.split('/products/');
            handle = handle[1];
            if(handle.indexOf('?') > -1){
              handle = handle.split('?');
              handle = handle[0];
            }
            if(handle.indexOf('#') > -1){
              handle = handle.split('#');
              handle = handle[0];
            }
            handle = decodeURIComponent(handle);
            handle = decodeURIComponent(handle);
            handle = decodeURIComponent(handle);
            arr.push(handle);
          }

        }
      });
      if(arr)
      {
		arr = Array.from(new Set(arr.map(JSON.stringify))).map(JSON.parse);
        arr = arr.chunk_inefficient2(20);
        var text = '';
        $.each(arr, function( index, value ) {
          text = '';
          $.each(value, function( f, p ) {
            text = text.concat(p+'|');
          });
          HsCartDrawer.addBuyButton(text,data,$);
        });
      }
    },
	isJson:function(item) {
		item = typeof item !== "string"
			? JSON.stringify(item)
			: item;

		try {
			item = JSON.parse(item);
		} catch (e) {
			return false;
		}

		if (typeof item === "object" && item !== null) {
			return true;
		}

		return false;
	},
    addBuyButton:function(text,data,$){
      if(text)
      {
        var handle = '',x = 0,url = '',where = '';
        text = text.slice(0, -1);
        $.ajax({
          type: 'GET',
          async:true,
          data:{q:text,view:'hs-products'},
          url: '/search',
          contentType: "application/json",
          beforeSend: function() {
            //loader
          },
          success: function(r) {
			if(HsCartDrawer.isJson(r) == true)
			{
				var obj = JSON.parse(r);
				$('a[href*="products"]').each(function( index ) {
				  where = $(this),url = $(this).attr('href');
				  if (typeof url !== "undefined") {
					if(url.indexOf('/products/') > -1){
					  x = x + 1;
					  handle = url.split('/products/');
					  handle = handle[1];
					  if(handle.indexOf('?') > -1){
						handle = handle.split('?');
						handle = handle[0];
					  }
                      if(handle.indexOf('#') > -1){
                        handle = handle.split('#');
                        handle = handle[0];
                      }
					  handle = decodeURIComponent(handle);
					  handle = decodeURIComponent(handle);
					  handle = decodeURIComponent(handle);
					  HsCartDrawer.fromCreateVariants(where,handle,obj,data,$);
					}
				  }
				});
			}
          },
          error: function(xhr) {
            //console.log('Try catch');
          },
          complete: function() {
			HsCartDrawer.resizeDesktopAndMobile(data,$);
          }
        });
      }
    },
    fromCreateVariants:function(where,handle,json,data,$){
      var count_options = 1,content = '',cartButton = '',position_element = '',quantity = '',button='',flag = '',filterText1 = '',filterText2 = '',filterText3 = '',options = [],variants = [],filteredArr1 = [],filteredArr2 = [],filteredArr3 = [],opt1= [],opt2= [],opt3= [],option1 = '',option2 = '',option3 = '',selectParent = '',selectVariant = '';
      $.each(json, function( index, value ) {
        if(handle == value.handle)
        {
          cartButton = $('.hs-product-cart-drawer-'+value.id);
          options = value.options;
          variants = value.variants;
          selectParent = '';
          selectVariant = '';
          position_element = ' '+data.quick_buy_button_position;
          opt1 = [];
          opt2 = [];
          opt3 = [];
		  count_options = 1;
          if(cartButton.length > 0)
          {
            return false;
          }
          $.each(variants, function( x, n ) {
            option1 = '';
            option2 = '';
            option3 = '';
            count_options = n.options.length;
            $.each(n.options, function( u, w ) {
              if(u == 0)
              {
                option1 = w;
              }
              if(u == 1)
              {
                option2 = w;
              }
              if(u == 2)
              {
                option3 = w;
              }
            });
            if(option1.length > 0)
            {
              opt1.push(option1);
            }
            if(option2.length > 0)
            {
              opt2.push(option2);
            }
            if(option3.length > 0)
            {
              opt3.push(option3);
            }
            selectParent = selectParent.concat('<option value="'+n.title+'" title="'+n.title+'" data-id="'+value.id+'" data-price="'+n.price+'" data-sku="'+n.sku+'" data-available="'+n.available+'" data-barcode="'+n.barcode+'" data-featuredimage="'+value.featured_image+'" data-inventorymanagement="'+n.inventory_management+'" data-compareatprice="'+n.compare_at_price+'" data-variantid="'+n.id+'">'+n.title+'</option>');
            selectVariant = selectVariant.concat('<li data-id="'+value.id+'" data-vid="'+n.id+'"><span>'+n.title+'</li></span>');
          });
          filterText1 = '';
          filterText2 = '';
          filterText3 = '';
          selectVariant = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-'+value.id+position_element+'">'+selectVariant+'</ul>';
          quantity = '<input type="number" class="hs-quick-button-quantity" name="hs-quick-button-quantity" value="1" min="1"><div class="farm-quantity-nav"> <div class="farm-quantity-button farm-quantity-up"><i class="fa fa-angle-up" aria-hidden="true"></i></div> <div class="farm-quantity-button farm-quantity-down"><i class="fa fa-angle-down" aria-hidden="true"></i></div> </div>';
          button = '<button type="button" class="hs-add-to-cart hs-button-cart-'+value.id+' animated bounceIn" data-id="'+value.id+'"><span><i class="fa '+data.quickbuybutton_icon+'"></i></span></button>';
          flag = '<div class="hs-flag-content hs-flag-'+value.id+'" style="display:none;"></div>';
          selectParent = '<select class="hs-option-parent-'+value.id+' hs-select-option-add-to-cart" name="none" data-id="'+value.id+'" style="display:none;">'+selectParent+'</select>';
          filteredArr1 = opt1.filter(function(item, index) {
            if (opt1.indexOf(item) == index)
              return item;
          });
          filteredArr2 = opt2.filter(function(item, index) {
            if (opt2.indexOf(item) == index)
              return item;
          });
          filteredArr3 = opt3.filter(function(item, index) {
            if (opt3.indexOf(item) == index)
              return item;
          });
          if(filteredArr1.length > 0)
          {
            $.each(filteredArr1, function( i, v ) {
              filterText1 = filterText1.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText1 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[0]+'</span><select class="hs-option-'+value.id+'-0 hs-select-option" name="none">'+filterText1+'</select></div>';
          }
          if(filteredArr2.length > 0)
          {
            $.each(filteredArr2, function( i, v ) {
              filterText2 = filterText2.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText2 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[1]+'</span><select class="hs-option-'+value.id+'-1 hs-select-option" name="none">'+filterText2+'</select></div>';
          }
          if(filteredArr3.length > 0)
          {
            $.each(filteredArr3, function( i, v ) {
              filterText3 = filterText3.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText3 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[2]+'</span><select class="hs-option-'+value.id+'-2 hs-select-option" name="none">'+filterText3+'</select></div>';
          }
          if(data.show_quantity_selector_buy_button == 0)
          {
            quantity = '';
          }
          
          content = '<div class="hs-change-select-option" style="display:none;">'+filterText1+filterText2+filterText3+'</div>'+selectParent;

          if(where.parent().find('img').length > 0)
          {
              where.prepend('<div class="hs-product-cart-drawer-'+value.id+' hs-content-cart-drawer-loop"></div>');
              $('.hs-product-cart-drawer-'+value.id).html(content);
              $('.hs-product-cart-drawer-'+value.id).css('position','relative');
              $('.hs-product-cart-drawer-'+value.id).append('<div class="hs-quantity-content-arrows'+position_element+'">'+quantity+button+flag+'</div>'+selectVariant);
          }
        }
      });
      HsCartDrawer.changeVariants(data,$);
      HsCartDrawer.onLoadVariants(data,$);
    },
    animatedHover:function(data,$){
      if(data.animatedHover == 1)
      {
        $('.hs-sticky-cart-cart-drawer').hover(
          function() {
            var where = $(this);
            if(!where.find('mark').hasClass('animated'))
            {
              where.find('mark').addClass('swing');
              where.find('mark').addClass('animated');
              setTimeout(function(){           
                where.find('mark').removeClass('swing');
                where.find('mark').removeClass('animated'); 
              }, 1000);
            }
          }
        );
      }
    },
    startAnimatedQuickBuyButton:function(data,$) {
      if(data.enable_cart_animator == 0){
        return false;
      }
      if(data.quick_buy_button_animation === 'none')
      {
        return false;
      }
      var button = $('.hs-add-to-cart');
      setTimeout(function() {
        button.removeClass('animated');
        button.removeClass('bounceIn');
        button.removeClass('bounce');
        button.removeClass('flash');
        button.removeClass('pulse');
        button.removeClass('rubberBand');
        button.removeClass('shake');
        button.removeClass('swing');
        button.removeClass('tada');
        button.removeClass('wobble');
        button.removeClass('jello');
      }, 1000);
      setTimeout(function() {
		button.addClass('animated');
        button.addClass(data.quick_buy_button_animation);
        // Again
        HsCartDrawer.startAnimatedQuickBuyButton(data,$);
        // Every 3 sec
      }, 3000);
	},
    startAnimatedCheckout:function(data,$) {
      if(data.enable_cart_animator == 0){
        return false;
      }
      if(data.checkout_button_animation === 'none')
      {
        return false;
      }
      var button = $('.hs-checkout-purchase,button[type="submit"][name="checkout"],input[type="submit"][name="checkout"]');
      setTimeout(function() {
        button.removeClass('animated');
        button.removeClass('bounceIn');
        button.removeClass('bounce');
        button.removeClass('flash');
        button.removeClass('pulse');
        button.removeClass('rubberBand');
        button.removeClass('shake');
        button.removeClass('swing');
        button.removeClass('tada');
        button.removeClass('wobble');
        button.removeClass('jello');
      }, 1000);
      setTimeout(function() {
		button.addClass('animated');
        button.addClass(data.checkout_button_animation);
        // Again
        HsCartDrawer.startAnimatedCheckout(data,$);
        // Every 3 sec
      }, 3000);
	},
    startAnimatedAddToCart:function(data,$) {
      if(data.enable_cart_animator == 0){
        return false;
      }
      if(data.add_to_cart_button_animation === 'none')
      {
        return false;
      }
      var button = $('button[type="submit"][name="add"]');

      setTimeout(function() {
        button.removeClass('animated');
        button.removeClass('bounceIn');
        button.removeClass('bounce');
        button.removeClass('flash');
        button.removeClass('pulse');
        button.removeClass('rubberBand');
        button.removeClass('shake');
        button.removeClass('swing');
        button.removeClass('tada');
        button.removeClass('wobble');
        button.removeClass('jello');
      }, 1000);

      setTimeout(function() {
		button.addClass('animated');
        button.addClass(data.add_to_cart_button_animation);
        // Again
        HsCartDrawer.startAnimatedAddToCart(data,$);
        // Every 3 sec
      }, 3000);
	},
	startAnimatedStickyBarButton:function(data,$) {
      if(data.enable_cart_animator == 0){
        return false;
      }
      if(data.sticky_bar_button_animation === 'none')
      {
        return false;
      }
      var button = $('.hs-checkout-bar-add-to-cart');

      setTimeout(function() {
        button.removeClass('animated');
        button.removeClass('bounceIn');
        button.removeClass('bounce');
        button.removeClass('flash');
        button.removeClass('pulse');
        button.removeClass('rubberBand');
        button.removeClass('shake');
        button.removeClass('swing');
        button.removeClass('tada');
        button.removeClass('wobble');
        button.removeClass('jello');
      }, 1000);

      setTimeout(function() {
		button.addClass('animated');
        button.addClass(data.sticky_bar_button_animation);
        // Again
        HsCartDrawer.startAnimatedStickyBarButton(data,$);
        // Every 3 sec
      }, 3000);
	},
    InitStickyCheckoutBar:function(data,$){
      if(!parseInt(data.enable_sticky_cart_bar))
      {
        return false;
      }
      var url = window.location.href,handle = '';
      if (typeof url !== "undefined") {
        if(url.indexOf('/products/') > -1){
          handle = url.split('/products/');
          handle = handle[1];
          if(handle.indexOf('?') > -1){
            handle = handle.split('?');
            handle = handle[0];
          }
          if(handle.indexOf('#') > -1){
            handle = handle.split('#');
            handle = handle[0];
          }
          handle = decodeURIComponent(handle);
          handle = decodeURIComponent(handle);
          handle = decodeURIComponent(handle);
        }
      }
      if(handle)
      {
        $.ajax({
          type: 'GET',
          async:true,
          data:{q:handle,view:'hs-products'},
          url: '/search',
          contentType: "application/json",
          beforeSend: function() {
            //loader
          },
          success: function(r) {
			if(HsCartDrawer.isJson(r) == true)
			{
				var obj = JSON.parse(r);
				if(obj)
				{
					HsCartDrawer.arr_variants = obj[0].variants;
					HsCartDrawer.stickyCheckoutBar(obj,data,$);
				}
			}
          },
          error: function(xhr) {
            //console.log('Try catch');
          },
          complete: function() {
			  HsCartDrawer.resizeDesktopAndMobile(data,$);
              HsCartDrawer.productReview(data,$);
          }
        });
      }
    },
    stickyCheckoutBar:function(json,data,$){
      var count_options = 1,review = '',hs_price = '',compare_price_active='',sticky_cart_bar_desktop_position = ' hs-desktop-top',sticky_cart_bar_mobile_position = ' hs-mobile-top',title = '',content = '',price = '',count_variants = 0,hidden_variant = '',compare_at_price = '',content_compare_at_price = '<div class="hs-checkout-bar-compare-at-price"></div>',checkoutBar = '',featured_image = '',quantity = '',button='',flag = '',filterText1 = '',filterText2 = '',filterText3 = '',options = [],variants = [],filteredArr1 = [],filteredArr2 = [],filteredArr3 = [],opt1= [],opt2= [],opt3= [],option1 = '',option2 = '',option3 = '',selectParent = '',selectVariant = '';
      if(data.sticky_cart_bar_desktop_position == 1)
      {
        sticky_cart_bar_desktop_position = ' hs-desktop-bottom';
      }
      if(data.sticky_cart_bar_mobile_position == 1)
      {
        sticky_cart_bar_mobile_position = ' hs-mobile-bottom';
      }
      $.each(json, function( index, value ) {
          $('body').append('<div class="hs-sticky-checkout-bar hs-sticky-checkout-bar-'+value.id+sticky_cart_bar_desktop_position+sticky_cart_bar_mobile_position+' hs-sticky---bar---'+data.style+'" style="visibility: hidden;opacity: 0;"></div>');
          
          checkoutBar = $('.hs-sticky-checkout-bar-'+value.id);
          title = value.title;
          price = value.price;
          compare_at_price = value.compare_at_price;
          featured_image = HsCartDrawer.imageResize(value.featured_image,'thumb');
          options = value.options;
          variants = value.variants;
          selectParent = '';
          selectVariant = '';
          compare_price_active = '';
          opt1 = [];
          opt2 = [];
          opt3 = [];
          count_options = 1;
          count_variants = variants.length;
          $.each(variants, function( x, n ) {
            option1 = '';
            option2 = '';
            option3 = '';
            count_options = n.options.length;
            $.each(n.options, function( u, w ) {
              if(u == 0)
              {
                option1 = w;
              }
              if(u == 1)
              {
                option2 = w;
              }
              if(u == 2)
              {
                option3 = w;
              }
            });
            if(option1.length > 0)
            {
              opt1.push(option1);
            }
            if(option2.length > 0)
            {
              opt2.push(option2);
            }
            if(option3.length > 0)
            {
              opt3.push(option3);
            }
            selectParent = selectParent.concat('<option value="'+n.id+'" data-id="'+value.id+'" title="'+n.title+'" data-price="'+n.price+'" data-sku="'+n.sku+'" data-available="'+n.available+'" data-barcode="'+n.barcode+'" data-featuredimage="'+value.featured_image+'" data-inventorymanagement="'+n.inventory_management+'" data-compareatprice="'+n.compare_at_price+'">'+n.title+'</option>');
            selectVariant = selectVariant.concat('<li data-id="'+value.id+'" data-vid="'+n.id+'"><span>'+n.title+'</li></span>');
          });
          filterText1 = '';
          filterText2 = '';
          filterText3 = '';
          selectParent = '<select class="hs-select-variants-bar" style="display:none;">'+selectParent+'</select>';
          selectVariant = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-'+value.id+'">'+selectVariant+'</ul>';
          quantity = '<div class="hs---quantity hs---buttons_added"><div class="hs---minus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" step="1" name="hs-quick-button-quantity2" value="1" title="Qty" class="hs-quick-button-quantity2" size="4" pattern="" inputmode=""><div class="hs---plus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>';
          button = '<button type="button" class="hs-add-to-cart hs-button-cart-'+value.id+' '+data.quick_buy_button_position+' animated bounceIn" data-id="'+value.id+'"><span><i class="fa '+data.quickbuybutton_icon+'"></i></span></button>';
          flag = '<div class="hs-flag-content hs-flag-'+value.id+'" style="display:none;"></div>';
          filteredArr1 = opt1.filter(function(item, index) {
            if (opt1.indexOf(item) == index)
              return item;
          });
          filteredArr2 = opt2.filter(function(item, index) {
            if (opt2.indexOf(item) == index)
              return item;
          });
          filteredArr3 = opt3.filter(function(item, index) {
            if (opt3.indexOf(item) == index)
              return item;
          });
          if(filteredArr1.length > 0)
          {
            hidden_variant = '';
            $.each(filteredArr1, function( i, v ) {
              if(count_variants == 1)
              {
                if(v == 'Default Title')
                {
                  hidden_variant = ' hs-hidden-select';
                }
              }
              filterText1 = filterText1.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText1 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[0]+'</span><select class="hs-option-'+value.id+'-0 hs-select-option-checkout-bar" name="none"><option value="'+value.options[0]+'" disabled>'+value.options[0]+'</option>'+filterText1+'</select></div>';
          }
          if(filteredArr2.length > 0)
          {
            $.each(filteredArr2, function( i, v ) {
              filterText2 = filterText2.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText2 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[1]+'</span><select class="hs-option-'+value.id+'-1 hs-select-option-checkout-bar" name="none"><option value="'+value.options[1]+'" disabled>'+value.options[1]+'</option>'+filterText2+'</select></div>';
          }
          if(filteredArr3.length > 0)
          {
            $.each(filteredArr3, function( i, v ) {
              filterText3 = filterText3.concat('<option value="'+v+'" data-id="'+value.id+'">'+v+'</option>');
            });
            filterText3 = '<div class="hs-select-box-load hs-load-select-box-bar-'+count_options+'"><span class="hs-select-text">'+value.options[2]+'</span><select class="hs-option-'+value.id+'-2 hs-select-option-checkout-bar" name="none"><option value="'+value.options[2]+'" disabled>'+value.options[2]+'</option>'+filterText3+'</select></div>';
          }
          if(compare_at_price > price)
          {
            compare_price_active = ' hs-compare-price-active';
            compare_at_price = HsCartDrawer.vat(compare_at_price,data,$);
          	content_compare_at_price = '<div class="hs-checkout-bar-compare-at-price"><s class="hs-money-compare-price">'+hsonslidecart.Currency.formatMoney(compare_at_price, data['money_format'])+'</s></div>';
          }
          price = HsCartDrawer.vat(price,data,$);
          hs_price = '<div class="hs-checkout-bar-price"><span class="hs-money-price'+compare_price_active+'">'+hsonslidecart.Currency.formatMoney(price, data['money_format'])+'</span></div>';
          if(featured_image == null)
          {
            featured_image = 'https://cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/hs-no-image_thumb.gif';
          }
          review = '<span class="shopify-product-reviews-badge" data-id="'+value.id+'"></span>';
          content = '<div class="hs-content-image-and-title">\
          <div class="hs-image-thumb">\
            <div class="hs-thumb-and-title">\
			  <div class="hs-bar-content-image">\
              	<img class="hs-bar-featured-image" src="'+featured_image+'" />\
              </div>\
			  <div class="hs-bar-content-title">\
                <a href="javascript:void(0);" class="hs-sticky-bar-add-to-cart-product-title">\
                  <div class="hs-sticky-bar-product-title">'+title+'</div>\
                  <div class="hs-product-review">'+review+'</div>\
                </a>\
			 </div>\
            </div>\
          </div>\
		  <div class="hs-bar-content-price"><div class="hs-hidden-quantity-mobile"><div class="hs-content-quantity">'+quantity+'</div></div>'+content_compare_at_price+hs_price+'</div>\
          </div>\
          <div class="hs-content-variant-select-option">\
            <div class="hs-change-select-option">\
            '+filterText1+filterText2+filterText3+'\
			<div class="hs-content-quantity">'+quantity+'</div>\
          </div>\
          	'+content_compare_at_price+hs_price+selectParent+'\
          </div>\
          <div class="hs-full-bar-button">\
            <button type="button" class="hs-checkout-bar-add-to-cart">\
              <span class="hs-add--to--cart">'+data.text_add_to_cart+'</span>\
              <span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span>\
            </button>\
          </div>';
          checkoutBar.html('<div class="hs-content-checkout-bar'+hidden_variant+'">'+content+'</div>');  
        
      });
      HsCartDrawer.changeVariantsCheckoutBar(data,$);
    },
    imageResize:function(t, r) {
      try {
        if ("original" == r) return t;
        var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        return e[1] + "_" + r + "." + e[2]
      } catch (r) {
        return t
      }
    },
    createCpokie:function (key, value,exdays) {
      expires = new Date();
      expires.setTime(expires.getTime()+ (exdays*24*60*60*1000));cookie = key + '=' + value + ';expires=' + expires.toUTCString()+';path=/';
      return document.cookie = cookie;
    },
    readCookie:function (key) {
      keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      if (keyValue) {
        return keyValue[2];
      }else{
        return '';
      }
    },
    setCookie:function (cname,cvalue,exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = 'expires=' + d.toGMTString();document.cookie = cname+'='+cvalue+'; '+expires+';path=/';
    },
    deleteCookie:function(cname){
      expires = new Date();expires.setTime(expires.getTime()+ (-1*24*60*60*1000));
      cookie = cname + '=;expires='+expires.toUTCString()+';path=/';
      return document.cookie = cookie;
    },
	addCart:function(arr,data,$){
		$.ajax({
			url: '//stickycart.heysenior.com/ajaxcart/add?shop='+HsCartDrawer.shopifyUrl,
          	async:true,
			type: 'POST',
			data: {'result':arr},
			cache: false,
			dataType: 'json',
			success: function(response) {
			},
			error: function(xhr) { // if error occured
			},
			complete: function() {
			},
		});
	},
    productReview:function(data,$){
      if (typeof SPR !== "undefined") {
          SPR.loadjQuery(function() {
          return SPR.$.ajaxSetup({
            cache: !1
          }),
            SPR.loadjQueryExtentions(SPR.$),
            SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
              SPR.initRatingHandler(),
              SPR.initDomEls(),
              SPR.loadProducts(),
              SPR.loadBadges();
          })
        })
      }
    },
    initproductReview:function(){
      if (typeof SPR !== "undefined") {
        SPR.loadStylesheet(),
          SPR.loadjQuery(function() {
          return SPR.$.ajaxSetup({
            cache: !1
          }),
            SPR.loadjQueryExtentions(SPR.$),
            SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
              SPR.initRatingHandler(),
              SPR.initDomEls(),
              SPR.loadProducts(),
              SPR.loadBadges();
          })
        })
      }
    },
    startDiscount:function(data,$){
      var discount_code =  HsCartDrawer.readCookie('hscodediscount'),total_price_global = parseFloat($('#hs-total-price-global').val());
      $('button.hs-apply-discount').unbind('click');
      $('button.hs-apply-discount').click(function(e){
        e.preventDefault();
        var discount = $('input.hs-discount-code').val();
        discount = encodeURIComponent(discount);
        $(this).addClass('hs-loading');
        HsCartDrawer.deleteCookie('hscodediscount');
        if(discount === '')
        {
          HsCartDrawer.errorDiscount(data,$);
          return false;
        }
        $.ajax({
          url: '/checkout?discount='+discount,
          async:true,
          dataType: "html",
          success: function(A){
            if(A)
            {
            	var d = $(A).find(".total-line-table__tbody .total-line .total-line__price .order-summary__emphasis").html(),
                e = $(A).find(".total-line-table__tbody .total-line .total-line__name>span").html(),
                su = $(A).find(".total-line__price.payment-due .payment-due__price").attr("data-checkout-payment-due-target"),
                s = $(A).find(".total-line--reduction .total-line__price").find(".order-summary__emphasis").attr("data-checkout-discount-amount-target"),
                free_shipping = $(A).find(".total-line--reduction .total-line__price").find(".order-summary__emphasis"),
                free_shipping_text = $(A).find(".total-line--reduction .total-line__price").find(".order-summary__emphasis").text(),
                taxes = $(A).find(".total-line--taxes .total-line__price").find(".order-summary__emphasis").attr("data-checkout-total-taxes-target"),
                g = $('#hs-total-price-global').val(),
                x = $(A).find("#error-for-reduction_code").length,
                warning = $(A).find(".notice--warning"),
                error_discount = $(A).find("#error-for-reduction_code"),
                f = '',
                hs_discount_checkout = data.text_discount_checkout,
                f_validate = 0,
                st = $(A).find(".total-line--subtotal .total-line__price .order-summary__emphasis").html(),
                sh = $(A).find(".total-line--shipping .total-line__price .order-summary__emphasis").html(),
                products = $(A).find('table.product-table').find('tbody').find('tr'),
                cupon_code = '',
                cupon_code_plus = 0,
                cupon_code_html = '',
                o = $(A).find(".total-line__price.payment-due .payment-due__price").html();
              	sh = HsCartDrawer.convertPrice(sh,data,$);
              	sh = parseFloat(sh);
              	if (isNaN(sh)) {
                  sh = 0;
                }
                $(products).each(function( index ) {
                  var code = $(this).find('.product__description').find('.reduction-code__text');
                  if(code.length > 0)
                  {
                  	cupon_code_html = code.html();
                    if(cupon_code_html.indexOf('(-') > -1){
                      cupon_code = cupon_code_html.split('(-');
                      cupon_code = cupon_code[1].replace('(-','');
                      cupon_code = cupon_code.replace(')','');
                      cupon_code = cupon_code.replace(/\s+/g,'');
                      cupon_code = HsCartDrawer.convertPrice(cupon_code,data,$);
                      cupon_code_plus += parseFloat(cupon_code);
                    }
                  }
                });
                if(free_shipping.length > 0)
                {
                  free_shipping_text = free_shipping_text.trim();
                }
                if(warning.length > 0)
                {
                  $('.hs_subtotal_amount_discount').html('');
                  $('.hs-success-code-discount').html('<div class="hs--content--warning"><div class="hs---warning---icon"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 22" style=" "><path d="M15.286 2.386l7.91 13.857C25.01 19.423 23.65 22 20.16 22H3.84C.35 22-1.01 19.427.805 16.243l7.91-13.857c1.815-3.178 4.754-3.185 6.57 0zm-1.737.992c-1.05-1.838-2.05-1.837-3.1 0L2.54 17.235C1.468 19.122 1.93 20 3.84 20h16.32c1.91 0 2.374-.88 1.298-2.765l-7.91-13.857zM12 6.5c.552 0 1 .448 1 1V12c0 .552-.448 1-1 1s-1-.448-1-1V7.5c0-.552.448-1 1-1zm-1.5 10c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z"></path></svg></div>'+warning.find('.notice__content').html()+'<a href="javascript:void(0)" class="hs-close-discount-slide-cart hs---warging"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></div>');
                  $('.hs-sub-total-cart').removeClass('hs-payment-discount');
                  $('button.hs-apply-discount').removeClass('hs-loading');
                  $('#hs-discount-price-global').val(0);
                  HsCartDrawer.createCpokie('hscodediscount', discount,365);
                  HsCartDrawer.closeCouponCheckout(data,$);
                  return false;
                }
                
                if (x == 0) {
                  o = HsCartDrawer.convertPrice(o,data,$);
                  s = parseFloat(s);
                  g = parseFloat(g);
                  taxes = parseFloat(taxes);
                  o = parseFloat(o);
                  o = o - taxes;
                  //f = HsCartDrawer.vat(s,data,$);
                  f = g - o;
                  f_validate = f;
                  f = hsonslidecart.Currency.formatMoney(f, data['money_format']);
                  HsCartDrawer.createCpokie('hscodediscount', discount,365);
                  $('.hs-sub-total-cart').addClass('hs-payment-discount');
                  if(sh > 0)
                  {
                    o = o - sh;
                  }
                  $('#hs-discount-price-global').val(o);
                  o = hsonslidecart.Currency.formatMoney(o, data['money_format']);
                  $('.hs_subtotal_amount_discount').html(o);
                  if(cupon_code_plus)
                  {
                    cupon_code_plus = hsonslidecart.Currency.formatMoney(cupon_code_plus, data['money_format']);
                    hs_discount_checkout = hs_discount_checkout.replace("{{ money }}", '<span class="hs_af_money">'+cupon_code_plus+'</span>');
                    $('.hs-success-code-discount').html('<div class="hs-success-code-discount"><div class="hs--content--success"><div class="hs---success---icon"><svg class="hs-discount-slide-cart-icon" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></div><p class="hs-notice__text">'+hs_discount_checkout+'</p><a href="javascript:void(0)" class="hs-close-discount-slide-cart hs---success"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></div></div>');
                  }else{
                    hs_discount_checkout = hs_discount_checkout.replace("{{ money }}", '<span class="hs_af_money">'+f+'</span>');
                    $('.hs-success-code-discount').html('<div class="hs-success-code-discount"><div class="hs--content--success"><div class="hs---success---icon"><svg class="hs-discount-slide-cart-icon" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></div><p class="hs-notice__text">'+hs_discount_checkout+'</p><a href="javascript:void(0)" class="hs-close-discount-slide-cart hs---success"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></div></div>');
                    if(!f_validate){
                      $('.hs_subtotal_amount_discount').html('');
                      $('.hs-success-code-discount').html('<div class="hs-success-code-discount"><div class="hs--content--success"><div class="hs---success---icon"><svg class="hs-discount-slide-cart-icon" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></div><p class="hs-notice__text">'+free_shipping_text+'</p><a href="javascript:void(0)" class="hs-close-discount-slide-cart hs---success"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></div></div>');
                      $('.hs-sub-total-cart').removeClass('hs-payment-discount');
                    }
                  }
                  HsCartDrawer.currencyConverter(data,$);
                }else{
                  HsCartDrawer.errorDiscount(data,$);
                }
            	$('button.hs-apply-discount').removeClass('hs-loading');
            }else{
              	//HsCartDrawer.errorDiscount(data,$);
              	$('button.hs-apply-discount').removeClass('hs-loading');
            }
            HsCartDrawer.closeCouponCheckout(data,$);
          },
          error: function(xhr) {
            if(xhr)
            {
              if(xhr.statusText == 'error')
              {
                window.location.href = '/checkout?discount='+discount;
              }
            }
		  },
		  complete: function() {
            if(parseInt(data.enable_additional_buttons))
            {
              if(Shopify.PaymentButton){
                Shopify.PaymentButton.init();
              }
            }
            HsCartDrawer.rewardsBar(total_price_global,data,$);
		  }
        });
      });
      if(discount_code !== '')
      {
        $('button.hs-apply-discount').trigger('click');
      }
    },
    convertPrice:function(o,data,$){
      if(o){
        o = o.replace(/[^a-zA-Z0-9]/g,'');
        o = o.replace(/[^0-9]/g,'');
      }
      return o;
    },
    closeCouponCheckout:function(data,$){
      $('.hs-close-discount-slide-cart').unbind('click');
      $('.hs-close-discount-slide-cart').click(function(e){
        e.preventDefault();
        var total_price_global = parseFloat($('#hs-total-price-global').val());
        HsCartDrawer.deleteCookie('hscodediscount');
        $('input.hs-discount-code').val('');
        $('#hs-discount-price-global').val(0);
        $('button.hs-apply-discount').trigger('click');
        HsCartDrawer.rewardsBar(total_price_global,data,$);
      });
    },
    addToCartFreeShipping:function(data,$){
      $('.hs-upsell-add-to-cart').unbind('click');
      $('.hs-upsell-add-to-cart').click(function(e){
        var where = $(this),variantid = $(this).closest('.hs-content-title-price-swiper').find('.hs-swipper-select-option-add-to-cart').val(),elementQty = where.closest('.hs-content-title-price-swiper').find('.hs-item-cart-content-quantity-upsell'),quantity = 1;
        where.addClass('hs-loading-btn');
        if(elementQty.length > 0)
        {
          quantity = elementQty.find('input').val();
        }
        HsCartDrawer.params = {'id':variantid,'quantity':quantity};
        HsCartDrawer.ajaxProductCartUpsell(HsCartDrawer.params,where,data,$);
      });
    },
    errorDiscount:function(data,$){
      $('button.hs-apply-discount').removeClass('hs-loading');
      $('.hs-sub-total-cart').removeClass('hs-payment-discount');
      $('.hs-error-code-discount').html('<span>'+data.text_validate_coupon+'</span>');
      $('.hs-success-code-discount').html('');
      $('.hs_subtotal_amount_discount').html('');
      $('#hs-discount-price-global').val(0);
      setTimeout(function(){ 
        $('.hs-error-code-discount').html('');
      }, 2000);
    },
    updateSlideCart:function(){
      HsCartDrawer.getCart(0,[],HsCartDrawer.json,HsCartDrawer.query);
    },
    getSlideCart:function(){
      HsCartDrawer.getCart(1,[],HsCartDrawer.json,HsCartDrawer.query);
    },
    getQuickBuyBytton:function(){
      HsCartDrawer.quickBuyButtonByCollections(HsCartDrawer.json,HsCartDrawer.query);
    },
    currencyConverter:function(data,$){
      if($('.currency-switcher').length > 0)
      {
        $('.currency-switcher').click(function(e){
          e.stopPropagation();
        });
        $('.currency-switcher').find('ul.list').find('li.selected').trigger('click', [ 'foo', 'bar' ] );
        $('.currency-switcher').removeClass('open');
        $('.currency-switcher').unbind('click');
      }
      if($('.pick_currency').length > 0)
      {
        $('.pick_currency').click(function(e){
          e.stopPropagation();
        });
        $('.pick_currency').find('.nice-select').find('ul.list').find('li.selected').trigger('click', [ 'foo', 'bar' ] );
        $('.pick_currency').find('.nice-select').removeClass('open');
        $('.pick_currency').unbind('click');
      }
      if($('select.currencies').length > 0)
      {
        $(".top_bar [data-currency-converter]").change();
      }
    },
    offerCoupon:function(data,$){
        if(!parseInt(data.all_page_enable_countdown_cart))
        {
          return false;
        }
      	var countdown_offer = '',text_countdown_offer = '',text_styles='',countdown_h=0;
        text_countdown_offer = data.all_page_time_remaining;
       	text_countdown_offer = text_countdown_offer.replace("{{ COUNTDOWN }}", "<span class='hs-countdown-offer-mobile'><span id='hs_countdown_offer_plus'></span></span>");
      	if(parseInt(data.all_page_enable_countdown_cart))
        {
          	text_styles = 'padding:5px 20px;width:100%;position:relative;top:0px;left:0px;z-index:2147483644;';
            if(parseInt(data.all_page_time_position))
            {
              text_styles = 'padding:5px 20px;width:100%;position:fixed;top:0px;left:0px;z-index:2147483644;';
            }
      		countdown_offer = '<div style="'+text_styles+'" class="hs-countdown-offer">'+text_countdown_offer+'</div>';
        }
      	if(countdown_offer !== '')
        {
          $('body').prepend(countdown_offer);
          $(document).ready(function() {
			HsCartDrawer.mgTop(data,$);
          });
        }
      	HsCartDrawer.iniTimerOffer(data,$);
    },
    mgTop:function(data,$){
      if(parseInt(data.all_page_enable_countdown_cart))
      {
        if(parseInt(data.all_page_time_position))
        {
          var countdown_h = $('.hs-countdown-offer').height();
          countdown_h = countdown_h + 10;
          countdown_h = countdown_h+'px';
          $('body').css('padding-top',countdown_h);
        }
      }
    },
    iniTimerOffer:function(data,$){
      var minutes = parseInt(data.all_page_how_many_minutes_cart_reservation),fiveMinutes = 60 * minutes;
      HsCartDrawer.countdown(minutes,fiveMinutes,data,$);
    },
    countdown:function(validate_minutes,seconds,data,$) {
      if(validate_minutes < 60)
      {
      	seconds = parseInt(sessionStorage.getItem("seconds"))||seconds;
      }
      function tick() {
        seconds--; 
        if(validate_minutes < 60)
        {
          sessionStorage.setItem("seconds", seconds)
        }
        var currentDate = new Date();
        var desktop_seconds = currentDate.getSeconds();
        var desktop_minutes = currentDate.getMinutes();
        var desktop_minutes = desktop_minutes * 60;
        var desktop_minutes = desktop_minutes + desktop_seconds;
        var fiveMinutes = 60 * validate_minutes;
        if(validate_minutes > 59)
        {
          fiveMinutes = fiveMinutes - 1;
          seconds = fiveMinutes - desktop_minutes;
        }
        var current_hours = Math.floor(seconds / 3600);
        current_hours = (current_hours < 10)? '0' + current_hours : current_hours;
        var current_minutes = parseInt(seconds/60) % 60;
        var current_seconds = seconds % 60;
        var text_hours = ' '+data.countdown_text_hours;
        var text_minutes = ' '+data.countdown_text_minutes;
        var text_seconds = ' '+data.countdown_text_seconds;
        if(current_hours == 1)
        {
          text_hours = ' hour';
        }
        if(current_minutes == 1)
        {
          text_minutes = ' minute';
        }
        if(current_seconds == 1)
        {
          text_seconds = ' second';
        }
        $('#hs_countdown_offer_plus').html("<span class='hs-countdown-slide-cart'>"+current_hours + text_hours+"</span><span class='hs-countdown-slide-cart'>"+current_minutes + text_minutes+"</span><span class='hs-countdown-slide-cart'>" + (current_seconds < 10 ? "0" : "") + current_seconds+text_seconds+'</span>');
        if( seconds > 0 ) {
          setTimeout(tick, 1000);
        }else{
          HsCartDrawer.iniTimerOffer(data,$);
          if(parseInt(data.all_page_countdown_expires_clear_cart))
          {
            $('.hs-countdown-offer').html(data.all_page_countdown_expires);
          	$('.hs-countdown-offer').remove();
          }
        }
      }
      tick();
    },
    autoLoadHref:function(data,$){
      $('a').click(function(e){	
        setTimeout(function(){ HsCartDrawer.addToCart(data,$); }, 100);
      });
      setTimeout(function(){ HsCartDrawer.addToCart(data,$); }, 1000);
    },
    initPageFly:function(data,$){
      var pfATCs = $('#__pf').find('[data-pf-type="ProductATC"]');
      pfATCs.click(e => {
        var checkoutAction = e.currentTarget.getAttribute('data-checkout');
        if (checkoutAction === 'same') {
          window.__pagefly_helper_store__ && window.__pagefly_helper_store__.subscribe(function() { 
            $.getJSON('/cart.json').then(cart => {
              HsCartDrawer.getSlideCart();
            });
          });
        }
      });
    },
    viewPage:function(data,$){
      if(HsCartDrawer.pathname.indexOf('viewcart=true') > -1){
        if(HsCartDrawer.shopifyUrl === 'sticky-cart-cart-drawer.myshopify.com')
        {
          var params = {id:29613833617496,quantity:1}
          $.ajax({
            type: 'POST',
            url : '/cart/add.js',
            dataType: 'json',
            async:true,
            data : params,
            success: function(response){
            },
            error: function(e,b,c){
            },
            complete:function(e){
              HsCartDrawer.getSlideCart(data,$);
            }
          });
        }else{
        	HsCartDrawer.getSlideCart(data,$);
        }
      }
    },
	init: function(data,$){
      	this.autoLoadHref(data,$);
        this.addstyle(data,$);
      	this.ipinfo(data,$);
      	this.moduleUpsell(data,$);
		this.contentPopup(data,$);
        this.quickBuyButtonByCollections(data,$);
		this.addToCart(data,$);
		this.showApp(data,$);
		this.resize(data,$);
        this.changeQuantityCart(data,$);
      	this.animatedHover(data,$);
      	this.startAnimatedQuickBuyButton(data,$);
		this.startAnimatedStickyBarButton(data,$);
      	this.startAnimatedCheckout(data,$);
      	this.startAnimatedAddToCart(data,$);
        this.InitStickyCheckoutBar(data,$);
      	this.initproductReview(data,$);
      	this.startDiscount(data,$);
        this.iniTimer(data,$);
        this.offerCoupon(data,$);
      	this.viewPage(data,$);
      	this.initPageFly(data,$);
        //this.addComboboxCollections(data,$);
	}
}

  var loadScript = function(url, callback){
    var script = document.createElement("script");
    script.type = "text/javascript";
    // If the browser is Internet Explorer.
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function(){
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);  
  };
  var myAppJavaScript = function($){
    HsCartDrawer.query = $;
    $.get('//services.heysenior.com/sticky/result/onget?shop='+HsCartDrawer.shopifyUrl, function(data) {
      if(data)
      {
        /*if(typeof window.HSSLIDECART !== 'undefined'
           && typeof window.HSSLIDECART.settings !== 'undefined'
           && typeof window.HSSLIDECART.settings.json !== 'undefined') {
           data = window.HSSLIDECART.settings.json;
        }*/
        if(!parseInt(data.enable_app))
        {
          return false;
        }
        if(data['money_format'].indexOf('amount') > -1){
          data['money_format'] = data['money_format'].replace( /<.*?>/g, '' );
        }
        if(HsCartDrawer.readCookie('cart_currency') !== '')
        {
          var currencyMoney = HsCartDrawer.readCookie('cart_currency');
          data['money_format'] = HsCurrency.moneyFormats[currencyMoney].money_format;
        }
        HsCartDrawer.json = data;
        if(data.status == 1)
        {
          $('a[href=cart],a[href=#cart]').unbind('click');
          $('a[href=cart],a[href=#cart]').click(function(e){
            e.preventDefault();
          });
        }
        $(function() {
          HsCartDrawer.init(data,$);
        });
        $(document).ready(function() {
          HsCartDrawer.addToCart(data,$);
        });
        $(window).on("load", function() {
          HsCartDrawer.addToCart(data,$);
        });
      }
    });
  };

loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
  jQuery191 = jQuery.noConflict(true);
  !function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).Swiper=t()}(this,(function(){"use strict";var e="undefined"==typeof document?{body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},location:{hash:""}}:document,t="undefined"==typeof window?{document:e,navigator:{userAgent:""},location:{},history:{},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){}}:window,i=function(e){for(var t=0;t<e.length;t+=1)this[t]=e[t];return this.length=e.length,this};function s(s,a){var r=[],n=0;if(s&&!a&&s instanceof i)return s;if(s)if("string"==typeof s){var o,l,d=s.trim();if(d.indexOf("<")>=0&&d.indexOf(">")>=0){var h="div";for(0===d.indexOf("<li")&&(h="ul"),0===d.indexOf("<tr")&&(h="tbody"),0!==d.indexOf("<td")&&0!==d.indexOf("<th")||(h="tr"),0===d.indexOf("<tbody")&&(h="table"),0===d.indexOf("<option")&&(h="select"),(l=e.createElement(h)).innerHTML=d,n=0;n<l.childNodes.length;n+=1)r.push(l.childNodes[n])}else for(o=a||"#"!==s[0]||s.match(/[ .<>:~]/)?(a||e).querySelectorAll(s.trim()):[e.getElementById(s.trim().split("#")[1])],n=0;n<o.length;n+=1)o[n]&&r.push(o[n])}else if(s.nodeType||s===t||s===e)r.push(s);else if(s.length>0&&s[0].nodeType)for(n=0;n<s.length;n+=1)r.push(s[n]);return new i(r)}function a(e){for(var t=[],i=0;i<e.length;i+=1)-1===t.indexOf(e[i])&&t.push(e[i]);return t}s.fn=i.prototype,s.Class=i,s.Dom7=i;var r={addClass:function(e){if(void 0===e)return this;for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.add(t[i]);return this},removeClass:function(e){for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.remove(t[i]);return this},hasClass:function(e){return!!this[0]&&this[0].classList.contains(e)},toggleClass:function(e){for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.toggle(t[i]);return this},attr:function(e,t){var i=arguments;if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var s=0;s<this.length;s+=1)if(2===i.length)this[s].setAttribute(e,t);else for(var a in e)this[s][a]=e[a],this[s].setAttribute(a,e[a]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},data:function(e,t){var i;if(void 0!==t){for(var s=0;s<this.length;s+=1)(i=this[s]).dom7ElementDataStorage||(i.dom7ElementDataStorage={}),i.dom7ElementDataStorage[e]=t;return this}if(i=this[0]){if(i.dom7ElementDataStorage&&e in i.dom7ElementDataStorage)return i.dom7ElementDataStorage[e];var a=i.getAttribute("data-"+e);return a||void 0}},transform:function(e){for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransform=e,i.transform=e}return this},transition:function(e){"string"!=typeof e&&(e+="ms");for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransitionDuration=e,i.transitionDuration=e}return this},on:function(){for(var e,t=[],i=arguments.length;i--;)t[i]=arguments[i];var a=t[0],r=t[1],n=t[2],o=t[3];function l(e){var t=e.target;if(t){var i=e.target.dom7EventData||[];if(i.indexOf(e)<0&&i.unshift(e),s(t).is(r))n.apply(t,i);else for(var a=s(t).parents(),o=0;o<a.length;o+=1)s(a[o]).is(r)&&n.apply(a[o],i)}}function d(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),n.apply(this,t)}"function"==typeof t[1]&&(a=(e=t)[0],n=e[1],o=e[2],r=void 0),o||(o=!1);for(var h,p=a.split(" "),c=0;c<this.length;c+=1){var u=this[c];if(r)for(h=0;h<p.length;h+=1){var v=p[h];u.dom7LiveListeners||(u.dom7LiveListeners={}),u.dom7LiveListeners[v]||(u.dom7LiveListeners[v]=[]),u.dom7LiveListeners[v].push({listener:n,proxyListener:l}),u.addEventListener(v,l,o)}else for(h=0;h<p.length;h+=1){var f=p[h];u.dom7Listeners||(u.dom7Listeners={}),u.dom7Listeners[f]||(u.dom7Listeners[f]=[]),u.dom7Listeners[f].push({listener:n,proxyListener:d}),u.addEventListener(f,d,o)}}return this},off:function(){for(var e,t=[],i=arguments.length;i--;)t[i]=arguments[i];var s=t[0],a=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(s=(e=t)[0],r=e[1],n=e[2],a=void 0),n||(n=!1);for(var o=s.split(" "),l=0;l<o.length;l+=1)for(var d=o[l],h=0;h<this.length;h+=1){var p=this[h],c=void 0;if(!a&&p.dom7Listeners?c=p.dom7Listeners[d]:a&&p.dom7LiveListeners&&(c=p.dom7LiveListeners[d]),c&&c.length)for(var u=c.length-1;u>=0;u-=1){var v=c[u];r&&v.listener===r?(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1)):r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1)):r||(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1))}}return this},trigger:function(){for(var i=[],s=arguments.length;s--;)i[s]=arguments[s];for(var a=i[0].split(" "),r=i[1],n=0;n<a.length;n+=1)for(var o=a[n],l=0;l<this.length;l+=1){var d=this[l],h=void 0;try{h=new t.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0})}catch(t){(h=e.createEvent("Event")).initEvent(o,!0,!0),h.detail=r}d.dom7EventData=i.filter((function(e,t){return t>0})),d.dispatchEvent(h),d.dom7EventData=[],delete d.dom7EventData}return this},transitionEnd:function(e){var t,i=["webkitTransitionEnd","transitionend"],s=this;function a(r){if(r.target===this)for(e.call(this,r),t=0;t<i.length;t+=1)s.off(i[t],a)}if(e)for(t=0;t<i.length;t+=1)s.on(i[t],a);return this},outerWidth:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},offset:function(){if(this.length>0){var i=this[0],s=i.getBoundingClientRect(),a=e.body,r=i.clientTop||a.clientTop||0,n=i.clientLeft||a.clientLeft||0,o=i===t?t.scrollY:i.scrollTop,l=i===t?t.scrollX:i.scrollLeft;return{top:s.top+o-r,left:s.left+l-n}}return null},css:function(e,i){var s;if(1===arguments.length){if("string"!=typeof e){for(s=0;s<this.length;s+=1)for(var a in e)this[s].style[a]=e[a];return this}if(this[0])return t.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(s=0;s<this.length;s+=1)this[s].style[e]=i;return this}return this},each:function(e){if(!e)return this;for(var t=0;t<this.length;t+=1)if(!1===e.call(this[t],t,this[t]))return this;return this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:void 0;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(a){var r,n,o=this[0];if(!o||void 0===a)return!1;if("string"==typeof a){if(o.matches)return o.matches(a);if(o.webkitMatchesSelector)return o.webkitMatchesSelector(a);if(o.msMatchesSelector)return o.msMatchesSelector(a);for(r=s(a),n=0;n<r.length;n+=1)if(r[n]===o)return!0;return!1}if(a===e)return o===e;if(a===t)return o===t;if(a.nodeType||a instanceof i){for(r=a.nodeType?[a]:a,n=0;n<r.length;n+=1)if(r[n]===o)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t,s=this.length;return new i(e>s-1?[]:e<0?(t=s+e)<0?[]:[this[t]]:[this[e]])},append:function(){for(var t,s=[],a=arguments.length;a--;)s[a]=arguments[a];for(var r=0;r<s.length;r+=1){t=s[r];for(var n=0;n<this.length;n+=1)if("string"==typeof t){var o=e.createElement("div");for(o.innerHTML=t;o.firstChild;)this[n].appendChild(o.firstChild)}else if(t instanceof i)for(var l=0;l<t.length;l+=1)this[n].appendChild(t[l]);else this[n].appendChild(t)}return this},prepend:function(t){var s,a;for(s=0;s<this.length;s+=1)if("string"==typeof t){var r=e.createElement("div");for(r.innerHTML=t,a=r.childNodes.length-1;a>=0;a-=1)this[s].insertBefore(r.childNodes[a],this[s].childNodes[0])}else if(t instanceof i)for(a=0;a<t.length;a+=1)this[s].insertBefore(t[a],this[s].childNodes[0]);else this[s].insertBefore(t,this[s].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&s(this[0].nextElementSibling).is(e)?new i([this[0].nextElementSibling]):new i([]):this[0].nextElementSibling?new i([this[0].nextElementSibling]):new i([]):new i([])},nextAll:function(e){var t=[],a=this[0];if(!a)return new i([]);for(;a.nextElementSibling;){var r=a.nextElementSibling;e?s(r).is(e)&&t.push(r):t.push(r),a=r}return new i(t)},prev:function(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&s(t.previousElementSibling).is(e)?new i([t.previousElementSibling]):new i([]):t.previousElementSibling?new i([t.previousElementSibling]):new i([])}return new i([])},prevAll:function(e){var t=[],a=this[0];if(!a)return new i([]);for(;a.previousElementSibling;){var r=a.previousElementSibling;e?s(r).is(e)&&t.push(r):t.push(r),a=r}return new i(t)},parent:function(e){for(var t=[],i=0;i<this.length;i+=1)null!==this[i].parentNode&&(e?s(this[i].parentNode).is(e)&&t.push(this[i].parentNode):t.push(this[i].parentNode));return s(a(t))},parents:function(e){for(var t=[],i=0;i<this.length;i+=1)for(var r=this[i].parentNode;r;)e?s(r).is(e)&&t.push(r):t.push(r),r=r.parentNode;return s(a(t))},closest:function(e){var t=this;return void 0===e?new i([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],s=0;s<this.length;s+=1)for(var a=this[s].querySelectorAll(e),r=0;r<a.length;r+=1)t.push(a[r]);return new i(t)},children:function(e){for(var t=[],r=0;r<this.length;r+=1)for(var n=this[r].childNodes,o=0;o<n.length;o+=1)e?1===n[o].nodeType&&s(n[o]).is(e)&&t.push(n[o]):1===n[o].nodeType&&t.push(n[o]);return new i(a(t))},filter:function(e){for(var t=[],s=0;s<this.length;s+=1)e.call(this[s],s,this[s])&&t.push(this[s]);return new i(t)},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this},add:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var i,a;for(i=0;i<e.length;i+=1){var r=s(e[i]);for(a=0;a<r.length;a+=1)this[this.length]=r[a],this.length+=1}return this},styles:function(){return this[0]?t.getComputedStyle(this[0],null):{}}};Object.keys(r).forEach((function(e){s.fn[e]=s.fn[e]||r[e]}));var n={deleteProps:function(e){var t=e;Object.keys(t).forEach((function(e){try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))},nextTick:function(e,t){return void 0===t&&(t=0),setTimeout(e,t)},now:function(){return Date.now()},getTranslate:function(e,i){var s,a,r;void 0===i&&(i="x");var n=t.getComputedStyle(e,null);return t.WebKitCSSMatrix?((a=n.transform||n.webkitTransform).split(",").length>6&&(a=a.split(", ").map((function(e){return e.replace(",",".")})).join(", ")),r=new t.WebKitCSSMatrix("none"===a?"":a)):s=(r=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===i&&(a=t.WebKitCSSMatrix?r.m41:16===s.length?parseFloat(s[12]):parseFloat(s[4])),"y"===i&&(a=t.WebKitCSSMatrix?r.m42:16===s.length?parseFloat(s[13]):parseFloat(s[5])),a||0},parseUrlQuery:function(e){var i,s,a,r,n={},o=e||t.location.href;if("string"==typeof o&&o.length)for(r=(s=(o=o.indexOf("?")>-1?o.replace(/\S*\?/,""):"").split("&").filter((function(e){return""!==e}))).length,i=0;i<r;i+=1)a=s[i].replace(/#\S+/g,"").split("="),n[decodeURIComponent(a[0])]=void 0===a[1]?void 0:decodeURIComponent(a[1])||"";return n},isObject:function(e){return"object"==typeof e&&null!==e&&e.constructor&&e.constructor===Object},extend:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];for(var i=Object(e[0]),s=1;s<e.length;s+=1){var a=e[s];if(null!=a)for(var r=Object.keys(Object(a)),o=0,l=r.length;o<l;o+=1){var d=r[o],h=Object.getOwnPropertyDescriptor(a,d);void 0!==h&&h.enumerable&&(n.isObject(i[d])&&n.isObject(a[d])?n.extend(i[d],a[d]):!n.isObject(i[d])&&n.isObject(a[d])?(i[d]={},n.extend(i[d],a[d])):i[d]=a[d])}}return i}},o={touch:t.Modernizr&&!0===t.Modernizr.touch||!!(t.navigator.maxTouchPoints>0||"ontouchstart"in t||t.DocumentTouch&&e instanceof t.DocumentTouch),pointerEvents:!!t.PointerEvent&&"maxTouchPoints"in t.navigator&&t.navigator.maxTouchPoints>0,observer:"MutationObserver"in t||"WebkitMutationObserver"in t,passiveListener:function(){var e=!1;try{var i=Object.defineProperty({},"passive",{get:function(){e=!0}});t.addEventListener("testPassiveListener",null,i)}catch(e){}return e}(),gestures:"ongesturestart"in t},l=function(e){void 0===e&&(e={});var t=this;t.params=e,t.eventsListeners={},t.params&&t.params.on&&Object.keys(t.params.on).forEach((function(e){t.on(e,t.params.on[e])}))},d={components:{configurable:!0}};l.prototype.on=function(e,t,i){var s=this;if("function"!=typeof t)return s;var a=i?"unshift":"push";return e.split(" ").forEach((function(e){s.eventsListeners[e]||(s.eventsListeners[e]=[]),s.eventsListeners[e][a](t)})),s},l.prototype.once=function(e,t,i){var s=this;if("function"!=typeof t)return s;function a(){for(var i=[],r=arguments.length;r--;)i[r]=arguments[r];s.off(e,a),a.f7proxy&&delete a.f7proxy,t.apply(s,i)}return a.f7proxy=t,s.on(e,a,i)},l.prototype.off=function(e,t){var i=this;return i.eventsListeners?(e.split(" ").forEach((function(e){void 0===t?i.eventsListeners[e]=[]:i.eventsListeners[e]&&i.eventsListeners[e].length&&i.eventsListeners[e].forEach((function(s,a){(s===t||s.f7proxy&&s.f7proxy===t)&&i.eventsListeners[e].splice(a,1)}))})),i):i},l.prototype.emit=function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var i,s,a,r=this;if(!r.eventsListeners)return r;"string"==typeof e[0]||Array.isArray(e[0])?(i=e[0],s=e.slice(1,e.length),a=r):(i=e[0].events,s=e[0].data,a=e[0].context||r);var n=Array.isArray(i)?i:i.split(" ");return n.forEach((function(e){if(r.eventsListeners&&r.eventsListeners[e]){var t=[];r.eventsListeners[e].forEach((function(e){t.push(e)})),t.forEach((function(e){e.apply(a,s)}))}})),r},l.prototype.useModulesParams=function(e){var t=this;t.modules&&Object.keys(t.modules).forEach((function(i){var s=t.modules[i];s.params&&n.extend(e,s.params)}))},l.prototype.useModules=function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach((function(i){var s=t.modules[i],a=e[i]||{};s.instance&&Object.keys(s.instance).forEach((function(e){var i=s.instance[e];t[e]="function"==typeof i?i.bind(t):i})),s.on&&t.on&&Object.keys(s.on).forEach((function(e){t.on(e,s.on[e])})),s.create&&s.create.bind(t)(a)}))},d.components.set=function(e){this.use&&this.use(e)},l.installModule=function(e){for(var t=[],i=arguments.length-1;i-- >0;)t[i]=arguments[i+1];var s=this;s.prototype.modules||(s.prototype.modules={});var a=e.name||Object.keys(s.prototype.modules).length+"_"+n.now();return s.prototype.modules[a]=e,e.proto&&Object.keys(e.proto).forEach((function(t){s.prototype[t]=e.proto[t]})),e.static&&Object.keys(e.static).forEach((function(t){s[t]=e.static[t]})),e.install&&e.install.apply(s,t),s},l.use=function(e){for(var t=[],i=arguments.length-1;i-- >0;)t[i]=arguments[i+1];var s=this;return Array.isArray(e)?(e.forEach((function(e){return s.installModule(e)})),s):s.installModule.apply(s,[e].concat(t))},Object.defineProperties(l,d);var h={updateSize:function(){var e,t,i=this.$el;e=void 0!==this.params.width?this.params.width:i[0].clientWidth,t=void 0!==this.params.height?this.params.height:i[0].clientHeight,0===e&&this.isHorizontal()||0===t&&this.isVertical()||(e=e-parseInt(i.css("padding-left"),10)-parseInt(i.css("padding-right"),10),t=t-parseInt(i.css("padding-top"),10)-parseInt(i.css("padding-bottom"),10),n.extend(this,{width:e,height:t,size:this.isHorizontal()?e:t}))},updateSlides:function(){var e=this.params,i=this.$wrapperEl,s=this.size,a=this.rtlTranslate,r=this.wrongRTL,o=this.virtual&&e.virtual.enabled,l=o?this.virtual.slides.length:this.slides.length,d=i.children("."+this.params.slideClass),h=o?this.virtual.slides.length:d.length,p=[],c=[],u=[];function v(t){return!e.cssMode||t!==d.length-1}var f=e.slidesOffsetBefore;"function"==typeof f&&(f=e.slidesOffsetBefore.call(this));var m=e.slidesOffsetAfter;"function"==typeof m&&(m=e.slidesOffsetAfter.call(this));var g=this.snapGrid.length,b=this.snapGrid.length,w=e.spaceBetween,y=-f,x=0,T=0;if(void 0!==s){var E,S;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*s),this.virtualSize=-w,a?d.css({marginLeft:"",marginTop:""}):d.css({marginRight:"",marginBottom:""}),e.slidesPerColumn>1&&(E=Math.floor(h/e.slidesPerColumn)===h/this.params.slidesPerColumn?h:Math.ceil(h/e.slidesPerColumn)*e.slidesPerColumn,"auto"!==e.slidesPerView&&"row"===e.slidesPerColumnFill&&(E=Math.max(E,e.slidesPerView*e.slidesPerColumn)));for(var C,M=e.slidesPerColumn,P=E/M,z=Math.floor(h/e.slidesPerColumn),k=0;k<h;k+=1){S=0;var $=d.eq(k);if(e.slidesPerColumn>1){var L=void 0,I=void 0,D=void 0;if("row"===e.slidesPerColumnFill&&e.slidesPerGroup>1){var O=Math.floor(k/(e.slidesPerGroup*e.slidesPerColumn)),A=k-e.slidesPerColumn*e.slidesPerGroup*O,G=0===O?e.slidesPerGroup:Math.min(Math.ceil((h-O*M*e.slidesPerGroup)/M),e.slidesPerGroup);L=(I=A-(D=Math.floor(A/G))*G+O*e.slidesPerGroup)+D*E/M,$.css({"-webkit-box-ordinal-group":L,"-moz-box-ordinal-group":L,"-ms-flex-order":L,"-webkit-order":L,order:L})}else"column"===e.slidesPerColumnFill?(D=k-(I=Math.floor(k/M))*M,(I>z||I===z&&D===M-1)&&(D+=1)>=M&&(D=0,I+=1)):I=k-(D=Math.floor(k/P))*P;$.css("margin-"+(this.isHorizontal()?"top":"left"),0!==D&&e.spaceBetween&&e.spaceBetween+"px")}if("none"!==$.css("display")){if("auto"===e.slidesPerView){var B=t.getComputedStyle($[0],null),H=$[0].style.transform,N=$[0].style.webkitTransform;if(H&&($[0].style.transform="none"),N&&($[0].style.webkitTransform="none"),e.roundLengths)S=this.isHorizontal()?$.outerWidth(!0):$.outerHeight(!0);else if(this.isHorizontal()){var X=parseFloat(B.getPropertyValue("width")),V=parseFloat(B.getPropertyValue("padding-left")),Y=parseFloat(B.getPropertyValue("padding-right")),F=parseFloat(B.getPropertyValue("margin-left")),W=parseFloat(B.getPropertyValue("margin-right")),R=B.getPropertyValue("box-sizing");S=R&&"border-box"===R?X+F+W:X+V+Y+F+W}else{var q=parseFloat(B.getPropertyValue("height")),j=parseFloat(B.getPropertyValue("padding-top")),K=parseFloat(B.getPropertyValue("padding-bottom")),U=parseFloat(B.getPropertyValue("margin-top")),_=parseFloat(B.getPropertyValue("margin-bottom")),Z=B.getPropertyValue("box-sizing");S=Z&&"border-box"===Z?q+U+_:q+j+K+U+_}H&&($[0].style.transform=H),N&&($[0].style.webkitTransform=N),e.roundLengths&&(S=Math.floor(S))}else S=(s-(e.slidesPerView-1)*w)/e.slidesPerView,e.roundLengths&&(S=Math.floor(S)),d[k]&&(this.isHorizontal()?d[k].style.width=S+"px":d[k].style.height=S+"px");d[k]&&(d[k].swiperSlideSize=S),u.push(S),e.centeredSlides?(y=y+S/2+x/2+w,0===x&&0!==k&&(y=y-s/2-w),0===k&&(y=y-s/2-w),Math.abs(y)<.001&&(y=0),e.roundLengths&&(y=Math.floor(y)),T%e.slidesPerGroup==0&&p.push(y),c.push(y)):(e.roundLengths&&(y=Math.floor(y)),(T-Math.min(this.params.slidesPerGroupSkip,T))%this.params.slidesPerGroup==0&&p.push(y),c.push(y),y=y+S+w),this.virtualSize+=S+w,x=S,T+=1}}if(this.virtualSize=Math.max(this.virtualSize,s)+m,a&&r&&("slide"===e.effect||"coverflow"===e.effect)&&i.css({width:this.virtualSize+e.spaceBetween+"px"}),e.setWrapperSize&&(this.isHorizontal()?i.css({width:this.virtualSize+e.spaceBetween+"px"}):i.css({height:this.virtualSize+e.spaceBetween+"px"})),e.slidesPerColumn>1&&(this.virtualSize=(S+e.spaceBetween)*E,this.virtualSize=Math.ceil(this.virtualSize/e.slidesPerColumn)-e.spaceBetween,this.isHorizontal()?i.css({width:this.virtualSize+e.spaceBetween+"px"}):i.css({height:this.virtualSize+e.spaceBetween+"px"}),e.centeredSlides)){C=[];for(var Q=0;Q<p.length;Q+=1){var J=p[Q];e.roundLengths&&(J=Math.floor(J)),p[Q]<this.virtualSize+p[0]&&C.push(J)}p=C}if(!e.centeredSlides){C=[];for(var ee=0;ee<p.length;ee+=1){var te=p[ee];e.roundLengths&&(te=Math.floor(te)),p[ee]<=this.virtualSize-s&&C.push(te)}p=C,Math.floor(this.virtualSize-s)-Math.floor(p[p.length-1])>1&&p.push(this.virtualSize-s)}if(0===p.length&&(p=[0]),0!==e.spaceBetween&&(this.isHorizontal()?a?d.filter(v).css({marginLeft:w+"px"}):d.filter(v).css({marginRight:w+"px"}):d.filter(v).css({marginBottom:w+"px"})),e.centeredSlides&&e.centeredSlidesBounds){var ie=0;u.forEach((function(t){ie+=t+(e.spaceBetween?e.spaceBetween:0)}));var se=(ie-=e.spaceBetween)-s;p=p.map((function(e){return e<0?-f:e>se?se+m:e}))}if(e.centerInsufficientSlides){var ae=0;if(u.forEach((function(t){ae+=t+(e.spaceBetween?e.spaceBetween:0)})),(ae-=e.spaceBetween)<s){var re=(s-ae)/2;p.forEach((function(e,t){p[t]=e-re})),c.forEach((function(e,t){c[t]=e+re}))}}n.extend(this,{slides:d,snapGrid:p,slidesGrid:c,slidesSizesGrid:u}),h!==l&&this.emit("slidesLengthChange"),p.length!==g&&(this.params.watchOverflow&&this.checkOverflow(),this.emit("snapGridLengthChange")),c.length!==b&&this.emit("slidesGridLengthChange"),(e.watchSlidesProgress||e.watchSlidesVisibility)&&this.updateSlidesOffset()}},updateAutoHeight:function(e){var t,i=[],s=0;if("number"==typeof e?this.setTransition(e):!0===e&&this.setTransition(this.params.speed),"auto"!==this.params.slidesPerView&&this.params.slidesPerView>1)for(t=0;t<Math.ceil(this.params.slidesPerView);t+=1){var a=this.activeIndex+t;if(a>this.slides.length)break;i.push(this.slides.eq(a)[0])}else i.push(this.slides.eq(this.activeIndex)[0]);for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var r=i[t].offsetHeight;s=r>s?r:s}s&&this.$wrapperEl.css("height",s+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);var t=this.params,i=this.slides,a=this.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&this.updateSlidesOffset();var r=-e;a&&(r=e),i.removeClass(t.slideVisibleClass),this.visibleSlidesIndexes=[],this.visibleSlides=[];for(var n=0;n<i.length;n+=1){var o=i[n],l=(r+(t.centeredSlides?this.minTranslate():0)-o.swiperSlideOffset)/(o.swiperSlideSize+t.spaceBetween);if(t.watchSlidesVisibility){var d=-(r-o.swiperSlideOffset),h=d+this.slidesSizesGrid[n];(d>=0&&d<this.size-1||h>1&&h<=this.size||d<=0&&h>=this.size)&&(this.visibleSlides.push(o),this.visibleSlidesIndexes.push(n),i.eq(n).addClass(t.slideVisibleClass))}o.progress=a?-l:l}this.visibleSlides=s(this.visibleSlides)}},updateProgress:function(e){if(void 0===e){var t=this.rtlTranslate?-1:1;e=this&&this.translate&&this.translate*t||0}var i=this.params,s=this.maxTranslate()-this.minTranslate(),a=this.progress,r=this.isBeginning,o=this.isEnd,l=r,d=o;0===s?(a=0,r=!0,o=!0):(r=(a=(e-this.minTranslate())/s)<=0,o=a>=1),n.extend(this,{progress:a,isBeginning:r,isEnd:o}),(i.watchSlidesProgress||i.watchSlidesVisibility)&&this.updateSlidesProgress(e),r&&!l&&this.emit("reachBeginning toEdge"),o&&!d&&this.emit("reachEnd toEdge"),(l&&!r||d&&!o)&&this.emit("fromEdge"),this.emit("progress",a)},updateSlidesClasses:function(){var e,t=this.slides,i=this.params,s=this.$wrapperEl,a=this.activeIndex,r=this.realIndex,n=this.virtual&&i.virtual.enabled;t.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=n?this.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+a+'"]'):t.eq(a)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=t.eq(0)).addClass(i.slideNextClass);var l=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===l.length&&(l=t.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),l.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass))},updateActiveIndex:function(e){var t,i=this.rtlTranslate?this.translate:-this.translate,s=this.slidesGrid,a=this.snapGrid,r=this.params,o=this.activeIndex,l=this.realIndex,d=this.snapIndex,h=e;if(void 0===h){for(var p=0;p<s.length;p+=1)void 0!==s[p+1]?i>=s[p]&&i<s[p+1]-(s[p+1]-s[p])/2?h=p:i>=s[p]&&i<s[p+1]&&(h=p+1):i>=s[p]&&(h=p);r.normalizeSlideIndex&&(h<0||void 0===h)&&(h=0)}if(a.indexOf(i)>=0)t=a.indexOf(i);else{var c=Math.min(r.slidesPerGroupSkip,h);t=c+Math.floor((h-c)/r.slidesPerGroup)}if(t>=a.length&&(t=a.length-1),h!==o){var u=parseInt(this.slides.eq(h).attr("data-swiper-slide-index")||h,10);n.extend(this,{snapIndex:t,realIndex:u,previousIndex:o,activeIndex:h}),this.emit("activeIndexChange"),this.emit("snapIndexChange"),l!==u&&this.emit("realIndexChange"),(this.initialized||this.runCallbacksOnInit)&&this.emit("slideChange")}else t!==d&&(this.snapIndex=t,this.emit("snapIndexChange"))},updateClickedSlide:function(e){var t=this.params,i=s(e.target).closest("."+t.slideClass)[0],a=!1;if(i)for(var r=0;r<this.slides.length;r+=1)this.slides[r]===i&&(a=!0);if(!i||!a)return this.clickedSlide=void 0,void(this.clickedIndex=void 0);this.clickedSlide=i,this.virtual&&this.params.virtual.enabled?this.clickedIndex=parseInt(s(i).attr("data-swiper-slide-index"),10):this.clickedIndex=s(i).index(),t.slideToClickedSlide&&void 0!==this.clickedIndex&&this.clickedIndex!==this.activeIndex&&this.slideToClickedSlide()}};var p={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this.params,i=this.rtlTranslate,s=this.translate,a=this.$wrapperEl;if(t.virtualTranslate)return i?-s:s;if(t.cssMode)return s;var r=n.getTranslate(a[0],e);return i&&(r=-r),r||0},setTranslate:function(e,t){var i=this.rtlTranslate,s=this.params,a=this.$wrapperEl,r=this.wrapperEl,n=this.progress,o=0,l=0;this.isHorizontal()?o=i?-e:e:l=e,s.roundLengths&&(o=Math.floor(o),l=Math.floor(l)),s.cssMode?r[this.isHorizontal()?"scrollLeft":"scrollTop"]=this.isHorizontal()?-o:-l:s.virtualTranslate||a.transform("translate3d("+o+"px, "+l+"px, 0px)"),this.previousTranslate=this.translate,this.translate=this.isHorizontal()?o:l;var d=this.maxTranslate()-this.minTranslate();(0===d?0:(e-this.minTranslate())/d)!==n&&this.updateProgress(e),this.emit("setTranslate",this.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,i,s,a){var r;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0),void 0===s&&(s=!0);var n=this,o=n.params,l=n.wrapperEl;if(n.animating&&o.preventInteractionOnTransition)return!1;var d,h=n.minTranslate(),p=n.maxTranslate();if(d=s&&e>h?h:s&&e<p?p:e,n.updateProgress(d),o.cssMode){var c=n.isHorizontal();return 0===t?l[c?"scrollLeft":"scrollTop"]=-d:l.scrollTo?l.scrollTo(((r={})[c?"left":"top"]=-d,r.behavior="smooth",r)):l[c?"scrollLeft":"scrollTop"]=-d,!0}return 0===t?(n.setTransition(0),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionEnd"))):(n.setTransition(t),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionStart")),n.animating||(n.animating=!0,n.onTranslateToWrapperTransitionEnd||(n.onTranslateToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd),n.onTranslateToWrapperTransitionEnd=null,delete n.onTranslateToWrapperTransitionEnd,i&&n.emit("transitionEnd"))}),n.$wrapperEl[0].addEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd))),!0}};var c={setTransition:function(e,t){this.params.cssMode||this.$wrapperEl.transition(e),this.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.params,a=this.previousIndex;if(!s.cssMode){s.autoHeight&&this.updateAutoHeight();var r=t;if(r||(r=i>a?"next":i<a?"prev":"reset"),this.emit("transitionStart"),e&&i!==a){if("reset"===r)return void this.emit("slideResetTransitionStart");this.emit("slideChangeTransitionStart"),"next"===r?this.emit("slideNextTransitionStart"):this.emit("slidePrevTransitionStart")}}},transitionEnd:function(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.previousIndex,a=this.params;if(this.animating=!1,!a.cssMode){this.setTransition(0);var r=t;if(r||(r=i>s?"next":i<s?"prev":"reset"),this.emit("transitionEnd"),e&&i!==s){if("reset"===r)return void this.emit("slideResetTransitionEnd");this.emit("slideChangeTransitionEnd"),"next"===r?this.emit("slideNextTransitionEnd"):this.emit("slidePrevTransitionEnd")}}}};var u={slideTo:function(e,t,i,s){var a;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var r=this,n=e;n<0&&(n=0);var o=r.params,l=r.snapGrid,d=r.slidesGrid,h=r.previousIndex,p=r.activeIndex,c=r.rtlTranslate,u=r.wrapperEl;if(r.animating&&o.preventInteractionOnTransition)return!1;var v=Math.min(r.params.slidesPerGroupSkip,n),f=v+Math.floor((n-v)/r.params.slidesPerGroup);f>=d.length&&(f=d.length-1),(p||o.initialSlide||0)===(h||0)&&i&&r.emit("beforeSlideChangeStart");var m,g=-l[f];if(r.updateProgress(g),o.normalizeSlideIndex)for(var b=0;b<d.length;b+=1)-Math.floor(100*g)>=Math.floor(100*d[b])&&(n=b);if(r.initialized&&n!==p){if(!r.allowSlideNext&&g<r.translate&&g<r.minTranslate())return!1;if(!r.allowSlidePrev&&g>r.translate&&g>r.maxTranslate()&&(p||0)!==n)return!1}if(m=n>p?"next":n<p?"prev":"reset",c&&-g===r.translate||!c&&g===r.translate)return r.updateActiveIndex(n),o.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==o.effect&&r.setTranslate(g),"reset"!==m&&(r.transitionStart(i,m),r.transitionEnd(i,m)),!1;if(o.cssMode){var w=r.isHorizontal();return 0===t?u[w?"scrollLeft":"scrollTop"]=-g:u.scrollTo?u.scrollTo(((a={})[w?"left":"top"]=-g,a.behavior="smooth",a)):u[w?"scrollLeft":"scrollTop"]=-g,!0}return 0===t?(r.setTransition(0),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.transitionEnd(i,m)):(r.setTransition(t),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(i,m))}),r.$wrapperEl[0].addEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd))),!0},slideToLoop:function(e,t,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var a=e;return this.params.loop&&(a+=this.loopedSlides),this.slideTo(a,t,i,s)},slideNext:function(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft}return this.slideTo(this.activeIndex+r,e,t,i)},slidePrev:function(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.snapGrid,n=this.slidesGrid,o=this.rtlTranslate;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft}function l(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var d,h=l(o?this.translate:-this.translate),p=r.map((function(e){return l(e)})),c=(n.map((function(e){return l(e)})),r[p.indexOf(h)],r[p.indexOf(h)-1]);return void 0===c&&s.cssMode&&r.forEach((function(e){!c&&h>=e&&(c=e)})),void 0!==c&&(d=n.indexOf(c))<0&&(d=this.activeIndex-1),this.slideTo(d,e,t,i)},slideReset:function(e,t,i){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,i)},slideToClosest:function(e,t,i,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===s&&(s=.5);var a=this.activeIndex,r=Math.min(this.params.slidesPerGroupSkip,a),n=r+Math.floor((a-r)/this.params.slidesPerGroup),o=this.rtlTranslate?this.translate:-this.translate;if(o>=this.snapGrid[n]){var l=this.snapGrid[n];o-l>(this.snapGrid[n+1]-l)*s&&(a+=this.params.slidesPerGroup)}else{var d=this.snapGrid[n-1];o-d<=(this.snapGrid[n]-d)*s&&(a-=this.params.slidesPerGroup)}return a=Math.max(a,0),a=Math.min(a,this.slidesGrid.length-1),this.slideTo(a,e,t,i)},slideToClickedSlide:function(){var e,t=this,i=t.params,a=t.$wrapperEl,r="auto"===i.slidesPerView?t.slidesPerViewDynamic():i.slidesPerView,o=t.clickedIndex;if(i.loop){if(t.animating)return;e=parseInt(s(t.clickedSlide).attr("data-swiper-slide-index"),10),i.centeredSlides?o<t.loopedSlides-r/2||o>t.slides.length-t.loopedSlides+r/2?(t.loopFix(),o=a.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),n.nextTick((function(){t.slideTo(o)}))):t.slideTo(o):o>t.slides.length-r?(t.loopFix(),o=a.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),n.nextTick((function(){t.slideTo(o)}))):t.slideTo(o)}else t.slideTo(o)}};var v={loopCreate:function(){var t=this,i=t.params,a=t.$wrapperEl;a.children("."+i.slideClass+"."+i.slideDuplicateClass).remove();var r=a.children("."+i.slideClass);if(i.loopFillGroupWithBlank){var n=i.slidesPerGroup-r.length%i.slidesPerGroup;if(n!==i.slidesPerGroup){for(var o=0;o<n;o+=1){var l=s(e.createElement("div")).addClass(i.slideClass+" "+i.slideBlankClass);a.append(l)}r=a.children("."+i.slideClass)}}"auto"!==i.slidesPerView||i.loopedSlides||(i.loopedSlides=r.length),t.loopedSlides=Math.ceil(parseFloat(i.loopedSlides||i.slidesPerView,10)),t.loopedSlides+=i.loopAdditionalSlides,t.loopedSlides>r.length&&(t.loopedSlides=r.length);var d=[],h=[];r.each((function(e,i){var a=s(i);e<t.loopedSlides&&h.push(i),e<r.length&&e>=r.length-t.loopedSlides&&d.push(i),a.attr("data-swiper-slide-index",e)}));for(var p=0;p<h.length;p+=1)a.append(s(h[p].cloneNode(!0)).addClass(i.slideDuplicateClass));for(var c=d.length-1;c>=0;c-=1)a.prepend(s(d[c].cloneNode(!0)).addClass(i.slideDuplicateClass))},loopFix:function(){this.emit("beforeLoopFix");var e,t=this.activeIndex,i=this.slides,s=this.loopedSlides,a=this.allowSlidePrev,r=this.allowSlideNext,n=this.snapGrid,o=this.rtlTranslate;this.allowSlidePrev=!0,this.allowSlideNext=!0;var l=-n[t]-this.getTranslate();if(t<s)e=i.length-3*s+t,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l);else if(t>=i.length-s){e=-i.length+t+s,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l)}this.allowSlidePrev=a,this.allowSlideNext=r,this.emit("loopFix")},loopDestroy:function(){var e=this.$wrapperEl,t=this.params,i=this.slides;e.children("."+t.slideClass+"."+t.slideDuplicateClass+",."+t.slideClass+"."+t.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index")}};var f={setGrabCursor:function(e){if(!(o.touch||!this.params.simulateTouch||this.params.watchOverflow&&this.isLocked||this.params.cssMode)){var t=this.el;t.style.cursor="move",t.style.cursor=e?"-webkit-grabbing":"-webkit-grab",t.style.cursor=e?"-moz-grabbin":"-moz-grab",t.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){o.touch||this.params.watchOverflow&&this.isLocked||this.params.cssMode||(this.el.style.cursor="")}};var m,g,b,w,y,x,T,E,S,C,M,P,z,k,$,L={appendSlide:function(e){var t=this.$wrapperEl,i=this.params;if(i.loop&&this.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&t.append(e[s]);else t.append(e);i.loop&&this.loopCreate(),i.observer&&o.observer||this.update()},prependSlide:function(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&this.loopDestroy();var a=s+1;if("object"==typeof e&&"length"in e){for(var r=0;r<e.length;r+=1)e[r]&&i.prepend(e[r]);a=s+e.length}else i.prepend(e);t.loop&&this.loopCreate(),t.observer&&o.observer||this.update(),this.slideTo(a,0,!1)},addSlide:function(e,t){var i=this.$wrapperEl,s=this.params,a=this.activeIndex;s.loop&&(a-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+s.slideClass));var r=this.slides.length;if(e<=0)this.prependSlide(t);else if(e>=r)this.appendSlide(t);else{for(var n=a>e?a+1:a,l=[],d=r-1;d>=e;d-=1){var h=this.slides.eq(d);h.remove(),l.unshift(h)}if("object"==typeof t&&"length"in t){for(var p=0;p<t.length;p+=1)t[p]&&i.append(t[p]);n=a>e?a+t.length:a}else i.append(t);for(var c=0;c<l.length;c+=1)i.append(l[c]);s.loop&&this.loopCreate(),s.observer&&o.observer||this.update(),s.loop?this.slideTo(n+this.loopedSlides,0,!1):this.slideTo(n,0,!1)}},removeSlide:function(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&(s-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+t.slideClass));var a,r=s;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)a=e[n],this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1);r=Math.max(r,0)}else a=e,this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1),r=Math.max(r,0);t.loop&&this.loopCreate(),t.observer&&o.observer||this.update(),t.loop?this.slideTo(r+this.loopedSlides,0,!1):this.slideTo(r,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},I=(m=t.navigator.platform,g=t.navigator.userAgent,b={ios:!1,android:!1,androidChrome:!1,desktop:!1,iphone:!1,ipod:!1,ipad:!1,edge:!1,ie:!1,firefox:!1,macos:!1,windows:!1,cordova:!(!t.cordova&&!t.phonegap),phonegap:!(!t.cordova&&!t.phonegap),electron:!1},w=t.screen.width,y=t.screen.height,x=g.match(/(Android);?[\s\/]+([\d.]+)?/),T=g.match(/(iPad).*OS\s([\d_]+)/),E=g.match(/(iPod)(.*OS\s([\d_]+))?/),S=!T&&g.match(/(iPhone\sOS|iOS)\s([\d_]+)/),C=g.indexOf("MSIE ")>=0||g.indexOf("Trident/")>=0,M=g.indexOf("Edge/")>=0,P=g.indexOf("Gecko/")>=0&&g.indexOf("Firefox/")>=0,z="Win32"===m,k=g.toLowerCase().indexOf("electron")>=0,$="MacIntel"===m,!T&&$&&o.touch&&(1024===w&&1366===y||834===w&&1194===y||834===w&&1112===y||768===w&&1024===y)&&(T=g.match(/(Version)\/([\d.]+)/),$=!1),b.ie=C,b.edge=M,b.firefox=P,x&&!z&&(b.os="android",b.osVersion=x[2],b.android=!0,b.androidChrome=g.toLowerCase().indexOf("chrome")>=0),(T||S||E)&&(b.os="ios",b.ios=!0),S&&!E&&(b.osVersion=S[2].replace(/_/g,"."),b.iphone=!0),T&&(b.osVersion=T[2].replace(/_/g,"."),b.ipad=!0),E&&(b.osVersion=E[3]?E[3].replace(/_/g,"."):null,b.ipod=!0),b.ios&&b.osVersion&&g.indexOf("Version/")>=0&&"10"===b.osVersion.split(".")[0]&&(b.osVersion=g.toLowerCase().split("version/")[1].split(" ")[0]),b.webView=!(!(S||T||E)||!g.match(/.*AppleWebKit(?!.*Safari)/i)&&!t.navigator.standalone)||t.matchMedia&&t.matchMedia("(display-mode: standalone)").matches,b.webview=b.webView,b.standalone=b.webView,b.desktop=!(b.ios||b.android)||k,b.desktop&&(b.electron=k,b.macos=$,b.windows=z,b.macos&&(b.os="macos"),b.windows&&(b.os="windows")),b.pixelRatio=t.devicePixelRatio||1,b);function D(i){var a=this.touchEventsData,r=this.params,o=this.touches;if(!this.animating||!r.preventInteractionOnTransition){var l=i;l.originalEvent&&(l=l.originalEvent);var d=s(l.target);if(("wrapper"!==r.touchEventsTarget||d.closest(this.wrapperEl).length)&&(a.isTouchEvent="touchstart"===l.type,(a.isTouchEvent||!("which"in l)||3!==l.which)&&!(!a.isTouchEvent&&"button"in l&&l.button>0||a.isTouched&&a.isMoved)))if(r.noSwiping&&d.closest(r.noSwipingSelector?r.noSwipingSelector:"."+r.noSwipingClass)[0])this.allowClick=!0;else if(!r.swipeHandler||d.closest(r.swipeHandler)[0]){o.currentX="touchstart"===l.type?l.targetTouches[0].pageX:l.pageX,o.currentY="touchstart"===l.type?l.targetTouches[0].pageY:l.pageY;var h=o.currentX,p=o.currentY,c=r.edgeSwipeDetection||r.iOSEdgeSwipeDetection,u=r.edgeSwipeThreshold||r.iOSEdgeSwipeThreshold;if(!c||!(h<=u||h>=t.screen.width-u)){if(n.extend(a,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=h,o.startY=p,a.touchStartTime=n.now(),this.allowClick=!0,this.updateSize(),this.swipeDirection=void 0,r.threshold>0&&(a.allowThresholdMove=!1),"touchstart"!==l.type){var v=!0;d.is(a.formElements)&&(v=!1),e.activeElement&&s(e.activeElement).is(a.formElements)&&e.activeElement!==d[0]&&e.activeElement.blur();var f=v&&this.allowTouchMove&&r.touchStartPreventDefault;(r.touchStartForcePreventDefault||f)&&l.preventDefault()}this.emit("touchStart",l)}}}}function O(t){var i=this.touchEventsData,a=this.params,r=this.touches,o=this.rtlTranslate,l=t;if(l.originalEvent&&(l=l.originalEvent),i.isTouched){if(!i.isTouchEvent||"mousemove"!==l.type){var d="touchmove"===l.type&&l.targetTouches&&(l.targetTouches[0]||l.changedTouches[0]),h="touchmove"===l.type?d.pageX:l.pageX,p="touchmove"===l.type?d.pageY:l.pageY;if(l.preventedByNestedSwiper)return r.startX=h,void(r.startY=p);if(!this.allowTouchMove)return this.allowClick=!1,void(i.isTouched&&(n.extend(r,{startX:h,startY:p,currentX:h,currentY:p}),i.touchStartTime=n.now()));if(i.isTouchEvent&&a.touchReleaseOnEdges&&!a.loop)if(this.isVertical()){if(p<r.startY&&this.translate<=this.maxTranslate()||p>r.startY&&this.translate>=this.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(h<r.startX&&this.translate<=this.maxTranslate()||h>r.startX&&this.translate>=this.minTranslate())return;if(i.isTouchEvent&&e.activeElement&&l.target===e.activeElement&&s(l.target).is(i.formElements))return i.isMoved=!0,void(this.allowClick=!1);if(i.allowTouchCallbacks&&this.emit("touchMove",l),!(l.targetTouches&&l.targetTouches.length>1)){r.currentX=h,r.currentY=p;var c=r.currentX-r.startX,u=r.currentY-r.startY;if(!(this.params.threshold&&Math.sqrt(Math.pow(c,2)+Math.pow(u,2))<this.params.threshold)){var v;if(void 0===i.isScrolling)this.isHorizontal()&&r.currentY===r.startY||this.isVertical()&&r.currentX===r.startX?i.isScrolling=!1:c*c+u*u>=25&&(v=180*Math.atan2(Math.abs(u),Math.abs(c))/Math.PI,i.isScrolling=this.isHorizontal()?v>a.touchAngle:90-v>a.touchAngle);if(i.isScrolling&&this.emit("touchMoveOpposite",l),void 0===i.startMoving&&(r.currentX===r.startX&&r.currentY===r.startY||(i.startMoving=!0)),i.isScrolling)i.isTouched=!1;else if(i.startMoving){this.allowClick=!1,a.cssMode||l.preventDefault(),a.touchMoveStopPropagation&&!a.nested&&l.stopPropagation(),i.isMoved||(a.loop&&this.loopFix(),i.startTranslate=this.getTranslate(),this.setTransition(0),this.animating&&this.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!a.grabCursor||!0!==this.allowSlideNext&&!0!==this.allowSlidePrev||this.setGrabCursor(!0),this.emit("sliderFirstMove",l)),this.emit("sliderMove",l),i.isMoved=!0;var f=this.isHorizontal()?c:u;r.diff=f,f*=a.touchRatio,o&&(f=-f),this.swipeDirection=f>0?"prev":"next",i.currentTranslate=f+i.startTranslate;var m=!0,g=a.resistanceRatio;if(a.touchReleaseOnEdges&&(g=0),f>0&&i.currentTranslate>this.minTranslate()?(m=!1,a.resistance&&(i.currentTranslate=this.minTranslate()-1+Math.pow(-this.minTranslate()+i.startTranslate+f,g))):f<0&&i.currentTranslate<this.maxTranslate()&&(m=!1,a.resistance&&(i.currentTranslate=this.maxTranslate()+1-Math.pow(this.maxTranslate()-i.startTranslate-f,g))),m&&(l.preventedByNestedSwiper=!0),!this.allowSlideNext&&"next"===this.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!this.allowSlidePrev&&"prev"===this.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),a.threshold>0){if(!(Math.abs(f)>a.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,r.startX=r.currentX,r.startY=r.currentY,i.currentTranslate=i.startTranslate,void(r.diff=this.isHorizontal()?r.currentX-r.startX:r.currentY-r.startY)}a.followFinger&&!a.cssMode&&((a.freeMode||a.watchSlidesProgress||a.watchSlidesVisibility)&&(this.updateActiveIndex(),this.updateSlidesClasses()),a.freeMode&&(0===i.velocities.length&&i.velocities.push({position:r[this.isHorizontal()?"startX":"startY"],time:i.touchStartTime}),i.velocities.push({position:r[this.isHorizontal()?"currentX":"currentY"],time:n.now()})),this.updateProgress(i.currentTranslate),this.setTranslate(i.currentTranslate))}}}}}else i.startMoving&&i.isScrolling&&this.emit("touchMoveOpposite",l)}function A(e){var t=this,i=t.touchEventsData,s=t.params,a=t.touches,r=t.rtlTranslate,o=t.$wrapperEl,l=t.slidesGrid,d=t.snapGrid,h=e;if(h.originalEvent&&(h=h.originalEvent),i.allowTouchCallbacks&&t.emit("touchEnd",h),i.allowTouchCallbacks=!1,!i.isTouched)return i.isMoved&&s.grabCursor&&t.setGrabCursor(!1),i.isMoved=!1,void(i.startMoving=!1);s.grabCursor&&i.isMoved&&i.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,c=n.now(),u=c-i.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(h),t.emit("tap click",h),u<300&&c-i.lastClickTime<300&&t.emit("doubleTap doubleClick",h)),i.lastClickTime=n.now(),n.nextTick((function(){t.destroyed||(t.allowClick=!0)})),!i.isTouched||!i.isMoved||!t.swipeDirection||0===a.diff||i.currentTranslate===i.startTranslate)return i.isTouched=!1,i.isMoved=!1,void(i.startMoving=!1);if(i.isTouched=!1,i.isMoved=!1,i.startMoving=!1,p=s.followFinger?r?t.translate:-t.translate:-i.currentTranslate,!s.cssMode)if(s.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1));if(s.freeModeMomentum){if(i.velocities.length>1){var v=i.velocities.pop(),f=i.velocities.pop(),m=v.position-f.position,g=v.time-f.time;t.velocity=m/g,t.velocity/=2,Math.abs(t.velocity)<s.freeModeMinimumVelocity&&(t.velocity=0),(g>150||n.now()-v.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=s.freeModeMomentumVelocityRatio,i.velocities.length=0;var b=1e3*s.freeModeMomentumRatio,w=t.velocity*b,y=t.translate+w;r&&(y=-y);var x,T,E=!1,S=20*Math.abs(t.velocity)*s.freeModeMomentumBounceRatio;if(y<t.maxTranslate())s.freeModeMomentumBounce?(y+t.maxTranslate()<-S&&(y=t.maxTranslate()-S),x=t.maxTranslate(),E=!0,i.allowMomentumBounce=!0):y=t.maxTranslate(),s.loop&&s.centeredSlides&&(T=!0);else if(y>t.minTranslate())s.freeModeMomentumBounce?(y-t.minTranslate()>S&&(y=t.minTranslate()+S),x=t.minTranslate(),E=!0,i.allowMomentumBounce=!0):y=t.minTranslate(),s.loop&&s.centeredSlides&&(T=!0);else if(s.freeModeSticky){for(var C,M=0;M<d.length;M+=1)if(d[M]>-y){C=M;break}y=-(y=Math.abs(d[C]-y)<Math.abs(d[C-1]-y)||"next"===t.swipeDirection?d[C]:d[C-1])}if(T&&t.once("transitionEnd",(function(){t.loopFix()})),0!==t.velocity){if(b=r?Math.abs((-y-t.translate)/t.velocity):Math.abs((y-t.translate)/t.velocity),s.freeModeSticky){var P=Math.abs((r?-y:y)-t.translate),z=t.slidesSizesGrid[t.activeIndex];b=P<z?s.speed:P<2*z?1.5*s.speed:2.5*s.speed}}else if(s.freeModeSticky)return void t.slideToClosest();s.freeModeMomentumBounce&&E?(t.updateProgress(x),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating=!0,o.transitionEnd((function(){t&&!t.destroyed&&i.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(s.speed),t.setTranslate(x),o.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))}))):t.velocity?(t.updateProgress(y),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,o.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(y),t.updateActiveIndex(),t.updateSlidesClasses()}else if(s.freeModeSticky)return void t.slideToClosest();(!s.freeModeMomentum||u>=s.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var k=0,$=t.slidesSizesGrid[0],L=0;L<l.length;L+=L<s.slidesPerGroupSkip?1:s.slidesPerGroup){var I=L<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;void 0!==l[L+I]?p>=l[L]&&p<l[L+I]&&(k=L,$=l[L+I]-l[L]):p>=l[L]&&(k=L,$=l[l.length-1]-l[l.length-2])}var D=(p-l[k])/$,O=k<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;if(u>s.longSwipesMs){if(!s.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(D>=s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k)),"prev"===t.swipeDirection&&(D>1-s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k))}else{if(!s.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(h.target===t.navigation.nextEl||h.target===t.navigation.prevEl)?h.target===t.navigation.nextEl?t.slideTo(k+O):t.slideTo(k):("next"===t.swipeDirection&&t.slideTo(k+O),"prev"===t.swipeDirection&&t.slideTo(k))}}}function G(){var e=this.params,t=this.el;if(!t||0!==t.offsetWidth){e.breakpoints&&this.setBreakpoint();var i=this.allowSlideNext,s=this.allowSlidePrev,a=this.snapGrid;this.allowSlideNext=!0,this.allowSlidePrev=!0,this.updateSize(),this.updateSlides(),this.updateSlidesClasses(),("auto"===e.slidesPerView||e.slidesPerView>1)&&this.isEnd&&!this.params.centeredSlides?this.slideTo(this.slides.length-1,0,!1,!0):this.slideTo(this.activeIndex,0,!1,!0),this.autoplay&&this.autoplay.running&&this.autoplay.paused&&this.autoplay.run(),this.allowSlidePrev=s,this.allowSlideNext=i,this.params.watchOverflow&&a!==this.snapGrid&&this.checkOverflow()}}function B(e){this.allowClick||(this.params.preventClicks&&e.preventDefault(),this.params.preventClicksPropagation&&this.animating&&(e.stopPropagation(),e.stopImmediatePropagation()))}function H(){var e=this.wrapperEl;this.previousTranslate=this.translate,this.translate=this.isHorizontal()?-e.scrollLeft:-e.scrollTop,-0===this.translate&&(this.translate=0),this.updateActiveIndex(),this.updateSlidesClasses();var t=this.maxTranslate()-this.minTranslate();(0===t?0:(this.translate-this.minTranslate())/t)!==this.progress&&this.updateProgress(this.translate),this.emit("setTranslate",this.translate,!1)}var N=!1;function X(){}var V={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,preventInteractionOnTransition:!1,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0},Y={update:h,translate:p,transition:c,slide:u,loop:v,grabCursor:f,manipulation:L,events:{attachEvents:function(){var t=this.params,i=this.touchEvents,s=this.el,a=this.wrapperEl;this.onTouchStart=D.bind(this),this.onTouchMove=O.bind(this),this.onTouchEnd=A.bind(this),t.cssMode&&(this.onScroll=H.bind(this)),this.onClick=B.bind(this);var r=!!t.nested;if(!o.touch&&o.pointerEvents)s.addEventListener(i.start,this.onTouchStart,!1),e.addEventListener(i.move,this.onTouchMove,r),e.addEventListener(i.end,this.onTouchEnd,!1);else{if(o.touch){var n=!("touchstart"!==i.start||!o.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(i.start,this.onTouchStart,n),s.addEventListener(i.move,this.onTouchMove,o.passiveListener?{passive:!1,capture:r}:r),s.addEventListener(i.end,this.onTouchEnd,n),i.cancel&&s.addEventListener(i.cancel,this.onTouchEnd,n),N||(e.addEventListener("touchstart",X),N=!0)}(t.simulateTouch&&!I.ios&&!I.android||t.simulateTouch&&!o.touch&&I.ios)&&(s.addEventListener("mousedown",this.onTouchStart,!1),e.addEventListener("mousemove",this.onTouchMove,r),e.addEventListener("mouseup",this.onTouchEnd,!1))}(t.preventClicks||t.preventClicksPropagation)&&s.addEventListener("click",this.onClick,!0),t.cssMode&&a.addEventListener("scroll",this.onScroll),t.updateOnWindowResize?this.on(I.ios||I.android?"resize orientationchange observerUpdate":"resize observerUpdate",G,!0):this.on("observerUpdate",G,!0)},detachEvents:function(){var t=this.params,i=this.touchEvents,s=this.el,a=this.wrapperEl,r=!!t.nested;if(!o.touch&&o.pointerEvents)s.removeEventListener(i.start,this.onTouchStart,!1),e.removeEventListener(i.move,this.onTouchMove,r),e.removeEventListener(i.end,this.onTouchEnd,!1);else{if(o.touch){var n=!("onTouchStart"!==i.start||!o.passiveListener||!t.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(i.start,this.onTouchStart,n),s.removeEventListener(i.move,this.onTouchMove,r),s.removeEventListener(i.end,this.onTouchEnd,n),i.cancel&&s.removeEventListener(i.cancel,this.onTouchEnd,n)}(t.simulateTouch&&!I.ios&&!I.android||t.simulateTouch&&!o.touch&&I.ios)&&(s.removeEventListener("mousedown",this.onTouchStart,!1),e.removeEventListener("mousemove",this.onTouchMove,r),e.removeEventListener("mouseup",this.onTouchEnd,!1))}(t.preventClicks||t.preventClicksPropagation)&&s.removeEventListener("click",this.onClick,!0),t.cssMode&&a.removeEventListener("scroll",this.onScroll),this.off(I.ios||I.android?"resize orientationchange observerUpdate":"resize observerUpdate",G)}},breakpoints:{setBreakpoint:function(){var e=this.activeIndex,t=this.initialized,i=this.loopedSlides;void 0===i&&(i=0);var s=this.params,a=this.$el,r=s.breakpoints;if(r&&(!r||0!==Object.keys(r).length)){var o=this.getBreakpoint(r);if(o&&this.currentBreakpoint!==o){var l=o in r?r[o]:void 0;l&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach((function(e){var t=l[e];void 0!==t&&(l[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")}));var d=l||this.originalParams,h=s.slidesPerColumn>1,p=d.slidesPerColumn>1;h&&!p?a.removeClass(s.containerModifierClass+"multirow "+s.containerModifierClass+"multirow-column"):!h&&p&&(a.addClass(s.containerModifierClass+"multirow"),"column"===d.slidesPerColumnFill&&a.addClass(s.containerModifierClass+"multirow-column"));var c=d.direction&&d.direction!==s.direction,u=s.loop&&(d.slidesPerView!==s.slidesPerView||c);c&&t&&this.changeDirection(),n.extend(this.params,d),n.extend(this,{allowTouchMove:this.params.allowTouchMove,allowSlideNext:this.params.allowSlideNext,allowSlidePrev:this.params.allowSlidePrev}),this.currentBreakpoint=o,u&&t&&(this.loopDestroy(),this.loopCreate(),this.updateSlides(),this.slideTo(e-i+this.loopedSlides,0,!1)),this.emit("breakpoint",d)}}},getBreakpoint:function(e){if(e){var i=!1,s=Object.keys(e).map((function(e){if("string"==typeof e&&e.startsWith("@")){var i=parseFloat(e.substr(1));return{value:t.innerHeight*i,point:e}}return{value:e,point:e}}));s.sort((function(e,t){return parseInt(e.value,10)-parseInt(t.value,10)}));for(var a=0;a<s.length;a+=1){var r=s[a],n=r.point;r.value<=t.innerWidth&&(i=n)}return i||"max"}}},checkOverflow:{checkOverflow:function(){var e=this.params,t=this.isLocked,i=this.slides.length>0&&e.slidesOffsetBefore+e.spaceBetween*(this.slides.length-1)+this.slides[0].offsetWidth*this.slides.length;e.slidesOffsetBefore&&e.slidesOffsetAfter&&i?this.isLocked=i<=this.size:this.isLocked=1===this.snapGrid.length,this.allowSlideNext=!this.isLocked,this.allowSlidePrev=!this.isLocked,t!==this.isLocked&&this.emit(this.isLocked?"lock":"unlock"),t&&t!==this.isLocked&&(this.isEnd=!1,this.navigation.update())}},classes:{addClasses:function(){var e=this.classNames,t=this.params,i=this.rtl,s=this.$el,a=[];a.push("initialized"),a.push(t.direction),t.freeMode&&a.push("free-mode"),t.autoHeight&&a.push("autoheight"),i&&a.push("rtl"),t.slidesPerColumn>1&&(a.push("multirow"),"column"===t.slidesPerColumnFill&&a.push("multirow-column")),I.android&&a.push("android"),I.ios&&a.push("ios"),t.cssMode&&a.push("css-mode"),a.forEach((function(i){e.push(t.containerModifierClass+i)})),s.addClass(e.join(" "))},removeClasses:function(){var e=this.$el,t=this.classNames;e.removeClass(t.join(" "))}},images:{loadImage:function(e,i,s,a,r,n){var o;function l(){n&&n()}e.complete&&r?l():i?((o=new t.Image).onload=l,o.onerror=l,a&&(o.sizes=a),s&&(o.srcset=s),i&&(o.src=i)):l()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var i=0;i<e.imagesToLoad.length;i+=1){var s=e.imagesToLoad[i];e.loadImage(s,s.currentSrc||s.getAttribute("src"),s.srcset||s.getAttribute("srcset"),s.sizes||s.getAttribute("sizes"),!0,t)}}}},F={},W=function(e){function t(){for(var i,a,r,l=[],d=arguments.length;d--;)l[d]=arguments[d];1===l.length&&l[0].constructor&&l[0].constructor===Object?r=l[0]:(a=(i=l)[0],r=i[1]),r||(r={}),r=n.extend({},r),a&&!r.el&&(r.el=a),e.call(this,r),Object.keys(Y).forEach((function(e){Object.keys(Y[e]).forEach((function(i){t.prototype[i]||(t.prototype[i]=Y[e][i])}))}));var h=this;void 0===h.modules&&(h.modules={}),Object.keys(h.modules).forEach((function(e){var t=h.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=typeof s||null===s)return;if(!(i in r&&"enabled"in s))return;!0===r[i]&&(r[i]={enabled:!0}),"object"!=typeof r[i]||"enabled"in r[i]||(r[i].enabled=!0),r[i]||(r[i]={enabled:!1})}}));var p=n.extend({},V);h.useModulesParams(p),h.params=n.extend({},p,F,r),h.originalParams=n.extend({},h.params),h.passedParams=n.extend({},r),h.$=s;var c=s(h.params.el);if(a=c[0]){if(c.length>1){var u=[];return c.each((function(e,i){var s=n.extend({},r,{el:i});u.push(new t(s))})),u}var v,f,m;return a.swiper=h,c.data("swiper",h),a&&a.shadowRoot&&a.shadowRoot.querySelector?(v=s(a.shadowRoot.querySelector("."+h.params.wrapperClass))).children=function(e){return c.children(e)}:v=c.children("."+h.params.wrapperClass),n.extend(h,{$el:c,el:a,$wrapperEl:v,wrapperEl:v[0],classNames:[],slides:s(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===h.params.direction},isVertical:function(){return"vertical"===h.params.direction},rtl:"rtl"===a.dir.toLowerCase()||"rtl"===c.css("direction"),rtlTranslate:"horizontal"===h.params.direction&&("rtl"===a.dir.toLowerCase()||"rtl"===c.css("direction")),wrongRTL:"-webkit-box"===v.css("display"),activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:h.params.allowSlideNext,allowSlidePrev:h.params.allowSlidePrev,touchEvents:(f=["touchstart","touchmove","touchend","touchcancel"],m=["mousedown","mousemove","mouseup"],o.pointerEvents&&(m=["pointerdown","pointermove","pointerup"]),h.touchEventsTouch={start:f[0],move:f[1],end:f[2],cancel:f[3]},h.touchEventsDesktop={start:m[0],move:m[1],end:m[2]},o.touch||!h.params.simulateTouch?h.touchEventsTouch:h.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,formElements:"input, select, option, textarea, button, video",lastClickTime:n.now(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:h.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),h.useModules(),h.params.init&&h.init(),h}}e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t;var i={extendedDefaults:{configurable:!0},defaults:{configurable:!0},Class:{configurable:!0},$:{configurable:!0}};return t.prototype.slidesPerViewDynamic=function(){var e=this.params,t=this.slides,i=this.slidesGrid,s=this.size,a=this.activeIndex,r=1;if(e.centeredSlides){for(var n,o=t[a].swiperSlideSize,l=a+1;l<t.length;l+=1)t[l]&&!n&&(r+=1,(o+=t[l].swiperSlideSize)>s&&(n=!0));for(var d=a-1;d>=0;d-=1)t[d]&&!n&&(r+=1,(o+=t[d].swiperSlideSize)>s&&(n=!0))}else for(var h=a+1;h<t.length;h+=1)i[h]-i[a]<s&&(r+=1);return r},t.prototype.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,i=e.params;i.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(s(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||s(),i.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}function s(){var t=e.rtlTranslate?-1*e.translate:e.translate,i=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(i),e.updateActiveIndex(),e.updateSlidesClasses()}},t.prototype.changeDirection=function(e,t){void 0===t&&(t=!0);var i=this.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e?this:(this.$el.removeClass(""+this.params.containerModifierClass+i).addClass(""+this.params.containerModifierClass+e),this.params.direction=e,this.slides.each((function(t,i){"vertical"===e?i.style.width="":i.style.height=""})),this.emit("changeDirection"),t&&this.update(),this)},t.prototype.init=function(){this.initialized||(this.emit("beforeInit"),this.params.breakpoints&&this.setBreakpoint(),this.addClasses(),this.params.loop&&this.loopCreate(),this.updateSize(),this.updateSlides(),this.params.watchOverflow&&this.checkOverflow(),this.params.grabCursor&&this.setGrabCursor(),this.params.preloadImages&&this.preloadImages(),this.params.loop?this.slideTo(this.params.initialSlide+this.loopedSlides,0,this.params.runCallbacksOnInit):this.slideTo(this.params.initialSlide,0,this.params.runCallbacksOnInit),this.attachEvents(),this.initialized=!0,this.emit("init"))},t.prototype.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var i=this,s=i.params,a=i.$el,r=i.$wrapperEl,o=i.slides;return void 0===i.params||i.destroyed?null:(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),a.removeAttr("style"),r.removeAttr("style"),o&&o.length&&o.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach((function(e){i.off(e)})),!1!==e&&(i.$el[0].swiper=null,i.$el.data("swiper",null),n.deleteProps(i)),i.destroyed=!0,null)},t.extendDefaults=function(e){n.extend(F,e)},i.extendedDefaults.get=function(){return F},i.defaults.get=function(){return V},i.Class.get=function(){return e},i.$.get=function(){return s},Object.defineProperties(t,i),t}(l),R={name:"device",proto:{device:I},static:{device:I}},q={name:"support",proto:{support:o},static:{support:o}},j={isEdge:!!t.navigator.userAgent.match(/Edge/g),isSafari:function(){var e=t.navigator.userAgent.toLowerCase();return e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0}(),isUiWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)},K={name:"browser",proto:{browser:j},static:{browser:j}},U={name:"resize",create:function(){var e=this;n.extend(e,{resize:{resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(){t.addEventListener("resize",this.resize.resizeHandler),t.addEventListener("orientationchange",this.resize.orientationChangeHandler)},destroy:function(){t.removeEventListener("resize",this.resize.resizeHandler),t.removeEventListener("orientationchange",this.resize.orientationChangeHandler)}}},_={func:t.MutationObserver||t.WebkitMutationObserver,attach:function(e,i){void 0===i&&(i={});var s=this,a=new(0,_.func)((function(e){if(1!==e.length){var i=function(){s.emit("observerUpdate",e[0])};t.requestAnimationFrame?t.requestAnimationFrame(i):t.setTimeout(i,0)}else s.emit("observerUpdate",e[0])}));a.observe(e,{attributes:void 0===i.attributes||i.attributes,childList:void 0===i.childList||i.childList,characterData:void 0===i.characterData||i.characterData}),s.observer.observers.push(a)},init:function(){if(o.observer&&this.params.observer){if(this.params.observeParents)for(var e=this.$el.parents(),t=0;t<e.length;t+=1)this.observer.attach(e[t]);this.observer.attach(this.$el[0],{childList:this.params.observeSlideChildren}),this.observer.attach(this.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach((function(e){e.disconnect()})),this.observer.observers=[]}},Z={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){n.extend(this,{observer:{init:_.init.bind(this),attach:_.attach.bind(this),destroy:_.destroy.bind(this),observers:[]}})},on:{init:function(){this.observer.init()},destroy:function(){this.observer.destroy()}}},Q={update:function(e){var t=this,i=t.params,s=i.slidesPerView,a=i.slidesPerGroup,r=i.centeredSlides,o=t.params.virtual,l=o.addSlidesBefore,d=o.addSlidesAfter,h=t.virtual,p=h.from,c=h.to,u=h.slides,v=h.slidesGrid,f=h.renderSlide,m=h.offset;t.updateActiveIndex();var g,b,w,y=t.activeIndex||0;g=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(b=Math.floor(s/2)+a+l,w=Math.floor(s/2)+a+d):(b=s+(a-1)+l,w=a+d);var x=Math.max((y||0)-w,0),T=Math.min((y||0)+b,u.length-1),E=(t.slidesGrid[x]||0)-(t.slidesGrid[0]||0);function S(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(n.extend(t.virtual,{from:x,to:T,offset:E,slidesGrid:t.slidesGrid}),p===x&&c===T&&!e)return t.slidesGrid!==v&&E!==m&&t.slides.css(g,E+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:E,from:x,to:T,slides:function(){for(var e=[],t=x;t<=T;t+=1)e.push(u[t]);return e}()}),void S();var C=[],M=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var P=p;P<=c;P+=1)(P<x||P>T)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+P+'"]').remove();for(var z=0;z<u.length;z+=1)z>=x&&z<=T&&(void 0===c||e?M.push(z):(z>c&&M.push(z),z<p&&C.push(z)));M.forEach((function(e){t.$wrapperEl.append(f(u[e],e))})),C.sort((function(e,t){return t-e})).forEach((function(e){t.$wrapperEl.prepend(f(u[e],e))})),t.$wrapperEl.children(".swiper-slide").css(g,E+"px"),S()},renderSlide:function(e,t){var i=this.params.virtual;if(i.cache&&this.virtual.cache[t])return this.virtual.cache[t];var a=i.renderSlide?s(i.renderSlide.call(this,e,t)):s('<div class="'+this.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return a.attr("data-swiper-slide-index")||a.attr("data-swiper-slide-index",t),i.cache&&(this.virtual.cache[t]=a),a},appendSlide:function(e){if("object"==typeof e&&"length"in e)for(var t=0;t<e.length;t+=1)e[t]&&this.virtual.slides.push(e[t]);else this.virtual.slides.push(e);this.virtual.update(!0)},prependSlide:function(e){var t=this.activeIndex,i=t+1,s=1;if(Array.isArray(e)){for(var a=0;a<e.length;a+=1)e[a]&&this.virtual.slides.unshift(e[a]);i=t+e.length,s=e.length}else this.virtual.slides.unshift(e);if(this.params.virtual.cache){var r=this.virtual.cache,n={};Object.keys(r).forEach((function(e){var t=r[e],i=t.attr("data-swiper-slide-index");i&&t.attr("data-swiper-slide-index",parseInt(i,10)+1),n[parseInt(e,10)+s]=t})),this.virtual.cache=n}this.virtual.update(!0),this.slideTo(i,0)},removeSlide:function(e){if(null!=e){var t=this.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1)this.virtual.slides.splice(e[i],1),this.params.virtual.cache&&delete this.virtual.cache[e[i]],e[i]<t&&(t-=1),t=Math.max(t,0);else this.virtual.slides.splice(e,1),this.params.virtual.cache&&delete this.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);this.virtual.update(!0),this.slideTo(t,0)}},removeAllSlides:function(){this.virtual.slides=[],this.params.virtual.cache&&(this.virtual.cache={}),this.virtual.update(!0),this.slideTo(0,0)}},J={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,addSlidesBefore:0,addSlidesAfter:0}},create:function(){n.extend(this,{virtual:{update:Q.update.bind(this),appendSlide:Q.appendSlide.bind(this),prependSlide:Q.prependSlide.bind(this),removeSlide:Q.removeSlide.bind(this),removeAllSlides:Q.removeAllSlides.bind(this),renderSlide:Q.renderSlide.bind(this),slides:this.params.virtual.slides,cache:{}}})},on:{beforeInit:function(){if(this.params.virtual.enabled){this.classNames.push(this.params.containerModifierClass+"virtual");var e={watchSlidesProgress:!0};n.extend(this.params,e),n.extend(this.originalParams,e),this.params.initialSlide||this.virtual.update()}},setTranslate:function(){this.params.virtual.enabled&&this.virtual.update()}}},ee={handle:function(i){var s=this.rtlTranslate,a=i;a.originalEvent&&(a=a.originalEvent);var r=a.keyCode||a.charCode;if(!this.allowSlideNext&&(this.isHorizontal()&&39===r||this.isVertical()&&40===r||34===r))return!1;if(!this.allowSlidePrev&&(this.isHorizontal()&&37===r||this.isVertical()&&38===r||33===r))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||e.activeElement&&e.activeElement.nodeName&&("input"===e.activeElement.nodeName.toLowerCase()||"textarea"===e.activeElement.nodeName.toLowerCase()))){if(this.params.keyboard.onlyInViewport&&(33===r||34===r||37===r||39===r||38===r||40===r)){var n=!1;if(this.$el.parents("."+this.params.slideClass).length>0&&0===this.$el.parents("."+this.params.slideActiveClass).length)return;var o=t.innerWidth,l=t.innerHeight,d=this.$el.offset();s&&(d.left-=this.$el[0].scrollLeft);for(var h=[[d.left,d.top],[d.left+this.width,d.top],[d.left,d.top+this.height],[d.left+this.width,d.top+this.height]],p=0;p<h.length;p+=1){var c=h[p];c[0]>=0&&c[0]<=o&&c[1]>=0&&c[1]<=l&&(n=!0)}if(!n)return}this.isHorizontal()?(33!==r&&34!==r&&37!==r&&39!==r||(a.preventDefault?a.preventDefault():a.returnValue=!1),(34!==r&&39!==r||s)&&(33!==r&&37!==r||!s)||this.slideNext(),(33!==r&&37!==r||s)&&(34!==r&&39!==r||!s)||this.slidePrev()):(33!==r&&34!==r&&38!==r&&40!==r||(a.preventDefault?a.preventDefault():a.returnValue=!1),34!==r&&40!==r||this.slideNext(),33!==r&&38!==r||this.slidePrev()),this.emit("keyPress",r)}},enable:function(){this.keyboard.enabled||(s(e).on("keydown",this.keyboard.handle),this.keyboard.enabled=!0)},disable:function(){this.keyboard.enabled&&(s(e).off("keydown",this.keyboard.handle),this.keyboard.enabled=!1)}},te={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0}},create:function(){n.extend(this,{keyboard:{enabled:!1,enable:ee.enable.bind(this),disable:ee.disable.bind(this),handle:ee.handle.bind(this)}})},on:{init:function(){this.params.keyboard.enabled&&this.keyboard.enable()},destroy:function(){this.keyboard.enabled&&this.keyboard.disable()}}};var ie={lastScrollTime:n.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function(){return t.navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var t="onwheel"in e;if(!t){var i=e.createElement("div");i.setAttribute("onwheel","return;"),t="function"==typeof i.onwheel}return!t&&e.implementation&&e.implementation.hasFeature&&!0!==e.implementation.hasFeature("","")&&(t=e.implementation.hasFeature("Events.wheel","3.0")),t}()?"wheel":"mousewheel"},normalize:function(e){var t=0,i=0,s=0,a=0;return"detail"in e&&(i=e.detail),"wheelDelta"in e&&(i=-e.wheelDelta/120),"wheelDeltaY"in e&&(i=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=i,i=0),s=10*t,a=10*i,"deltaY"in e&&(a=e.deltaY),"deltaX"in e&&(s=e.deltaX),e.shiftKey&&!s&&(s=a,a=0),(s||a)&&e.deltaMode&&(1===e.deltaMode?(s*=40,a*=40):(s*=800,a*=800)),s&&!t&&(t=s<1?-1:1),a&&!i&&(i=a<1?-1:1),{spinX:t,spinY:i,pixelX:s,pixelY:a}},handleMouseEnter:function(){this.mouseEntered=!0},handleMouseLeave:function(){this.mouseEntered=!1},handle:function(e){var t=e,i=this,a=i.params.mousewheel;i.params.cssMode&&t.preventDefault();var r=i.$el;if("container"!==i.params.mousewheel.eventsTarged&&(r=s(i.params.mousewheel.eventsTarged)),!i.mouseEntered&&!r[0].contains(t.target)&&!a.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var o=0,l=i.rtlTranslate?-1:1,d=ie.normalize(t);if(a.forceToAxis)if(i.isHorizontal()){if(!(Math.abs(d.pixelX)>Math.abs(d.pixelY)))return!0;o=d.pixelX*l}else{if(!(Math.abs(d.pixelY)>Math.abs(d.pixelX)))return!0;o=d.pixelY}else o=Math.abs(d.pixelX)>Math.abs(d.pixelY)?-d.pixelX*l:-d.pixelY;if(0===o)return!0;if(a.invert&&(o=-o),i.params.freeMode){var h={time:n.now(),delta:Math.abs(o),direction:Math.sign(o)},p=i.mousewheel.lastEventBeforeSnap,c=p&&h.time<p.time+500&&h.delta<=p.delta&&h.direction===p.direction;if(!c){i.mousewheel.lastEventBeforeSnap=void 0,i.params.loop&&i.loopFix();var u=i.getTranslate()+o*a.sensitivity,v=i.isBeginning,f=i.isEnd;if(u>=i.minTranslate()&&(u=i.minTranslate()),u<=i.maxTranslate()&&(u=i.maxTranslate()),i.setTransition(0),i.setTranslate(u),i.updateProgress(),i.updateActiveIndex(),i.updateSlidesClasses(),(!v&&i.isBeginning||!f&&i.isEnd)&&i.updateSlidesClasses(),i.params.freeModeSticky){clearTimeout(i.mousewheel.timeout),i.mousewheel.timeout=void 0;var m=i.mousewheel.recentWheelEvents;m.length>=15&&m.shift();var g=m.length?m[m.length-1]:void 0,b=m[0];if(m.push(h),g&&(h.delta>g.delta||h.direction!==g.direction))m.splice(0);else if(m.length>=15&&h.time-b.time<500&&b.delta-h.delta>=1&&h.delta<=6){var w=o>0?.8:.2;i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.mousewheel.timeout=n.nextTick((function(){i.slideToClosest(i.params.speed,!0,void 0,w)}),0)}i.mousewheel.timeout||(i.mousewheel.timeout=n.nextTick((function(){i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.slideToClosest(i.params.speed,!0,void 0,.5)}),500))}if(c||i.emit("scroll",t),i.params.autoplay&&i.params.autoplayDisableOnInteraction&&i.autoplay.stop(),u===i.minTranslate()||u===i.maxTranslate())return!0}}else{var y={time:n.now(),delta:Math.abs(o),direction:Math.sign(o),raw:e},x=i.mousewheel.recentWheelEvents;x.length>=2&&x.shift();var T=x.length?x[x.length-1]:void 0;if(x.push(y),T?(y.direction!==T.direction||y.delta>T.delta)&&i.mousewheel.animateSlider(y):i.mousewheel.animateSlider(y),i.mousewheel.releaseScroll(y))return!0}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1},animateSlider:function(e){return e.delta>=6&&n.now()-this.mousewheel.lastScrollTime<60||(e.direction<0?this.isEnd&&!this.params.loop||this.animating||(this.slideNext(),this.emit("scroll",e.raw)):this.isBeginning&&!this.params.loop||this.animating||(this.slidePrev(),this.emit("scroll",e.raw)),this.mousewheel.lastScrollTime=(new t.Date).getTime(),!1)},releaseScroll:function(e){var t=this.params.mousewheel;if(e.direction<0){if(this.isEnd&&!this.params.loop&&t.releaseOnEdges)return!0}else if(this.isBeginning&&!this.params.loop&&t.releaseOnEdges)return!0;return!1},enable:function(){var e=ie.event();if(this.params.cssMode)return this.wrapperEl.removeEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=s(this.params.mousewheel.eventsTarged)),t.on("mouseenter",this.mousewheel.handleMouseEnter),t.on("mouseleave",this.mousewheel.handleMouseLeave),t.on(e,this.mousewheel.handle),this.mousewheel.enabled=!0,!0},disable:function(){var e=ie.event();if(this.params.cssMode)return this.wrapperEl.addEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(!this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=s(this.params.mousewheel.eventsTarged)),t.off(e,this.mousewheel.handle),this.mousewheel.enabled=!1,!0}},se={update:function(){var e=this.params.navigation;if(!this.params.loop){var t=this.navigation,i=t.$nextEl,s=t.$prevEl;s&&s.length>0&&(this.isBeginning?s.addClass(e.disabledClass):s.removeClass(e.disabledClass),s[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass)),i&&i.length>0&&(this.isEnd?i.addClass(e.disabledClass):i.removeClass(e.disabledClass),i[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass))}},onPrevClick:function(e){e.preventDefault(),this.isBeginning&&!this.params.loop||this.slidePrev()},onNextClick:function(e){e.preventDefault(),this.isEnd&&!this.params.loop||this.slideNext()},init:function(){var e,t,i=this.params.navigation;(i.nextEl||i.prevEl)&&(i.nextEl&&(e=s(i.nextEl),this.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===this.$el.find(i.nextEl).length&&(e=this.$el.find(i.nextEl))),i.prevEl&&(t=s(i.prevEl),this.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===this.$el.find(i.prevEl).length&&(t=this.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",this.navigation.onNextClick),t&&t.length>0&&t.on("click",this.navigation.onPrevClick),n.extend(this.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}))},destroy:function(){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;t&&t.length&&(t.off("click",this.navigation.onNextClick),t.removeClass(this.params.navigation.disabledClass)),i&&i.length&&(i.off("click",this.navigation.onPrevClick),i.removeClass(this.params.navigation.disabledClass))}},ae={update:function(){var e=this.rtl,t=this.params.pagination;if(t.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var i,a=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,r=this.pagination.$el,n=this.params.loop?Math.ceil((a-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length;if(this.params.loop?((i=Math.ceil((this.activeIndex-this.loopedSlides)/this.params.slidesPerGroup))>a-1-2*this.loopedSlides&&(i-=a-2*this.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==this.params.paginationType&&(i=n+i)):i=void 0!==this.snapIndex?this.snapIndex:this.activeIndex||0,"bullets"===t.type&&this.pagination.bullets&&this.pagination.bullets.length>0){var o,l,d,h=this.pagination.bullets;if(t.dynamicBullets&&(this.pagination.bulletSize=h.eq(0)[this.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(this.isHorizontal()?"width":"height",this.pagination.bulletSize*(t.dynamicMainBullets+4)+"px"),t.dynamicMainBullets>1&&void 0!==this.previousIndex&&(this.pagination.dynamicBulletIndex+=i-this.previousIndex,this.pagination.dynamicBulletIndex>t.dynamicMainBullets-1?this.pagination.dynamicBulletIndex=t.dynamicMainBullets-1:this.pagination.dynamicBulletIndex<0&&(this.pagination.dynamicBulletIndex=0)),o=i-this.pagination.dynamicBulletIndex,d=((l=o+(Math.min(h.length,t.dynamicMainBullets)-1))+o)/2),h.removeClass(t.bulletActiveClass+" "+t.bulletActiveClass+"-next "+t.bulletActiveClass+"-next-next "+t.bulletActiveClass+"-prev "+t.bulletActiveClass+"-prev-prev "+t.bulletActiveClass+"-main"),r.length>1)h.each((function(e,a){var r=s(a),n=r.index();n===i&&r.addClass(t.bulletActiveClass),t.dynamicBullets&&(n>=o&&n<=l&&r.addClass(t.bulletActiveClass+"-main"),n===o&&r.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),n===l&&r.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next"))}));else{var p=h.eq(i),c=p.index();if(p.addClass(t.bulletActiveClass),t.dynamicBullets){for(var u=h.eq(o),v=h.eq(l),f=o;f<=l;f+=1)h.eq(f).addClass(t.bulletActiveClass+"-main");if(this.params.loop)if(c>=h.length-t.dynamicMainBullets){for(var m=t.dynamicMainBullets;m>=0;m-=1)h.eq(h.length-m).addClass(t.bulletActiveClass+"-main");h.eq(h.length-t.dynamicMainBullets-1).addClass(t.bulletActiveClass+"-prev")}else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next");else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next")}}if(t.dynamicBullets){var g=Math.min(h.length,t.dynamicMainBullets+4),b=(this.pagination.bulletSize*g-this.pagination.bulletSize)/2-d*this.pagination.bulletSize,w=e?"right":"left";h.css(this.isHorizontal()?w:"top",b+"px")}}if("fraction"===t.type&&(r.find("."+t.currentClass).text(t.formatFractionCurrent(i+1)),r.find("."+t.totalClass).text(t.formatFractionTotal(n))),"progressbar"===t.type){var y;y=t.progressbarOpposite?this.isHorizontal()?"vertical":"horizontal":this.isHorizontal()?"horizontal":"vertical";var x=(i+1)/n,T=1,E=1;"horizontal"===y?T=x:E=x,r.find("."+t.progressbarFillClass).transform("translate3d(0,0,0) scaleX("+T+") scaleY("+E+")").transition(this.params.speed)}"custom"===t.type&&t.renderCustom?(r.html(t.renderCustom(this,i+1,n)),this.emit("paginationRender",this,r[0])):this.emit("paginationUpdate",this,r[0]),r[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](t.lockClass)}},render:function(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,i=this.pagination.$el,s="";if("bullets"===e.type){for(var a=this.params.loop?Math.ceil((t-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length,r=0;r<a;r+=1)e.renderBullet?s+=e.renderBullet.call(this,r,e.bulletClass):s+="<"+e.bulletElement+' class="'+e.bulletClass+'"></'+e.bulletElement+">";i.html(s),this.pagination.bullets=i.find("."+e.bulletClass)}"fraction"===e.type&&(s=e.renderFraction?e.renderFraction.call(this,e.currentClass,e.totalClass):'<span class="'+e.currentClass+'"></span> / <span class="'+e.totalClass+'"></span>',i.html(s)),"progressbar"===e.type&&(s=e.renderProgressbar?e.renderProgressbar.call(this,e.progressbarFillClass):'<span class="'+e.progressbarFillClass+'"></span>',i.html(s)),"custom"!==e.type&&this.emit("paginationRender",this.pagination.$el[0])}},init:function(){var e=this,t=e.params.pagination;if(t.el){var i=s(t.el);0!==i.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&i.length>1&&1===e.$el.find(t.el).length&&(i=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&i.addClass(t.clickableClass),i.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(i.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&i.addClass(t.progressbarOppositeClass),t.clickable&&i.on("click","."+t.bulletClass,(function(t){t.preventDefault();var i=s(this).index()*e.params.slidesPerGroup;e.params.loop&&(i+=e.loopedSlides),e.slideTo(i)})),n.extend(e.pagination,{$el:i,el:i[0]}))}},destroy:function(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.pagination.$el;t.removeClass(e.hiddenClass),t.removeClass(e.modifierClass+e.type),this.pagination.bullets&&this.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&t.off("click","."+e.bulletClass)}}},re={setTranslate:function(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=this.rtlTranslate,i=this.progress,s=e.dragSize,a=e.trackSize,r=e.$dragEl,n=e.$el,o=this.params.scrollbar,l=s,d=(a-s)*i;t?(d=-d)>0?(l=s-d,d=0):-d+s>a&&(l=a+d):d<0?(l=s+d,d=0):d+s>a&&(l=a-d),this.isHorizontal()?(r.transform("translate3d("+d+"px, 0, 0)"),r[0].style.width=l+"px"):(r.transform("translate3d(0px, "+d+"px, 0)"),r[0].style.height=l+"px"),o.hide&&(clearTimeout(this.scrollbar.timeout),n[0].style.opacity=1,this.scrollbar.timeout=setTimeout((function(){n[0].style.opacity=0,n.transition(400)}),1e3))}},setTransition:function(e){this.params.scrollbar.el&&this.scrollbar.el&&this.scrollbar.$dragEl.transition(e)},updateSize:function(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=e.$dragEl,i=e.$el;t[0].style.width="",t[0].style.height="";var s,a=this.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,r=this.size/this.virtualSize,o=r*(a/this.size);s="auto"===this.params.scrollbar.dragSize?a*r:parseInt(this.params.scrollbar.dragSize,10),this.isHorizontal()?t[0].style.width=s+"px":t[0].style.height=s+"px",i[0].style.display=r>=1?"none":"",this.params.scrollbar.hide&&(i[0].style.opacity=0),n.extend(e,{trackSize:a,divider:r,moveDivider:o,dragSize:s}),e.$el[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](this.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY},setDragPosition:function(e){var t,i=this.scrollbar,s=this.rtlTranslate,a=i.$el,r=i.dragSize,n=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-a.offset()[this.isHorizontal()?"left":"top"]-(null!==o?o:r/2))/(n-r),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var l=this.minTranslate()+(this.maxTranslate()-this.minTranslate())*t;this.updateProgress(l),this.setTranslate(l),this.updateActiveIndex(),this.updateSlidesClasses()},onDragStart:function(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el,r=i.$dragEl;this.scrollbar.isTouched=!0,this.scrollbar.dragStartPos=e.target===r[0]||e.target===r?i.getPointerPosition(e)-e.target.getBoundingClientRect()[this.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),r.transition(100),i.setDragPosition(e),clearTimeout(this.scrollbar.dragTimeout),a.transition(0),t.hide&&a.css("opacity",1),this.params.cssMode&&this.$wrapperEl.css("scroll-snap-type","none"),this.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this.scrollbar,i=this.$wrapperEl,s=t.$el,a=t.$dragEl;this.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,t.setDragPosition(e),i.transition(0),s.transition(0),a.transition(0),this.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el;this.scrollbar.isTouched&&(this.scrollbar.isTouched=!1,this.params.cssMode&&(this.$wrapperEl.css("scroll-snap-type",""),s.transition("")),t.hide&&(clearTimeout(this.scrollbar.dragTimeout),this.scrollbar.dragTimeout=n.nextTick((function(){a.css("opacity",0),a.transition(400)}),1e3)),this.emit("scrollbarDragEnd",e),t.snapOnRelease&&this.slideToClosest())},enableDraggable:function(){if(this.params.scrollbar.el){var t=this.scrollbar,i=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=t.$el[0],n=!(!o.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},l=!(!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};o.touch?(r.addEventListener(i.start,this.scrollbar.onDragStart,n),r.addEventListener(i.move,this.scrollbar.onDragMove,n),r.addEventListener(i.end,this.scrollbar.onDragEnd,l)):(r.addEventListener(s.start,this.scrollbar.onDragStart,n),e.addEventListener(s.move,this.scrollbar.onDragMove,n),e.addEventListener(s.end,this.scrollbar.onDragEnd,l))}},disableDraggable:function(){if(this.params.scrollbar.el){var t=this.scrollbar,i=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=t.$el[0],n=!(!o.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},l=!(!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};o.touch?(r.removeEventListener(i.start,this.scrollbar.onDragStart,n),r.removeEventListener(i.move,this.scrollbar.onDragMove,n),r.removeEventListener(i.end,this.scrollbar.onDragEnd,l)):(r.removeEventListener(s.start,this.scrollbar.onDragStart,n),e.removeEventListener(s.move,this.scrollbar.onDragMove,n),e.removeEventListener(s.end,this.scrollbar.onDragEnd,l))}},init:function(){if(this.params.scrollbar.el){var e=this.scrollbar,t=this.$el,i=this.params.scrollbar,a=s(i.el);this.params.uniqueNavElements&&"string"==typeof i.el&&a.length>1&&1===t.find(i.el).length&&(a=t.find(i.el));var r=a.find("."+this.params.scrollbar.dragClass);0===r.length&&(r=s('<div class="'+this.params.scrollbar.dragClass+'"></div>'),a.append(r)),n.extend(e,{$el:a,el:a[0],$dragEl:r,dragEl:r[0]}),i.draggable&&e.enableDraggable()}},destroy:function(){this.scrollbar.disableDraggable()}},ne={setTransform:function(e,t){var i=this.rtl,a=s(e),r=i?-1:1,n=a.attr("data-swiper-parallax")||"0",o=a.attr("data-swiper-parallax-x"),l=a.attr("data-swiper-parallax-y"),d=a.attr("data-swiper-parallax-scale"),h=a.attr("data-swiper-parallax-opacity");if(o||l?(o=o||"0",l=l||"0"):this.isHorizontal()?(o=n,l="0"):(l=n,o="0"),o=o.indexOf("%")>=0?parseInt(o,10)*t*r+"%":o*t*r+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=h){var p=h-(h-1)*(1-Math.abs(t));a[0].style.opacity=p}if(null==d)a.transform("translate3d("+o+", "+l+", 0px)");else{var c=d-(d-1)*(1-Math.abs(t));a.transform("translate3d("+o+", "+l+", 0px) scale("+c+")")}},setTranslate:function(){var e=this,t=e.$el,i=e.slides,a=e.progress,r=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){e.parallax.setTransform(i,a)})),i.each((function(t,i){var n=i.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(n+=Math.ceil(t/2)-a*(r.length-1)),n=Math.min(Math.max(n,-1),1),s(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){e.parallax.setTransform(i,n)}))}))},setTransition:function(e){void 0===e&&(e=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){var a=s(i),r=parseInt(a.attr("data-swiper-parallax-duration"),10)||e;0===e&&(r=0),a.transition(r)}))}},oe={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,i=e.targetTouches[0].pageY,s=e.targetTouches[1].pageX,a=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s-t,2)+Math.pow(a-i,2))},onGestureStart:function(e){var t=this.params.zoom,i=this.zoom,a=i.gesture;if(i.fakeGestureTouched=!1,i.fakeGestureMoved=!1,!o.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;i.fakeGestureTouched=!0,a.scaleStart=oe.getDistanceBetweenTouches(e)}a.$slideEl&&a.$slideEl.length||(a.$slideEl=s(e.target).closest(".swiper-slide"),0===a.$slideEl.length&&(a.$slideEl=this.slides.eq(this.activeIndex)),a.$imageEl=a.$slideEl.find("img, svg, canvas"),a.$imageWrapEl=a.$imageEl.parent("."+t.containerClass),a.maxRatio=a.$imageWrapEl.attr("data-swiper-zoom")||t.maxRatio,0!==a.$imageWrapEl.length)?(a.$imageEl.transition(0),this.zoom.isScaling=!0):a.$imageEl=void 0},onGestureChange:function(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!o.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;i.fakeGestureMoved=!0,s.scaleMove=oe.getDistanceBetweenTouches(e)}s.$imageEl&&0!==s.$imageEl.length&&(o.gestures?i.scale=e.scale*i.currentScale:i.scale=s.scaleMove/s.scaleStart*i.currentScale,i.scale>s.maxRatio&&(i.scale=s.maxRatio-1+Math.pow(i.scale-s.maxRatio+1,.5)),i.scale<t.minRatio&&(i.scale=t.minRatio+1-Math.pow(t.minRatio-i.scale+1,.5)),s.$imageEl.transform("translate3d(0,0,0) scale("+i.scale+")"))},onGestureEnd:function(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!o.gestures){if(!i.fakeGestureTouched||!i.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!I.android)return;i.fakeGestureTouched=!1,i.fakeGestureMoved=!1}s.$imageEl&&0!==s.$imageEl.length&&(i.scale=Math.max(Math.min(i.scale,s.maxRatio),t.minRatio),s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale("+i.scale+")"),i.currentScale=i.scale,i.isScaling=!1,1===i.scale&&(s.$slideEl=void 0))},onTouchStart:function(e){var t=this.zoom,i=t.gesture,s=t.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(I.android&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this.zoom,i=t.gesture,s=t.image,a=t.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(this.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=n.getTranslate(i.$imageWrapEl[0],"x")||0,s.startY=n.getTranslate(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0),this.rtl&&(s.startX=-s.startX,s.startY=-s.startY));var r=s.width*t.scale,o=s.height*t.scale;if(!(r<i.slideWidth&&o<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-r/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-o/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!t.isScaling){if(this.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!this.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),a.prevPositionX||(a.prevPositionX=s.touchesCurrent.x),a.prevPositionY||(a.prevPositionY=s.touchesCurrent.y),a.prevTime||(a.prevTime=Date.now()),a.x=(s.touchesCurrent.x-a.prevPositionX)/(Date.now()-a.prevTime)/2,a.y=(s.touchesCurrent.y-a.prevPositionY)/(Date.now()-a.prevTime)/2,Math.abs(s.touchesCurrent.x-a.prevPositionX)<2&&(a.x=0),Math.abs(s.touchesCurrent.y-a.prevPositionY)<2&&(a.y=0),a.prevPositionX=s.touchesCurrent.x,a.prevPositionY=s.touchesCurrent.y,a.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,i=e.image,s=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!i.isTouched||!i.isMoved)return i.isTouched=!1,void(i.isMoved=!1);i.isTouched=!1,i.isMoved=!1;var a=300,r=300,n=s.x*a,o=i.currentX+n,l=s.y*r,d=i.currentY+l;0!==s.x&&(a=Math.abs((o-i.currentX)/s.x)),0!==s.y&&(r=Math.abs((d-i.currentY)/s.y));var h=Math.max(a,r);i.currentX=o,i.currentY=d;var p=i.width*e.scale,c=i.height*e.scale;i.minX=Math.min(t.slideWidth/2-p/2,0),i.maxX=-i.minX,i.minY=Math.min(t.slideHeight/2-c/2,0),i.maxY=-i.minY,i.currentX=Math.max(Math.min(i.currentX,i.maxX),i.minX),i.currentY=Math.max(Math.min(i.currentY,i.maxY),i.minY),t.$imageWrapEl.transition(h).transform("translate3d("+i.currentX+"px, "+i.currentY+"px,0)")}},onTransitionEnd:function(){var e=this.zoom,t=e.gesture;t.$slideEl&&this.previousIndex!==this.activeIndex&&(t.$imageEl.transform("translate3d(0,0,0) scale(1)"),t.$imageWrapEl.transform("translate3d(0,0,0)"),e.scale=1,e.currentScale=1,t.$slideEl=void 0,t.$imageEl=void 0,t.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,i,a,r,n,o,l,d,h,p,c,u,v,f,m,g,b=this.zoom,w=this.params.zoom,y=b.gesture,x=b.image;(y.$slideEl||(y.$slideEl=this.clickedSlide?s(this.clickedSlide):this.slides.eq(this.activeIndex),y.$imageEl=y.$slideEl.find("img, svg, canvas"),y.$imageWrapEl=y.$imageEl.parent("."+w.containerClass)),y.$imageEl&&0!==y.$imageEl.length)&&(y.$slideEl.addClass(""+w.zoomedSlideClass),void 0===x.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,i="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=x.touchesStart.x,i=x.touchesStart.y),b.scale=y.$imageWrapEl.attr("data-swiper-zoom")||w.maxRatio,b.currentScale=y.$imageWrapEl.attr("data-swiper-zoom")||w.maxRatio,e?(m=y.$slideEl[0].offsetWidth,g=y.$slideEl[0].offsetHeight,a=y.$slideEl.offset().left+m/2-t,r=y.$slideEl.offset().top+g/2-i,l=y.$imageEl[0].offsetWidth,d=y.$imageEl[0].offsetHeight,h=l*b.scale,p=d*b.scale,v=-(c=Math.min(m/2-h/2,0)),f=-(u=Math.min(g/2-p/2,0)),(n=a*b.scale)<c&&(n=c),n>v&&(n=v),(o=r*b.scale)<u&&(o=u),o>f&&(o=f)):(n=0,o=0),y.$imageWrapEl.transition(300).transform("translate3d("+n+"px, "+o+"px,0)"),y.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+b.scale+")"))},out:function(){var e=this.zoom,t=this.params.zoom,i=e.gesture;i.$slideEl||(i.$slideEl=this.clickedSlide?s(this.clickedSlide):this.slides.eq(this.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas"),i.$imageWrapEl=i.$imageEl.parent("."+t.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&(e.scale=1,e.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+t.zoomedSlideClass),i.$slideEl=void 0)},enable:function(){var e=this.zoom;if(!e.enabled){e.enabled=!0;var t=!("touchstart"!==this.touchEvents.start||!o.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!o.passiveListener||{passive:!1,capture:!0};o.gestures?(this.$wrapperEl.on("gesturestart",".swiper-slide",e.onGestureStart,t),this.$wrapperEl.on("gesturechange",".swiper-slide",e.onGestureChange,t),this.$wrapperEl.on("gestureend",".swiper-slide",e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.on(this.touchEvents.start,".swiper-slide",e.onGestureStart,t),this.$wrapperEl.on(this.touchEvents.move,".swiper-slide",e.onGestureChange,i),this.$wrapperEl.on(this.touchEvents.end,".swiper-slide",e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.on(this.touchEvents.cancel,".swiper-slide",e.onGestureEnd,t)),this.$wrapperEl.on(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i)}},disable:function(){var e=this.zoom;if(e.enabled){this.zoom.enabled=!1;var t=!("touchstart"!==this.touchEvents.start||!o.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!o.passiveListener||{passive:!1,capture:!0};o.gestures?(this.$wrapperEl.off("gesturestart",".swiper-slide",e.onGestureStart,t),this.$wrapperEl.off("gesturechange",".swiper-slide",e.onGestureChange,t),this.$wrapperEl.off("gestureend",".swiper-slide",e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.off(this.touchEvents.start,".swiper-slide",e.onGestureStart,t),this.$wrapperEl.off(this.touchEvents.move,".swiper-slide",e.onGestureChange,i),this.$wrapperEl.off(this.touchEvents.end,".swiper-slide",e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.off(this.touchEvents.cancel,".swiper-slide",e.onGestureEnd,t)),this.$wrapperEl.off(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i)}}},le={loadInSlide:function(e,t){void 0===t&&(t=!0);var i=this,a=i.params.lazy;if(void 0!==e&&0!==i.slides.length){var r=i.virtual&&i.params.virtual.enabled?i.$wrapperEl.children("."+i.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):i.slides.eq(e),n=r.find("."+a.elementClass+":not(."+a.loadedClass+"):not(."+a.loadingClass+")");!r.hasClass(a.elementClass)||r.hasClass(a.loadedClass)||r.hasClass(a.loadingClass)||(n=n.add(r[0])),0!==n.length&&n.each((function(e,n){var o=s(n);o.addClass(a.loadingClass);var l=o.attr("data-background"),d=o.attr("data-src"),h=o.attr("data-srcset"),p=o.attr("data-sizes");i.loadImage(o[0],d||l,h,p,!1,(function(){if(null!=i&&i&&(!i||i.params)&&!i.destroyed){if(l?(o.css("background-image",'url("'+l+'")'),o.removeAttr("data-background")):(h&&(o.attr("srcset",h),o.removeAttr("data-srcset")),p&&(o.attr("sizes",p),o.removeAttr("data-sizes")),d&&(o.attr("src",d),o.removeAttr("data-src"))),o.addClass(a.loadedClass).removeClass(a.loadingClass),r.find("."+a.preloaderClass).remove(),i.params.loop&&t){var e=r.attr("data-swiper-slide-index");if(r.hasClass(i.params.slideDuplicateClass)){var s=i.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+i.params.slideDuplicateClass+")");i.lazy.loadInSlide(s.index(),!1)}else{var n=i.$wrapperEl.children("."+i.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');i.lazy.loadInSlide(n.index(),!1)}}i.emit("lazyImageReady",r[0],o[0])}})),i.emit("lazyImageLoad",r[0],o[0])}))}},load:function(){var e=this,t=e.$wrapperEl,i=e.params,a=e.slides,r=e.activeIndex,n=e.virtual&&i.virtual.enabled,o=i.lazy,l=i.slidesPerView;function d(e){if(n){if(t.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(a[e])return!0;return!1}function h(e){return n?s(e).attr("data-swiper-slide-index"):s(e).index()}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+i.slideVisibleClass).each((function(t,i){var a=n?s(i).attr("data-swiper-slide-index"):s(i).index();e.lazy.loadInSlide(a)}));else if(l>1)for(var p=r;p<r+l;p+=1)d(p)&&e.lazy.loadInSlide(p);else e.lazy.loadInSlide(r);if(o.loadPrevNext)if(l>1||o.loadPrevNextAmount&&o.loadPrevNextAmount>1){for(var c=o.loadPrevNextAmount,u=l,v=Math.min(r+u+Math.max(c,u),a.length),f=Math.max(r-Math.max(u,c),0),m=r+l;m<v;m+=1)d(m)&&e.lazy.loadInSlide(m);for(var g=f;g<r;g+=1)d(g)&&e.lazy.loadInSlide(g)}else{var b=t.children("."+i.slideNextClass);b.length>0&&e.lazy.loadInSlide(h(b));var w=t.children("."+i.slidePrevClass);w.length>0&&e.lazy.loadInSlide(h(w))}}},de={LinearSpline:function(e,t){var i,s,a,r,n,o=function(e,t){for(s=-1,i=e.length;i-s>1;)e[a=i+s>>1]<=t?s=a:i=a;return i};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=o(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){this.controller.spline||(this.controller.spline=this.params.loop?new de.LinearSpline(this.slidesGrid,e.slidesGrid):new de.LinearSpline(this.snapGrid,e.snapGrid))},setTranslate:function(e,t){var i,s,a=this,r=a.controller.control;function n(e){var t=a.rtlTranslate?-a.translate:a.translate;"slide"===a.params.controller.by&&(a.controller.getInterpolateFunction(e),s=-a.controller.spline.interpolate(-t)),s&&"container"!==a.params.controller.by||(i=(e.maxTranslate()-e.minTranslate())/(a.maxTranslate()-a.minTranslate()),s=(t-a.minTranslate())*i+e.minTranslate()),a.params.controller.inverse&&(s=e.maxTranslate()-s),e.updateProgress(s),e.setTranslate(s,a),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof W&&n(r[o]);else r instanceof W&&t!==r&&n(r)},setTransition:function(e,t){var i,s=this,a=s.controller.control;function r(t){t.setTransition(e,s),0!==e&&(t.transitionStart(),t.params.autoHeight&&n.nextTick((function(){t.updateAutoHeight()})),t.$wrapperEl.transitionEnd((function(){a&&(t.params.loop&&"slide"===s.params.controller.by&&t.loopFix(),t.transitionEnd())})))}if(Array.isArray(a))for(i=0;i<a.length;i+=1)a[i]!==t&&a[i]instanceof W&&r(a[i]);else a instanceof W&&t!==a&&r(a)}},he={makeElFocusable:function(e){return e.attr("tabIndex","0"),e},addElRole:function(e,t){return e.attr("role",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterKey:function(e){var t=this.params.a11y;if(13===e.keyCode){var i=s(e.target);this.navigation&&this.navigation.$nextEl&&i.is(this.navigation.$nextEl)&&(this.isEnd&&!this.params.loop||this.slideNext(),this.isEnd?this.a11y.notify(t.lastSlideMessage):this.a11y.notify(t.nextSlideMessage)),this.navigation&&this.navigation.$prevEl&&i.is(this.navigation.$prevEl)&&(this.isBeginning&&!this.params.loop||this.slidePrev(),this.isBeginning?this.a11y.notify(t.firstSlideMessage):this.a11y.notify(t.prevSlideMessage)),this.pagination&&i.is("."+this.params.pagination.bulletClass)&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){if(!this.params.loop&&this.navigation){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;i&&i.length>0&&(this.isBeginning?this.a11y.disableEl(i):this.a11y.enableEl(i)),t&&t.length>0&&(this.isEnd?this.a11y.disableEl(t):this.a11y.enableEl(t))}},updatePagination:function(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each((function(i,a){var r=s(a);e.a11y.makeElFocusable(r),e.a11y.addElRole(r,"button"),e.a11y.addElLabel(r,t.paginationBulletMessage.replace(/{{index}}/,r.index()+1))}))},init:function(){this.$el.append(this.a11y.liveRegion);var e,t,i=this.params.a11y;this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&(this.a11y.makeElFocusable(e),this.a11y.addElRole(e,"button"),this.a11y.addElLabel(e,i.nextSlideMessage),e.on("keydown",this.a11y.onEnterKey)),t&&(this.a11y.makeElFocusable(t),this.a11y.addElRole(t,"button"),this.a11y.addElLabel(t,i.prevSlideMessage),t.on("keydown",this.a11y.onEnterKey)),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.on("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey)},destroy:function(){var e,t;this.a11y.liveRegion&&this.a11y.liveRegion.length>0&&this.a11y.liveRegion.remove(),this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&e.off("keydown",this.a11y.onEnterKey),t&&t.off("keydown",this.a11y.onEnterKey),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.off("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey)}},pe={init:function(){if(this.params.history){if(!t.history||!t.history.pushState)return this.params.history.enabled=!1,void(this.params.hashNavigation.enabled=!0);var e=this.history;e.initialized=!0,e.paths=pe.getPathValues(),(e.paths.key||e.paths.value)&&(e.scrollToSlide(0,e.paths.value,this.params.runCallbacksOnInit),this.params.history.replaceState||t.addEventListener("popstate",this.history.setHistoryPopState))}},destroy:function(){this.params.history.replaceState||t.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){this.history.paths=pe.getPathValues(),this.history.scrollToSlide(this.params.speed,this.history.paths.value,!1)},getPathValues:function(){var e=t.location.pathname.slice(1).split("/").filter((function(e){return""!==e})),i=e.length;return{key:e[i-2],value:e[i-1]}},setHistory:function(e,i){if(this.history.initialized&&this.params.history.enabled){var s=this.slides.eq(i),a=pe.slugify(s.attr("data-history"));t.location.pathname.includes(e)||(a=e+"/"+a);var r=t.history.state;r&&r.value===a||(this.params.history.replaceState?t.history.replaceState({value:a},null,a):t.history.pushState({value:a},null,a))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,i){if(t)for(var s=0,a=this.slides.length;s<a;s+=1){var r=this.slides.eq(s);if(pe.slugify(r.attr("data-history"))===t&&!r.hasClass(this.params.slideDuplicateClass)){var n=r.index();this.slideTo(n,e,i)}}else this.slideTo(0,e,i)}},ce={onHashCange:function(){var t=e.location.hash.replace("#","");if(t!==this.slides.eq(this.activeIndex).attr("data-hash")){var i=this.$wrapperEl.children("."+this.params.slideClass+'[data-hash="'+t+'"]').index();if(void 0===i)return;this.slideTo(i)}},setHash:function(){if(this.hashNavigation.initialized&&this.params.hashNavigation.enabled)if(this.params.hashNavigation.replaceState&&t.history&&t.history.replaceState)t.history.replaceState(null,null,"#"+this.slides.eq(this.activeIndex).attr("data-hash")||"");else{var i=this.slides.eq(this.activeIndex),s=i.attr("data-hash")||i.attr("data-history");e.location.hash=s||""}},init:function(){if(!(!this.params.hashNavigation.enabled||this.params.history&&this.params.history.enabled)){this.hashNavigation.initialized=!0;var i=e.location.hash.replace("#","");if(i)for(var a=0,r=this.slides.length;a<r;a+=1){var n=this.slides.eq(a);if((n.attr("data-hash")||n.attr("data-history"))===i&&!n.hasClass(this.params.slideDuplicateClass)){var o=n.index();this.slideTo(o,0,this.params.runCallbacksOnInit,!0)}}this.params.hashNavigation.watchState&&s(t).on("hashchange",this.hashNavigation.onHashCange)}},destroy:function(){this.params.hashNavigation.watchState&&s(t).off("hashchange",this.hashNavigation.onHashCange)}},ue={run:function(){var e=this,t=e.slides.eq(e.activeIndex),i=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(i=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=n.nextTick((function(){e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),e.params.cssMode&&e.autoplay.running&&e.autoplay.run()}),i)},start:function(){return void 0===this.autoplay.timeout&&(!this.autoplay.running&&(this.autoplay.running=!0,this.emit("autoplayStart"),this.autoplay.run(),!0))},stop:function(){return!!this.autoplay.running&&(void 0!==this.autoplay.timeout&&(this.autoplay.timeout&&(clearTimeout(this.autoplay.timeout),this.autoplay.timeout=void 0),this.autoplay.running=!1,this.emit("autoplayStop"),!0))},pause:function(e){this.autoplay.running&&(this.autoplay.paused||(this.autoplay.timeout&&clearTimeout(this.autoplay.timeout),this.autoplay.paused=!0,0!==e&&this.params.autoplay.waitForTransition?(this.$wrapperEl[0].addEventListener("transitionend",this.autoplay.onTransitionEnd),this.$wrapperEl[0].addEventListener("webkitTransitionEnd",this.autoplay.onTransitionEnd)):(this.autoplay.paused=!1,this.autoplay.run())))}},ve={setTranslate:function(){for(var e=this.slides,t=0;t<e.length;t+=1){var i=this.slides.eq(t),s=-i[0].swiperSlideOffset;this.params.virtualTranslate||(s-=this.translate);var a=0;this.isHorizontal()||(a=s,s=0);var r=this.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:r}).transform("translate3d("+s+"px, "+a+"px, 0px)")}},setTransition:function(e){var t=this,i=t.slides,s=t.$wrapperEl;if(i.transition(e),t.params.virtualTranslate&&0!==e){var a=!1;i.transitionEnd((function(){if(!a&&t&&!t.destroyed){a=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1)s.trigger(e[i])}}))}}},fe={setTranslate:function(){var e,t=this.$el,i=this.$wrapperEl,a=this.slides,r=this.width,n=this.height,o=this.rtlTranslate,l=this.size,d=this.params.cubeEffect,h=this.isHorizontal(),p=this.virtual&&this.params.virtual.enabled,c=0;d.shadow&&(h?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=s('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=t.find(".swiper-cube-shadow")).length&&(e=s('<div class="swiper-cube-shadow"></div>'),t.append(e)));for(var u=0;u<a.length;u+=1){var v=a.eq(u),f=u;p&&(f=parseInt(v.attr("data-swiper-slide-index"),10));var m=90*f,g=Math.floor(m/360);o&&(m=-m,g=Math.floor(-m/360));var b=Math.max(Math.min(v[0].progress,1),-1),w=0,y=0,x=0;f%4==0?(w=4*-g*l,x=0):(f-1)%4==0?(w=0,x=4*-g*l):(f-2)%4==0?(w=l+4*g*l,x=l):(f-3)%4==0&&(w=-l,x=3*l+4*l*g),o&&(w=-w),h||(y=w,w=0);var T="rotateX("+(h?0:-m)+"deg) rotateY("+(h?m:0)+"deg) translate3d("+w+"px, "+y+"px, "+x+"px)";if(b<=1&&b>-1&&(c=90*f+90*b,o&&(c=90*-f-90*b)),v.transform(T),d.slideShadows){var E=h?v.find(".swiper-slide-shadow-left"):v.find(".swiper-slide-shadow-top"),S=h?v.find(".swiper-slide-shadow-right"):v.find(".swiper-slide-shadow-bottom");0===E.length&&(E=s('<div class="swiper-slide-shadow-'+(h?"left":"top")+'"></div>'),v.append(E)),0===S.length&&(S=s('<div class="swiper-slide-shadow-'+(h?"right":"bottom")+'"></div>'),v.append(S)),E.length&&(E[0].style.opacity=Math.max(-b,0)),S.length&&(S[0].style.opacity=Math.max(b,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+l/2+"px","-moz-transform-origin":"50% 50% -"+l/2+"px","-ms-transform-origin":"50% 50% -"+l/2+"px","transform-origin":"50% 50% -"+l/2+"px"}),d.shadow)if(h)e.transform("translate3d(0px, "+(r/2+d.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+d.shadowScale+")");else{var C=Math.abs(c)-90*Math.floor(Math.abs(c)/90),M=1.5-(Math.sin(2*C*Math.PI/360)/2+Math.cos(2*C*Math.PI/360)/2),P=d.shadowScale,z=d.shadowScale/M,k=d.shadowOffset;e.transform("scale3d("+P+", 1, "+z+") translate3d(0px, "+(n/2+k)+"px, "+-n/2/z+"px) rotateX(-90deg)")}var $=j.isSafari||j.isUiWebView?-l/2:0;i.transform("translate3d(0px,0,"+$+"px) rotateX("+(this.isHorizontal()?0:c)+"deg) rotateY("+(this.isHorizontal()?-c:0)+"deg)")},setTransition:function(e){var t=this.$el;this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),this.params.cubeEffect.shadow&&!this.isHorizontal()&&t.find(".swiper-cube-shadow").transition(e)}},me={setTranslate:function(){for(var e=this.slides,t=this.rtlTranslate,i=0;i<e.length;i+=1){var a=e.eq(i),r=a[0].progress;this.params.flipEffect.limitRotation&&(r=Math.max(Math.min(a[0].progress,1),-1));var n=-180*r,o=0,l=-a[0].swiperSlideOffset,d=0;if(this.isHorizontal()?t&&(n=-n):(d=l,l=0,o=-n,n=0),a[0].style.zIndex=-Math.abs(Math.round(r))+e.length,this.params.flipEffect.slideShadows){var h=this.isHorizontal()?a.find(".swiper-slide-shadow-left"):a.find(".swiper-slide-shadow-top"),p=this.isHorizontal()?a.find(".swiper-slide-shadow-right"):a.find(".swiper-slide-shadow-bottom");0===h.length&&(h=s('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"left":"top")+'"></div>'),a.append(h)),0===p.length&&(p=s('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"right":"bottom")+'"></div>'),a.append(p)),h.length&&(h[0].style.opacity=Math.max(-r,0)),p.length&&(p[0].style.opacity=Math.max(r,0))}a.transform("translate3d("+l+"px, "+d+"px, 0px) rotateX("+o+"deg) rotateY("+n+"deg)")}},setTransition:function(e){var t=this,i=t.slides,s=t.activeIndex,a=t.$wrapperEl;if(i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;i.eq(s).transitionEnd((function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1)a.trigger(e[i])}}))}}},ge={setTranslate:function(){for(var e=this.width,t=this.height,i=this.slides,a=this.$wrapperEl,r=this.slidesSizesGrid,n=this.params.coverflowEffect,l=this.isHorizontal(),d=this.translate,h=l?e/2-d:t/2-d,p=l?n.rotate:-n.rotate,c=n.depth,u=0,v=i.length;u<v;u+=1){var f=i.eq(u),m=r[u],g=(h-f[0].swiperSlideOffset-m/2)/m*n.modifier,b=l?p*g:0,w=l?0:p*g,y=-c*Math.abs(g),x=l?0:n.stretch*g,T=l?n.stretch*g:0;Math.abs(T)<.001&&(T=0),Math.abs(x)<.001&&(x=0),Math.abs(y)<.001&&(y=0),Math.abs(b)<.001&&(b=0),Math.abs(w)<.001&&(w=0);var E="translate3d("+T+"px,"+x+"px,"+y+"px)  rotateX("+w+"deg) rotateY("+b+"deg)";if(f.transform(E),f[0].style.zIndex=1-Math.abs(Math.round(g)),n.slideShadows){var S=l?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),C=l?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===S.length&&(S=s('<div class="swiper-slide-shadow-'+(l?"left":"top")+'"></div>'),f.append(S)),0===C.length&&(C=s('<div class="swiper-slide-shadow-'+(l?"right":"bottom")+'"></div>'),f.append(C)),S.length&&(S[0].style.opacity=g>0?g:0),C.length&&(C[0].style.opacity=-g>0?-g:0)}}(o.pointerEvents||o.prefixedPointerEvents)&&(a[0].style.perspectiveOrigin=h+"px 50%")},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},be={init:function(){var e=this.params.thumbs,t=this.constructor;e.swiper instanceof t?(this.thumbs.swiper=e.swiper,n.extend(this.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),n.extend(this.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):n.isObject(e.swiper)&&(this.thumbs.swiper=new t(n.extend({},e.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),this.thumbs.swiperCreated=!0),this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass),this.thumbs.swiper.on("tap",this.thumbs.onThumbClick)},onThumbClick:function(){var e=this.thumbs.swiper;if(e){var t=e.clickedIndex,i=e.clickedSlide;if(!(i&&s(i).hasClass(this.params.thumbs.slideThumbActiveClass)||null==t)){var a;if(a=e.params.loop?parseInt(s(e.clickedSlide).attr("data-swiper-slide-index"),10):t,this.params.loop){var r=this.activeIndex;this.slides.eq(r).hasClass(this.params.slideDuplicateClass)&&(this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft,r=this.activeIndex);var n=this.slides.eq(r).prevAll('[data-swiper-slide-index="'+a+'"]').eq(0).index(),o=this.slides.eq(r).nextAll('[data-swiper-slide-index="'+a+'"]').eq(0).index();a=void 0===n?o:void 0===o?n:o-r<r-n?o:n}this.slideTo(a)}}},update:function(e){var t=this.thumbs.swiper;if(t){var i="auto"===t.params.slidesPerView?t.slidesPerViewDynamic():t.params.slidesPerView;if(this.realIndex!==t.realIndex){var s,a=t.activeIndex;if(t.params.loop){t.slides.eq(a).hasClass(t.params.slideDuplicateClass)&&(t.loopFix(),t._clientLeft=t.$wrapperEl[0].clientLeft,a=t.activeIndex);var r=t.slides.eq(a).prevAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index(),n=t.slides.eq(a).nextAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index();s=void 0===r?n:void 0===n?r:n-a==a-r?a:n-a<a-r?n:r}else s=this.realIndex;t.visibleSlidesIndexes&&t.visibleSlidesIndexes.indexOf(s)<0&&(t.params.centeredSlides?s=s>a?s-Math.floor(i/2)+1:s+Math.floor(i/2)-1:s>a&&(s=s-i+1),t.slideTo(s,e?0:void 0))}var o=1,l=this.params.thumbs.slideThumbActiveClass;if(this.params.slidesPerView>1&&!this.params.centeredSlides&&(o=this.params.slidesPerView),this.params.thumbs.multipleActiveThumbs||(o=1),o=Math.floor(o),t.slides.removeClass(l),t.params.loop||t.params.virtual&&t.params.virtual.enabled)for(var d=0;d<o;d+=1)t.$wrapperEl.children('[data-swiper-slide-index="'+(this.realIndex+d)+'"]').addClass(l);else for(var h=0;h<o;h+=1)t.slides.eq(this.realIndex+h).addClass(l)}}},we=[R,q,K,U,Z,J,te,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarged:"container"}},create:function(){n.extend(this,{mousewheel:{enabled:!1,enable:ie.enable.bind(this),disable:ie.disable.bind(this),handle:ie.handle.bind(this),handleMouseEnter:ie.handleMouseEnter.bind(this),handleMouseLeave:ie.handleMouseLeave.bind(this),animateSlider:ie.animateSlider.bind(this),releaseScroll:ie.releaseScroll.bind(this),lastScrollTime:n.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[]}})},on:{init:function(){!this.params.mousewheel.enabled&&this.params.cssMode&&this.mousewheel.disable(),this.params.mousewheel.enabled&&this.mousewheel.enable()},destroy:function(){this.params.cssMode&&this.mousewheel.enable(),this.mousewheel.enabled&&this.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){n.extend(this,{navigation:{init:se.init.bind(this),update:se.update.bind(this),destroy:se.destroy.bind(this),onNextClick:se.onNextClick.bind(this),onPrevClick:se.onPrevClick.bind(this)}})},on:{init:function(){this.navigation.init(),this.navigation.update()},toEdge:function(){this.navigation.update()},fromEdge:function(){this.navigation.update()},destroy:function(){this.navigation.destroy()},click:function(e){var t,i=this.navigation,a=i.$nextEl,r=i.$prevEl;!this.params.navigation.hideOnClick||s(e.target).is(r)||s(e.target).is(a)||(a?t=a.hasClass(this.params.navigation.hiddenClass):r&&(t=r.hasClass(this.params.navigation.hiddenClass)),!0===t?this.emit("navigationShow",this):this.emit("navigationHide",this),a&&a.toggleClass(this.params.navigation.hiddenClass),r&&r.toggleClass(this.params.navigation.hiddenClass))}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){n.extend(this,{pagination:{init:ae.init.bind(this),render:ae.render.bind(this),update:ae.update.bind(this),destroy:ae.destroy.bind(this),dynamicBulletIndex:0}})},on:{init:function(){this.pagination.init(),this.pagination.render(),this.pagination.update()},activeIndexChange:function(){this.params.loop?this.pagination.update():void 0===this.snapIndex&&this.pagination.update()},snapIndexChange:function(){this.params.loop||this.pagination.update()},slidesLengthChange:function(){this.params.loop&&(this.pagination.render(),this.pagination.update())},snapGridLengthChange:function(){this.params.loop||(this.pagination.render(),this.pagination.update())},destroy:function(){this.pagination.destroy()},click:function(e){this.params.pagination.el&&this.params.pagination.hideOnClick&&this.pagination.$el.length>0&&!s(e.target).hasClass(this.params.pagination.bulletClass)&&(!0===this.pagination.$el.hasClass(this.params.pagination.hiddenClass)?this.emit("paginationShow",this):this.emit("paginationHide",this),this.pagination.$el.toggleClass(this.params.pagination.hiddenClass))}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){n.extend(this,{scrollbar:{init:re.init.bind(this),destroy:re.destroy.bind(this),updateSize:re.updateSize.bind(this),setTranslate:re.setTranslate.bind(this),setTransition:re.setTransition.bind(this),enableDraggable:re.enableDraggable.bind(this),disableDraggable:re.disableDraggable.bind(this),setDragPosition:re.setDragPosition.bind(this),getPointerPosition:re.getPointerPosition.bind(this),onDragStart:re.onDragStart.bind(this),onDragMove:re.onDragMove.bind(this),onDragEnd:re.onDragEnd.bind(this),isTouched:!1,timeout:null,dragTimeout:null}})},on:{init:function(){this.scrollbar.init(),this.scrollbar.updateSize(),this.scrollbar.setTranslate()},update:function(){this.scrollbar.updateSize()},resize:function(){this.scrollbar.updateSize()},observerUpdate:function(){this.scrollbar.updateSize()},setTranslate:function(){this.scrollbar.setTranslate()},setTransition:function(e){this.scrollbar.setTransition(e)},destroy:function(){this.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){n.extend(this,{parallax:{setTransform:ne.setTransform.bind(this),setTranslate:ne.setTranslate.bind(this),setTransition:ne.setTransition.bind(this)}})},on:{beforeInit:function(){this.params.parallax.enabled&&(this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0)},init:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTranslate:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTransition:function(e){this.params.parallax.enabled&&this.parallax.setTransition(e)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var e=this,t={enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}};"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach((function(i){t[i]=oe[i].bind(e)})),n.extend(e,{zoom:t});var i=1;Object.defineProperty(e.zoom,"scale",{get:function(){return i},set:function(t){if(i!==t){var s=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,a=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,s,a)}i=t}})},on:{init:function(){this.params.zoom.enabled&&this.zoom.enable()},destroy:function(){this.zoom.disable()},touchStart:function(e){this.zoom.enabled&&this.zoom.onTouchStart(e)},touchEnd:function(e){this.zoom.enabled&&this.zoom.onTouchEnd(e)},doubleTap:function(e){this.params.zoom.enabled&&this.zoom.enabled&&this.params.zoom.toggle&&this.zoom.toggle(e)},transitionEnd:function(){this.zoom.enabled&&this.params.zoom.enabled&&this.zoom.onTransitionEnd()},slideChange:function(){this.zoom.enabled&&this.params.zoom.enabled&&this.params.cssMode&&this.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){n.extend(this,{lazy:{initialImageLoaded:!1,load:le.load.bind(this),loadInSlide:le.loadInSlide.bind(this)}})},on:{beforeInit:function(){this.params.lazy.enabled&&this.params.preloadImages&&(this.params.preloadImages=!1)},init:function(){this.params.lazy.enabled&&!this.params.loop&&0===this.params.initialSlide&&this.lazy.load()},scroll:function(){this.params.freeMode&&!this.params.freeModeSticky&&this.lazy.load()},resize:function(){this.params.lazy.enabled&&this.lazy.load()},scrollbarDragMove:function(){this.params.lazy.enabled&&this.lazy.load()},transitionStart:function(){this.params.lazy.enabled&&(this.params.lazy.loadOnTransitionStart||!this.params.lazy.loadOnTransitionStart&&!this.lazy.initialImageLoaded)&&this.lazy.load()},transitionEnd:function(){this.params.lazy.enabled&&!this.params.lazy.loadOnTransitionStart&&this.lazy.load()},slideChange:function(){this.params.lazy.enabled&&this.params.cssMode&&this.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){n.extend(this,{controller:{control:this.params.controller.control,getInterpolateFunction:de.getInterpolateFunction.bind(this),setTranslate:de.setTranslate.bind(this),setTransition:de.setTransition.bind(this)}})},on:{update:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},resize:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},observerUpdate:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},setTranslate:function(e,t){this.controller.control&&this.controller.setTranslate(e,t)},setTransition:function(e,t){this.controller.control&&this.controller.setTransition(e,t)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}"}},create:function(){var e=this;n.extend(e,{a11y:{liveRegion:s('<span class="'+e.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')}}),Object.keys(he).forEach((function(t){e.a11y[t]=he[t].bind(e)}))},on:{init:function(){this.params.a11y.enabled&&(this.a11y.init(),this.a11y.updateNavigation())},toEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},fromEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},paginationUpdate:function(){this.params.a11y.enabled&&this.a11y.updatePagination()},destroy:function(){this.params.a11y.enabled&&this.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,replaceState:!1,key:"slides"}},create:function(){n.extend(this,{history:{init:pe.init.bind(this),setHistory:pe.setHistory.bind(this),setHistoryPopState:pe.setHistoryPopState.bind(this),scrollToSlide:pe.scrollToSlide.bind(this),destroy:pe.destroy.bind(this)}})},on:{init:function(){this.params.history.enabled&&this.history.init()},destroy:function(){this.params.history.enabled&&this.history.destroy()},transitionEnd:function(){this.history.initialized&&this.history.setHistory(this.params.history.key,this.activeIndex)},slideChange:function(){this.history.initialized&&this.params.cssMode&&this.history.setHistory(this.params.history.key,this.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){n.extend(this,{hashNavigation:{initialized:!1,init:ce.init.bind(this),destroy:ce.destroy.bind(this),setHash:ce.setHash.bind(this),onHashCange:ce.onHashCange.bind(this)}})},on:{init:function(){this.params.hashNavigation.enabled&&this.hashNavigation.init()},destroy:function(){this.params.hashNavigation.enabled&&this.hashNavigation.destroy()},transitionEnd:function(){this.hashNavigation.initialized&&this.hashNavigation.setHash()},slideChange:function(){this.hashNavigation.initialized&&this.params.cssMode&&this.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1}},create:function(){var e=this;n.extend(e,{autoplay:{running:!1,paused:!1,run:ue.run.bind(e),start:ue.start.bind(e),stop:ue.stop.bind(e),pause:ue.pause.bind(e),onVisibilityChange:function(){"hidden"===document.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===document.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1)},onTransitionEnd:function(t){e&&!e.destroyed&&e.$wrapperEl&&t.target===this&&(e.$wrapperEl[0].removeEventListener("transitionend",e.autoplay.onTransitionEnd),e.$wrapperEl[0].removeEventListener("webkitTransitionEnd",e.autoplay.onTransitionEnd),e.autoplay.paused=!1,e.autoplay.running?e.autoplay.run():e.autoplay.stop())}}})},on:{init:function(){this.params.autoplay.enabled&&(this.autoplay.start(),document.addEventListener("visibilitychange",this.autoplay.onVisibilityChange))},beforeTransitionStart:function(e,t){this.autoplay.running&&(t||!this.params.autoplay.disableOnInteraction?this.autoplay.pause(e):this.autoplay.stop())},sliderFirstMove:function(){this.autoplay.running&&(this.params.autoplay.disableOnInteraction?this.autoplay.stop():this.autoplay.pause())},touchEnd:function(){this.params.cssMode&&this.autoplay.paused&&!this.params.autoplay.disableOnInteraction&&this.autoplay.run()},destroy:function(){this.autoplay.running&&this.autoplay.stop(),document.removeEventListener("visibilitychange",this.autoplay.onVisibilityChange)}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){n.extend(this,{fadeEffect:{setTranslate:ve.setTranslate.bind(this),setTransition:ve.setTransition.bind(this)}})},on:{beforeInit:function(){if("fade"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"fade");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e)}},setTranslate:function(){"fade"===this.params.effect&&this.fadeEffect.setTranslate()},setTransition:function(e){"fade"===this.params.effect&&this.fadeEffect.setTransition(e)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){n.extend(this,{cubeEffect:{setTranslate:fe.setTranslate.bind(this),setTransition:fe.setTransition.bind(this)}})},on:{beforeInit:function(){if("cube"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"cube"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e)}},setTranslate:function(){"cube"===this.params.effect&&this.cubeEffect.setTranslate()},setTransition:function(e){"cube"===this.params.effect&&this.cubeEffect.setTransition(e)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){n.extend(this,{flipEffect:{setTranslate:me.setTranslate.bind(this),setTransition:me.setTransition.bind(this)}})},on:{beforeInit:function(){if("flip"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"flip"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};n.extend(this.params,e),n.extend(this.originalParams,e)}},setTranslate:function(){"flip"===this.params.effect&&this.flipEffect.setTranslate()},setTransition:function(e){"flip"===this.params.effect&&this.flipEffect.setTransition(e)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:!0}},create:function(){n.extend(this,{coverflowEffect:{setTranslate:ge.setTranslate.bind(this),setTransition:ge.setTransition.bind(this)}})},on:{beforeInit:function(){"coverflow"===this.params.effect&&(this.classNames.push(this.params.containerModifierClass+"coverflow"),this.classNames.push(this.params.containerModifierClass+"3d"),this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0)},setTranslate:function(){"coverflow"===this.params.effect&&this.coverflowEffect.setTranslate()},setTransition:function(e){"coverflow"===this.params.effect&&this.coverflowEffect.setTransition(e)}}},{name:"thumbs",params:{thumbs:{multipleActiveThumbs:!0,swiper:null,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){n.extend(this,{thumbs:{swiper:null,init:be.init.bind(this),update:be.update.bind(this),onThumbClick:be.onThumbClick.bind(this)}})},on:{beforeInit:function(){var e=this.params.thumbs;e&&e.swiper&&(this.thumbs.init(),this.thumbs.update(!0))},slideChange:function(){this.thumbs.swiper&&this.thumbs.update()},update:function(){this.thumbs.swiper&&this.thumbs.update()},resize:function(){this.thumbs.swiper&&this.thumbs.update()},observerUpdate:function(){this.thumbs.swiper&&this.thumbs.update()},setTransition:function(e){var t=this.thumbs.swiper;t&&t.setTransition(e)},beforeDestroy:function(){var e=this.thumbs.swiper;e&&this.thumbs.swiperCreated&&e&&e.destroy()}}}];return void 0===W.use&&(W.use=W.Class.use,W.installModule=W.Class.installModule),W.use(we),W}));
  myAppJavaScript(jQuery191);
});
/*document.addEventListener("DOMContentLoaded", function(event) {
  var HSContentLoaded = 0;
  $(document).ajaxSuccess(function (a,b,c) {
  	if(HSContentLoaded > 0)
    {
      if(c.url.indexOf('/cart.js?_=57892') < 0)
      {
        if(c.url !== '/cart.json')
        {
          if(c.url.indexOf('/cart.js') > -1)
          {
            HsCartDrawer.getSlideCart();
          }
        }
      }
    }
    HSContentLoaded = 1;
  });
});*/